{
  "customLoginPage": {
    "badRequest": {
      "bad_credentials": "The entered email address or password is not correct.",
      "account_disabled": "User is disabled. Please contact administration.",
      "unknown_error": "An unknown error occurred. Please try again later."
    }
  },
  "common": {
    "b2b_login_disabled": "For security reasons, your user account has been locked due to a prolonged period of inactivity. Please contact your administrator to reactivate your account.",
    "text_orderTemplate_csv_missing_header": "The order could not be uploaded. Please use the order template to upload an order.",
    "customer_registration": "Customer Registration",
    "text_account_mypart_count_message": "You have requested to upload own part numbers into {0} system.###Your original file showed {1} part numbers; your new file show {2} part numbers.###Once your file is completely uploaded to {3} system, it will replace any existing information from your new uploaded file.###Do you want to continue uploading?",
    "text_retrun_request_submit_part_nature_defect": "Reason for Return*",
    "address_lineh1": "Address*",
    "register_checkbox_dealerADBAccess_label": "My Request",
    "general_required_nonalphabets": "Please enter a correct postal code",
    "text_return_request_please_upload_all": "Please upload any documents that are necessary for reviewing your return request form.",
    "text_warranty_submit_axle_position": "Axle Position*",
    "form_select_empty_axle_position": "Please Select",
    "myaccount_warranty_axlePosition_toolTip": "Axle position represents the vehicle location of the component in this claim.",
    "text_return_request_document_attachement_all": "Documents can be attached if they are in jpg, word, or pdf format and if they do not exceed 9MB in total.",
    "text_account_savedcart_to_activecart": "The following saved cart will restore as active cart",
    "order_history_openposition_price_label": "**Open Qty shows all quantities not shipped",
    "text_warranty_submit_returning_kbpart_number": "Returning Knorr-Bremse Part No.*",
    "address_add_new_msg": "Add a new Address",
    "form_global_error_pallet": "The total weight of the pallets should not be less than the total weight of the cores.",
    "text_core_submit_new_address": "New Address",
    "text_account_core_localEMEA": "local Knorr-Bremse customer support team.",
    "core_report_XLS": "XLS",
    "additional_soldto_location_description": "Enter additional location you should have access to (sold to number, address, or dealer code)",
    "DTC_Trouble_Code_Search": "Diagnostic Trouble Code Search",
    "DTC_Please_Select": "Please Select",
    "dtc_PlaceHolder_description": "Enter a DTC, SPN/FMI, SID/FMI or Blink Code (X-X)",
    "breadcrumb_faqpage": "FAQ",
    "faq_extension_text": ".pdf",
    "saved_cart_id_text": "ID",
    "please_note_text": "Please note:",
    "must_be_placed_by": "must be placed by",
    "training_detail_page_view_available_dates_button": "View All Available Dates",
    "training_detail_page_view_online_button": "E-Learning Registration",
    "training_detail_page_view_available_dates": "Available Dates for this Training",
    "training_detail_page_filter_country": "Filter by Country",
    "training_detail_page_filter_language": "Filter by Language",
    "training_detail_page_course_name": "Course Name",
    "training_detail_page_date_time": "Date and Time",
    "training_detail_page_price": "Price per person",
    "breadcrumb_training_text": "Training",
    "training_detail_page_language": "Language : ",
    "training_detail_book_training_button": "Book Training",
    "training_detail_page_day": "Day",
    "training_detail_Excl_tax": "Excl. Tax",
    "training_detail_Google_Maps": "Google Maps",
    "text_booking_training_company_informtaion": "Company Information",
    "text_booking_training_Company_Details": "Company Details",
    "text_booking_training_Company_ID": "Company ID (Soldto)*",
    "text_booking_training_Role_Industry": "Role in Industry*",
    "text_booking_training_Address2": "Address 2 (e.g. unit,floor,house,name)",
    "text_booking_training_VAT": "VAT ID",
    "text_booking_training_VAT_lite_user": "VAT ID*",
    "text_booking_training_Last_Name_Contact_Person": "Last Name (Contact Person)*",
    "text_booking_training_First_Name_Contact_Person": "First Name (Contact Person)*",
    "text_booking_training_Add_Participants_Information": "Edit Participants Information",
    "text_booking_training_Last_Name_Participant": "Last Name (Participant)*",
    "text_booking_training_First_Name_Participant": "First Name (Participant)*",
    "text_booking_training_Email_Address": "Email-Address*",
    "text_booking_training_dateofbirth": "Date Of Birth*",
    "text_booking_training_Bill_Participant": "Bill Participant?",
    "text_booking_training_Knorr_Bremse_Participant": "Knorr-Bremse Participant?",
    "text_booking_training_book_training_now": "Book your Training now",
    "text_booking_training_select_course_date": "Selected Course Date",
    "text_booking_training_add_another_participant": "Add another participant",
    "text_booking_training_review": "Review",
    "text_booking_training_Participant_review": "Save + Close",
    "text_booking_training_Participant": "Participant",
    "text_booking_training_successfull": "Successfully booked.",
    "text_booking_training_failed_noseats": "No Seats Available.",
    "text_booking_training_confirmation_header1": "Thank you for Booking your Training!",
    "text_booking_training_confirmation_header2": "Your booked training with the booking no. {0} was submitted successfully.",
    "text_booking_training_confirmation_header3": "You will receive an email confirmation with all details of your booked training.",
    "text_booking_training_confirmation_back_to_homepage": "Back to Homepage",
    "text_edit_training_participant": "Successfully Updated.",
    "text_category_training_header": "TECHNICAL TRAININGS OFFERED BY KNORR-BREMSE TRUCKSERVICES",
    "#text_category_training_view_training_button": "Show Registration Detail",
    "text_training_detail_info": "Training Information",
    "text_training_detail_description": "Description of Training",
    "text_training_detail_shortDescription": "Short description of Training content",
    "text_training_detail_prerequisites": "Prerequisites",
    "text_training_detail_targetgroup": "Target group",
    "text_training_detail_content": "Content",
    "text_training_detail_goals": "Goals",
    "text_training_detail_notes": "Notes",
    "breadcrumb_my_training_text": "My Trainings",
    "text_account_training_emptyTrainings": "No Training(s) Found",
    "text_booking_training_successfull_approved": "Training request has been approved",
    "text_booking_training_successfull_decline": "Training request has been declined",
    "text_account_training_registration_totalResults": "{0} Training Registration(s) Found",
    "text_account_training_registration_totalResultsSinglePag": "{0} Training Registration(s) Found",
    "text_account_training_registration_totalResultsSingleOrder": "1 Training Registration Found",
    "text_account_training_registration_totalResultsCurrPage": "{0} of {1} Training Registration Found",
    "basket_error_kb_training_admin_missing": "Cannot access the requested url ,as login customer does not belongs to KB training admin group",
    "basket_error_distributor_training_admin_missing": "Cannot access the requested url ,as login customer does not belongs to distributor training admin group",
    "text_training_Last_Name_participant": "Last Name participant",
    "text_training_Last_Name_contactperson": "Last Name contact person",
    "text_training_Company_Name_participant": "Company Name participant",
    "text_training_Company_Name_contactperson": "Company Name contact person",
    "#text_training_Company_Number_SoldTo_Contact": "Company Number (Sold-To Number) contact person",
    "text_training_participants_page_totalResults": "{0} Participants Found",
    "text_approve_back_btn": "Approve",
    "text_no_result_found": "No result found",
    "text_training_error_msg": "Please check all your entries on this form. After submission no further changes can be made to the return request.",
    "text_msg1": "Yes",
    "text_msg2": "No",
    "text_training_history_heading": "My Training History",
    "text_account_warranty_table_header_dsiplay_claim_number": "You can open this submitted claim in a PDF format or open this submitted claim in a new template to create a new claim.",
    "text_account_warranty_table_header_dsiplay_claim_number_content": "The new claim will contain the same vehicle information as the original claim - Please confirm VIN and application information is correct before submitting",
    "text_account_warranty_table_header_dsiplay_claim_number_button_pdf": "Open Claim as PDF",
    "text_account_warranty_table_header_dsiplay_claim_number_button_template": "Open Claim as a new Template",
    "text_ADB_applicationNum": "Brake Application Number",
    "text_ADB_controlNumber": "Customers Control Number",
    "text_ADB_controlNumber_internal_tooltext": "If you have an internal control number, project number, or application number",
    "text_ADB_axleManufacturer": "Axle Manufacturer*",
    "text_ADB_oem": "OEM*",
    "vehicleModel_code_value": "Vehicle Model*",
    "text_ADB_vehicleType": "Vehicle Type*",
    "text_ADB_chassisNumber": "Chassis Number*",
    "text_ADB_chassisNumber_tooltext": "You may enter multiple chassis numbers if the specifications for each chassis are the same as what is indicated on this form.",
    "text_ADB_axleConfig": "Axle Configuration*",
    "text_ADB_vocation": "Vocation*",
    "text_ADB_GAWR_Front": "GAWR Front",
    "text_ADB_GAWR_Forward": "GAWR Forward Rear",
    "text_ADB_GAWR_Pusher": "GAWR Pusher",
    "text_ADB_GAWR_Rear": "GAWR Rear Rear",
    "text_ADB_GAWR_Tag": "GAWR Tag/Auxillary",
    "text_ADB_Auxiliary_Axle": "Auxiliary Axle",
    "text_ADB_GAWR_Mid_Rear": "GAWR Mid Rear",
    "text_ADB_ADDITIONAL_AXLE": "Additional Axle GAWR",
    "text_ADB_Additional_Axle_Cust": "Additional Customer Axle Weight Limitation",
    "text_ADB_tire_Type": "Tire Type",
    "text_ADB_tire_TypeSLR": "Tire SLR",
    "text_ADB_gvwr": "GVWR*",
    "text_ADB_wheelBaseRange": "Wheelbase Range*",
    "text_ADB_frontTires": "Front Tires*",
    "text_ADB_frontTiresSLR": "Front Tires SLR*",
    "text_ADB_rearTire": "Rear Tire*",
    "text_ADB_wheelBase": "Rear Tires SLR*",
    "text_ADB_cgHeightLaden": "CG Height (Laden)*",
    "text_ADB_cgHeightUnladen": "CG Height (Unladen)*",
    "text_ADB_proposed_FR": "Proposed Front",
    "text_ADB_proposed_FM": "Proposed Forward Rear",
    "text_ADB_proposed_SAB": "Proposed Mild Rear",
    "text_ADB_proposed_DAB": "Proposed Rear Rear",
    "text_ADB_proposed_Pusher": "Proposed Pusher",
    "text_ADB_proposed_Tag": "Proposed Tag/Auxiliary",
    "text_ADB_proposed_AuxilaryAxle": "Proposed Auxiliary Axle",
    "text_ADB_Comments": "General Comments",
    "#text_ADB_Commentsandattachments": "Comments and Attachments",
    "text_ADB_register_company_phoneNumber": "Phone Number",
    "account_adb_breadcrumbs": "Visit My Page",
    "text_ADB_please_note": "Please Note:",
    "text_ADB_customer_information": "Customer Information",
    "text_ADB_vehicle_information": "Vehicle Information:",
    "text_ADB_axle_gawr": "Axle GAWR:",
    "text_ADB_add_an_aditional_axl_gawr": "Add an Additional Axle GAWR:",
    "text_ADB_customer_axle_weight_limitation": "Customer Axle Weight Limitation:",
    "text_ADB_add_aditional_customer_axle_weight_limitation": "Add Additional Customer Axle Weight Limitation:",
    "text_ADB_add_aditional_customer_tire_type": "TIRE TYPE",
    "text_ADB_tire_statically_loaded_radius": "Tire Statically Loaded Radius (SLR)",
    "text_ADB_vehicle_specification": "Vehicle Specification",
    "text_ADB_proposed_tag_axle": "Proposed Tag Axle / Auxiliary Axle Brake",
    "Bendix_break_application": "Brake Application Request Form",
    "text_ADB_add_axel": "Add Axle",
    "text_ADB_add_axel_cutomer": "Add Axle Customer",
    "text_ADB_tire_type": "Add Tire Type",
    "text_ADB_add_tire_slr": "Add Tire SLR",
    "text_break_submission_NA_text1": "Thank you for submitting your Brake Application Form. Click <a href='/bendixADBSearchPage' style='text-decoration: underline'> here</a> to search for a status of your Brake Application Form.",
    "text_break_submission_NA_text2": "Thank you for saving your Brake Application Form. Click <a href='/bendixADBSearchPage' style='text-decoration: underline'><u> here</u></a> when you are ready to continue your application.",
    "text_brakeform_submit_review_carefully": "Your form has been checked for completeness and is ready to be submitted. Click the Submit button to <u>submit</u> your application.",
    "Bendix_break_application_msg1": "Bendix offers customers a Brake Application Request Form for Air Disc, Drum, and Hybrid (Disc/Drum) brakes that can be sized to your vehicle.",
    "Bendix_break_application_msg2": "All fields marked with an asterisk (*) are mandatory.",
    "Bendix_break_application_msg3": "You have the ability to complete and submit your form or save it for later.",
    "Bendix_break_application_msg4": "For additional information, please review the",
    "text_generalInfo_submitdate": "Creation Date",
    "text_core_search_appNumber": "Brake Application No.",
    "text_headline_status": "Status",
    "text_bendix_search_text1": "Bendix offers customers the ability to search Brake Application Request Form status online.",
    "text_bendix_search_text2": "To see all Brake Application Requests submitted under the selected customer ID, check the box \"Show Brake Application requests from coworkers\".",
    "text_bendix_search_point1": "For Saved (Not Submitted) applications, click on the Brake Application number to edit your form",
    "text_bendix_search_point2": "If the status reads \"Input Required\" additional information is needed from you to process your request",
    "text_bendix_search_point3": "If attachments are included in your application, they will be available in a PDF format",
    "text_bendix_search_text3": "Brake Application Form Search",
    "text_bendix_search_text4": "Core Return Search Form",
    "text_bendix_search_text5": "Customers can search their core returns online. All core returns submitted by any user linked to the selected Customer ID will be visible in the search results.",
    "text_ADB_rearTires": "Rear Tires*",
    "text_adb_submission_review_text": "Please review your form prior to submitting.",
    "adb_register_lastName": "Last Name",
    "bendix_foundation_brake_application": "Bendix Brake Applications Requests",
    "text_bendix_foundation_brake": "Bendix offers customers a Brake Application Request Form for Air Disc, Drum, and Hybrid (Disc/Drum) brakes that can be sized to your vehicle.",
    "text_message1": "You must",
    "text_message2": "Sign in",
    "text_meassage3": "to your account to access the following links:",
    "text_application_search": "Brake Application Search",
    "addtional_comment_enginnering_admin": "Additional Recommendations by Engineering Team",
    "text_compare_products": "Compare Products",
    "text_compare_part_number": "You can compare up to 4 part numbers",
    "text_product_image": "Product Image",
    "text_part_number": "Part Number",
    "text_type_number": "Type Number",
    "text_description": "Description",
    "text_add_button": "ADD",
    "text_sales_status": "Sales Status",
    "text_aftermarket_part_number": "Aftermarket part number",
    "text_market": "Market",
    "text_core_group": "Core Group",
    "text_core_class": "Core Class",
    "text_Packaging": "Packaging",
    "text_back_to_result_button": "Back to Result",
    "text_training_request_table_search": "Search",
    "text_training_request_table_training": "Training",
    "text_training_request_table_submissiondate": "Submission Date",
    "text_training_request_table_location": "Location",
    "text_training_request_table_startdate": "Training Start Date",
    "text_training_request_table_enddate": "Training End Date",
    "text_training_request_table_contactperson": "Contact Person Name",
    "text_training_request_table_companyname": "Contact Person Company Name",
    "text_training_request_table_participantname": "Participant Name",
    "text_training_request_table_participantcompanyname": "Participant Company Name",
    "text_training_request_table_approval": "Approval",
    "text_training_request_table_ExportMyData": "Export My Data",
    "text_training_request_table_Reset": "Reset",
    "text_training_request_table_Registration": "Registration ID",
    "text_training_request_table_search1": "Search",
    "#text_training_request_table_search_distributor": "Training Distributor Search",
    "text_training_request_table_myParticipants": "My Participants",
    "text_training_request_table_searchterm": "Search Term",
    "text_training_request_table_trainingRegistration": "Training Registration",
    "text_account_return_request_lable": "Return Request Form",
    "text_account_warranty_table_header_inspection_report1": "Inspection",
    "text_account_warranty_table_header_inspection_report2": "Report",
    "text_pdf_download_error": "PDF download failed.",
    "text_account_warrenty_search_content": "Bendix offers customers the ability to search warranty claims on-line. You can search for your warranty cliam using several different search criteria. Please note that Customer ID and filing date are required fields.",
    "text_return_request_heading": "Return Request Form",
    "text_return_request_po_number": "PO Number*",
    "text_return_request_return_type": "Return Type*",
    "text_warranty_submit_kb_return_request_number": "Return Request Number",
    "type_B2BCustomerAccessRequestEnum_CORE_REPORTS_name_oem": "Core Submission / Reports",
    "type_B2BCustomerAccessRequestEnum_CORE_REPORTS_name": "Core Reports / Core Return Submissions",
    "text_training_Company_Name_training_admin_true": "Training short Code",
    "text_training_Company_Name_training_admin_false": "Training Name",
    "text_training_Company_Name_trainingBookingCode": "Training Registration ID",
    "text_training_Company_Name_countryISO": "Country of Training",
    "training_selectCountry": "Please select a country/region",
    "text_cart_popup_tag": "Scale/Promotion prices click to view",
    "text_cart_popup_tag_new": "Click here for pricing information",
    "text_cart_popup_tag_msg_title": "Scale/Promotion Price",
    "text_cart_popup_tag_msg_title_new": "Pricing Information",
    "text_cart_popup_tag_msg_content": "The following part",
    "text_cart_popup_tag_msg_content2": "currently has a promotion price from",
    "text_cart_popup_tag_msg_content3": "to",
    "text_cart_popup_tag_msg_content1": "The following part",
    "text_cart_popup_tag_msg": "has scale pricing (price is shown per piece)",
    "text_cart_popup_tag_datemsg": "This promotion runs from {0} until {1}",
    "text_scale_price": "Scale pricing for",
    "text_scale_price_to": " to ",
    "text_scale_price_or": " or",
    "text_scale_price_more": ">",
    "text_scale_price_per_piece": "{0} per pc",
    "adb_approvalType_INREVIEW": "Engineering Review",
    "adb_approvalType_RECEIVED": "Engineering Approved",
    "adb_approvalType_AWAITING": "Input Required",
    "adb_approvalType_REJECTED": "Rejected",
    "adb_approvalType_SAVED": "Saved (Not Submitted)",
    "text_booking_training_Company_ID2": "Customer ID*",
    "text_training_request_table_search_distributor": "Training Search",
    "text_attachment_download_error": "Attachment download failed.",
    "text_ADB_brakeType": "Brake Type*",
    "text_ADB_approvalType": "Approval Type",
    "text_category_training_view_training_button": "Show Training Detail",
    "text_training_Company_Number_SoldTo_Contact": "Knorr-Bremse customer number (sold-to) contact person",
    "text_software_download_content1": "For support with the installation of the software, please contact our technical support:",
    "text_software_download_content2": "e-Mail:",
    "text_software_download_content3": "00800 1905 2222 (calls are free of charge from German landlines, charges may vary for calls from mobile phones.)",
    "text_software_download_header": "Software Download",
    "text_solr_data_document_asc": "Document Description Ascending",
    "text_solr_data_document_dsc": "Document Description Descending",
    "text_solr_data_docuemnt_type_asc": "Document Type Ascending",
    "text_solr_data_docuemnt_type_dsc": "Document Type Descending",
    "text_solr_data_docuemnt_number_asc": "Document Number Ascending",
    "text_solr_data_docuemnt_number_dsc": "Document Number Descending",
    "text_solr_data_docuemnt_file_asc": "Document File Size Ascending",
    "text_solr_data_docuemnt_file_dsc": "Document File Size Descending",
    "text_solr_data_docuemnt_revision_asc": "Document Revision Ascending",
    "text_solr_data_docuemnt_revision_dsc": "Document Revision Descending",
    "text_solr_data_training_name_asc": "Training Name Ascending",
    "text_solr_data_training_name_dsc": "Training Name Descending",
    "text_solr_data_training_code_asc": "Training Code Ascending",
    "text_solr_data_training_code_dsc": "Training Code Descending",
    "text_solr_data_software_title_asc": "Software Title Ascending",
    "text_solr_data_software_title_dsc": "Software Title Descending",
    "text_solr_data_software_description_asc": "Software Description Ascending",
    "text_solr_data_software_description_dsc": "Software Description Descending",
    "text_solr_data_software_language_asc": "Software Language Ascending",
    "text_solr_data_software_language_dsc": "Software Language Descending",
    "text_search_training_date_from": "Training Date From",
    "text_search_training_date_to": "Training Date to",
    "text_training_redirection_message": "Technical trainings are not offered in {0} language. To get information on technical trainings in {1} please select the language {2}.",
    "text_training_redirection_or": "or",
    "text_booking_training_new_participants": "Participants",
    "training_header_description": "With our training courses, we accompany you as always during training and further education, prepare you for the repair and replacement of the proven Knorr-Bremse products and also train you in the use of new technologies.",
    "checkout_summary_adb_save": "SAVE",
    "kb_search_result_breadcrumb": "results for",
    "checkout_summary_adb_saveFL": "Save For Later",
    "text_generalInfo_id": "Brake Application NO.",
    "text_generalInfo_customerid": "Customer",
    "text_generalInfo_comments": "Comments",
    "text_warranty_submit_customer_id": "Customer ID",
    "document_notification_input_email": "Email for Subscription",
    "text_request_search_bendix_adb_number": "Brake Application Number",
    "text_favorite_to_add": "Add to favorites",
    "text_favorite_added": "Added to favorites",
    "training_details_price_not_available": "POA",
    "text_cart_popup_tag_per": "{0} per",
    "text_cart_popup_tag_unit_iso": "PCE",
    "text_account_supporttickets_invalid_format": "Note: word, xls, xlsx, csv, txt, tif, gif, jpg, pdf files are allowed!",
    "basket_page_cartId_message": "There are Scale/Promotional prices available for some items in your cart - Click to view",
    "basket_page_cartId_message_new": "Click on the tag icon to view additional pricing information for some items in your cart",
    "text_cart_popup_tag_unit_piece": "PCE",
    "homepage_teaser_name_techTrainingEmea": "Technical Training",
    "date_format_capital": "({0})*",
    "breadcrumb_steeringGear_text": "Bendix® Remanufactured Steering Gear Search by Application",
    "breadcrumb_formulaBlue_text": "Formula Blue® Part Search by Application",
    "no_report_file_to_download": "No Report Files to Download.",
    "myReport_page_text_download_your_report": "Download your report",
    "text_smartire_us_mpg": "US MPG",
    "text_contactusform_submission_success": "Form Submitted Successfully.",
    "text_contactusform_submission_error": "Please correct the below errors.",
    "text_contactusform_submission_failed": "Something went wrong. Please try again later.",
    "text_contactusform_page_title": "Contact us!",
    "account_confirmation_address_added": "Address created successfully",
    "text_account_table_header_kbnumber": "Part Number",
    "search_mobile_page_searchText": "You searched for",
    "text_account_table_header_poNumber": "PO Number",
    "address_postcode": "Post Code",
    "header_quick_order": "QUICK\n ORDER",
    "checkout_deliveryMethod_notSelected": "Please select a method of delivery for your order",
    "search_page_totalResults": "Item(s) Found",
    "account_confirmation_address_updated": "Address updated successfully",
    "text_account_saveCart_edit_success": "Cart was successfully updated",
    "address_country": "Country",
    "text_Show_orders_of_coworkers": "Show orders from coworkers",
    "text_account_profile_updatePasswordForm": "Password",
    "text_spe_Certificate_nach_label": "Confirmation Â§ 29 StVZO",
    "register_submit": "Register",
    "text_account_customerPONumber": "PO Number",
    "address_title_pleaseSelect": "title",
    "header_welcome": "Welcome",
    "text_company_manageUser_registration_totalResults": "New Request(s) found",
    "account_confirmation_address_removed": "Address removed successfully",
    "address_townCity": "City",
    "address_selectCountry": "Country",
    "register_description": "For a fast checkout, easy access to previous orders, and the ability to create an address book and store settings. Register below.",
    "text_account_kbpartNumber": "KB part number",
    "text_account_OrderDateTo": "Order Date:To",
    "header_link_login": "Sign in / Register",
    "text_account_OrderDate": "Order Date:From",
    "text_account_table_header_type": "Type",
    "text_account_table_header_itemRef": "Item ref no. (item)",
    "text_total_gross_weight_warning_EMEA": "Warning: Â this shipment does not meet the minimum weight requirement of 400KG, either add more old units or restrict underweight shipments to a maximum of once per month.",
    "text_warranty_submit_email": "Email*",
    "homepage_teaser_name_EconX": "EconXÂ®",
    "homepage_teaser_name_EconXElefant": "EconXÂ® Calipers",
    "no_price_file_to_download": "No Price File to Download.RÃ©fÃ©rence",
    "text_account_warranty_table_header_decision_france": "RefusÃ©e",
    "text_adb_admin_edit_partNumber": "Part Number",
    "text_adb_admin_edit_additionComments": "Additional Comments",
    "rhs_select_vehicle_gear_number_text": "Please select your vehicle make and enter the full 8-character serial number before the dash (-) as shown below without any spaces or the â-Câ at the end.",
    "rhs_search_form_error_not_found": "Steering Gear serial number : Not Found <br><br>Check serial carefully and re-enter the serial number_Â  If still not found, please contact Sheppard at <a href",
    "rhs_search_form_success_status_release": "Steering Gear serial number : GoodÂ <br><br>Vehicle can be returned to service with no further remedy action",
    "text_rememberMe_cookie": "Please consent to functional cookies to âRemember my log-inâ. You may change your cookie settings",
    "text_Show_warranty_of_coworkers": "Show warranty claims from co-workers",
    "vizseek_search_Invalid_text3": "or",
    "contacUS_required": "Required",
    "contactUS_select_your_country": "Select Your Country",
    "value_calculator_header": "EnduraSureÂ®-Pro Savings Summary",
    "value_calculator_enduraSure_summary": "EnduraSureÂ®-Pro Summary",
    "value_calculator_enduraSure_perTractor": "Upcharge for EnduraSureÂ®-Pro per Tractor",
    "value_calculator_enduraSure_perTractor_desc": "Estimated upcharge for EnduraSureÂ®-Pro on tractor over current option. Cost can range from $50 to $150 per new tractor.",
    "value_calculator_enduraSure_perTrailer": "Upcharge for EnduraSureÂ®-Pro per Trailer",
    "value_calculator_enduraSure_perTrailer_desc": "Estimated upcharge for EnduraSureÂ®-Pro on trailer over current option. Cost can range from $50 to $150 per new trailer.",
    "value_calculator_proEmail_summary": "EnduraSureÂ®-Pro Email Summary",
    "value_cal_landingPage_textMsg": "Find out how much you can save when you choose BendixÂ® Air Disc Brakes, EnduraSureÂ®-Pro Spring Brakes and SmarTireÂ® Tire Pressure Monitoring System by Bendix CVS. Check out our easy-to-use value calculators.",
    "endurasure_procalculator_title": "EnduraSureÂ®-Pro",
    "text_warranty_submit_datein_service_invalid_future": "Date put in service can't be in future date.",
    "text_warranty_submit_date_removed_service_invalid_future": "Date removed from service can't be in future date.",
    "text_account_openPosition_page_totalResults": "{0} Open Position(s) Found ",
    "text_account_openPosition_page_totalResultsSinglePag": "{0} Open Position(s) Found ",
    "lastFive": "Your password has already been updated.",
    "register_data-protection": "Data Protection Declaration",
    "loginTitle": "Returning Customer",
    "loginsubTitle": "Please Sign-in",
    "loginremembermecheck": "Remember my log-in",
    "forgotPassword": "Forgot your password?",
    "userlogin": "Login",
    "loginpara": "Register with Bendix and get product availability, pricing, order information, and much more!",
    "loginNewUser": "New User?",
    "loginregisterBtn": "Register",
    "text_account_table_header_order": "Bendix Order Number",
    "text_warranty_submit_date_removed_invalid": "Date Removed from Service can't be less than the Date In Service.",
    "header_link_login": "Sign In",
    "text_account_warranty_table_header_display_creditmemo_popup_content": "Please contact your corporate offices for payment details. All warranty payments are issued to ",
    "text_quick_order_form": "Quick order form",
    "text_import_order": "Import order",
    "text_company_approvers_page_showPageResults": "Show paginated ",
    "checkout_product_not_purchasable": "Unfortunately Part number {0} is no longer purchasable, please remove this product before proceeding to checkout",
    "text_core_search_heading": "If you are unsure of the material number or core group enter the known information below in the appropriate field. The provided information is of help to correctly fill in the Core Return Request and to manage your Cores accordingly.",
    "checkout_summary_paymentMethod_savedCards_paymentCard": "Payment Card",
    "basket_add_to_cart": "Add",
    "text_software_group_download_heading": "Software Group",
    "text_software_download_heading": "Software Type",
    "text_software_download_heading2": "Software Package Type",
    "text_account_order_tracking": "Tracking Number",
    "text_account_order_tracking_ID": "Tracking ID",
    "basket_save_cart_action_save": "Save",
    "quote_save": "Save Quote",
    "checkout_orderConfirmation_order_note": "Order Note:",
    "guest_register_submit": "Register",
    "basket_save_cart_validation_description_size": "Cart description cannot be more than 255 characters",
    "guest_checkout_existingaccount_register_error": "An account with email id {0} already exists.",
    "storelocator_dealer": "Dealers",
    "text_warranty_search_to_date_invalid": "Claim Date To can't be less than the Claim Date From.",
    "text_warranty_search_from_date_invalid_equal": "Claim Date can't be equal.",
    "basket_information_quantity_adjusted": "Your items have been modified to match available stock levels",
    "pickup_in_stock": "{0} IN STOCK",
    "text_account_quote_status_display_SELLER_SUBMITTED": "Submitted",
    "checkout_page_DeliveryMethodForOrder_NA_orderNote": "Enter order notes: <br />(Please enter zip/postal code below linked to the carrier account number provided)",
    "aria_pickupinstore_storesloaded": "Stores loaded",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_firstName": "This value is invalid for this field",
    "text_button_save": "Save Address",
    "address_companyName_invalid": "Please enter company name",
    "text_account_warranty_table_header_decision_refused": "Refused",
    "checkout_error_paymentethod_formentry_sop_missing_card_expirationYear": "Please enter an expiry year",
    "text_select_you_path_upload": "Path of the file to upload:",
    "text_reports_detailEmea": "Each line item transaction",
    "checkout_summary_deliveryMode_useThisDeliveryMethod": "Use this delivery method",
    "user_request_approval": "Request Approval",
    "mycompany_click_locked_user": "Locked User -Click to Activate User",
    "payment_issueNumber_toolong": "The issue number is too long.",
    "text_generalInfo_packaging": "Packaging",
    "text_currency": "Select Currency",
    "text_quote_yes_button_label": "Yes",
    "text_swithToMobileStore": "Switch back to mobile",
    "storeDetails_table_telephone": "Telephone",
    "text_account_consent_template_notFound": "Consent template not found",
    "text_headertext": "Confirm",
    "text_account_myPart_updatePersonalDetails": "My Own Part Numbers",
    "checkout_summary_paymentMethod_addPaymentDetails_enterYourCardDetails": "Please enter your card details for payment",
    "pdp_page_add_to_cart": "Add to Cart",
    "text_account_orderDetails_backToOrderHistory": "Back To order history",
    "search_nav_facetShowMore_price": "more prices...",
    "basket_page_totals_total_items_one": "{0} ITEM",
    "mobile_storelocator_title": "Store Locator",
    "text_paymentcard_remove_confirm": "Are you sure you want to delete this payment card?",
    "text_account_warranty_table_header_core_value": "Core Value",
    "checkout_summary_placeOrder_wrongDateFormatMessage": "Date format must be {0}.",
    "guest_description": "Prefer to shop without creating an account? <br />It's quick and simple!",
    "text_quote_discount_by_percentage": "Discount by Percentage",
    "mobile_search_nav_facetValueCount": "{0}",
    "coupon_already_exists_cart": "A coupon of the same campaign has already been applied to the cart.",
    "order_history_order_number": "Order #:",
    "text_reports_download": "Download Report",
    "checkout_multi_deliveryAddress_remove": "Remove",
    "basket_save_cart_on_success": "Cart {0} was successfully saved",
    "text_actions": "Actions",
    "text_warranty_submit_date": "Date",
    "checkout_summary_paymentMethod_addPaymentDetails_useThesePaymentDetails": "Use these payment details",
    "basket_page_totals_netTax": "Tax:",
    "import_csv_savedCart_requestedDateEmea": "Optional : Requested delivery date (format {0})",
    "checkout_page_DeliveryMethodForOrder_EMEA_orderNote": "Order Note",
    "address_prefecture_invalid": "Please select a prefecture",
    "address_line2_shipping_page_form": "Address line 2",
    "text_account_savedCarts_page_showPageResults": "Show paginated",
    "text_account_order_yourOrder": "Your Order",
    "text_storefinder_desktop_page_totalResults": "{0} Stores found",
    "text_account_consent_already_withdrawn": "Consent is already withdrawn",
    "netPrice_check": "Net Price",
    "storeFinder_line_text": "or",
    "text_reports_detailNa": "Line item transactions",
    "text_core_search_finder": "Core Group Finder",
    "text_account_order_back_btn": "Back",
    "product_share_share": "Share",
    "login_password": "Password*",
    "checkout_page_back_to_cart": "Back to Cart",
    "text_warranty_terms_highway_applications": "These applications have normal frequency braking duty cycles and operate primarily on hard surface roadways.",
    "search_nav_applied_facets_emea": "Applied Filters",
    "basket_export_user_orders": "Orders",
    "text_Shipping_Packaging_content1": "For all questions email",
    "text_Shipping_Packaging_content2": "Please provide your account number along with core return number.",
    "basket_export_user_preferredEmailLanguage": "Preferred Email Language",
    "password_strength_verystrong": "Very strong",
    "text_storefinder_mobile_page_linkNextPage": "Next &raquo;",
    "text_account_consent_notFound": "Consent not found",
    "text_core_search_partnum": "Bendix Part Number",
    "text_account_orderHistory_page_sort_byCodeDesc": "Order No-Desc",
    "text_account_coworker_orders": "Show Co-Workers Information",
    "basket_page_itemNumber": "Item no.",
    "account_confirmation_address_added": "Your address was created.",
    "basket_export_user_country": "Country",
    "text_core_submission_pleaseNote": "Please Note",
    "text_account_quote_action_display_ORDER": "Order Quote",
    "text_page_message_underconstruction": "<strong>Information:</strong>  Page Under Construction - Not Completely Functional",
    "text_quickOrder_page_total": "Total",
    "text_quickOrder_page_total_EMEA": "Total Weight (GROSS)",
    "text_account_order_total_includesTax": "Total includes {0} in taxes",
    "cart_product_deleteall": "Do you want to delete all selected items?",
    "checkout_multi_address_added": "Your address was created.",
    "text_emergencyOrder_withoutstock_message1": "The requested quantity for",
    "text_emergencyOrder_withoutstock_message2": "part no.",
    "text_emergencyOrder_withoutstock_message3": "is not fully available.",
    "text_emergencyOrder_withoutstock_message4": "Therefore, the selected order type",
    "text_emergencyOrder_withoutstock_message5": "will not be shipped today.",
    "address_selectPrefecture": "Prefecture",
    "checkout_summary_deliveryAddress_saveAndUseThisAddress": "Save and use this address",
    "text_account_quote_active": "Effectiveness",
    "text_warranty_submit_primary_complaint": "Primary Complaint*",
    "text_headline_search": "Here you can search for products",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_phoneNumber": "Please enter a value for this field",
    "text_account_order_order": "Order",
    "inverse_check": "Xref",
    "register_company_address_two_invalid": "Please enter the second company address",
    "text_account_myPart_success_uploded": "All part numbers have been successfully uploaded.",
    "address_lastName_invalid": "Please enter a last name",
    "general_zoom": "Enlarged view of picture",
    "open_qty": "Open Qty**",
    "system_error_link_expired_title": "The link you are trying to access has expired. Please contact your customer service team",
    "basket_restoration": "Welcome back {0}. Some items from your previous shopping cart have been restored to your current shopping cart.",
    "checkout_summary_deliveryAddress_saveAddressInMyAddressBook": "Save Shipping Address",
    "text_core_submit_emailAddress_invalid": "Please Enter Valid Email",
    "basket_page_totals_error_wrongzipcode": "Please enter a valid zip code",
    "text_account_table_header_kbnumber": "KnorrBremse Order Number",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_postalCode": "This value is invalid for this field",
    "cart_product_deletealltext": "Do you want to delete the selected items?",
    "text_deliveryMethod": "Delivery Method",
    "product_product_salesStatus": "Product Status",
    "text_storefinder_desktop_page_linkNextPage": "Next",
    "text_warranty_submit_recall_type": "Recall Type*",
    "core_report_coreparent": "Please Select Core Parent",
    "quote_requote_error": "Error requoting.",
    "core_error_reports_emea": "You do not have permission, please <a href",
    "storeFinder_table_view_map": "View map",
    "order_history_billing_address": "Billing Address",
    "text_account_orderHistory_page_linkNextPage": "Next Page",
    "cart_page_deliverydate": "Delivery Date",
    "basket_page_totals_total": "Total",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_city": "Please enter a value for this field",
    "login_link_forgottenPwd": "Forgot your password?",
    "cart_total_poa_EMEA": "Price on Request = we were unable to show a price at this time. However, you can continue with your order.<p>If you need additional assistance, please contact your  <a target='_blank' href='https://truckservices.knorr-bremse.com/about-us/contacts'>local Knorr-Bremse customer service.</a></p>",
    "text_headline_bottombanner": "Bottom Banner",
    "import_csv_savedCart_fileCSVRequired": "Imported file must be a text file with CSV extension.",
    "checkout_orderConfirmation_orderStatus": "Order Status : {0}",
    "checkout_multi_hostedOrderPostPage_header_wait": "Please wait while we transfer you",
    "mobile_checkout_continue_button": "Continue",
    "checkout_checkout_single": "Checkout Single",
    "core_report_NA_description": "Core reports are published online at the beginning of every month for previous month activity.",
    "product_grid_expand": "Expand",
    "text_product": "Product",
    "search_nav_done_button": "Done",
    "text_quote_not_cancelable": "Quote {0} is not cancelable",
    "text_account_addressBook_addAddress_label": "Add Address for Emergency orders",
    "text_consent_disclaimer": "download disclaimer",
    "quote_create_success": "Quote created with success.",
    "import_csv_savedCart_uploadFile": "Please keep to the order template format if you create your own upload file in your ERP",
    "text_account_close": "Close Account",
    "warranty_eligibility_check_date_removed_from_service": "Date Removed from Service",
    "text_warranty_document_claim_refund": "If you claim a refund you need to upload a proof of the expenses; claims without proff will be rejeced.",
    "payment_nameOnCard_invalid": "Please enter name on the card",
    "text_account_warranty_table_header_credit_amount": "Credit Amount (USD)",
    "price_here_download_files": "Here you can download your price files",
    "basket_page_change_configuration": "Change configuration",
    "text_account_orderHistory_emptyOrderHistory": "No Order(s) Found",
    "basket_export_user_title": "Title",
    "text_core_search_CR": "CR#",
    "text_core_search_CustomerCR": "Customer Reference#",
    "text_core_search_CRStatus": "CR Status",
    "text_core_search_CreationDate": "Creation Date",
    "text_core_search_CoreReturnMonth": "Core Return Month",
    "text_core_search_BOLStatus": "Shipment Number",
    "text_core_search_BOLPDF": "BOL PDF",
    "text_core_search_savedReturn": "Saved (Not Submitted)",
    "text_core_search_noSavedReturn": "SUBMITTED",
    "popup_cart_title": "Your Shopping Cart",
    "text_account_quote_status_display_SELLER_REQUEST": "Requested",
    "address_line1_invalid": "Please enter address Line 1",
    "checkout_multi_deliveryAddress_editAddress": "Edit address",
    "import_csv_savedCart_import": "Import",
    "text_quote_comments_label": "Comments",
    "checkout_error_authorization_failed": "We are sorry but your transaction could not be completed at this time; please try again later or contact customer service at 555-555-5555",
    "text_storefinder_responsive_page_showAllResults": "Show all",
    "text_account_saved_cart_detail_list_price": "List Price",
    "product_view_details_name": "Part description",
    "checkout_express_error_deliveryAddress": "Express checkout is not available since you do not have a default delivery address. Please set a default delivery address in your account to use Express Checkout next time.",
    "checkout_summary_reviewYourOrder": "Final Review",
    "#password_strength_minchartext": "Minimum length is %d characters",
    "text_account_order_orderDetails_orderNumber": "Order # {0}",
    "text_storefinder_desktop_page_firstPage": "&laquo;",
    "productsalesstatus_label_apac_code20": "Non saleable to the IAM",
    "type_KbEcomDocument_products_name": "Products",
    "FAQ_label_Account": "Account",
    "FAQ_label_Core": "Core",
    "FAQ_label_Warranty": "Warranty",
    "FAQ_label_Order": "Order",
    "FAQ_label_Training": "Training",
    "FAQ_label_Products": "Products",
    "FAQ_label_Other": "Others",
    "text_warranty_submit_part_information": "Part Information Number",
    "register_checkPwd_invalid": "Please confirm your password",
    "checkout_multi_deliveryMethod_stepHeader": "2 - Select Delivery Method",
    "text_warranty_submit_types_operation": "Type of Operation*",
    "checkout_orderConfirmation_Order_ID": "Order No:",
    "checkout_error_paymentethod_formentry_sop_invalid_card_accountNumber": "The card number is not valid",
    "checkout_pickup_estimated_total": "Estimated Total:",
    "review_based_on": "({0})",
    "text_account_quote_action_display_EXPIRED": "Expired",
    "register_company_accessRequesting_invalid": "Please choose at least one access",
    "text_account_core_search_showAllResults": "Show All",
    "text_account_core_table_header_model": "Type Number",
    "register_email_mandatory": "Company Email Address*",
    "storelocator_error_no_results_title": "No store results were found for your search criteria.",
    "text_account_warranty_table_header_model": "Model",
    "payment_month": "Month",
    "text_core_submit_address_addressCompany": "Company*",
    "search_back_to_product_list": "Back to product list",
    "text_account_order_status_display_open": "Open",
    "checkout_multi_deliveryAddress_noExistingAddresses": "You don't have any addresses in your address book.",
    "checkout_summary_paymentMethod_securityCode_whatIsThis": "(What is this?)",
    "text_account_closeAccount_popup_title": "Confirm Account Closure",
    "order_history_shipping_address": "Shipping Address",
    "text_core_submission_headerNA_text3": "page.",
    "mobile_checkout_confirmOrder": "Final Review",
    "text_core_submission_pkgQty": "Package Qty",
    "text_core_submission_BoxQty": "Qty",
    "text_core_submission_palletQty": "Qty",
    "order_form_subtotal": "Subtotal",
    "text_core_submission_headerNA_text2": "For information regarding how to fill out this form go to",
    "text_core_submission_headerNA_text1": "Please fill in all required information once your return is <b><u>packaged and ready</u></b> for pickup to ensure an efficient core return process.",
    "text_account_online_ordering": "Online Ordering",
    "checkout_error_paymentethod_formentry_sop_invalid_card_expirationMonth": "The expiry month is not valid",
    "address_townCity_invalid": "Please enter a Town/City",
    "text_account_trackOrders": "Track your orders",
    "productsalesstatus_label_apac_code10": "Obsolete",
    "text_stores": "Stores",
    "warranty_check": "Warrany",
    "productsalesstatus_label_apac_code40": "Saleable to the IAM - whilst stocks last",
    "text_quickOrder_requested": "Requested",
    "address_error_sim_invalid": "Part number {0} cannot be shipped to the entered delivery address. Please change the delivery address or delete this part number.",
    "validation_donotcontainName_invalid": "please do not use first name,last name or full name in password.",
    "open_estimated_delivery_date": "Estimated Delivery Date",
    "login_optional": "(optional)",
    "storeDetails_table_from": "from",
    "storeFinder_link": "Store Finder",
    "text_account_savedCarts_page_sortTitle": "Sort by",
    "text_account_myPart_select_customer": "Select at least one customer",
    "basket_export_user_city": "City",
    "register_phone": "Phone Number (Mobile Preferred)",
    "storelocator_distributor": "Distributors",
    "guest_register_description": "Benefit from a faster checkout for your next purchase and access your order history",
    "checkout_checkout_multi_pci": "Checkout Multi with PCI",
    "import_csv_savedCart_uploadStarted": "Uploading file...",
    "text_account_core_search_noRequestFound": "No Results found.",
    "checkout_multi_confirmOrder": "FINAL REVIEW",
    "general_month_december": "December",
    "text_core_submission_headerEMEA_text3": "Please check the",
    "password_strength_medium": "Medium",
    "text_core_submission_headerEMEA_text2": "Rejected core e.g. calipers without adjuster in place, will be scrapped without credit or further notice.",
    "address_building": "Building Name or Number",
    "text_core_submission_headerEMEA_text4": "for further details",
    "text_core_submission_headerEMEA_text1": "Fill in carefully all required information to ensure an efficient return process - only complete forms can be processed!",
    "checkout_summary_deliveryAddress_enterDeliveryAddressButton": "Edit Delivery Address",
    "productsalesstatus_label_apac_code30": "Saleable to the IAM",
    "basket_page_quote_discounts_link_percent_off": "{0}% off",
    "text_account_paymentDetails": "Payment Details",
    "order_totals_savings": "Savings:",
    "text_updates": "Updates",
    "text_account_savedcart_cart_name": "Cart Name",
    "vor_textnextline_warning": "Knorr-Bremse is not liable for late or missed deliveries due to incorrectly entered addresses.",
    "text_warranty_submit_business_type": "Business Type*",
    "text_quote_done_button_label": "Done",
    "registration_error_account_exists_title": "An account already exists for this email address.",
    "text_account_profile_updatePersonalDetails_mobile": "Edit",
    "text_account_warranty_table_header_claim_status": "Claim Status",
    "search_page_xref_number": "Cross-Ref",
    "cart_product_configuration_toolong": "Value is too long",
    "basket_page_viewFuture": "Check Emergency Availability",
    "checkout_multi_hostedOrderPageError_header": "Error Details",
    "review_comment": "Review Description",
    "text_account_orderHistory_seebelow": "See Below",
    "text_checkout_pickup_in_store_address": "Pickup in Store - {0}, {1}",
    "text_iam_partNo": "IAM Part No.",
    "updatePwd_description": "Please enter a new password.",
    "text_account_order_status": "Status: {0}",
    "text_select_file_type_upload": "Note: word, xls, xlsx, csv, txt, tif, gif , jpg, pdf, HTML files are allowed!",
    "file_size_gigabytes": "{0} GB",
    "product_product_partname": "Part Name",
    "register_accept_read": "Read",
    "search_page_linkPreviousPage": "Previous Page",
    "login_new_user": "New User ?",
    "import_csv_savedCart_noFile": "No file chosen.",
    "register_name_invalid": "Combined length of first name and last name must be less than 255 characters",
    "text_select_all_file_loaded": "All files has been attached successfully",
    "checkout_pickup_simplifyPickup": "Simplify Pickup Location",
    "basket_page_totalUSD": "Total",
    "review_show_all": "Show All",
    "checkout_multi_paymentMethod_addPaymentDetails_savePaymentDetailsInAccount": "Save these payment details in my account",
    "text_select_country": "Select your Country and Language",
    "text_expresscheckout_line3": "using a default shipping method",
    "text_expresscheckout_line1": "setting a default Delivery Address in your account or when you checkout",
    "address_regionIso_invalid": "Please enter a region",
    "text_expresscheckout_line2": "setting a default Payment Details when you checkout",
    "text_generalInfo_netWeight": "Net Weight",
    "text_free": "FREE",
    "product_grid_itemsText": "items",
    "profile_lastName_invalid": "Please enter a last name",
    "basket_page_listpriceApac": "List Price(Total)",
    "payment_startDate": "Start date (Maestro / Solo / Switch only)",
    "address_country_invalid": "Please select a country/region",
    "address_prefecture": "Prefecture name",
    "checkout_multi_paymentMethod_createSubscription_billingAddress_noneSelectedMsg": "Please enter a billing address or enter a delivery address first so that it can be used as billing address.",
    "minicart_cart_alt": "Your Shopping Cart",
    "text_account_update_email_address": "Email Address",
    "text_account_savedCarts_page_currentPage": "Page {0} of {1}",
    "text_account_order_min_NA": "Min order/rush surcharge:",
    "text_account_orderHistory_page_totalResultsSingleOrder": "1 Order",
    "text_core_submit_fax": "Fax",
    "checkout_orderConfirmation_yourItems": "Your Items",
    "basket_page_totals_minordercharge": "Min Order Charge",
    "basket_select_product": "Select",
    "text_account_quote_status": "Status",
    "storelocator_postcode_city_search": "Postcode/City Search",
    "text_warranty_terms_pick_delivery": "Pick & Delivery (Cargo box)",
    "quick_order_page_ordertype": "Order Type",
    "quote_cart_empty_error": "Missing or empty cart",
    "text_account_savedCarts_page_lastPage": "&raquo;",
    "text_account_orderHistory_mobile_page_currentPage": "{0} of {1}",
    "text_storefinder_desktop_page_currentPage": "{0} of {1}",
    "profile_currentPassword_invalid": "Please enter your current password",
    "register_terms_not_accepted": "Please accept our terms & conditions to register.",
    "mini_cart_text_cart": "Cart",
    "checkout_multi_deliveryMethod_breadcrumb": "DELIVERY OPTIONS",
    "text_generalInfo_customsInfo": "Customs Information",
    "text_warranty_terms_inter_city": "Inter City Truck",
    "cart_items": "{0} item(s)",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_street1": "This value is invalid for this field",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_street2": "This value is invalid for this field",
    "login_error_incorrect_password_title": "The entered email address or password is not correct.",
    "text_account_closeAccount_popup_confirm": "Are you sure you want to close your account?",
    "text_generalInfo_subjecttochange": "Subject to change based on delivering warehouses; for further details contact your local customer service.",
    "address_city": "City*",
    "basket_validation_voucherNotValid": "The coupon applied on the cart is no longer valid and has been removed from the cart.",
    "text_warranty_submit_vehicle_manufacturer": "Vehicle Manufacturer",
    "search_nav_applied_facets": "Applied Facets",
    "text_warranty_terms_highway_information": "On Highway applications:",
    "text_account_myPart": "My Own Part Numbers",
    "onLine_check": "Order Online",
    "mobile_checkout_items_hide": "Hide Items",
    "register_lastName": "Last Name*",
    "text_account_savedCart_delete": "Delete Cart",
    "pickup_in_store": "Pick Up in Store",
    "basket_page_coresurcharge": "Core Charge",
    "basket_page_coredeposit": "Core Deposit",
    "register_company_industryRole": "Company Industry Role",
    "checkout_orderConfirmation_coupon_valid_range": "Valid from {0} until {1}",
    "text_account_order_discount": "Order Discounts:",
    "text_account_addressBook_page_firstPage": "&laquo;",
    "basket_error_occurred": "Error occurred while adding to Cart",
    "pickup_force_in_stock": "IN STOCK",
    "text_core_submit_address_requestedDate": "Available collection dates:*",
    "text_account_myPart_download_button": "Download My Own Part Numbers",
    "checkout_summary_paymentMethod_billingAddress_header": "Billing Address:",
    "product_bookmark_and_share": "Bookmark and Share",
    "basket_page_title_yourPickUpItems": "Your Pick Up Items",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_street1": "Please enter a value for this field",
    "remember_me": "Remember my log-in",
    "text_compare_show_difference_only": "Show Differences Only",
    "text_core_submission_return": "Core Return Request",
    "text_account_quote_page_sortTitle": "Sort by",
    "checkout_paymentMethod_notSelected": "Please provide details of your payment for your order",
    "text_generalInfo_weight_dimensions": "Weights & Dimensions",
    "text_submit_warranty": "Warranty Claim Application",
    "checkout_orderConfirmation_thankYou": "Thank you for your order. Your order number is {0}",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_street2": "Please enter a value for this field",
    "coupon_invalid_code_provided": "The coupon code entered is not valid.",
    "sold_to_popup_text_three": "for further assistance",
    "text_warranty_submit_vehicle_engine_manufacturers": "Engine Manufacturer",
    "text_showFacet": "Show Refinement",
    "register_company_address_city_invalid": "Please enter the company city",
    "basket_page_coreCharges": "Core Charges",
    "text_page_ifnotfound": "if you can't find what you are looking for.",
    "globle_search_message": "Please enter at least 3 characters",
    "basket_page_message_update_reducedNumberOfItemsAdded_noStock": "<a href",
    "storeDetails_table_openingSpecialDays": "Special Opening Times",
    "text_reports_creditReconNa": "Details of month end core debit/credit",
    "text_account_table_header_poNumber": "Customer PO Number",
    "text_warranty_submit_product_not_found": "Product Not found",
    "register_company_accessRequesting": "Requesting Access for",
    "checkout_express_error_paymentInfo": "Express checkout is not available since you do not have a default payment info. Please set a default payment info in your account to use Express Checkout next time.",
    "text_account_order_title_deliveryItems": "Delivery Items",
    "text_warranty_submit_customer_information": "Reference and Customer Information",
    "checkout_multi_order_summary": "ORDER SUMMARY",
    "core_submit_warranty_crn_number_label": "If checked the system will create the CR Number",
    "basket_information_obselete_status_true": "This product is replaced by {0} as it is obsolete now.",
    "checkout_multi_sop_useMyDeliveryAddress": "Use my Delivery Address",
    "address_postcode": "Postcode",
    "text_user_table_header_order": "Order",
    "text_warranty_select_file_wish": "Select file you wish to upload and click on the \"Upload\" button. Each upload file will be added to the claim.",
    "register_company_industryRole_invalid": "Please select at least one  industry role",
    "text_sales_status_description_emea_code_40_anonymous": "Saleable to the IAM",
    "storeDetails_table_opening_opened": "Opened",
    "mycompany_search_term": "Search term",
    "header_quick_order": "QUICK ORDER",
    "text_account_orderHistory_mobile_page_sort_byOrderNumber": "Order Number",
    "basket_page_availability": "Availability",
    "checkout_error_paymentethod_formentry_sop_invalid_card_issueNumber": "The issue number is not valid",
    "product_view_details_code": "Part #",
    "basket_error_invalid_configuration": "You have invalid product configuration. {0} issue(s) must be resolved before checkout.",
    "text_header_connect": "Connect",
    "text_quote_edit_confirmation_modal_title": "Edit Quote Warning",
    "order_quantity": "Quantity",
    "download_click_on_text": "To do so, click on \"START DOWNLOAD\"",
    "text_storefinder_responsive_page_lastPage": "&raquo;",
    "text_reports_detail": "Full Detail",
    "address_state": "State / Province",
    "storeFinder_pagination_previous": "Previous",
    "pdp_page_contact_us": "Contact Us",
    "pdp_page_contact_enquiry": "Enquiry",
    "text_sales_status_description_apac_code_40": "Saleable to the IAM - whilst stocks last",
    "login_error_incorrect_password_subtitle": "If you forgot your password, please use the Forgotten Password link.",
    "file_size_megabytes": "{0} MB",
    "text_headline_navigationbar": "Browse through the navigation bar",
    "text_account_orderHistory_page_sortTitle": "Sort by",
    "login_email": "Email Address*",
    "basket_page_remove": "Remove",
    "text_account_account": "Account",
    "address_line2_shipping_page_form_emea": "House Number",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_city": "Please enter a value for this field",
    "checkout_multi_pickup_items": "Pick Up #{0} - {1} Item(s)",
    "text_quickOrder_order_type": "Order Type",
    "register_dataprotection_acceptNA": "I Accept the",
    "general_terms_and_conditions": "General terms and conditions",
    "text_quote_submit_not_modifiable_message": "Once a request for quote is submitted it cannot be modified.",
    "checkout_multi_paymentMethod_edit": "Edit",
    "updatePwd_checkPwd": "Confirm Password",
    "order_productDetails": "Product Details",
    "checkout_error_paymentethod_formentry_sop_invalid_card_startYear": "The start year is not valid",
    "text_account_myPart_upload_button": "Upload My Own Part Numbers",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_city": "This value is invalid for this field",
    "pickup_location_required": "Please provide your location to see products available in your area.",
    "text_account_addressBook_yourDefaultAddress": "This is your default address",
    "text_account_profile_confirmationUpdated": "Your profile has been updated",
    "coWorker_check": "Co-Worker Order",
    "text_pagenotfound_homepage": "home page",
    "pickup_here_button": "Pick Up Here",
    "mobile_checkout_deliveryAddress_use": "Use",
    "checkout_page_summary_final_review_shipping_address": "Shipping Address",
    "checkout_deliveryMethod_notSelected": "Please select a carrier to complete the checkout process.",
    "checkout_orderConfirmation_get_coupon": "You've earned the following coupon!",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_postalCode": "Please enter a value for this field",
    "text_account_savedcart_numberofproducts": "Number of Positions",
    "text_reports_creditEmea": "Explanation of the month end core debit/credit",
    "checkout_error_paymentethod_formentry_sop_missing_card_cvNumber": "Please enter a value for this field",
    "checkout_multi_deliveryAddress_selectAddressMessage": "Select an existing address for your delivery.",
    "checkout_orderConfirmation_copySentToShort": "A copy of your order details has been sent to",
    "checkout_multi_address_updated": "Your address was updated",
    "register_pwd_invalid": "Password does not meet minimum requirements.",
    "basket_save_cart_max_chars": "Characters Left",
    "text_country_selector_APAC": "Asia Pacific",
    "promotional_box_main_heading": "News & Updates of Products and Services",
    "address_postalcode": "Zip/Postal Code*",
    "text_checkout_noDeliveryModes": "Please check the delivery address. If not selected already, please select the delivery address first and try again.",
    "checkout_summary_deliveryAddress_header": "Delivery Address",
    "storeFinder_see_more": "See more...",
    "text_account_savedcart_save_activecart": "I do not want to save items for later",
    "general_find_a_store": "Find a Store",
    "cart_page_checkout": "Check Out",
    "search_mobile_page_sortTitle": "Sort by:",
    "register_email_duplicate": "The entered email address is already registered with an existing account",
    "text_voucher_apply_invalid_error": "This coupon is not valid",
    "text_quickOrder_product_not_unique": "Product not unique",
    "text_account_quote_myquotes": "My Quotes",
    "basket_information_quantity_reducedNumberOfItemsAdded_maxOrderQuantityExceeded": "Unfortunately the quantity you chose exceeded the maximum order quantity for this product.",
    "text_account_confirmation_password_updated": "Your password has been changed",
    "general_required_po_checkout_mandatory": "Customer PO # is mandatory in order to complete the checkout process",
    "general_required_cr_no_checkout_mandatory": "Customer Ref No is mandatory in order to complete the checkout process",
    "text_consent_read": "I have read the",
    "text_consent_read_document": "I have read the",
    "text_consent_disclaimer_document": "download disclaimer.",
    "text_consent_disclaimer_document_next": "",
    "text_consent_read_privacy": "I have read the",
    "text_consent_dpr_pdp_privacy": "privacy notice.",
    "text_account_update_status_subscribed": "Subscribe",
    "text_notification_for_confirm_subscription": "You will receive an email from us. Please confirm the subscription within 24 hours.",
    "search_nav_facetShowLess_brand": "less brands...",
    "checkout_page_summary_order_type": "Order Type",
    "basket_save_cart_name": "Name",
    "text_headline_login": "Click here to login",
    "checkout_multi_pickupInStore_confirm_and_continue": "Simply confirm the information below and continue to the next step of checkout.",
    "text_cookie_notification_accept": "x",
    "checkout_multi_deliveryMethod_message": "Items will ship as soon as they are available. <br> See Order Summary for more information.",
    "text_account_quote_remove": "Remove",
    "text_quote_comment_label": "Negotiation Comment",
    "text_account_profile_updateEmail_mobile": "Change Email",
    "basket_page_total": "Total",
    "checkout_checkout_multi_pci-sop": "PCI-SOP",
    "text_account_savedCarts_noSavedCarts": "No Saved Carts Found",
    "account_confirmation_forgotten_password_link_sent": "Password reset instructions have been sent to your e-mail address. Please contact customer support if you require additional assistance.",
    "basket_page_shipping_find_store": "Find a Store",
    "basket_page_totals_grossTax": "Your order includes {0} tax.",
    "storeDetails_table_opening": "Hours",
    "checkout_summary_deliveryMode_selectDeliveryMethodForOrder": "Shipment Method",
    "account_confirmation_email_sent": "Reset Password Instructions Sent!",
    "account_confirmation_valid_email_sent": "Reset password instructions have been sent to your valid email address",
    "text_account_savedCarts_page_totalResultsSingleOrder": "1 Saved Cart",
    "text_company_manage_units_notapproved": "Your registration request has not been approved yet, post approval you will receive an email with further information.",
    "text_account_addressBook_page_sort_byName": "Name",
    "DeliveryType_Complete_name": "Complete Delivery",
    "text_account_orderHistory_page_totalResults": "{0} Order(s) Found",
    "checkout_orderConfirmation_copySentTo": "A copy of your order details has been sent to {0}",
    "import_csv_savedCart_filesNote": "Here you can upload a file containing a list of all part numbers you want to order. The list will be used to automatically update your Shopping Cart.",
    "text_quote_discount_apply_calculation_error": "There is an internal error for applying the discount. Please try again.",
    "text_core_submission_wghtApx": "Weight approx.",
    "breadcrumb_techteam_text": "Tech Team",
    "breadcrumb_DTC_text": "DTC Search",
    "search_nav_categoryNav": "Shop by Category",
    "storeFinder_noResults": "No Stores Found",
    "text_pleaseSelect": "title",
    "register_company_address_two": "Address 2 (e.g. unit, floor, house name)",
    "basket_error_entrygroup_remove": "Unable to remove cart entry group #{0} due to an error.",
    "consent_form_global_error": "Something went wrong while saving your consent. Please manage your consent in the Consent Management page.",
    "text_volumePrices": "Volume prices available",
    "text_account_warranty_search_page_totalResultsSinglePag": "{0} Claims",
    "product_bundles": "Buy this item in a bundle",
    "order_free": "FREE",
    "product_grid_confirmQtys_message": "Navigating away from this page will result in losing the data you have entered!",
    "text_headline_myaccount": "Click here to login or get to your Account",
    "text_paymentDetails": "Payment Details",
    "text_core_submit_firstName": "First Name",
    "pickup_search_button": "Find Stores",
    "text_warranty_submit_part_scale": "Scale*",
    "text_warranty_submit_part_scale_emea": "Scale",
    "basket_page_totals_total_items": "{0} ITEMS",
    "checkout_summary_paymentMethod_addPaymentDetails_billingAddressDiffersFromDeliveryAddress": "If your billing address is  different  to your delivery address, please use this form to enter your billing address",
    "popup_cart_empty": "Empty Cart",
    "register_title": "Title",
    "text_warranty_submit_part_requestedPartAmount": "Requested Part Amount*",
    "text_account_orderHistory_page_sort_byOrderType": "Order Type-Asc",
    "profile_newPassword": "New Password*",
    "basket_restoration_errorMsg": "Your cart could not be restored.",
    "basket_page_totals_quote_total_original": "Original Subtotal:",
    "register_company_phoneNumber": "Phone Number",
    "quote_approve": "Approve Quote",
    "checkout_error_paymentethod_formentry_sop_missing_card_expirationMonth": "Please enter an expiry month",
    "checkout_orderDetails_hide": "[-] Hide Order Details",
    "search_meta_title": "Search",
    "core_number_not_available": "The part entered does not have a core. Please enter a different part number or click on the x to close the search",
    "text_account_order_status_display_processing": "In Process",
    "text_addToCart_outOfStock": "out of stock online",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_firstName": "Please enter a value for this field",
    "quickorder_page_ordertypes": "Order Type",
    "storeFinder_pagination_next": "Next",
    "text_account_order_summary": "A summary of your order is below:",
    "text_warranty_terms_firetruck_home": "Firetruck",
    "checkout_multi_next": "Next &raquo;",
    "text_warranty_submit_labourrequested_no": "No",
    "text_account_paymentDetails_billingAddress": "Billing Address",
    "mini_cart_popup_quantity": "Quantity :",
    "text_storefinder_mobile_page_totalResults": "{0} Stores found",
    "text_warranty_submit_email2": "Email Address 2",
    "text_warranty_submit_email1": "Email Address 1",
    "text_account_savedCart_dateSaved": "Date Saved",
    "checkout_summary_deliveryMode_noneSelected": "None selected",
    "checkout_multi_shipment_pickup_location": "Shipment/Pick Up Location",
    "checkout_page_summary_final_review_carrierSelection": "Carrier Selection:",
    "quote_create_error": "Error creating quote.",
    "payment_cardType_invalid": "Please select a card type",
    "register_remember": "Remember me on this computer",
    "search_nav_changeLocation": "Change Location",
    "text_account_orderHistory_page_sort_byCategory": "Order Category-Asc",
    "product_share_viewMoreServices": "View more services",
    "basket_validation_couponNotValid": "The coupon applied on the cart is no longer valid and has been removed from the cart.",
    "address_countryIso": "Country*",
    "open_total_usd": "Open Total USD",
    "warranty_eligibility_check_vehicle_identification_number": "Vehicle Identification Number",
    "text_account_addressBook_page_sort_byDateModified": "Date Modified",
    "checkout_page_summary_deliveryMode_selectDeliveryMethodForOrder_NA": "Carrier Selection",
    "checkout_page_summary_deliveryMode_selectDeliveryMethodForOrder_NA_STOR": "Carrier Selection (for collect shipments only)",
    "register_dataprotection_id": "dataprotection-check",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_email": "This value is invalid for this field",
    "product_average_review_rating": "Products Average Rating {0} / 5",
    "search_nav_facetShowLess_category": "less categories...",
    "text_label_loadingmoreresults": "Loading more results...",
    "text_warranty_submit_final_review": "Final Review",
    "cart_page_customer_reference_apac": "Item Ref No.",
    "warranty_eligibility_check_bendix_part_number": "Bendix Part Number*",
    "pdp_page_sign_in": "Sign In",
    "text_coreClass": "Core Class",
    "pickup_pagination_next": "Next",
    "text_account_savedCart_id": "ID",
    "text_logout": "Logout",
    "register_email": "Email Address",
    "text_warranty_submit_claim_ref_number": "Customer Claim Reference Number*",
    "forgottenPwd_email_invalid": "Please enter a valid email",
    "text_select_cutomer_id_user_account": "Select Customer ID to be linked with this new user account",
    "basket_export_cart_item_quantity": "Quantity",
    "address_postcodeJP": "Postal Code preceded by postal symbol",
    "core_error_submission_na": "You do not have permission, please <a href",
    "text_header_languageandcurrency": "Language and Currency",
    "productsalesstatus_label_apac_code40_anonymous": "Saleable to the IAM",
    "search_mobile_no_results": "No Results Found",
    "product_grid_futurestock_updatefuture_availability": "Show future availability",
    "text_account_savedCarts_ShoopingCart": "Saved Shopping Cart",
    "text_account_profile_myProfile": "My Profile",
    "text_quote_cancel_success": "Quote {0} has been canceled",
    "review_back": "Back To Reviews",
    "text_warranty_eligibility_part_number_error": "Please enter a valid Bendix Part Number",
    "text_account_orderHistory_page_sort_byDate": "Date",
    "aria_pickupinstore_loading": "Loading... Please wait...",
    "basket_restoration_restorationError": "Your cart could not be restored.",
    "product_start_bundle": "Start Bundle",
    "text_account_orderHistory_orderNumber": "Order Number",
    "register_title_invalid": "Please select a title",
    "text_cust_part_no": "Customer Part No.",
    "register_company_name_invalid": "Please enter the company name",
    "text_account_closeAccount_button": "Close Account",
    "text_warranty_search_reset": "Reset",
    "checkout_pickup_pickup_in_store": "Pickup in Store - {0}, {1}",
    "profile_pwd": "Password",
    "text_add_row_button": "Add Row",
    "register_company_faxNumber_invalid": "Please enter the company fax number",
    "import_csv_savedCart_requestedDate": "Requested delivery date (format MM/DD/YYYY)",
    "profile_title": "Title",
    "checkout_multi_cancel": "Cancel",
    "header_link_logout": "Sign Out",
    "checkout_multi_inStore": "In Store",
    "basket_page_title": "Item",
    "address_line1": "Address Line 1",
    "checkout_multi_deliveryMethod_notprovided": "You must provide a delivery option in order to go to the next step.",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_shippingMethod": "Please enter a value for this field",
    "text_button_menu": "Menu",
    "text_quote_expiration_time_warning": "Note: If the expiry date is set to today or earlier, it will be set to {0} days from today.",
    "only_bendix_personel": "Only Bendix Personnel Rights",
    "text_htcCode": "HTC Code",
    "warranty_eligibility_check_date_in_service": "Date in Service",
    "text_account_addressBook_addressDetails": "Address Details",
    "checkout_summary_deliveryAddress_noneSelected": "None selected",
    "text_button_showall": "Show All",
    "text_account_addressBook_confirmationUpdated": "Your address was updated",
    "review_alias": "Your Name",
    "test_account_core_reportsinfoEMEA": "If you cannot get a particular core report, please contact your",
    "popup_cart_showing": "Showing {0} of {1} Items",
    "text_warranty_claim_information": "Claim Information",
    "text_account_savedCart_name": "Name",
    "register_termsOfUsage_message": "Webshop Terms Of Use",
    "text_account_quote_status_display_BUYER_ORDERED": "Ordered",
    "basket_page_cartId": "Cart ID:",
    "search_nav_facetShowLess_typenumber": "less ..",
    "register_customer_regisration": "CUSTOMER REGISTRATION",
    "text_checkout": "Checkout",
    "mycompany_set_right": "Set User Rights",
    "product_overview": "Details",
    "mobile_checkout_multi_button_submit": "Submit",
    "product_volumePrices_column_price": "Price each",
    "text_warranty_search_from_date_to_date_invalid": "Claim Date From can't be greater than Claim Date To.",
    "text_account_profile_resetPassword": "Reset Password",
    "review_show_less": "Show Less",
    "checkout_pickup_no_delivery_required": "No delivery required for this order",
    "pagination_items": "Item(s)",
    "breadcrumb_quickOrder": "Quick Order",
    "checkout_summary_deliveryAddress_editDeliveryAddressButton": "Edit Delivery Address",
    "register_company_phoneNumber_invalid": "Please enter the company phone number",
    "header_changecustomer_id": "Change Customer ID",
    "search_spellingSuggestion_prompt": "Did you mean:",
    "text_account_savedCart_message": "Promotions and totals reflect what existed at the time the cart was saved. Promotions and totals may change or no longer apply when the cart is restored.",
    "text_account_profile_cancel": "Cancel",
    "text_warranty_submit_requested_cost": "Requested Cost Reimbursement",
    "click_export_download": "Click export to download the data in an Excel file.",
    "basket_confirmation_items_added": "Your saved items were added to your cart.",
    "text_warranty_search_search": "Search",
    "checkout_multi_hostedOrderPageError_ERROR_150": "General system failure. Possible action: Wait a few minutes and resend the order.",
    "pickup_product_availability": "Product Availability by Store Location",
    "text_account_yourAccount": "My Account",
    "basket_page_cartIdShort": "ID:",
    "review_rating_invalid": "Please enter a rating",
    "text_account_order_orderNumberShort": "Order #: {0}",
    "text_warranty_search_claim_from_date": "Claim Date From*",
    "text_quickOrder_product_quantity_max": "Quantity reduced due to insufficient stock",
    "checkout_multi_hostedOrderPageError_ERROR_151": "The request was received, but a server time-out occurred. Possible action: To avoid duplicating the order, do not resend the request until you have contacted our sales team.",
    "text_account_warranty_search_page_linkNextPage": "Next Page",
    "checkout_multi_hostedOrderPageError_ERROR_152": "The request was received, but a service did not finish running in time. Possible action: To avoid duplicating the order, do not resend the request until you have contacted our sales team.",
    "search_meta_description_results": "Search results for",
    "profile_title_invalid": "Please select a title",
    "text_generalInfo_coreInformation": "Core Information",
    "order_history_status_date": "Status Date:",
    "address_townJP": "City, village, city ward",
    "checkout_summary_paymentMethod_securityCode_whatIsThis_description": "The last 3 digits on the signature strip on the back of the card. For American Express, it's the 4 digits just above the hologram on the front of the card.",
    "text_account_order_status_display_created": "Created",
    "product_product_spec": "Specs",
    "text_account_quotes_noQuotes": "No Quotes",
    "checkout_page_replaced": "Replaced",
    "paymentMethod_paymentDetails_expires": "Expires {0} / {1}",
    "product_grid_outOfStock": "Out of Stock",
    "text_materialType": "Material Type",
    "storeDetails_table_email": "Email",
    "basket_export_cart_item_sku": "Sku",
    "text_pagenotfound_or": "or",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_phoneNumber": "This value is invalid for this field",
    "text_warranty_submit_enter_product_code": "Please enter product code",
    "cart_product_deletetext": "Do you want to delete the selected item?",
    "text_weight_approx": "Weight approx. [kg]",
    "basket_page_totals_quote_total_after_discount": "New Subtotal:",
    "pickup_out_of_stock": "OUT OF STOCK",
    "general_unknown_identifier": "Unknown identifier was passed",
    "text_account_addressBook_page_showAllResults": "Show all",
    "text_core_submit_address_address": "Address*",
    "text_quantity": "Quantity",
    "general_continue_button": "Continue",
    "quote_approve_error": "Error approving quote.",
    "text_account_warranty_search_page_showPageResults": "Show paginated",
    "product_grid_future_tooltip_qty": "QTY",
    "text_account_savedcart_restore_btn": "Restore",
    "text_account_savedcart_cart_id": "ID",
    "search_nav_facetShowMore": "View More",
    "basket_validation_configurationError": "{0} has configuration error(s) that need to be fixed before proceeding to checkout.",
    "storelocator_search_results_go": "Go",
    "text_headline_homebanner": "Top Banner",
    "account_confirmation_address_updated": "Your address was updated.",
    "text_cutoff_orderconfirmation_timezone_EMEA": "Cut-off time: {0} must be placed by {1} {2}",
    "text_quote_discount_modal_title": "Discount {0}",
    "text_warranty_terms_transit_bus": "Transit Bus (City Coach)",
    "text_account_savedCart_position": "Positions",
    "text_account_savedCart_remove": "Action",
    "checkout_multi_items_to_pickup": "Pick Up:",
    "pickup_pagination_from": "from&nbsp;",
    "checkout_multi_paymentMethod_addPaymentDetails_useSavedCard": "Use a saved card",
    "pickup_pagination_stores": "&nbsp;stores found",
    "text_account_savedcart_retain_savedcart": "Keep a copy of this cart on saved list",
    "cart_page_ordertypes": "Order Type",
    "text_warranty_terms_highway_off": "Off Highway applications:",
    "text_account_quote_page_sort_byName": "Name",
    "text_account_warranty_search_page_totalResults": "of {0} Claims",
    "text_warranty_submit_part_labour_requested": "Labor Requested*",
    "login_title": "Returning Customer",
    "coupon_general_error": "Coupon Redemption Failed.",
    "checkout_login_loginAndCheckout": "Login To Your Account",
    "text_account_orderHistory_mobile_page_currentResults": "{0} - {1} of {2} orders",
    "basket_your_shopping_basket": "Your Shopping Cart",
    "review_submitted_by": "Submitted by",
    "register_company_address_zip": "Zip/Postal Code*",
    "guest_confirm_email": "Confirm Email Address",
    "checkout_orderDetails_show": "[+] View Order Details",
    "text_account_warranty_table_header_ref_number": "Customer Warranty Claim Reference No.",
    "text_headertext_conf": "Confirm",
    "cart_groups_remove": "remove",
    "checkout_multi_deliveryMethod": "DELIVERY OPTIONS",
    "popup_cart_customer_price": "Customer Price",
    "search_nav_facetShowMore_brand": "more brands...",
    "review_write_review": "Write Review",
    "product_grid_futurestock_refresh": "Update Future",
    "checkout_orderConfirmation_summary": "A summary of your order is below:",
    "text_account_saveCart_edit_success": "Cart {0} was successfully updated",
    "checkout_page_show_all_position_text": "Show / Hide sub items",
    "cart_page_total": "Total",
    "header_link_account": "My Account",
    "text_account_savedCart_total": "Total",
    "text_account_addressBook_addAddress": "Add Address for Emergency orders",
    "text_skipToNavigation": "Skip to navigation menu",
    "checkout_summary_deliveryMode_items_for_pickup": "{0} Items for Pickup in Store",
    "guest_pwd": "Password",
    "core_report_date": "Month,Year",
    "checkout_pages_availabilty_final_review": "Save and Next",
    "price_select_all": "Select All",
    "text_warranty_submit_part_hourlyLabourRate": "Hourly Labor Rate (per pc)",
    "mobile_payment_issueNumber": "Issue number (Maestro / Solo / Switch only)",
    "address_shipping_page_form": "Street Address *",
    "text_account_warranty_search_empty": "No warranty claims found. Please change your search criteria and try again",
    "text_account_profile_updatePersonalDetails": "Personal details",
    "text_core_search_kbpart": "Knorr-Bremse Part #",
    "download_must_agree_text": "You must agree to our",
    "search_nav_facetShowMore_stores": "Show More Stores",
    "product_view_details": "View Details",
    "text_headline_coreGroupDesc": "Core Group / Description",
    "quote_reject": "Reject Quote",
    "text_core_submission_NA_text1": "Thank you for submitting your core return request. Please check your inbox for a copy of the submitted core return form.",
    "text_account_saved_cart_detail_net_price": "Net Price",
    "text_core_submission_NA_text2": "Reminder:",
    "text_core_submission_NA_text2a": "Please include a copy of the Bendix core return form along with your shipment.",
    "text_core_submit_address_stateCode": "State/Province*",
    "text_core_submission_NA_text3": "All shipments are to be shipped <b>PREPAID</b> to the address below.",
    "checkout_multi_payment": "Payment:",
    "text_account_gereral_rights": "General Rights",
    "checkout_multi_deliveryAddress_selectSuggestedAddress": "Verify Your address.<br>We suggest you accept one of the following changes to your address:",
    "checkout_multi_secure_checkout": "Secure Checkout",
    "checkout_checkout": "Go To Cart",
    "checkout_multi_hostedOrderPostPage_button_submit": "Submit",
    "general_month_june": "June",
    "text_account_addressBook_manageYourAddresses": "Manage your address book",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_postalCode": "This value is invalid for this field",
    "product_detail_quantity": "Qty",
    "text_status": "Status",
    "checkout_multi_deliveryMethod_edit": "Edit",
    "text_generalInfo_packagingInformation": "Packaging Information",
    "text_quickOrder_delete_checkboxes": "Delete All",
    "text_account_orderHistory_page_sort_byCategoryDesc": "Order Category-Desc",
    "open_order_category": "Order Category",
    "basket_page_deliveryQty": "Delivery Qty",
    "general_month_april": "April",
    "text_iam_for": "Recommended IAM part numbers for {0} including Service New + EconX:",
    "text_quote_edit_warning_message": "Are you sure you want to edit this approved quote?",
    "checkout_multi_hostedOrderPostPage_header_debug": "This page shows all of the Hosted Order Page (HOP) API fields that will be sent to the HOP URL.  It can be used to debug the HOP by changing the values to simulate the desired behaviour.",
    "text_quote_conteroffer_confirmation_message": "Are you sure you want to offer this vendor quote?",
    "quote_state_BUYER_DRAFT": "DRAFT",
    "text_account_addressBook_page_totalResults": "{0} Address(s) Found",
    "address_province_invalid": "Please enter a province",
    "text_warranty_submit_part_datecode": "Date Code",
    "text_headline_orderitems": "All information about your order items",
    "homepage_proeuct_categories": "Product Categories",
    "text_account_addressBook_page_linkPreviousPage": "Previous Page",
    "text_shippingMethod": "Shipping Method",
    "basket_page_totals_estimatedZip": "Zip code:",
    "text_account_saved_cart_detail_core_charges": "Core Charges",
    "order_form_currency": "$",
    "basket_page_price": "Price",
    "basket_export_user_fax": "Fax",
    "storelocator_search_totalResults": "Showing {0} nearest stores",
    "checkout_multi_deliveryMethod_header": "Delivery Options",
    "text_unitOfMeasure": "Unit",
    "text_marketType": "Type",
    "text_marketTypeNA": "Market",
    "text_account_open_position": "Open Positions",
    "checkout_estimateDeliveryDate_empty": "OPEN",
    "text_generalInfo_countryOrigin": "Country of Origin",
    "text_user_table_delete_user_account": "Delete User Account",
    "text_account_orderHistory_total": "Total",
    "product_variants_size": "Size",
    "text_account_quote_duplicate": "Duplicate",
    "text_account_addressBook": "Address Book",
    "text_account_quote_page_linkPreviousPage": "Previous Page",
    "text_warranty_search_from_date_invalid_future": "Claim Date From can't be in future date.",
    "cart_groups_edit": "edit",
    "label_emea_nextday": "Next day before 12pm",
    "checkout_multi_hostedOrderPageError_globalError": "Failed to create subscription.  Please see error details below.",
    "text_account_quote_page_totalResultsSingleOrder": "1 Quote found",
    "text_warranty_terms_refuse_hauler": "Refuse Hauler",
    "checkout_multi_deliveryMethod_stepHeader_done": "2 - Delivery Method",
    "checkout_summary_deliveryMode_selectDeliveryMethod": "Select Delivery Method",
    "checkout_multi_paymentDetails_notprovided": "You must provide a payment details in order to go to the next step.",
    "storeFinder_table_distance": "Distance",
    "product_price_from": "From {0}",
    "basket_page_delivery": "Delivery",
    "checkout_page_summary_final_review_billing_address": "Billing Address",
    "text_core_submit_date": "Date",
    "text_warranty_submit_part_repairTime": "Repair Time (in hrs)",
    "text_search_icon_coreGroup": "Search Core Group",
    "text_add_to_core_form": "Add to core form",
    "general_delete_all_button": "Delete",
    "checkout_page_summary_final_review_delivery_type": "Delivery Type:",
    "text_warranty_terms_other_vehicle": "Other non-typical use vehicles",
    "basket_page_item": "Item (style number)",
    "text_account_closeAccount_popup_action": "Close My Account",
    "review_no_reviews": "Be the first to write a review.",
    "label_emea_forwarder": "Stock",
    "text_core_rights_label": "Core Rights",
    "open_total_usd_APAC": "Net Price JPY",
    "text_account_savedCarts_page_sort_byCode": "Sort by : ID",
    "search_nav_facetShowMore_collection": "more collections...",
    "product_grid_formDescription": "Select items below and add to cart",
    "basket_page_message_update_pickupinstoreitem": "Pickup in store item was updated.",
    "profile_firstName_invalid": "Please enter a first name",
    "basket_information_merge_successful": "The cart saved against your user account and your current cart have been merged. Click here to visit your cart.",
    "register_dataprotection_accept": "I have read the",
    "basket_page_totals_subtotal": "Subtotal:",
    "order_totals_delivery": "Delivery:",
    "text_generalInfo_coreGroup": "Core Group",
    "address_room_invalid": "Please enter a room number",
    "text_warranty_terms_yard_truck": "Yard Truck",
    "checkout_multi_addressDetails": "Address Details",
    "text_account_consent_consentManagement_general_text": "To personalize your experience, we'd like your consent to receive your profile data:",
    "cart_count": "{0}",
    "address_regionIso": "State/Province*",
    "save_page_continue": "Save Cart",
    "text_account_orderHistory_page_sort_byTypeNo": "Type No-Asc",
    "basket_export_user_customerID": "Customer ID",
    "core_report_format": "File format",
    "text_account_quote_date_placed": "Date Placed",
    "text_account_profile": "Profile",
    "text_account_addressBook_addEditAddress": "Add/Edit Address",
    "pagination_or": "or",
    "text_account_core_search_showPageResults": "Show paginated",
    "text_warranty_name": "Name",
    "text_header_language": "Click here to change the language",
    "text_quickOrder_page_part_no": "Part No.",
    "text_consent_agree": "and agree with the collection and processing of the personal data I provide to download a document",
    "review_based_on_one": "Based on {0} review",
    "import_csv_savedCart_fileConstraint": "Maximum file size:",
    "text_quote_not_submitable": "Quote cannot be submitted since total is negative",
    "text_address": "Address*",
    "text_additional_info": "Addtional information:",
    "text_quickorder_limit_character": "Max. 35 characters, no more input!",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_phoneNumber": "This value is invalid for this field",
    "product_variants_type": "Type",
    "collection_address_provided": "If different from above, please add personal contact details applicable for the collection address:",
    "pickup_address_provided": "If contact person is different from the person above add below:",
    "review_submitted_anonymous": "Anonymous",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_phoneNumber": "Please enter a value for this field",
    "register_company_soldto": "Default Sold To",
    "emea_register_company_soldto": "Knorr-Bremse Customer Numbers",
    "additional_soldto_description_emea": "Enter additional Knorr-Bremse customer numbers you should have access to (customer number and/or address)",
    "text_quick_order_reset_form": "Reset Form",
    "product_close": "Close",
    "text_account_warranty_table_header_date": "Claim Date",
    "text_account_warranty_search_page_sort_byDate": "Date",
    "search_page_product_document": "Documents",
    "text_warranty_terms_line_haul": "Line Haul Tractor/Trailer",
    "basket_page_min_order_NA": "Min order/rush surcharge:",
    "header_link_selectSalesarea": "Select Sales Area",
    "register_webshop": "webshop",
    "order_history_min_order": "Min order/rush surcharge:",
    "search_nav_facetShowLess_nameForFacet": "less ..",
    "account_error_account_exists_with_email_address_subtitle": "Please choose an alternative email address.",
    "text_quote_description_not_applicable": "N/A",
    "register_webshop_accept": "I accept the",
    "product_product_document": "Documents",
    "search_placeholder": "Enter a part number, type number, title or document details",
    "text_submit_review_carefully": "Please carefully review all your entries prior to submitting your online form.",
    "breakForm_submit_review_carefully": "Your form is ready to be submitted",
    "quote_save_error": "Error saving quote.",
    "core_error_submission_emea": "You do not have permission, please <a href",
    "text_account_savedCarts_page_sort_byTotal": "Sort by : Total",
    "category_navTitle": "Shop by Category",
    "search_mobile_page_linkPreviousPage": "&laquo; Previous",
    "basket_error_checkout_empty_cart": "You cannot proceed to checkout with empty cart.",
    "text_account_paymentDetails_delete_following": "The following payment method will be deleted",
    "checkout_summary_paymentMethod_paymentDetails_noneSelected": "None selected",
    "text_core_submit_month": "Core Return Month",
    "import_csv_savedCart_importCondition": "*Order type needs to be selected before the file can be uploaded.File format must be CSV, file size max (10KB).",
    "text_storefinder_responsive_page_sortTitle": "Sort by:",
    "basket_export_user_firstName": "First Name",
    "text_quote_discount_by_amount": "Discount by Amount",
    "cart_checkout_error": "Error proceeding to checkout.",
    "download_the_document_text": "before you can download the document.",
    "payment_cardNumber": "Card number",
    "popup_cart_showall": "Show All",
    "text_account_addressBook_back_btn": "Back",
    "test_account_core_reportsinfoNA": "If you have any questions about your Core Reports, please contact us at",
    "profile_checkPwd_invalid": "Please confirm your password",
    "basket_export_user_zipCode": "Zip/Postal Code",
    "text_core_submission_package": "Package Type",
    "quote_reject_initiate_request": "Minimum {0} subtotal to submit a quote.",
    "payment_cardType_pleaseSelect": "Please select a card type",
    "search_nav_facetShowMore_availableInStores": "more stores...",
    "login_login": "Login",
    "basket_export_user_phone": "Phone",
    "text_account_order_netTax": "Tax:",
    "text_header_storefinder": "Store Finder",
    "checkout_pages_change_billing_address": "Change Billing Address",
    "text_warranty_please_upload_all": "Please upload all documents that are necessary for processing your return request form.",
    "import_csv_savedCart_enterContentNote": ", enter your information on the file, and click on",
    "mobile_search_add_refinements": "Refine",
    "text_account_order_shipping": "Shipping Costs:",
    "text_account_quote_status_display_SELLER_DRAFT": "Draft",
    "text_paymentMethod": "Payment Method",
    "text_account_quote_page_totalResults": "of {0} Quotes",
    "j_password": "Password",
    "register_company_website_invalid": "Please enter the company website address",
    "mobile_checkout_paymentMethod": "Payment Details",
    "text_account_core_search_lastPage": "&raquo;",
    "cart_page_reqdeliveryApac": "Req Departure Date",
    "text_account_quote_page_firstPage": "&laquo;",
    "breadcrumb_login": "Login",
    "order_product_seeDetails": "See details",
    "general_month_october": "October",
    "basket_view_basket": "View cart",
    "text_storefinder_desktop_page_sort_byName": "By Name",
    "text_setDefault": "Set as default",
    "checkout_summary_shippingAddress": "Shipping Address",
    "text_warranty_submit_replacement_type": "Replacement Type*",
    "register_company_address_street": "Address With Street Number*",
    "text_warranty_terms_shuttle_bus": "Shuttle or Tour Bus",
    "order_history_reorder_button": "Re-Order",
    "basket_export_user_warranty": "Warranty",
    "cart_view": "VIEW CART",
    "review_general_error": "Please fill all mandatory review fields",
    "text_pagenotfound_error": "Sorry, the page you were looking for could not be found.",
    "text_account_addressBook_page_linkNextPage": "Next Page",
    "text_account_order_savings": "Order Savings:",
    "text_core_address": "Collection Address",
    "text_pickup_address": "Pickup Address",
    "text_quote_discount_apply_argument_invalid_error": "The discount input is invalid. Please try again.",
    "basket_page_per_pc": "(per pc)",
    "core_report_parent": "Core Parent",
    "text_quickOrder_product_not_found": "Product not found",
    "text_voucher_release_error": "Error while removing the voucher {0}",
    "basket_save_cart_info_msg": "Your cart will be moved to Saved Cart list.",
    "text_account_orderHistory_page_sort_byTypeDesc": "Type No-Desc",
    "text_nocategory_found_message": "No category found",
    "basket_page_error_remove": "Product was already removed from your cart.",
    "basket_page_totals_delivery": "Delivery:",
    "login_register": "Register",
    "text_account_orderHistory_page_sort_byOpenQty": "Open Qty-Asc",
    "text_quickOrder_page_emea_apac_part_no": "Knorr-Bremse Part No. / Customer Part No.",
    "address_province": "Province",
    "guest_required_message": "Fields marked * are required",
    "address_phone_invalid": "Incorrect phone number",
    "basket_page_shipping_change_store": "Change Store",
    "pdp_page_quantity": "Qty",
    "text_core_taillift": "Taillift Required?*",
    "checkout_page_summary_change_shipping_address": "Change Shipping Address",
    "static_category_sidenavigation_empty": "No sub categories found for \"{0}\"",
    "text_account_paymentDetails_noPaymentInformation": "No Saved Payment Details",
    "text_warranty_vehicle_manufacter": "Vehicle Manufacturer",
    "checkout_orderConfirmation_title": "Order Confirmation",
    "review_number_of": "of",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_country": "This value is invalid for this field",
    "basket_page_totals_savings": "Savings",
    "document_download_kb_text": "Download a Knorr-Bremse document",
    "checkout_multi_breadcrumb": "Checkout",
    "address_subarea": "Subarea",
    "basket_page_deliveryDateApac": "Requested Departure Date",
    "text_warranty_same_email_invalid": "Email 1 & 2 cannot be same",
    "sold_to_popup_text_two": "Contact Us",
    "quick_order_customer_reference": "Customer Item Ref. No.",
    "user_error_account_invalid_doubleOpt_msg": "Please confirm your registration in the e-mail with the confirmation link. Only then can your registration be processed and you will receive an e-mail with further information.",
    "text_warranty_rights_label": "Warranty Rights",
    "text_warranty_oem_label": "OEM (ADB Access/Only for Bendix)",
    "text_account_order_receivedPromotions": "Received Promotions",
    "quote_edit_done": "New Cart",
    "address_companyAddress_shipping_page_form_emea": "Address 2",
    "basket_page_min_order_qty": "Min Order QTY",
    "text_core_submission_upgradegrp": "Upgrade Core Class",
    "quote_submit": "Submit Quote",
    "text_generalInfo_coreClass": "Core Class",
    "text_quickOrder_page_na_part_no": "Bendix Part No. / Customer Part No.",
    "text_quickOrder_page_qty": "Qty",
    "text_account_quote_page_showAllResults": "Show all",
    "register_company_countryState_invalid": "Please Select State*",
    "basket_potential_promotions": "Potential Promotions",
    "text_consent_button_decline": "Decline",
    "product_share_email": "E-mail",
    "text_account_consent_withdrawn": "Your consent has been withdrawn",
    "text_account_quote_action_display_SAVE": "Save Quote",
    "basket_export_user_email": "Email",
    "popup_cart_core_charges": "Core Charges",
    "basket_validation_unavailable": "Unfortunately {0} was removed from your cart as it is no longer available.",
    "checkout_multi_paymentMethod_savedCards_paymentCard": "Payment Card",
    "text_core_submit_coreClass": "Core Class",
    "text_account_configuration_display": "View Configuration",
    "address_companyName": "Company Name*",
    "quote_accept_error": "Error accepting quote.",
    "text_account_orderHistory_page_sort_byPartNo": "Part No-Asc",
    "text_account_warranty_search_page_showAllResults": "Show all",
    "text_account_warranty_search_page_sort_byOrderNumber": "Warranty Claim Number",
    "text_account_addressBook_page_sort_byDateSaved": "Date Saved",
    "breadcrumb_home": "Home",
    "storeFinder_use_this_form": "Use this form to search for a store",
    "text_core_search_or": "OR",
    "text_account_orderHistory_page_sort_byTotalDesc": "Total-Desc",
    "register_accept_message": "Accept",
    "payment_expiryMonth_invalid": "Please select expiry month of the card",
    "text_account_addressBook_updateAddress": "Update Address",
    "file_size_kilobytes": "{0} KB",
    "checkout_multi_deliveryAddress_continue": "Get Availability & Final Review",
    "product_grid_subtotalText": "Subtotal",
    "basket_added_to_basket_pdp": "Added to Cart",
    "account_confirmation_default_address_changed": "Your default address was updated.",
    "checkout_security_code": "Security Code",
    "text_core_submit_crm_invalid": "Required",
    "storefinder_location_disabled": "Please enable location services from browser",
    "order_history_customer_po_number": "PO #:",
    "product_grid_editSize": "Edit",
    "basket_pickup_product_variant": "{0}: {1}",
    "checkout_multi_saveAddress": "Save Address",
    "text_warranty_submit_product_not_unique": "Product Not Unique",
    "checkout_summary_deliveryAddress": "Delivery Address",
    "text_viewfullsite": "View Full Site",
    "mycompany_legend": "Legend",
    "mobile_search_nav_clearSelections": "Clear all selections",
    "category_na_meta_description": "Bendix ABS, ATC, Actuators, Air Disc Brakes, Air Treatment, Compressors, Drum Brakes, Steering Gears, Valves, and Formula Blue Hydraulic Brakes",
    "register_title_emea": "Title*",
    "review_reviews": "Reviews",
    "text_account_orderHistory_page_firstPage": "&laquo;",
    "text_account_savedCarts_page_sort_byDateSaved": "Sort by : Date Saved",
    "product_grid_yourPrice": "Your Price",
    "checkout_orderConfirmation_Shipping_Address": "Shipping Address",
    "text_core_submission_crmno": "CRM Number",
    "basket_page_quote_discounts_link": "Discount",
    "basket_page_min_order": "Minimum Order Charge:",
    "quick_order_page_qty_validation": "Quantity and Request Delivery Date are mandatory, please enter the missing information.",
    "quick_order_page_qty_validation_emea": "Order Type, Quantity and Request Delivery Date are mandatory, please enter the missing information.",
    "checkout_summary_paymentMethod_paymentDetails_expires": "Expires {0} / {1}",
    "storeFinder_table_opening": "Opening Hours",
    "quote_approve_success": "Quote approved with success.",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_titleCode": "Please enter a value for this field",
    "text_account_quote_page_sort_byState": "Status",
    "text_account_addressBook_page_lastPage": "&raquo;",
    "quote_cart_comments": "Cart Comments",
    "text_account_addressBook_page_totalResultsSinglePag": "{0} Addresses",
    "popup_cart_quantity_added": "Quantity Added",
    "checkout_orderConfirmation_Customer_ID": "Customer ID:",
    "text_itemPrice": "Item Price",
    "checkout_orderConfirmation_order_Type": "Order Type:",
    "text_document_download": "Start Document Download",
    "text_core_submission_review_text": "Please review your form prior to submitting.  You will be unable to edit your form after it has been submitted.",
    "text_account_openPositions_back": "Back to Open Positions",
    "text_core_submission_pdfEMEA": "Core Manual (Y059594)",
    "text_quote_cancel_confirmation_modal_title": "Cancel Quote {0}",
    "search_nav_facetShowLess_availableInStores": "less stores...",
    "register_company_address_street_invalid": "Please enter the company address",
    "text_account_warranty_search_page_currentPage": "Page {0} of {1}",
    "text_account_core_search_totalResultsSinglePag": "{0} Result(s) found",
    "text_core_search_partNumber_EMEA": "Enter Knorr-Bremse Part #",
    "search_openPositions_export_line1": "Open Positions Export File status quo: {0}",
    "checkout_orderConfirmation_PO_Date": "PO #:",
    "checkout_multi_deliveryAddress_stepHeader": "1 - Select Delivery Address",
    "storeFinder_pagination_from": "from",
    "search_openPositions_export_line2": "Selection : {0},{1},Orders sent from {2} to {3}",
    "text_cutoff_timezone_EMEA": "Please note: {0} must be placed by {1} {2}",
    "text_account_profile_updateEmail": "Update your email",
    "text_warranty_search_claim_to_date": "Claim Date To*",
    "basket_error_product_removed": "Sorry, one or more products were removed from your cart as they are not in stock or are no longer available.",
    "text_weight_complete": "Weight complete. [kg]",
    "basket_page_quote_discounts_link_target_as": "Target as {0}",
    "text_account_savedcart_delete_popuptitle": "Delete Saved Cart",
    "DeliveryType_Partial_name": "Partial Delivery",
    "file_size_bytes": "{0} Bytes",
    "registration_error_generic": "An error occured. Please try again later.",
    "text_account_addressBook_page_sortTitle": "Sort by",
    "basket_restoration_delivery_changed": "{0} was restored to your cart, but the delivery method has changed due to low local stock.",
    "text_expires": "Expires",
    "updatePwd_title": "Update Password",
    "checkout_orderConfirmation_coupon_valid_from": "Valid from {0}",
    "payment_expiryYear_invalid": "Please select expiry year of the card",
    "basket_page_title_yourDeliveryItems": "Your Delivery Items",
    "saved_cart_total_number_one": "{0} Saved Cart",
    "checkout_orderConfirmation_pickupItems": "{0} Items for Pick Up in Store",
    "text_account_warranty_search_page_firstPage": "&laquo;",
    "text_account_profile_emailNotChanged": "Your email was not updated",
    "text_account_quote_cancel": "Cancel",
    "form_register_empty": "Select Your Country",
    "order_confirmation_guest_register_description": "For a Fast Checkout and Easy Access to Previous Orders",
    "product_variants_select_variant": "Please select variant",
    "text_remove": "Remove",
    "address_furtherSubarea": "Further subarea number, house number",
    "text_account_orderHistory_mobile_page_linkPreviousPage": "&laquo; Previous",
    "text_account_savedCart_qty": "Positions",
    "text_help": "Help",
    "register_company_countryCode_invalid": "Please select the company country",
    "text_storefinder_desktop_page_showAllResults": "Show all",
    "text_account_order_orderDetails_billingInformtion": "Billing Information",
    "text_account_orderHistory_page_sort_byPO": "PO No-Asc",
    "text_account_orderHistory_page_showAllResults": "Show all",
    "order_history_customer_reference_number": "Customer Reference #:",
    "warranty_eligibility_check_mileage_in_service": "Mileage in Service*",
    "checkout_multi_deliveryMethod_selectDeliveryMethodMessage": "Shipment Method",
    "text_none": "None",
    "header_customer_id": "Customer ID :",
    "warranty_claim_yes": "Yes",
    "text_warranty_search_customerID": "Customer ID",
    "coupon_order_recalculation_error": "Error occured while re-calculatinng the order.",
    "mobile_checkout_paymentMethod_addOrSelect_card": "Select a saved payment card from your wallet or add a new card",
    "updatePwd_pwd": "New Password",
    "storeFinder_orSearchBy": "Or search by:",
    "menu_button_home": "Home",
    "testuser_message_display": "Test User is not allowed to place an order",
    "text_account_order_delivery": "Delivery:",
    "basket_export_user_lastLogin": "Last Login",
    "basket_export_user_currency": "Currency",
    "text_headline_refinements": "Choose the relevance or add refinements",
    "text_account_profile_updateProfile_mobile": "Update Profile",
    "updatePwd_token_invalid": "The link used to access the update page was invalid.",
    "text_user_table_save": "Save",
    "address_district_and_street": "District and Street",
    "order_totals_subtotal": "Subtotal:",
    "address_subarea_invalid": "Please enter a subarea",
    "text_cookie_notification": "We use cookies to ensure that we give you the best experience on our website. If you continue, you agree with our policy statement.",
    "checkout_pickup_items_appear_later": "Order items to be picked up will appear later in the checkout",
    "checkout_order_type_maxQuantityExceeded": "You are allowed to order a maximum of {0} pieces per position based on the chosen order type as {1}. Please update your cart in order to continue further.",
    "text_warranty_submit_claim_type": "Claim Type*",
    "text_quote_discount_type_null_error": "The discount type is null.",
    "basket_add_to_basket": "Add to cart",
    "storeFinder_stores_nearto": "Stores near: {0}",
    "text_account_quote_status_display_SELLERAPPROVER_PENDING": "Pending Approval",
    "text_user_table_header_Core": "Core",
    "text_cutoff_timezone_NA": "Please note: Emergency orders must be placed by 4:00 pm EST",
    "checkout_pickup_items_to_be_delivered": "Items to be delivered",
    "text_weight_code": "[kg]",
    "b2b_unit_order_block_error_checkout": "You are unable to place an order at this time, please contact us",
    "text_account_savedCarts_page_firstPage": "&laquo;",
    "text_account_quote_page_sort_byCode": "Quote ID",
    "register_firstName_invalid": "Please enter a first name",
    "text_account_orderHistory_page_sort_byPartNoDesc": "Part No-Desc",
    "register_dataprotection_messageNA": "Data Protection Declaration",
    "product_grid_items_selected": "Quantity selected:",
    "basket_save_cart_description": "Description",
    "text_button_new": "New",
    "user_invalid_msg": "Your account has been locked, please contact your company administrator accordingly",
    "text_account_savedCarts": "Saved Carts",
    "text_generalInfo_customTarrifNo": "Harmonized System (HS) Code",
    "checkout_checkout_multi_deliveryAddress_viewAddressBook": "Address Book",
    "profile_currentPassword": "Current Password*",
    "core_report_pdf": "PDF",
    "text_total": "Total",
    "text_account_consent_already_given": "Consent already given",
    "text_headline_addtocart": "Click to add the product to cart",
    "text_account_order_orderStatus": "The order is {0}",
    "cart_total_poa_NA": "Price on Request is showing in your cart, we were unable to provide you a price at this time, however, you can continue with your order. <p>If you need additional assistance, please email us via <a target='_blank' href='https://b2bendix.com/contact-us-form'>contact us</a> or call 1-800-AIR-BRAKE,  option1.</p>",
    "text_account_savedCart_numberOfProducts": "Number of Products",
    "text_vmrsCodeRear": "VMRS Code (Rear)",
    "register_company_companyStateCode_invalid": "Please enter the company state",
    "basket_export_csv_file": "Export CSV",
    "profile_firstName": "First Name",
    "text_warranty_submit_part_otherCost": "Other Cost",
    "text_core_submission_EMEA_text2": "If you have got further questions about your submitted core return request, please contact your local Knorr-Bremse core team.",
    "mobile_checkout_cart_viewFullCart": "View Full Cart",
    "text_core_submission_EMEA_text1": "Thank you for submitting your core return request. You will receive an acknowledgement email with further information.",
    "register_site_companyrole_invalid": "Please Select Industry Role",
    "text_account_savedCart_edit": "Edit & Save",
    "text_media_languages": "Languages",
    "checkout_error_paymentethod_formentry_sop_missing_card_issueNumber": "Please enter an issue number",
    "forgottenPwd_email": "Email Address",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_street2": "This value is invalid for this field",
    "checkout_summary_paymentMethod_addPaymentDetails_savePaymentDetailsInAccount": "Save these payment details in my account",
    "product_variants_available": "available online",
    "checkout_summary_paymentMethod_savedCards_noExistingSavedCards": "You don't have any saved cards",
    "storeFinder_navigateTo": "Navigate To",
    "text_account_online_order_rights": "Online Ordering Rights",
    "text_emergencyOrder_withoutstock_message6": "Instead, this order will be shipped as order type \"Stock\" with applicable freight costs as soon as the requested quantity will be available.",
    "text_emergencyOrder_withoutstock_message7": "You can now either continue without changes to checkout or go back to your cart and change the order type accordingly.",
    "text_emergencyOrder_left_quotes": "\"",
    "text_emergencyOrder_right_quotes": "\"",
    "text_popup_title_emergency": "Emergency Orders",
    "text_popup_title_Vor": "VOR Orders",
    "na_text_emergencyOrder_withoutstock_message1": "The requested quantity for",
    "na_text_emergencyOrder_withoutstock_message2": "part no.",
    "na_text_emergencyOrder_withoutstock_message3": "is not fully available. Therefore, the order type",
    "na_text_emergencyOrder_withoutstock_message4": "will not ship today.",
    "na_text_emergencyOrder_withoutstock_message5": "You can continue to checkout or go back to your cart to adjust your order.",
    "na_text_emergencyOrder_withoutstock_message6": "Emergency order fee will still apply if you continue to checkout",
    "text_account_quote_action_display_CANCEL": "Cancel Quote",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_street1": "This value is invalid for this field",
    "import_csv_savedCart_genericError": "Error in uploading the order template. Please try again or contact customer service.",
    "import_csv_core_genericError": "An error happened in uploading your core return template_ Please try again or contact <u><a href",
    "text_headline_marketType": "Market Type",
    "text_account_quote_date_updated": "Date Updated",
    "text_account_quote_date_created": "Date Created",
    "checkout_multi_deliveryAddress_useThisAddress": "Use this Address",
    "text_headline_terms": "Agree with the terms and conditions",
    "checkout_summary_paymentMethod_savedCards_UseThisSavedCard": "Use these payment details",
    "address_firstName_invalid": "Please enter a first name",
    "basket_export_user_lastName": "Last Name",
    "checkout_pickup_pickup_in_store_title": "PICKUP IN STORE",
    "review_required": "Fields marked* are required",
    "basket_validation_movedFromPOSToStore": "Your items have been modified to match available stock levels. One or more pickup in store items were updated to shipping.",
    "checkout_deliverydate_past": "The requested delivery date cannot be less than {0}.",
    "popup_cart_total": "Total",
    "text_account_orderHistory_page_sort_byOrderTypeDesc": "Order Type-Desc",
    "text_account_orderHistory": "Order History",
    "basket_page_quantity": "Quantity",
    "text_account_savedCarts_page_sort_byName": "Sort by : Name",
    "text_warranty_submit_parts_disposition": "Parts Disposition if denied*",
    "checkout_page_summary_final_review_order_type": "Order Type:",
    "account_confirmation_signout_title": "You have signed out of your account.",
    "basket_page_validation_message": "Product(s) have been updated/removed in your cart.",
    "profile_checkEmail": "Confirm New Email Address",
    "text_dimension": "Dimensions (L x W x H)",
    "basket_page_emea_orderQty": "Order Qty",
    "basket_page_1_pc_only": "(1 PC Only)",
    "order_history_subtotal": "Subtotal:",
    "text_user_table_header_Warranty": "Warranty",
    "search_page_xref_name": "Cross-Ref Name",
    "text_account_order_status_display_completed": "Completed",
    "text_sales_status_description_emea_code_40": "Saleable to the IAM - whilst stocks last",
    "basket_page_product": "Product",
    "product_grid_in_stock": "In Stock",
    "checkout_error_cart_notcalculated": "We are sorry but your transaction could not be completed at this time; please try again later or contact customer service at 555-555-5555",
    "mobile_checkout_deliveryAddress": "Delivery Address",
    "text_quote_state_label": "Status",
    "storeFinder_currentPosition": "Current Position",
    "import_csv_savedCart_uploadTemplate": "Choose File",
    "cart_page_checkout_no": "No",
    "text_generalInfo_vrms": "VMRS Codes / Description",
    "address_selectState": "State / Province",
    "review_write_title_product": "Write a Review for {0}",
    "basket_page_title_pickupFrom": "Pick Up from:",
    "text_account_orderHistory_noOrders": "No Orders Found",
    "text_quote_name_label": "Name",
    "text_enter_partnumber_placeholder": "Enter Partnumber",
    "storeFinder_table_store": "Store",
    "text_consent_and": "and the",
    "login_error_account_not_found_title": "The entered email address or password is not correct.",
    "register_company_companyStateCode_japan": "Prefecture*",
    "account_error_login_please": "You must login to access this page. Please log in with your credentials below.",
    "checkout_multi_paymentMethod_addPaymentDetails_useThesePaymentDetails": "Use these payment details",
    "checkout_multi_sop_globalError": "An error occurred processing your request. Possible action: Wait a few minutes and resend the order.",
    "basket_page_na_orderQty": "Qty",
    "checkout_multi_paymentMethod_savedCards_actions": "Actions",
    "text_account_profile_updatePasswordForm": "Update Password",
    "account_confirmation_profile_updated": "Your profile has been updated.",
    "text_ExportMyData_label": "Export My Data",
    "text_PrintCertificate_label": "Certificate of participation",
    "text_spe_Certificate_label": "Certificate of participation",
    "text_spe_Certificate_nach_label": "Confirmation § 29 StVZO",
    "text_data_sheet_print_label": "Datasheet",
    "register_company_companyStateCode": "State*",
    "product_grid_viewFuture": "Future",
    "text_account_quote_page_totalResultsCurrPage": "{0} of {1} Quotes",
    "text_account_savedCarts_page_showAllResults": "Show all",
    "checkout_edit": "Edit",
    "text_quote_code": "Quote ID:",
    "text_account_quote_action_display_CREATE": "Create Quote",
    "label_emea_snd": "Saturday am next day delivery",
    "checkout_error_paymentethod_formentry_sop_invalid_card_cardType": "The card type is not supported",
    "core_error_reports_na": "You do not have permission, please <a href",
    "text_myaccount": "&laquo; My Account",
    "import_csv_savedCart_enterContentNoteEmea": ", enter your information on the file, select your order type and click on",
    "checkout_login_guestCheckout": "Check Out as a Guest",
    "text_account_quote_status_display_EXPIRED": "Expired",
    "text_core_submission_address_emea": "If the collection address is not provided in the selection above, then please fill in the collection address in the entry fields below:",
    "text_core_submission_address_na": "If the pickup address is not provided in the selection list above, please add a new address below:",
    "text_backToMobileStore": "Mobile",
    "text_account_order_appliedCoupons": "Applied Coupons:",
    "text_account_warranty_table_header_credit_memo": "Credit Memo #",
    "text_warranty_eligibility_error": "Error in Warranty Eligibility Check. Please try again or contact customer service.",
    "password_strength_minchartext": "Password must contain at least %d characters, upper and lower case letter, number, a special character and must not contain part or full name",
    "label_emea_collection": "Collection",
    "warranty_eligibility_check": "Warranty Eligibility Check",
    "warranty_terms": "Warranty Terms",
    "warranty_quick_coverage_guide": "Quick Coverage Guide",
    "warranty_documents": "Warranty Documents",
    "warranty_shipping_packaging": "Shipping/Packaging",
    "mobile_basket_page_update": "Update quantity",
    "checkout_paymentMethod_noSecurityCode": "Please provide security code.",
    "address_line1_shipping_page_form_emea": "Address*",
    "checkout_summary_deliveryAddress_useForNewAddress": "Please use this form to enter a new address",
    "text_warranty_terms_school_bus": "School Bus",
    "search_nav_facetShowMore_size": "more sizes...",
    "payment_cardType": "Card type",
    "text_account_addressBook_page_currentPage": "Page {0} of {1}",
    "product_product_partnumber": "Part No:",
    "checkout_error_terms_not_accepted": "Please accept our terms & conditions before submitting your order.",
    "register_email_invalid": "Please enter a valid email",
    "import_csv_savedCart_fileContentNote": "To use this feature - Select your order type, click on",
    "search_nav_resultsForStore": "Results for: {0}",
    "text_select_you_can_upload": "You can only upload max 9 mb",
    "checkout_summary_paymentMethod_securityCode": "Security Code",
    "core_report_csv": "CSV",
    "text_storefinder_desktop_page_showPageResults": "Show paginated",
    "text_quote_expiration_time_label": "Expiry Date",
    "checkout_summary_paymentMethod_addPaymentDetails_useSavedCard": "Use a saved card",
    "text_select_specific_file": "Select file you wish to upload and click on the \"Upload\" button. Each upload file will be added to the claim.",
    "address_city_shipping_page_form": "City*",
    "text_account_order_consignment_status_processing": "In Process",
    "text_account_closeAccount_retention_info": "When you close your account, your personal information will be kept for the duration of the statutory retention periods. For more information, please refer to our <a target=\"_blank\" href=\"https://qa-mytruckservices.knorr-bremse.com/UK/en_GB/GBP/privacyNote\"> Privacy Notice.</a> Customer Support will be able to assist you with any order history or proof of purchase needs during this time.<br/><br/>At the end of the retention period, the following profile information will be deleted and will no longer be accessible to you or anyone else:<br/><br/><ul><li>email addresses</li><li>contact information</li><li>shipping details</li><li>delivery preferences</li><li>consent management settings</li><li>account history</li><li>payment details</li><li>order history</li></ul>",
    "text_register_caps": "REGISTER",
    "core_report_EMEA_description": "You can download on this page your Knorr-Bremse core reports from the previous 24 months.Core report updates will be provided online in the beginning of the following month.",
    "basket_page_free": "FREE",
    "text_account_quote_status_display_BUYER_DRAFT": "Draft",
    "checkout_summary_placeOrder_readTermsAndConditions": "By placing the order, I am confirming that I have read and agree with the",
    "text_warranty_submit_part_labourAmount": "Labor Amount (Auto fill)",
    "checkout_multi_paymentMethod_paymentDetails_noneSelected": "None selected",
    "address_building_and_room": "Building Name and Room Number",
    "register_submit": "Register now",
    "storelocator_query": "Postcode / Town",
    "basket_export_user_website": "Website Address",
    "text_account_order_totalSavings": "You saved {0} on your order",
    "system_error_page_not_found": "404 Page Not Found",
    "text_account_savedcart_activecart_msg": "The current items in the cart will be saved as:",
    "text_warranty_print": "Print",
    "product_variants_select_size": "Select a size",
    "login_required_message": "Fields marked * are required",
    "password_strength_weak": "Weak",
    "text_country_selector_EMEA": "Europe",
    "text_voucher_apply_input_placeholder": "enter coupon code",
    "text_quote_illegal_state_error_reason": "Please note that {0} action you tried to perform is not allowed for quote {1} with {2} status. Reason: {3}",
    "register_termsConditions_id": "termscondition-check",
    "register_lastName_invalid": "Please enter a last name",
    "text_quote_dateformat": "MM/dd/yyyy",
    "pickup_pagination_previous": "Previous",
    "register_checkPwd": "Confirm Password*",
    "text_account_paymentDetails_paymentCard_default": "My Default Payment Card",
    "text_quote_no_button_label": "No",
    "text_warranty_document_once_claim": "Once the claim is sent, it is not longer possible to attach a document.",
    "text_quote_checkout_confirmation_modal_title": "Confirm Accept and Checkout Quote {0}?",
    "import_csv_savedCart_fileContentEmea": "Must be a saleable Knorr-Bremse part number",
    "text_account_savedcart_delete_msg": "The following cart will be deleted",
    "text_account_order_consignment_status_pickedup": "Picked Up",
    "storeFinder_store_locator": "Store Locator",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_country": "Please enter a value for this field",
    "text_warranty_eligibility_endDateLesser_error_title": "Date Removed from Service should be greater than Date in Service",
    "storeFinder_meta_title": "Stores near",
    "text_account_quote_code": "Quote ID",
    "text_account_warranty_claim_search": "Warranty Claim Search",
    "order_history_customer_ID": "Customer ID",
    "checkout_multi_summary_breadcrumb": "Final Review",
    "search_mobile_page_showAllResults": "Show all",
    "product_grid_availability": "Availability",
    "checkout_paymentMethod_createSubscription_billingAddress_noneSelected": "Please enter a billing address or enter a delivery address first so that it can be used as billing address.",
    "text_warranty_submit_button": "Submit",
    "checkout_page_summary_final_review_customerId": "Customer ID:",
    "checkout_multi_deliveryAddress_addressBook": "Address Book",
    "text_core_submit_coreLineItems_invalid": "Required",
    "quote_cart_title": "This cart is being quoted",
    "product_grid_averagePriceUnitText": "Average Price / Unit",
    "system_error_link_expired_subtitle": "Complete the forgotten password form again.",
    "price_to_use_feature": "To use this feature, select the price files you want to download then click on download your price file button.",
    "register_company_address_street_emea1": "Address*",
    "basket_page_quote_discounts_link_absolute_off": "{0} off",
    "text_plp_page_impp": "IAM p/n:",
    "review_rating": "Your Rating",
    "text_warranty_terms_some_parts": "**Some parts could have extended warranties, please look under the Warranty Document tab for information.",
    "register_companystreet_name_invalid_kbRegisterForm_companyStreetNumber": "Please enter the House Number",
    "general_month_august": "August",
    "text_account_core_search_linkPreviousPage": "Previous Page",
    "checkout_multi_paymentMethod_savedCards_billingAddress": "Billing Address",
    "label_emea_bnd": "Before 9am next day delivery",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_street1": "Please enter a value for this field",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_street2": "Please enter a value for this field",
    "product_variants_only_left": "only {0} left online",
    "registration_confirmation_message_title": "Thank you for submitting your registration, you will be receiving an email to confirm your registration.",
    "demo_registration_confirmation_message_title": "Thank you for submitting your demo registration, please select the available demos from below.",
    "basket_page_netpriceApac": "Net Price (Total)",
    "general_continue_shopping": "Continue Shopping",
    "text_quote_conteroffer_possible_checkout_message": "This is a binding vendor quote. The buyer may check out immediately.",
    "mobile_checkout_edit_link": "Edit",
    "checkout_orderConfirmation_Total": "Total",
    "checkout_checkout_multi_pci_select": "Select a PCI option",
    "text_homepage_banner_label": "WELCOME TO B2BENDIX.COM",
    "pdp_page_listprice": "List Price",
    "text_percentage": "%",
    "text_headertext_info": "Info",
    "text_storefinder_desktop_page_sortTitle": "Sort by:",
    "text_account_orderHistory_page_sort_byDateDesc": "Date-Desc",
    "register_checkbox_list_label": "List Price",
    "text_account_order_consignment_store_title": "Store",
    "quote_state_expired": "This quote has expired. Create a new quote or edit the expired quote.",
    "basket_page_message_update_pickupinstoreitem_toship": "Pickup in store item was updated to shipping.",
    "search_nav_facetShowLess_price": "less prices...",
    "search_nav_facetValueCount": "({0})",
    "review_rating_alt": "stars",
    "core_report_NA_description_example": "Example: On January 1st you can download your December core report which will show all your December activity.",
    "text_headline_breadcrumbs": "Breadcrumbs",
    "text_account_savedcart_restore_popuptitle": "Restore Saved Cart",
    "header_mobile_link_login": "Login",
    "orderHistory_page_totalResultsDetails": "{0} of {1} Orders",
    "mycompany_enter_name_placeholder": "Enter a name or an email address",
    "form_select_none": "None",
    "text_quote_submit_confirmation_message": "Are you sure you want to submit this quote?",
    "text_generalInfo_grossWeight": "Gross Weight",
    "text_account_addressBook_setDefaultDeliveryAddress": "Set default delivery address",
    "basket_restoration_unavailable": "Unfortunately {0} is no longer available. You previously had {2} in your cart.",
    "updatePwd_token_invalidated": "Your password has already been updated.",
    "pagination_view": "View",
    "text_voucher_apply_input_label": "Coupon code",
    "profile_pwd_invalid": "Please enter your password",
    "register_site_companyrole": "Industry Role*",
    "storeDetails_table_features": "Features",
    "text_core_submit_address_addressPhone": "Phone",
    "basket_page_customerPrice": "Customer Price",
    "text_account_orderHistory_actions": "Actions",
    "text_pagenotexist_error": "That page Doesn't Exist!",
    "payment_expiryDate": "Expiry date*",
    "address_zipcode": "Zip / Postal Code",
    "quote_less_comments": "View less comments",
    "checkout_multi_deliveryMethod_noExistingDeliveryMethod": "No delivery method currently exist.",
    "quote_cart_checkout_error": "The vendor quote was modified, Please Accept & Checkout again.",
    "text_consent_dpr_pdp": "privacy notice",
    "customeradmin_check": "Customer Admin",
    "registration_error_account_exists_subtitle": "If you forgot your password, please use the Forgotten Password link.",
    "text_core_submit_address_countryISO": "Country*",
    "text_account_order_includesTax": "Your order includes {0} tax",
    "import_csv_savedCart_title": "Order Import",
    "text_warranty_terms_logging_vehicle": "Logging or Mining vehicles",
    "checkout_multi_purchaseOrderNumber_label_NA": "Customer PO#*",
    "register_back_login": "Back to login",
    "checkout_multi_paymentMethod_createSubscription_failedMsg": "Failed to create subscription. Please check the values entered.",
    "checkout_pages_availabilty_final_review_NA": "Next",
    "text_warranty_submit_part_description": "Description (auto fill)",
    "address_shipping_page_form_na": "Street Address*",
    "text_account_savedCart_description": "Description",
    "register_termsConditions": "I am confirming that I have read and agreed with the <a class",
    "text_account_orderHistory_page_totalResultsSinglePag": "{0} Orders",
    "text_address_remove_following": "The following address will be deleted from your Address Book",
    "quote_cancel": "Cancel Quote",
    "quote_save_cart_error": "There was an internal error. Please try again.",
    "checkout_checkout_multi_pci-hop": "PCI-HOP",
    "text_account_quote_manage_items": "Manage Items",
    "basket_received_promotions": "Received Promotions",
    "text_quote_validity_message": "This quote is valid until {0}",
    "text_account_order_status_display_Error": "Pending",
    "text_account_orderHistory_page_sort_byDescription": "Description-Asc",
    "text_warranty_note": "Note:",
    "core_submit_warranty_material_included": "Warranty Material Included?",
    "text_account_savedCarts_page_totalResultsCurrPage": "{0} of {1} Saved Carts",
    "text_skipToContent": "Skip to content",
    "pickup_search_message": "Enter your Zip/Postal Code or your City with State/Province:",
    "text_quote_submit_confirmation_modal_title": "Confirm Requested Quote {0}?",
    "pickup_pagination_last": "Last",
    "checkout_page_summary_deliveryMode_selectDeliveryMethodForOrder": "Delivery Type",
    "checkout_multi_hostedOrderPageError_breadcrumb": "Error",
    "register_webshop_id": "webshop-check",
    "text_account_order_consignment_status_cancelled": "Cancelled",
    "text_warranty_size": "Size",
    "address_phone": "Phone number",
    "demo_access_code": "Demo Access Code",
    "text_headline_footer_navigationbar": "Browse through the footer navigation bar",
    "text_warranty_submit_part_otherCostDescription": "Other Cost Descriptions",
    "review_show_more": "Show More",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_state": "This value is invalid for this field",
    "text_warranty_terms_ineterstate_truck": "Interstate Truck",
    "text_account_orderHistory_mobile_page_totalResults": "{0} Orders found",
    "product_related_products": "Related Products",
    "text_account_core_breadcrumbEMEA": "Core Group Finder",
    "basket_page_orderQty": "Order Qty",
    "text_reports_creditRecon": "Reconciliation",
    "text_quickOrder_product_quantity_invalid": "Invalid quantity",
    "search_nav_removeAttribute": "Remove Attribute",
    "checkout_summary_deliveryMode_editDeliveryMethod": "Edit Delivery Method",
    "saved_quote_total_number": "Quotes ({0})",
    "text_account_paymentType": "Payment Type",
    "basket_information_quantity_reducedNumberOfItemsAdded_lowStock": "A lower quantity of this product has been added to your cart due to insufficient stock",
    "checkout_orderConfirmation_thankYouForOrder": "Thank you for your Order!",
    "order_itemPrice": "Item Price",
    "text_company_manage_units_notActivated": "Your account has not been activated yet, please contact your customer admin for further information.",
    "text_warranty_upload_file": "Upload Files",
    "text_headline_weightAndDimension": "Weight and Dimensions",
    "To": "use this feature - Click on <b>Download Order Template</b>, enter your information on the file, select your order type and click on <b>Upload Order Template</b>",
    "mobile_checkout_cart_viewLess": "View less",
    "text_company_users_label": "Company Users",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_lastName": "This value is invalid for this field",
    "text_reports_summaryNa": "All high level core group activity",
    "text_warranty_submit_labourrequested_yes": "Yes",
    "checkout_multi_paymentMethod_addPaymentDetails_generalError": "An error occurred contacting the payment provider.  Wait a few minutes and try again.  If the problem persist, please contact our sales team.",
    "text_account_order_status_display_cancelling": "Cancel Pending",
    "checkout_orderConfirmation_continueShopping": "Continue Shopping",
    "text_core_submission_thank_text": "Thank you, Your Bendix Core Team",
    "core_check": "Core",
    "popup_close": "Close",
    "text_warranty_search_claim_ref_no": "Customer Claim Reference No.",
    "text_select_you_record_sets": "Record Sets:",
    "text_quickOrder_form_product_exists": "Sku already exists in the form",
    "text_account_savedCart_link": "Save Cart",
    "register_terms_condition": "General conditions of Sale and Delivery",
    "register_termsOfUsage": "Terms of Usage",
    "corePrice_check": "Core Price",
    "text_quote_name_description_invalid": "Please enter a valid name and description",
    "address_selectProvince": "Province",
    "cart_page_estdelivery": "Est Delivery Date",
    "text_core_submit_lastName": "Last Name",
    "text_weight": "Weight",
    "basket_validation_invalidGroup": "This group is improperly configured. Please edit it.",
    "import_csv_savedCart_fileContentNoteEmea": "To use this feature - Click on",
    "address_townJP_invalid": "Please enter a city, village, city ward",
    "basket_error_date_invalid": "Please select a date not earlier than {0}.",
    "search_mobile_page_linkNextPage": "Next &raquo;",
    "checkout_orderConfirmation_thankYouForOrder_bendix": "Thank you for ordering from Bendix, Below is your order summary.",
    "general_mobile_store": "Mobile Store",
    "text_filter_by": "Filter By",
    "text_account_quotes_page_totalResultsCurrPage": "{0} of {1} Quotes",
    "basket_export_user_status": "Status",
    "search_nav_facetTitle": "Shop by {0}",
    "basket_page_entry_unknownAction": "Unknown cart entry action",
    "text_account_paymentDetails_managePaymentDetails": "Manage your payment details",
    "basket_page_message_update": "Product quantity has been updated.",
    "sold_to_popup_text_one": "You cannot place an order at this time, please",
    "checkout_summary_paymentMethod_savedCards_selectSavedCardOrEnterNew": "Select existing payment details or enter new payment details",
    "text_account_core_search_totalResultsSingleOrder": "1 Result found.",
    "text_account_quote_page_totalResultsSinglePag": "{0} Quotes found",
    "checkout_summary_paymentMethod_savedCards_billingAddress": "Billing Address",
    "mobile_checkout_deliveryMethod": "Delivery Options",
    "cart_page_customer_reference": "Customer Item Ref. No.",
    "address_phoneNumber": "Phone Number",
    "account_error_account_not_found": "No account was found for the email address provided.",
    "checkout_error_paymentethod_formentry_sop_invalid_card_cvNumber": "The security code is not valid",
    "checkout_multi_paymentMethod_breadcrumb": "Payment & Billing Address",
    "text_headline_register": "Click here to register a new customer",
    "basket_save_cart_on_error": "There was an exception while saving Cart {0}",
    "text_account_warranty_table_header_status": "Status",
    "basket_export_user_userCreated": "User Created / Activation Date",
    "mycompany_click_delete_user": "Click to Delete User",
    "doubleopt_confirmation_message_title": "Thank you for confirming your registration, you will be receiving an email with log-in details once approved.",
    "product_view_details_typenumber": "Type #",
    "j_username": "Login",
    "checkout_orderConfirmation_success": "Your order was successful!",
    "text_quickOrder_page_price": "Price",
    "checkout_order_type_lineEntriesExceeded_emergencyEMEA": "You have selected {0} order: You can order 2 positions with a maximum of 2 pieces per position. Please update your cart in order to continue further.",
    "quote_not_editable": "Quote ID : {0} is not editable",
    "text_warranty_vehicle_identification_number": "Vehicle Identification Number*",
    "text_warranty_vehicle_identification_notnumber": "Vehicle Identification Number",
    "text_checkout_pickup_in_store": "Pickup in Store",
    "text_reports_credit": "Debit/Credit Reconciliation",
    "mobile_checkout_deliveryAddress_selectAddressMessage": "Choose a delivery address from your address book, or add a new one",
    "text_warranty_submit_part_totalCost": "Total Cost (Auto fill)",
    "product_share_tweet": "Tweet this",
    "checkout_multi_paymentMethod_continue": "Next",
    "resetPwd_title": "Reset Password",
    "checkout_summary_paymentMethod_savedCards_enterNewPaymentDetails": "Enter new payment details",
    "basket_restoration_view_cart": "<a href",
    "checkout_orderConfirmation_thankYouForOrder_emea": "Thank you for ordering from Knorr-Bremse Commercial Vehicle Systems. Below is your order summary",
    "text_account_order_orderNumberLabel": "Your Order Number is",
    "basket_cartpage_kb_partNo": "Knorr-Bremse",
    "text_storefinder_responsive_page_firstPage": "&laquo;",
    "text_account_addressBook_saveAddress": "Save address",
    "search_page_showAllResults": "Show all",
    "text_address_remove_confirm": "Are you sure you want to delete this address?",
    "text_account_order_consignment_trackingID_notavailable": "Not available.",
    "profile_email_unique": "The email you entered is not available",
    "checkout_summary_edit": "Edit",
    "checkout_page_summary_final_review_order_note": "Order Note:",
    "text_account_orderHistory_page_linkPreviousPage": "Previous Page",
    "text_core_submit_address_addressFax": "Fax",
    "breadcrumb_not_found": "Page Not Found",
    "label_emea_uk_pksh": "Next day before 12pm",
    "text_warranty_select_all_files": "All files has been attached successfully",
    "text_core_submit_crm": "CR Number*",
    "text_core_na_submit_crm": "Bendix Core Return Number",
    "text_core_submit_customercrm": "Customer Reference Number",
    "text_core_search_crm": "CR Number",
    "basket_page_cartHelpMessageMobile": "Need help? <br />Call our team to help you directly <a href",
    "choose_delivery_carrier_account_number": "Your Carrier account number",
    "address_title_pleaseSelect": "Please select...",
    "text_account_quote_status_display_SELLERAPPROVER_DRAFT": "Draft",
    "text_warranty_submit_claim_information": "Claim Information",
    "basket_page_totals_noNetTax": "*No taxes are included in the total",
    "checkout_order_type_lineEntriesExceeded_emergencyNA": "You have selected {0} order: You can order 2-line items with a maximum of 2 pieces per line. Please update your cart in order to continue further.",
    "text_core_submission_clarify": "Please clearly label the parts \"warranty material\"",
    "product_emea_meta_description": "Get detailed information about the selected Knorr-Bremse product including technical attributes, associated documents, service solutions and tools.",
    "text_storefinder_mobile_page_description": "Please provide your location to see stores in your area or let your device find nearby stores for you",
    "text_expresscheckout_header": "Express Checkout",
    "text_storefinder_desktop_page_linkPreviousPage": "Previous",
    "register_dataprotection_message": "Privacy Notice",
    "text_quote_illegal_state_error": "Please note that {0} action you tried to perform is not allowed for quote {1} with {2} status",
    "text_account_quote_page_showPageResults": "Show paginated",
    "checkout_orderConfirmation_Order_Date": "Order Date:",
    "text_account_quote_page_lastPage": "&raquo;",
    "register_pwd": "Password*",
    "review_confirmation_thank_you_subtitle": "We try to put all reviews on the site within 24 hours.",
    "updatePwd_pwd_invalidMatch": "Password must meet the given requirements",
    "quote_view": "View Quote",
    "basket_error_no_pickup_location": "Please select stores for the entries highlighted in red",
    "basket_cartpage_typeNo": "Customer Part No.",
    "cart_basket_typeNo": "Type No.",
    "search_meta_description_on": "on",
    "text_account_order_consignment_pickUpBy": "Pick Up By",
    "download_agree_disclaimer_text": "I agree to the disclaimer",
    "review_write_description": "Please enter your review",
    "basket_information_quantity_noItemsAdded_noStock": "Sorry, there is insufficient stock for your cart.",
    "text_account_profile_paymentCart_removed": "Payment Card removed successfully",
    "text_account_orderHistory_mobile_page_sort_byDate": "Date",
    "password_strength_strong": "Strong",
    "text_sales_status_description_apac_code_40_anonymous": "Saleable to the IAM",
    "validation_checkEmail_equals": "Email and Re-enter email address does not match",
    "mobile_checkout_continue_shopping": "Continue Shopping",
    "text_account_savedCarts_page_totalResultsSinglePag": "{0} Saved Carts",
    "register_company_website": "Website Address",
    "text_account_orderHistory_page_sort_byDescriptionDesc": "Description-Desc",
    "basket_items": "Items",
    "text_quickOrder_page_product": "Product",
    "basket_page_cartHelpContent": "Need Help? Contact us or call Customer Service at 1-###-###-####. If you are calling regarding your shopping cart, please reference the Shopping Cart ID above.",
    "vor_text_warning": "Please ensure you have entered the complete address including post code as per the correct mail standard format.",
    "guest_checkout": "New to {0}?",
    "quote_newcart_error": "An error occurred processing your request. Please try to submit your request again.",
    "breadcrumb_quote_edit": "Edit Quote",
    "checkout_summary_paymentMethod_addPaymentDetails_useSavedCard_description": "Registered customers may select a previously saved card",
    "basket_restoration_lowStock": "Unfortunately a lower quantity of {0} was restored to your cart due to low stock. {3} were added to your cart, you now have {2}.",
    "text_account_orderHistory_page_sort_byTotal": "Total-Asc",
    "text_account_quote_action_display_EDIT": "Edit Quote",
    "basket_page_poa": "Price on Request",
    "storeDetails_title": "Store Details",
    "order_history_realtime_heading": "The information on this  page is real-time information. Updated delivery information is shown in red colour.",
    "text_account_consent_consentManagement": "Consent Management",
    "address_room": "Room Number",
    "text_guest_customer": "Guest",
    "checkout_multi_paymentMethod_addPaymentDetails_enterYourCardDetails": "Please enter your card details for payment",
    "profile_checkPwd": "Confirm Password*",
    "profile_checkEmail_invalid": "Please confirm your email address",
    "checkout_checkout_flow_select": "Select an alternative checkout flow",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_shippingMethod": "This value is invalid for this field",
    "basket_page_itemDescription": "Description",
    "checkout_multi_hostedOrderPageError_continue": "Continue",
    "review_see_reviews": "Show Reviews",
    "checkout_information_delivery_method_changed": "Your delivery method has been updated based on your delivery location.",
    "text_account_order_qty": "Qty",
    "address_regionIso_shipping_form": "State/Province*",
    "text_iconCartRemove": "Remove",
    "pdp_page_corecharges": "Core Charges",
    "basket_page_totals_discounts": "Order Discounts:",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_lastName": "This value is invalid for this field",
    "basket_page_entry_action_REMOVE": "Remove",
    "register_company_address_city": "City*",
    "register_demo_code": "Demo Code",
    "quote_comment_invalid": "Comment cannot be more than 255 characters",
    "general_month_february": "February",
    "text_account_profile_changePassword_mobile": "Change Password",
    "text_account_viewOrderHistory": "View order history",
    "saved_cart_total_number": "Saved Carts ({0})",
    "checkout_error_paymentethod_formentry_invalid": "Please check your payment details are correct or provide a different payment method.",
    "checkout_multi_sop_remove": "Remove",
    "pickup_pagination_page_details": "{0} to {1} of {2}",
    "checkout_error_paymentethod_formentry_sop_invalid_card_startMonth": "The start month is not valid",
    "checkout_pickup_store_destinations": "{0} store pickup destination(s)",
    "product_product_details_future_title": "Future availability",
    "text_account_table_head_order_category": "Order Category",
    "saved_cart_total_description": "You have",
    "NotBlank_orderHistoryForm_startDate": "Please enter Start Date",
    "review_confirmation_thank_you_title": "Thank you for your review.",
    "text_core_submit_emailAddress": "Confirmation email address*",
    "text_max_vehicle_size": "e.g. max. vehicle size",
    "checkout_order_type_lineEntriesExceeded": "You are allowed to order a maximum of {0} lines based on the chosen order type as {1}. Please update your cart in order to continue further.",
    "checkout_summary_paymentMethod_savedCards_actions": "Actions",
    "popup_quick_view_select": "Select Options",
    "basket_export_user_core": "Core Reports",
    "text_delete_savedcart_error": "Error while deleting saved cart",
    "checkout_summary_placeOrder_readTermsAndConditions_EMEA": "By placing the order, I am confirming that I have read and agree with the <a class",
    "text_storefinder_responsive_page_currentPage": "{0} of {1}",
    "registration_consent_link": "To view other options or to change your settings, go to the Consent Management page in My Account.",
    "checkout_orderConfirmation_Carrier_Selection": "Carrier Selection:",
    "basket_error_invalid_configuration_edit": "Resolve issues",
    "checkout_orderConfirmation_coupon_valid_until": "Valid until {0}",
    "text_consent_button_more": "Learn more",
    "text_warranty_submit_part_add": "Add a Part Number",
    "order_orderItems": "Order Items",
    "register_company_address_street_emea": "House Number",
    "register_company_address_street_emea_lite_user": "House Number",
    "text_reports_summary": "Summary",
    "text_account_savedCart_backToSavedCarts": "Back to Saved Carts",
    "text_quickOrder_delivery_date": "Delivery Date",
    "text_productDetails": "Product Details",
    "text_account_order_orderBreadcrumb": "Order Details",
    "text_account_quote_page_linkNextPage": "Next Page",
    "cart_total_note": "* freight costs/charges can be added",
    "please_select_state_text": "Please Select",
    "storeFinder_find_a_store": "Find an Authorized Bendix outlet near you",
    "text_button_cancel": "Cancel",
    "text_warranty_terms_charter_bus": "Interstate or Charter Bus",
    "basket_page_shipping": "Shipping",
    "text_core_submit_soldto": "Customer ID",
    "text_account_order_status_display_error": "Pending",
    "quote_reject_error": "Error rejecting quote.",
    "b2b_unit_order_blocked_login": "Please contact customer service.",
    "order_history_order_type_others": "Others",
    "text_company_manageUser_registration_totalResults": "New Request(s) Found",
    "address_district_invalid": "Please enter a district",
    "text_core_submit_address_address2": "Address 2",
    "checkout_multi_paymentMethod_viewSavedPayments": "View Saved Payments",
    "open_total_usd_EMEA": "Net Price - in {0}*",
    "text_warranty_eligibility_success": "Yes,part is covered under warranty",
    "text_warranty_attachement_available": "Attachments available",
    "general_month_september": "September",
    "text_guest_ordererror": "Guest Order Error Page",
    "text_button_use": "Use",
    "storeFinder_nearby_stores": "Nearby Stores",
    "text_quote_description_label": "Description",
    "text_account_core_search_currentPage": "Page {0} of {1}",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_country": "Please enter a value for this field",
    "checkout_multi_paymentMethod_savedCards_stepHeader": "3 - Select Payment Details",
    "text_account_quote_name": "Name",
    "text_quote_discount_adjust_total": "Adjust Total",
    "address_title_invalid": "Please select a title",
    "basket_added_to_basket": "Added to Cart",
    "deliveryMode_select_delivery_type": "Delivery",
    "text_cart": "Cart",
    "text_account_warranty_search_page_totalResultsCurrPage": "{0} of {1} Claims",
    "text_restore_savedcart_error": "Error while restoring saved cart",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_email": "Please enter a value for this field",
    "text_default": "Default",
    "paymentMethod_billingAddress_header": "Billing Address:",
    "checkout_deliveryAddress_notSelected": "Please provide a delivery address for your order",
    "basket_page_customerprice": "Customer Price",
    "quick_order_req": "REQ",
    "text_expresscheckout_info1": "By succesfully configuring your settings this way, signed users will proceed directly to the Final Review step when proceeding to checkout",
    "text_expresscheckout_info2": "Users who have not yet signed in may choose Express Checkout in the shopping cart",
    "general_month_march": "March",
    "text_confirmation_warranty": "Warranty Confirmation",
    "text_warranty_terms_app_frequency": "These applications have high frequency braking duty cycles, operate under more severe conditions and may be used on either hard surface roadways or in off-road conditions.",
    "text_account_warranty_search_page_linkPreviousPage": "Previous Page",
    "text_expresscheckout_info3": "The express checkout feature is not available to Guest Users",
    "search_nav_facetShowLess_size": "less sizes...",
    "general_month_january": "January",
    "order_history_order_date": "Order Date:",
    "text_countryOfOrigin": "Country of Origin",
    "text_account_addressBook_page_sort_byCode": "ID",
    "checkout_orderConfirmation_orderNumberShort": "Order # {0}",
    "text_user_registraion_request_label": "Registration Requests",
    "basket_page_totals_estimatetaxesbutton": "Estimate tax",
    "login_description": "Please Sign-in",
    "text_account_orderHistory_page_totalResultsCurrPage": "{0} of {1} Orders Found",
    "warranty_claim_no": "Yes",
    "register_state_placeholder": "Select Your State",
    "text_storefinder_responsive_page_linkNextPage": "Next",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_country": "This value is invalid for this field",
    "register_checkbox_priceDownloadAccess_label": "Download Price File",
    "storeFinder_table_view_store": "View store",
    "profile_submit": "Update",
    "quote_submit_success": "Quote submitted with success.",
    "text_storefinder_mobile_page_currentResults": "{0} - {1} of {2} stores",
    "checkout_multi_deliveryAddress_noSuggestedAddresses": "No address suggestions",
    "basket_page_itemPrice": "Item price",
    "search_page_sortTitle": "Sort by:",
    "checkout_summary_deliveryMode_number_of_pickup_destinations": "{0} Store Pickup Destination(s)",
    "register_termsOfUsage_accept_invalid": "You have to accept the Webshop Terms of Use",
    "import_csv_savedCart_downloadTemplate": "Download Order Template",
    "import_csv_core_downloadTemplate": "Download Core Template",
    "price_download_files": "Download Your Price Files",
    "text_account_order_consignment_status_shipped": "Shipped",
    "text_account_change_email_address": "Change Email Address",
    "search_nav_selectRefinements_title": "Select Refinements",
    "text_core_submit_phone": "Phone",
    "text_core_submit_personalDetails_phone": "Phone",
    "text_core_submit_personalDetails_emailAddress": "Confirmation email address",
    "text_core_submit_address": "Address*",
    "text_core_submit_address_country": "Country*",
    "text_core_submit_address_selectState": "State / Province*",
    "text_core_submit_personalDetails": "Personal Details",
    "text_core_address_city": "City*",
    "text_core_submit_zipCode": "Zip/Postal Code*",
    "text_core_submission_wghttotal": "Total Weight",
    "checkout_multi_paymentMethod_addPaymentDetails_header": "Payment Details",
    "checkout_summary_deliveryAddress_noExistingAddresses": "You don't have any addresses in your address book.",
    "text_account_savedCarts_page_linkNextPage": "Next Page",
    "checkout_multi_addEditform": "Please use this form to add/edit an address.",
    "storeDetails_map_link": "Map",
    "basket_page_netprice": "Net Price",
    "pdp_information_replacedby": "Replaced by:",
    "payment_year": "Year",
    "checkout_orderConfirmation_Summary_title": "Order Summary",
    "checkout_page_summary_final_review_customer_refrence": "Customer Reference #:",
    "text_warranty_submit_enter_amount": "(enter amount on a per piece basis)",
    "text_account_savedCarts_page_totalResults": "{0} Cart(s) Found",
    "text_account_quote_action_display_CHECKOUT": "Accept and Check Out Quote",
    "text_account_orderHistory_mobile_page_sortTitle": "Sort by:",
    "text_quote_dateformat_datepicker_selection": "mm/dd/yy",
    "register_company_b2bUnits_invalid": "Please Select at least one sold to",
    "review_number_reviews": "Reviews",
    "basket_error_quantity_notNull": "Quantity field cannot be empty.",
    "text_account_addressBook_noSavedAddresses": "No Saved Addresses Found",
    "quote_submit_error": "Error submitting quote.",
    "basket_page_deliveryDate": "Requested Delivery Date",
    "product_share_print": "Print",
    "download_disclaimer_text": "Download Disclaimer",
    "review_submit": "Submit Review",
    "pickup_in_store_back_to_results": "Back",
    "text_account_warranty_search_page_sortTitle": "Sort by",
    "import_csv_savedCart_fileContent": "Must be a saleable Bendix part number",
    "text_myCompanyManage_content": "In this section you can create, edit and delete all users of your company",
    "import_csv_savedCart_selectFile": "Select a file to upload. The file must be a text file with extension CSV.",
    "basket_error_date_success": "Requested delivery date updated.",
    "checkout_orderConfirmation_cut-off-time": "Please note:",
    "storeDetails_table_distanceFromCurrentLocation": "{0} from Current Location",
    "product_grid_future_tooltip_delivery": "Delivery",
    "search_mobile_page_currentPage": "{0} - {1} of {2} products",
    "quote_acceptandcheckout": "Accept and Checkout",
    "pickup_mobile_back_to_cart_page": "Back to Shopping Bag",
    "basket_restoration_items_msg": "The following items are:",
    "text_user_table_lock_user_account": "Lock User Account",
    "checkout_pickup_items_to_be_shipped": "Ship To:",
    "checkout_error_paymentethod_formentry_sop_missing_card_accountNumber": "Please enter a card number",
    "text_minOrderQuantity": "Minimum order quantity",
    "checkout_checkout_multi": "Checkout Multi",
    "checkout_multi_paymentMethod_addPaymentDetails_enterDifferentBillingAddress": "Enter a different billing address",
    "text_account_consent_cookiesusage": "Usage of Cookies",
    "address_postcode_invalid": "Please enter post code",
    "text_headline_addaddress": "Click to add an address",
    "storeDetails_table_opening_closed": "Closed",
    "basket_add_free_gift": "Add your free gift to Cart",
    "basket_page_message_remove": "Product has been removed from your cart.",
    "cart_orderType_selection": "Please select",
    "cart_select_order_type_errormsg": "Please select Order Type",
    "address_line2_invalid": "Please enter address Line 2",
    "search_Results_NextPage_link": "Next",
    "register_checkbox_admin_label": "Customer Admin",
    "register_checkbox_training_label": "Technical Training",
    "register_checkbox_training_book_label": "Book Technical Training",
    "register_checkbox_training_admin_label": "Customer Training Admin",
    "register_checkbox_admin": "Customer Admin",
    "register_site_company": "Information*",
    "text_account_orderHistory_page_sort_byPODesc": "PO No-Desc",
    "warranty_eligibility_check_type_of_operation": "Type of Operation*",
    "text_core_submit_address_zipCode": "Zip/Postal Code*",
    "popup_done": "Done",
    "register_termOfUsage_accept_dataProtection": "You have to accept the Data Protection Declaration",
    "cart_page_quantity_label": "QTY",
    "basket_export_user_username": "Username",
    "text_account_profile_saveUpdates": "Update",
    "checkout_page_summary_deliveryMode_selectDeliveryMethodForOrder_EMEA": "Delivery Type",
    "text_core_submission_pdfNA": "Bendix Core Center",
    "checkout_summary_paymentMethod_savedCards_header": "Select Payment Details",
    "text_warranty_document_attachement_all": "Documents can be attached if they are in jpg, word, or pdf format and if they do not exceed 9MB in total.",
    "product_product_details_future_date": "Estimated delivery date",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_state": "Please enter a value for this field",
    "order_form_total": "Order Form Total",
    "order_history_order_type": "Order Type:",
    "text_account_warranty_search_page_lastPage": "&raquo;",
    "core_error_generic": "No Results found.",
    "paymentMethod_header": "Payment Details",
    "NotBlank_orderHistoryForm_endDate": "Please enter End Date",
    "checkout_summary_paymentMethod_addPaymentDetails_header": "Payment Details",
    "address_townCity": "Town/City*",
    "address_required": "Fields marked* are required",
    "checkout_orderConfirmation_pickupPoints": "{0} Store Pick Up Destination(s)",
    "text_warranty_eligibility_mileageInService_invalid": "Please enter a valid Mileage in Service without any special characters.",
    "search_nav_refine_button": "Refine",
    "checkout_summary_paymentMethod_addPaymentDetails_billingAddress": "Billing Address",
    "payment_issueNumber": "Issue number",
    "quote_newcart_success": "Quote {0} was successfully saved",
    "text_coreGroup": "Core Group",
    "text_warranty_email_two_invalid": "Please correct email id",
    "review_headline": "Review Title",
    "checkout_multi_deliveryAddress_addressSuggestions_addressNotFound": "Or keep your original address:",
    "address_district": "District",
    "checkout_multi_paymentMethod_seeOrderSummaryForMoreInformation": "See the Order Summary area for more information.",
    "text_account_addressBook_page_sort_byTotal": "Total",
    "basket_save_cart_validation_name_notBlank": "Cart name cannot be blank",
    "text_popupCartTitle": "Your Shopping Cart",
    "basket_page_surcharge": "Core Surcharge",
    "text_account_core_search_firstPage": "&laquo;",
    "text_warranty_eligibility_mileage_mi_error": "Mileage can't be more than 6213711 miles",
    "forgottenPwd_description": "Please enter your account email address.  Instructions on how to reset Password will be sent to this address.",
    "text_account_order_total": "Total",
    "payment_cardNumber_invalid": "Please enter a valid card number",
    "error_account_myPart_template_format": "Please upload data in the right format - take the upload excel template.",
    "basket_page_needHelp": "Need help?",
    "general_month_july": "July",
    "product_grid_selectSize": "Select",
    "text_headline_description": "Description",
    "checkout_multi_paymentMethod_addPaymentDetails_billingAddress": "Billing Address",
    "text_account_paymentDetails_paymentCard": "Payment Card",
    "import_csv_savedCart_chooseFile": "Choose file",
    "general_delete_button": "Delete",
    "search_nav_appliedFilters": "Remove",
    "text_account_savedCart_savedCartBreadcrumb": "Saved Cart {0}",
    "text_account_quote_action_display_REJECT": "Reject Quote",
    "basket_cartpage_pos": "Pos",
    "cart_page_reqdelivery": "Req Delivery Date",
    "text_account_paymentDetails_delete_popup_title": "Delete Payment",
    "text_headline_productinfo": "Click to get more information about product overview, product review or delivery method",
    "text_account_orderHistory_page_sort_byOrderNumber": "Order Number",
    "text_reports_summaryEmea": "All activity for the month by group at a high level",
    "text_account_quote_page_currentPage": "Page {0} of {1}",
    "storeFinder_viewMap": "View Map",
    "text_headline_orderinfo": "All information about delivery address, delivery method and payment method",
    "checkout_order_purchaseOrderNumber_label_EMEA": "Customer Ref. No:",
    "search_page_firstPage": "&laquo;",
    "text_headline_profile": "Click here to view your profile, address book, payment details or order history",
    "storeFinder_search": "Search",
    "basket_added_to_mobile_basket": "Added Item",
    "storefinder_searchterm_invalid": "Please enter search term or zip code",
    "checkout_pickup_confirm_and_continue": "Simply confirm the information below and continue to the next step of checkout.",
    "product_share_sendToFacebook": "Send to Facebook",
    "order_form": "Order Form",
    "text_account_savedCart_edit_title": "Edit Saved Cart",
    "text_account_warranty_table_header_reason": "Reason for Rejection",
    "basket_page_totals_estimatedtotal": "Estimated total:",
    "text_warranty_terms_motor_home": "Motor Home",
    "checkout_multi_paymentMethod_savedCards_selectSavedCardOrEnterNew": "Select existing payment details or enter new payment details",
    "basket_save_cart": "Save Cart",
    "checkout_multi_deliveryAddress_stepHeader_done": "1 - Delivery Address",
    "basket_quick_order_error": "{0} Product(s) were not added to the cart, Review errors on quick orders page",
    "text_component_message_underconstruction": "<strong>Information:</strong>  Component Under Construction - Not Completely Functional",
    "text_account_paymentDetails_delete": "Delete",
    "text_account_core_search_total": "Total",
    "text_copyright": "&copy; 2016 hybris software",
    "text_account_quote_action_display_SUBMIT": "Submit Quote",
    "review_comment_invalid": "Please enter a description",
    "pickup_back_to_product_page": "&lt; Back to Product Page",
    "text_warranty_submit_quantity_invalid": "Please enter a valid Quantity",
    "text_voucher_apply_button_label": "Apply",
    "product_volumePrices_column_qa": "Quantity",
    "checkout_error_paymentethod_formentry_sop_invalid_card_expirationYear": "The expiry year is not valid",
    "text_account_manageQuotes_breadcrumb": "Quotes",
    "text_productHierarchy": "Product Hierarchy",
    "account_confirmation_close_title": "Your account has been closed.",
    "text_account_order_pickup_location": "Pick Up Location:",
    "text_user_table_linked_customer": "Linked Customer ID/Select Default Sold To",
    "text_user_table_unlock_user_account": "Unlock User Account",
    "basket_export_user_company": "Company*",
    "text_account_quote_email": "E-Mail",
    "download_start_download_button_text": "start download",
    "text_account_order_consignment_status_readyforpickup": "In Store Pick-Up",
    "form_global_already_registered": "The entered email address is already registered with an existing account",
    "search_page_nearbyStores": "You searched for nearby stores",
    "text_headline_productcategories": "Product categories",
    "import_csv_savedCart_quantity": "Quantity",
    "address_selectCountry": "Please select a country/region",
    "text_attn": "ATTN:",
    "checkout_summary_placeOrder_readTermsAndConditions_close": "Close",
    "profile_lastName": "Last Name",
    "register_firstName": "First Name*",
    "product_na_meta_description": "Bendix Commercial Vehicle Systems offers a complete line of air compressors, valves, ABS, stability systems, driver assistance systems, air dryers, plus air disc and drum brakes",
    "checkout_pickup_items_at_one_location": "All items in your order selected for pickup are currently available at these store locations:",
    "open_total_usd_NA": "Net Price {0}*",
    "mycompany_click_edit_user": "Click to Edit User Details",
    "text_account_quote_status_display_BUYER_SUBMITTED": "Submitted",
    "text_quote_previous_estimated_total_display": "Previous Estimated Total",
    "text_warranty_submit_part_nature_defect": "Nature of Defect",
    "text_warranty_submit_part_nature_defect_na": "Nature of Defect",
    "text_quickOrder_product_not_purchaseable": "Part number cannot be purchased. Please enter another part number.",
    "register_checkbox_coworker_label": "Show Co-Workers Information",
    "text_headline_findstore": "Find your store",
    "quote_name_invalid": "Please enter a valid name",
    "text_account_quote_status_display_CANCELLED": "Cancelled",
    "text_account_orderHistory_page_currentPage": "Page {0} of {1}",
    "text_core_submission_review_emea": "Please check all your entries on this form. After submission no further changes can be made to the return request.",
    "text_account_orderHistory_page_lastPage": "&raquo;",
    "text_headline_coreAttributes": "Core",
    "listPrice_check": "List Price",
    "order_history_total": "Total",
    "quote_requote": "Requote",
    "header_hello": "Hello",
    "text_warranty_eligibility_mileage_km_error": "Mileage can't be more than 9999999 kilometers",
    "product_variants_colour": "Colour",
    "text_account_paymentDetails_setDefaultPaymentDetails": "Set default payment details",
    "checkout_summary_paymentMethod_editPaymentMethod": "Edit Payment Method",
    "checkout_multi_deliveryMethod_continue": "Next",
    "register_webshop_accept_invalid": "You have to accept the Webshop Terms and Conditions",
    "text_javascript_disabled": "JavaScript is required to access the page. Please enable JavaScript.",
    "basket_page_listprice": "List Price",
    "text_account_savedCart_back_to_saved_cart": "Back to Saved Carts",
    "search_nav_facetShowMore_style": "more styles...",
    "register_company_countryState": "State*",
    "checkout_orderConfirmation_Billing_Address": "Billing Address",
    "text_account_quote_total": "Total",
    "checkout_error_paymentethod_formentry_sop_missing_card_startYear": "Please enter a start year",
    "text_account_core_search_linkNextPage": "Next Page",
    "text_consent_dpr": "data protection declaration",
    "product_grid_quantityText": "Quantity",
    "storeFinder_postcode_town": "Postcode / Town",
    "search_page_showPageResults": "Show paginated",
    "checkout_summary_deliveryAddress_useThisAddress": "Use this address",
    "address_regionIso_prefecture": "Prefecture",
    "mobile_checkout_paymentMethod_add_card": "Add New Card",
    "checkout_multi_paymentMethod_addPaymentDetails_useSavedCard_description": "Registered customers may select a previously saved card",
    "register_description": "Interested to register with Bendix? Gain access to product pricing and in-store availability, track orders and much more!",
    "basket_information_quantity_reducedNumberOfItemsAdded_nextDeliveryUnit": "The entered order quantity in item {0} for part number {1} changed due to a minimum order quantity.",
    "coupon_not_active_expired": "The coupon code entered is no longer valid.",
    "text_notproduct_found_message": "No product found",
    "button_label_viewcart": "View Cart",
    "checkout_multi_paymentMethod_savedCards_noExistingSavedCards": "You don't have any saved cards",
    "import_csv_savedCart_fileMaxSizeExceeded": "The file is too large.",
    "text_account_orderHistory_page_sort_byCode": "Order No-Asc",
    "pickup_buy_online_message": "Buy your products now and pick them up later in store.",
    "text_account_order_orderPlaced": "Placed on {0}",
    "text_warranty_view_add_information": "View/Add",
    "text_view": "View",
    "text_deviceCode": "Device Code",
    "text_warranty_view_max_mb": "(max, 9.00 MB )",
    "text_account_order_unconsignedEntry_status_pending": "Pending",
    "checkout_pickup_items_to_pickup": "{0} item(s) to pickup",
    "product_grid_formDescriptionh": "Select items below and add to cart",
    "text_account_savedcart_to_activechart": "The following saved cart will restore as active cart",
    "text_account_kbpartNumber": "Bendix Part Number/Customer Part Number",
    "text_account_order_warning_storePickUpItems": "Reminder - Please pick up your items(s) soon.",
    "cart_page_checkout_yes": "Yes",
    "text_account_quote_status_display_BUYER_APPROVED": "Approved",
    "text_account_core_search_sortTitle": "Sort By:",
    "text_warranty_tag_serial_number": "T.A.G. Serial Number",
    "checkout_pickup_items_available_at_one_location": "YOUR PICKUP ITEMS ARE AVAILABLE AT ONE LOCATION (Does not affect delivery orders)",
    "basket_restoration_noStock": "Unfortunately <a href",
    "quote_create": "Request a Quote",
    "search_page_product_cross_reference_emea": "Cross Reference",
    "pickup_mobile_back_to_product_page": "Back to Product Page",
    "basket_page_id": "Item ID",
    "search_page_product": "Product",
    "search_Results_previousPage_link": "Prev",
    "search_page_lastPage": "&raquo;",
    "text_expresscheckout_title": "Benefit from a faster checkout by:",
    "basket_error_quantity_invalid": "Please provide a positive number to update the quantity of an item.",
    "text_account_order_orderNumber": "Your Order Number is {0}",
    "storeFinder_table_address": "Address",
    "text_hideFacet": "Hide Refinement",
    "address_default": "Make this my default address",
    "search_page_linkNextPage": "Next Page",
    "text_account_order_orderTotals": "Order Total",
    "order_order_totals": "Order Totals",
    "search_mobile_page_totalResults": "{0} item(s)",
    "product_variants_in_stock": "In Stock",
    "text_account_order_status_display_cancelled": "Cancelled",
    "checkout_login_registerAndCheckout": "Register and Checkout",
    "pickup_results_button": "Pick Up",
    "register_checkbox_updateMyPart_label": "Download / Upload own Part numbers",
    "checkout_orderConfirmation_orderNumber": "Your order number is {0}",
    "basket_page_shipping_pickup": "Pickup",
    "storeFinder_pagination_stores": "stores found",
    "mobile_checkout_items_show": "Show more Items",
    "storeDetails_table_distanceFromSource": "{0} from {1}",
    "checkout_multi_pickupInStore": "Pick Up in Store",
    "text_headline_sortandrefine": "Sort and refine",
    "text_account_order_subtotal": "Subtotal:",
    "register_company_name": "Company Name*",
    "text_account_savedCarts_page_linkPreviousPage": "Previous Page",
    "cart_page_shop": "Shop",
    "checkout_multi_deliveryMethod_deliveryOptions": "Delivery Options",
    "label_emea_sand": "SAND",
    "text_page_return": "Or you can return to our.",
    "checkout_summary_deliveryMode_header": "Delivery Options",
    "text_headline_categories": "Click here the menu button to get to the categories",
    "search_page_pageSize_title": "Products per Page:",
    "text_core_submission_wghtCode": "(lbs)",
    "basket_export_user_address2": "Address 2",
    "basket_export_user_address1": "Address 1",
    "checkout_multi_purchaseOrderNumber_label_EMEA": "Customer Ref. No*",
    "search_no_results": "0 items found for keyword <strong>{0}</strong>",
    "product_variants_select_style": "Please select style first",
    "text_quote_edit_confirmation_message": "This quote has been approved, Editing this quote will prevent checkout until the new edits are approved.",
    "checkout_multi_paymentMethod": "Payment & Billing Address",
    "text_country_selector_NA": "North America",
    "product_grid_readonly_qty": "Qty",
    "text_warranty_vehicle_unit_number": "Vehicle/Unit Number",
    "basket_page_shipping_ship": "Ship",
    "text_account_OrderDateTo": "Order Date To*",
    "updatePwd_submit": "Update",
    "core_error_b2bunit": "Please Select at least one Core Parent",
    "profile_email": "New Email Address",
    "open_type_number": "Type Number",
    "text_save_cart_title": "Save Cart",
    "register_new_customer": "Create an Account",
    "select_demo": "Select Demo",
    "register_dataprotection_accept_invalid": "You have to accept the Data Protection",
    "text_header_menu": "Menu",
    "cart_page_requested": "Requested",
    "register_company_countryCode": "Country*",
    "text_companyRegistrationRequest_heading": "Registration Requests",
    "basket_save_cart_validation_name_charset": "Cart name can only be alpha numeric",
    "checkout_summary_paymentMethod_addPaymentDetails_paymentCard": "Payment Card",
    "quick_order_delivery_date": "Delivery Date",
    "text_account_addressBook_page_showPageResults": "Show paginated",
    "cart_page_replaced": "Replaced",
    "product_grid_future_tooltip_error": "Sorry, but it is not possible to retrieve the future availability data at this time. Please try later.",
    "text_warranty_search_to_date_invalid_future": "Claim Date To can't be in future date.",
    "payment_startDate_invalid": "Start date must precede the expiry date",
    "basket_page_comment_menu": "Comment",
    "text_core_submission_memo": "(Core Return Memo Number)",
    "product_product_details": "Product details",
    "quote_reject_success": "Quote rejected with success.",
    "text_account_profile_updatePassword": "Please use this form to update your account password",
    "checkout_multi_paymentMethod_savedCards_enterNewPaymentDetails": "Enter New Payment Details",
    "core_submit_warranty_certify_check": "I certify that the cores on this CRM have been removed from trucks and/or heavy-duty vehicles in the territory of Canada.",
    "text_core_submit_address_addressLName": "Last Name",
    "text_account_quote_page_sort_byDate": "Updated Date",
    "text_account_quote_status_display_SELLERAPPROVER_REJECTED": "Rejected",
    "text_account_quote_status_display_BUYER_REJECTED": "Rejected",
    "checkout_summary_deliveryAddress_selectExistingAddress": "Select Existing Address",
    "cart_page_estdeliveryApac": "Est Departure Date",
    "text_subcategories_label": "Category",
    "checkout_checkout_multi_pci-ws": "PCI-Default",
    "mycompany_active_user": "Active User - Click to Lock User",
    "text_storefinder_mobile_page_currentPage": "{0} of {1}",
    "basket_page_quote_discounts": "Quote Discount:",
    "basket_export_cart_item_name": "Name",
    "text_account_savedcart_numberofpositions": "Number of Positions",
    "warranty_eligibility_check_submit": "Submit",
    "text_quickOrder_product_code_invalid": "Invalid product code",
    "checkout_multi_sop_savePaymentInfo": "Save Payment Info",
    "search_nav_facetShowLess_style": "less styles...",
    "cart_checkout": "CHECKOUT",
    "basket_page_productdetails": "Product Details",
    "text_storefinder_responsive_page_linkPreviousPage": "Previous",
    "search_nav_facetShowLess": "View Less",
    "text_account_core_search_totalResultsCurrPage": "Showing {0} of {1} results",
    "product_image_zoom_in": "Click To Zoom",
    "text_quote_cancel_button_label": "Cancel",
    "checkout_multi_deliveryAddress_addAddress": "Add new address",
    "payment_cvn": "Card Verification Number",
    "checkout_multi_paymentMethod_addPaymentDetails_billingAddressDiffersFromDeliveryAddress": "If your billing address is  different  to your delivery address, please use this form to enter your billing address",
    "product_variants_out_of_stock": "Out of Stock",
    "checkout_multi_deliveryAddress": "Shipment/Pick Up Location",
    "text_account_core_search_totalResults": "{0} New Result(s) found",
    "storeFinder_findStoresNearMe": "Search",
    "text_connect": "Connect",
    "text_account_savedCart_restore": "Restore",
    "text_account_savedCart_restore_detail": "Restore",
    "text_account_warranty_table_header_decision": "Decision",
    "account_confirmation_payment_details_removed": "Your payment details were removed.",
    "product_product_details_more": "More product details",
    "text_account_profile_createnewuser": "Create New User Account",
    "checkout_summary_reviewYourOrderMessage": "Please review your order carefully!",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_lastName": "Please enter a value for this field",
    "pdp_page_generaltab_soldinmultipleof": "Sold in multiple of",
    "label_emea_b9nd": "B9ND",
    "order_history_status": "Order Status:",
    "basket_error_quantity_invalid_binding": "Invalid quantity: please provide a valid quantity number to add this product to your cart",
    "checkout_error_payment_not_accepted": "Your payment was declined. Please check your payment details are correct.",
    "checkout_pickup_items_simplify_pickup_location": "I would like to change my order to pickup all my items in the same store",
    "text_warranty_submit_duplicate_parts_error": "Please remove duplicate Part Number and submit again.",
    "text_account_myCore": "My Core",
    "text_account_coreReports": "Core Reports",
    "basket_save_cart_action_cancel": "Cancel",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_postalCode": "Please enter a value for this field",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_firstName": "This value is invalid for this field",
    "text_account_orderHistory_page_sort_byOpenQtyDesc": "Open Qty-Desc",
    "account_confirmation_password_updated": "Success! You can now login using your new password.",
    "login_error_invalidSalesArea": "You don't have sufficient permissions to log in",
    "search_page_product_cross_reference": "Cross-Ref",
    "general_month_november": "November",
    "register_state_invalid": "Please Select State",
    "header_link_login": "Sign in",
    "text_quickOrder_header": "Quick Order",
    "text_account_quote_status_display_SELLERAPPROVER_APPROVED": "Approved",
    "text_core_submit_address_addressFName": "First Name",
    "form_empty_select": "Please Select",
    "quote_description_invalid": "Description cannot be more than 255 characters",
    "order_history_delivery_type": "Delivery Type:",
    "checkout_summary_paymentMethod_addPaymentDetails_enterDifferentBillingAddress": "Enter a different billing address",
    "text_account_closeAccount_header": "About Closing Your Account",
    "order_total": "Total",
    "text_account_quote_msg5": "Locked User-Click to Activate",
    "Please": "carefully check each request and either edit and approve it, or decline it.",
    "registration_confirmation_message_subtitle": "Please check your email to verify your email address.",
    "mobile_multi_checkout_selectExistingCard": "Choose from existing Payment Details",
    "popup_cart_quantity": "Quantity",
    "text_storefinder_responsive_page_showPageResults": "Show paginated",
    "text_button_accept": "Accept",
    "waiver_button_accept": "Accept and Submit",
    "search_page_searchText": "You searched for",
    "text_account_order_title_storePickUpItems": "Store Pick Up Items",
    "text_quote_discount_rate_null_error": "The discount rate is null.",
    "address_street": "Street Name with Street Number",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_city": "This value is invalid for this field",
    "login_error_account_not_found_subtitle": "If you forgot your password, please use the Forgotten Password link.",
    "text_storefinder_mobile_page_linkPreviousPage": "&laquo; Previous",
    "text_headline_vmrs": "Vehicle Maintenance Report Standards",
    "text_account_order_min_EMEA": "Minimum Order Charge:",
    "text_account_addressBook_page_totalResultsCurrPage": "{0} of {1} Saved Addresses",
    "text_warranty_submit_requestedPartAmount_invalid": "Please enter a valid Requested Handling Amount",
    "checkout_placeOrder_failed": "Failed to place the order",
    "address_error_formentry_invalid": "Errors were found with the address you provided. Please check the errors below and re-submit your address.",
    "text_address_delete": "Delete",
    "checkout_summary_paymentMethod_header": "Payment Details",
    "cart_page_continue": "Continue Shopping",
    "text_account_addressBook_page_totalResultsSingleOrder": "1 Addresses",
    "text_consent_email": "Enter your email address",
    "text_account_consent_given": "Your consent has been given",
    "text_warranty_submit_part_quantity": "Quantity*",
    "basket_page_message_update_reducedNumberOfItemsAdded_lowStock": "The entered quantity in position number {4} for part number {5} has been changed due to pack size restrictions.",
    "basket_page_viewFuture_unavailable": "Future stock system is unavailable, please try again later.",
    "text_warranty_submit_vehicle_information": "Vehicle Information",
    "text_warranty_dealer_code": "Dealer Code result*",
    "text_dates_difference_error": "Please limit the date to maximum 365 days!",
    "basket_cartpage_partNo": "Part No.",
    "text_storefinder_responsive_page_totalResults": "1-10 from {0} Stores found",
    "basket_page_totals_deliverycountry": "Delivery destination:",
    "text_account_OrderDate": "Order Date From*",
    "basket_export_user_state": "State",
    "address_postcodeJP_invalid": "Please enter post code preceded by postal symbol",
    "text_storefinder_responsive_page_sort_byName": "By Name",
    "text_account_orderHistory_orderStatus": "Order Status",
    "text_account_quote_action_display_VIEW": "View Quote",
    "checkout_orderConfirmation_checkoutSuccessful": "Checkout Successful",
    "checkout_multi_deliveryAddress_notprovided": "You must provide a shipping address in order to go to the next step.",
    "product_product_details_future_qty": "Qty",
    "text_CloseMyAccount_label": "Close My Account",
    "text_account_order_shipto": "Ship To",
    "text_vmrsCode": "VMRS Code",
    "checkout_page_delivery_address_emergency": "Add New Address (Emergency Orders Only)",
    "text_cust_ref_no": "Item Ref No.",
    "account_error_account_exists_with_email_address_title": "An account already exists for email address {0}",
    "text_quote_cancel_confirmation_message": "Are you sure you want to cancel this quote?",
    "form_field_required": "Required",
    "label_emea_emgy": "VOR",
    "checkout_multi_shipment_items": "Shipment - {0} Item(s)",
    "text_account_order_title_details": "Order Details",
    "password_strength_veryweak": "Very weak",
    "breadcrumb_cart": "Cart",
    "order_product": "Product",
    "text_warranty_submit_part_serialno": "Serial No.",
    "product_product_typenumber": "Type Number",
    "text_link_home_label": "Home",
    "user_locked_invalid_msg": "Your account has been locked, please contact your company administrator accordingly",
    "order_totals_total": "Total:",
    "checkout_multi_deliveryAddress_address": "Address",
    "product_image_zoom_out": "Zoom Out",
    "checkout_multi_deliveryAddress_select": "Select",
    "register_company_faxNumber": "Fax Number",
    "register_checkbox_ordering_label": "Online Ordering",
    "basket_restoration_view_cart_btn": "View Cart",
    "text_generalInfo_description": "Description",
    "checkout_summary_paymentMethod_addPaymentDetails_saveAndUseThesePaymentDetails": "Save and use these payment details",
    "general_month_may": "May",
    "basket_configure_product": "Configure",
    "basket_save_cart_validation_name_size": "Cart name cannot be more than 255 characters",
    "orderHistory_page_totalResults": "of {0} Orders",
    "text_deliveryAddress": "Delivery Address",
    "address_country": "Country/Region",
    "text_account_addressBook_manageDeliveryAddresses": "Manage your delivery address",
    "checkout_summary_deliveryAddress_edit": "Edit",
    "checkout_error_paymentethod_formentry_sop_missing_card_startMonth": "Please enter a start month",
    "quote_enter_comment": "Add a comment and press enter",
    "text_addToCart": "Add to cart",
    "text_account_order_title_inProgressItems": "In Progress Order Items",
    "text_core_submit_address_addressEmail": "Email",
    "import_csv_savedCart_fileRequired": "The file cannot be empty.",
    "cart_page_merge_message": "You have multiple positions in the cart with same part number and requested delivery date which will be merged on checkout, do you wish to proceed?",
    "text_headline_additional": "Additional Information",
    "text_account_table_header_type": "Order Type",
    "quote_cart_insufficient_access_rights_error": "Insufficient access rights for cart {0}.",
    "pdp_page_netprice": "Net Price",
    "quote_edit_locked": "Quote ID : {0} is currently being edited by {1}",
    "storeDetails_table_address": "Address",
    "text_account_quote_status_display_BUYER_OFFER": "Vendor Quote",
    "text_account_orderHistory_mobile_page_linkNextPage": "Next &raquo;",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_state": "This value is invalid for this field",
    "text_storefinder_mobile_page_noResults": "No results for your area.",
    "text_core_submission_upgrade": "Upgrade",
    "text_account_profile_changePassword": "Change your password",
    "text_voucher_apply_applied_success": "The {0} has been applied successfully",
    "basket_text_shippingcost": "Shipping Costs:",
    "search_page_currentPage": "Page {0} of {1}",
    "text_submit_warranty_error": "Error in Warranty Claim Submit. Please try again or contact customer service.",
    "search_nav_facetShowLess_collection": "less collections...",
    "import_csv_savedCart_requestedDateApac": "Optional : Requested delivery date (format YYYY/MM/DD)",
    "checkout_summary_placeOrder": "Place Order",
    "basket_information_quantity_noItemsAdded_maxOrderQuantityExceeded": "Unfortunately the quantity you chose exceeded the maximum order quantity for this product.",
    "text_account_saveCart_edit_error": "There was an exception while updating Cart {0}",
    "breadcrumb_quote_view": "Quote {0}",
    "basket_export_user_industryRole": "Industry Role",
    "search_nav_facetShowLess_colour": "less colours...",
    "checkout_paymentMethod_createSubscription_failed": "Failed to create subscription. Please check the values entered.",
    "text_quote_checkout_warning_message": "Modifying the cart may result in voiding the vendor quote.",
    "checkout_express_error_notAvailable": "Express checkout is not available since it is disabled.",
    "basket_page_update": "Update",
    "text_account_quote_status_display_BUYER_ACCEPTED": "Accepted",
    "pickup_pagination_first": "First",
    "search_nav_refinements": "Refinements",
    "text_loadingMessage": "Loading...",
    "register_checkbox_net_label": "Net Price",
    "text_account_core_search": "Show All",
    "product_view_more": "More >",
    "text_consent_accept": "Knorr-Bremse needs your mandatory email address in order to be able to inform you about updates to this downloaded document in justified cases with regard to our legal liability obligations.",
    "#text_consent_accept": "Please accept the privacy notice and the download disclaimer",
    "product_variants_update": "update",
    "guest_email": "Email Address",
    "text_account_profile_updateEmailAddress": "Enter your new email address and confirm with your password",
    "pickup_product_by_store_location": "Product by store location",
    "text_quote_conteroffer_confirmation_modal_title": "Confirm Vendor Quote {0}?",
    "basket_export_cart_error": "There was an exception while exporting Cart",
    "account_confirmation_signout_subtitle": "Your cart will be waiting for you when you sign back in.",
    "basket_page_number": "No.",
    "product_product_details_future_nostock": "This product has no future availability information.",
    "text_header_loginandaccount": "Login and Account",
    "checkout_multi_sop_useThisPaymentInfo": "Use this payment info",
    "checkout_multi_paymentMethod_addPaymentDetails_paymentCard": "Card Details",
    "text_warranty_email_one_invalid": "Please correct email id",
    "checkout_error_paymentethod_formentry_sop_missing_card_cardType": "Please select a cart type",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_lastName": "Please enter a value for this field",
    "review_headline_invalid": "Please enter a title",
    "text_core_submit_address_requestedTime": "Available collection times:*",
    "text_core_submit_address_city": "City*",
    "basket_page_viewFuture_not_multisku": "The selected code {0} is not a multidimensional product.",
    "text_core_submit_itemQty_invalid": "Required",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_state": "Please enter a value for this field",
    "checkout_express_error_deliveryMode": "Express checkout is not available. An error occurred setting the delivery mode.",
    "review_write_title": "Write a Review",
    "text_quickorder_template": "Order Import Template",
    "text_productreviews": "Reviews",
    "quote_more_comments": "View more comments",
    "forgottenPwd_submit": "Send Email",
    "text_backoffice_user_resetPassword": "Reset Backoffice User Password",
    "forgottenPwd_username": "Username",
    "forgottenPwd_reset": "Reset Password",
    "updatePwd_backoffice_title": "Update Backoffice User Password",
    "account_backoffice_confirmation_password_updated": "Backoffice User Password Has Changed",
    "account_backoffice_user_confirmation_password_set": "Backoffice user password has been successfully reset",
    "backoffice_user_password_match_with_lastpassword": "Password should not match with last 5 password and also should not contain part or full name",
    "backoffice_resetPwd_title": "Reset Backoffice User Password",
    "import_csv_savedCart_success": "Every line could be uploaded successfully without any errors.",
    "address_furtherSubarea_invalid": "Please enter further subarea number",
    "text_consent_button_accept": "OK",
    "checkout_multi_deliveryMethod_useThisDeliveryMethod": "Use Selected Delivery Method",
    "register_checkbox_inversexref_label": "Inverse search KB to Xref",
    "checkout_multi_deliveryAddress_selectSuggestedAddress_sumbitAsIs": "Submit As Is",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_firstName": "Please enter a value for this field",
    "guest_checkPwd": "Confirm Password*",
    "checkout_page_summary_deliveryMode_selectDeliveryMethodForOrder_NA_error": "Please select a carrier to complete the checkout process.",
    "text_companyRegistrationRequest_content": "You will find in the overview below every registration request of employees of your company who have already submitted the registration from. Please carefully check each request and either edit and approve it, or decline it.",
    "text_storefinder_desktop_page_lastPage": "&raquo;",
    "text_account_profile_updateForm": "Please use this form to update your personal details",
    "checkout_error_tax_missing": "We are sorry but your transaction could not be completed at this time; please try again later or contact customer service at 555-555-5555",
    "checkout_orderConfirmation_coupon_code": "Use coupon code: {0}",
    "password_strength_tooshortpwd": "Too short",
    "cart_expresscheckout_checkbox": "I would like to Express Checkout",
    "text_account_orderHistory_page_showPageResults": "Show paginated",
    "register_company_address_zip_invalid": "Please enter the company postalcode",
    "quote_edit": "Edit Quote",
    "text_account_selectSalesarea": "Which sales area do you want to access?",
    "basket_validation_entryGroupError": "One of entry groups has error(s) that need to be fixed before proceeding to checkout.",
    "basket_page_totals_error_wrongcountry": "Please select a country/region",
    "forgottenPwd_title": "Reset Password",
    "storelocator_error_no_results_subtitle": "Check that you entered a valid postcode or place name.",
    "text_account_orderHistory_viewOrders": "View your order history",
    "checkout_pickup_continue_button": "Continue",
    "basket_validation_noStock": "Unfortunately <a href",
    "product_variants_size_guide": "Size guide",
    "register_termsOfUsage_accept": "I Accept the",
    "order_history_status_details": "Order Status Details",
    "checkout_multi_deliveryAddress_edit": "Edit",
    "login_required": "Required",
    "guest_register": "Create an Account",
    "checkout_page_summary_deliveryMode_selectDeliveryMethodForOrder_EMEA_error": "Please select a delivery type to complete the checkout process.",
    "text_search": "Search",
    "basket_export_cart_item_price": "Price",
    "checkout_multi_deliveryAddress_breadcrumb": "Shipment/Pick Up Location",
    "text_account_warranty_search_page_totalResultsSingleOrder": "1 Claim",
    "text_account_savedCart_title_details": "Saved Cart Details",
    "text_headline_orders": "View your orders",
    "text_myaccount_orderHistory": "&laquo; Order History",
    "text_warranty_submit_part_requestedHandlingAmount": "Requested Handling Amount",
    "checkout_multi_paymentMethod_savedCards_select": "Select",
    "text_warranty_terms_cement_mixer": "Cement Mixer",
    "checkout_multi_paymentMethod_paymentDetails_expires": "Expires {0} / {1}",
    "text_address_delete_popup_title": "Delete Address",
    "cart_page_title": "Your Shopping Cart",
    "basket_restoration_success": "{0}",
    "popup_cart_pickup": "Pick Up",
    "product_grid_futurestock_hidefuture_availability": "Hide future availability",
    "payment_issueNumber_invalid": "Only numbers are allowed for that field",
    "text_label_showmoreresults": "Show more results",
    "basket_page_title_yourDeliveryItems_pickup": "Order items to be picked up will appear later in the checkout.",
    "text_country_selector_MENA": "Middle East & Africa",
    "updatePwd_checkPwd_invalid": "Please confirm your password",
    "storeFinder_stores_nearby": "Stores Nearby",
    "search_nav_facetShowMore_colour": "more colours...",
    "register_checkbox_core_label": "Core Charge",
    "na_help_title": "Bendix Help Center",
    "na_welcome_to_help_center": "Welcome to Bendix Help Center",
    "na_customer_text": "As a customer you will be able to view all help and instruction documents that will help you navigate the website.",
    "na_click_the_following_text": "Click the following How to Guides or search for keywords related to your request",
    "na_search_placeholder": "Enter Keyword Here",
    "na_help_search_button": "Search",
    "for_non_logged_in_users": "For Non-Logged in Users",
    "how_to_read_the_privacy": "How to Read the Privacy Cookie Statement",
    "how_to_regional_selection": "How to read Regional selection page",
    "how_to_register_for_an_online": "How to register for an on-line account",
    "how_to_register_for_an_online_mx": "How to register at B2Bendix.com",
    "how_to_view_360": "How to view 360 product images",
    "for_approved_logged_in_users": "For Approved / Logged in Users",
    "how_to_download_a_price_file": "How to download a price file",
    "how_to_check_warranty": "How to check warranty eligibility of a part",
    "how_to_close_my_account": "How to close my account",
    "how_to_delete_user": "How to delete a user",
    "how_to_disable_user": "How to disable a user",
    "how_to_download_or_upload": "How to Download or Upload my own customer part number",
    "how_to_export_my_data": "How to export my data",
    "how_to_rest_your_password": "How to reset your password",
    "how_to_retrigger_the_rest_password": "How to re-trigger the reset password email",
    "how_to_search_for_a_core_report": "How to search for a core report",
    "how_to_search_open_line": "How to search open line positions status",
    "how_to_search_order_status": "How to search order status",
    "how_to_see_pending_registration": "How to see pending registration",
    "how_to_set_up_user_rights": "How to set up user rights during registration",
    "how_to_update_my_profile": "How to update my profile",
    "how_to_use_the_order_import": "How to use the Import order template",
    "how_to_use_the_quick_order": "How to use the Quick order form",
    "How_to_submitforacorereport": "How to submit the core return",
    "How_to_submitforaWarrantyclaim": "How to submit the Warranty Claim",
    "for_company_admin_users": "For Company Admin Users",
    "pdp_technicalattribute_guide": "Technical Attributes Guide",
    "basket_page_packing_qty": "Sold in Multiples of",
    "coupon_already_redeemed": "The coupon code entered has been redeemed already.",
    "text_account_warranty_page_totalResults": " Claim(s) Found",
    "basket_page_title_yourItems": "Your Cart",
    "payment_nameOnCard": "Name on card",
    "storeFinder_meta_description_results": "store Locations near to",
    "basket_validation_lowStock": "Unfortunately a lower quantity of <a href",
    "text_quote_dateformat_datepicker_selection_hint": "mm/dd/yyyy",
    "text_account_orderHistory_back": "Back to History",
    "text_account_openPosition_emptyPositions": "No Open Position(s) Found",
    "text_account_savedCarts_page_sort_byDateModified": "Sort by : Date Modified",
    "product_product_details_future_quantity": "Quantity",
    "basket_page_qty": "Qty",
    "storeDetails_table_distance": "Distance",
    "text_account_orderHistory_datePlaced": "Date Placed",
    "quick_order_page_alert_order_type_change": "The dates have been revised according to the order type",
    "text_warranty_cahssis_number": "Chassis Number",
    "text_account_core_breadcrumbNA": "Bendix Core Information Center",
    "text_core_submission_coregrade": "Core Grade",
    "text_core_part_number": "Part number",
    "checkout_summary_select_payment_method": "Select Payment Method",
    "text_company_users": "Company Users",
    "text_quote_expiration_time_invalid": "Please enter a valid expiry date",
    "text_language": "Select Language",
    "basket_page_totals_estimatedtotaltax": "Estimated tax:",
    "search_nav_facetShowMore_category": "more categories...",
    "text_warranty_terms_dump_truck": "Dump Truck",
    "text_generalInfo_dimension": "Dimensions (L x W x H )",
    "text_headertext_error": "Error(s)",
    "checkout_page_deliveryType_complete_message": "Complete delivery chosen - the latest date on your cart positions is the expected delivery date for the entire order",
    "pdp_availableText": "AVAILABLE",
    "pdp_unavailableText": "NOT AVAILABLE",
    "pdp_validEmailText": "Please enter valid email",
    "globle_invalidDateFormat": "Invalid date format!",
    "globle_notLessThanToday": "The Date must not less than today's date",
    "globle_notLessThanDefault": "The Date must not less than default date",
    "globle_weekendDate": "Weekend! Please select another date",
    "warranty_vinError": "VIN should be 17 digits",
    "warranty_duplicatePartNo": "Part number already exists!",
    "fselect_defaultPlaceholder": "Select some options",
    "fselect_pageCoreReportPlaceholder": "Please Select Core Parent",
    "fselect_noResultFound": "No results found",
    "fselect_selected": "selected",
    "fselect_pageUploadPartPlaceholder": "Search a Customer ID, Company Name",
    "fselect_pageAddUserPlaceholder": "Search a Customer ID, Company Name, or Address",
    "text_checkout_page_delivered_qty": "Delivered Qty :",
    "text_checkout_page_delivery_qty": "Delivery Qty",
    "is_kb_transport_required": "Do you require transportation from Knorr-Bremse?",
    "select_collection_address": "Please select a loading address below:",
    "select_pickup_address": "Select a pick-up address below:",
    "text_tooltip_actual_weight": "If you have the ability to weigh your return and it is different than our estimated weight above, please enter that here",
    "text_tooltip_package_type": "Pallets should be standard size, less than 48\" tall and under 2,000lbs.",
    "type_of_packaging": "Type of packaging",
    "no_of_pacakges": "Number of packages",
    "size_of_freight": "Size of Freight",
    "length_width_height": "(Length/Width/Height)",
    "core_stackable": "Stackable ?",
    "type_of_packaging_select": "Please Select",
    "text_Type_here_to_search_address": "Type here to search address",
    "text_Saved_Shipping_Addresses": "Saved Shipping Addresses",
    "text_Saved_Billing_Addresses": "Saved Billing Addresses",
    "user_rights_approval": "Set User Rights",
    "text_core_submission_upgradegrp_mob": "Upgrade Core Class",
    "core_submit_warranty_material_includedyes": "Warranty Material Included",
    "core_submit_warranty_material_includedyes_warrantyClaimNo": "Warranty Claim Number",
    "text_core_PackageType": "PackageType",
    "select_collection_address_pdf": "Collection Address",
    "text_core_Ship-to_pdf": "Ship-to",
    "text_core_packaging_pdf": "Type Of packaging",
    "text_core_Stackable_pdf": "Stackable",
    "text_core_CollectionDate": "Collection Date",
    "text_core_CollectionTime": "Collection Time",
    "text_core_ForkLift": "Fork Lift Required",
    "text_core_TailLift": "Tail Lift Required",
    "text_core_addinfo": "Addition Info",
    "text_order_status_partially_delivered": "Partially delivered",
    "automatically_generated_by_kb": "Automatically generated by Knorr-Bremse",
    "text_account_table_header_shipTo": "Ship-to ID",
    "text_account_table_header_itemRef": "Item Ref. Number",
    "text_account_table_header_reqDelDate_apac": "Requested Departure Date",
    "text_account_table_header_estDelDate_apac": "Estimated Departure Date",
    "text_account_table_header_order_emea": "Knorr-Bremse order number",
    "text_core_submission_upgradeonly": "Upgrade Core",
    "text_core_submission_grouponly": "Group",
    "text_core_submission_classonly": "Class",
    "text_core_submit_coreGroup": "Core Group",
    "tooltip_text": "e.g. max. vehicle size",
    "text_core_submission_error_msg_qty": "Only 6 Characters Allowed",
    "text_core_submission_error_msg_package_qty": "Only 5 Characters Allowed",
    "text_account_quote_msg1": "Delete a user account",
    "text_account_quote_msg2": "Are you sure you want to delete the following user account?",
    "text_account_quote_msg3": "Note: You can not undo this deletion.",
    "quickorder_checkbox_not_selected_text": "Checkbox not selected.",
    "order_history_cumulative_price": "*Cumulative Price for one piece including any Core, Freight and applicable surcharges",
    "order_history_cumulative_price_second_legend_text": "**Cumulative total price including any Core, Freight and applicable surcharges",
    "breadcrumbs_core": "Core Submission",
    "text_warranty_submit_kb_claim_number_emea": "Knorr-Bremse Warranty Claim Number",
    "text_warranty_submit_first_name": "First Name*",
    "text_warranty_submit_last_name": "Last Name*",
    "text_warranty_submit_kb_vin_number": "Vehicle ID/VIN-Number/Chassis Number",
    "text_warranty_submit_kb_axle_number": "Axle No.",
    "text_warranty_submit_part_invoice_number": "Knorr-Bremse Invoice No.",
    "text_core_submit_phoneEMEA": "Phone",
    "fork_lift_required": "Forklift Required?",
    "text_weight_core": "weight per pallet",
    "text_weight_core_EMEA": "weight per pallet / KG",
    "text_total_gross_weight_warning_EMEA": "Warning:  this shipment does not meet the minimum weight requirement of 400KG, either add more old units or restrict underweight shipments to a maximum of once per month.",
    "text_warranty_submit_email": "Email Address*",
    "text_warranty_submit_returning_kbpart_number": "Bendix Part Number (Auto fill)",
    "error_account_myPart_template_format_confirm_msg": "Selected file is not in the right format - do you want to continue?",
    "user_diaabled_invalid_msg": "This user account has been closed, please contact your admin",
    "basket_error_admin_missing": "Cannot access the requested url ,as login customer does not belongs to admin group",
    "text_warranty_submit_returning_emeapart_number": "Returning Customer Part Number",
    "text_warranty_submit_emea_part_number": "Returning Knorr-Bremse Part Number*",
    "text_warranty_submit_part_mileage_emea": "Mileage / Part In Service",
    "text_warranty_duplicate_file_error": "Duplicate file! Please rename and upload",
    "text_warranty_submit_part_type_number_emea": "Type No.(auto fill)",
    "text_warranty_submit_part_datein_service_emea": "Date put into service*",
    "select_a_carrier_error_emea": "Please select a carrier to complete the checkout process.",
    "address_search_input_text": "Search",
    "ja_how_to_register_user_by_customer_admin": "How to register user by customer admin",
    "ja_how_to_register_on_kb_japan": "How to register user",
    "text_warranty_shipping_packaging_tab_part_return": "Part Return Shipping Instruction:",
    "text_warranty_shipping_packaging_tab_product_claim": "Product claimed to be defective must be returned freight prepaid (Freight paid by the sender) via the Original Equipment (OE) dealership or authorized Bendix distributor within thirty (30) days after the date any defect is first discovered.",
    "text_warranty_shipping_packaging_tab__address": "Address to the Bendix Warranty Claim Center indicated below. Please be sure that \"Bendix Warranty Center\" and Warranty Claim number is clearly marked on the package.",
    "text_warranty_shipping_packaging_tab_us_address": "In the US, ship freight PRE-PAID to:",
    "text_warranty_shipping_packaging_tab_us_address_bendix": "Bendix Commercial Vehicle Systems",
    "text_warranty_shipping_packaging_tab_us_address_bendix_line1": "ATTN: Warranty Dept",
    "text_warranty_shipping_packaging_tab_us_address_bendix_line2": "1850 Riverfork Dr",
    "text_warranty_shipping_packaging_tab_us_address_bendix_line3": "Huntington, Indiana 46750",
    "text_warranty_shipping_packaging_tab_canada_address": "In Canada, ship freight PRE-PAID to:",
    "text_warranty_shipping_packaging_tab_canada_address_bendix": "Bendix Commercial Vehicle Systems Warranty Center",
    "text_warranty_shipping_packaging_tab_canada_address_bendix_line1": "8851 Crescent 4",
    "text_warranty_shipping_packaging_tab_canada_address_bendix_line2": "Anjou, Quebec H1J 1A9",
    "default_sold_to_info1": "The Default Sold To will be the main location assigned to you when you log into the system.",
    "default_sold_to_info2": "If you have access to more than one sold to location, you will have a dropdown list to select from.",
    "emea_help_title": "Knorr-Bremse FAQ Center",
    "emea_welcome_to_help_center": "Welcome to Knorr-Bremse FAQ Center",
    "emea_customer_text": "As a customer you will be able to view all help and instruction documents that will help you navigate the website.",
    "emea_click_the_following_text": "Click the following How to Guides or search for keywords related to your request",
    "How_to_register": "How to register",
    "How_to_resetyourpassword": "How to reset your password",
    "How_to_ReadthePrivacy_CookiesStatement": "How to Read the Privacy_Cookies Statement",
    "How_to_readtheRegionalSelectionPage": "How to read the Regional Selection Page",
    "How_to_usetheQuickOrderForm": "How to use the Quick Order Form",
    "How_to_usetheImportOrderTemplate": "How to use the Import Order Template",
    "How_to_updatemyprofile": "How to update my profile",
    "How_to_exportmydata": "How to export my data",
    "How_to_closemyaccount": "How to close my account",
    "How_to_searchorderstatus": "How to search order status",
    "How_to_SearchOpenLinePositionStatus": "How to Search Open Line Position Status",
    "How_to_DownloadPriceFile": "How to Download Price File",
    "How_to_ManageMyOwnCustomerPartNumbers": "How to Manage My Own Customer Part Numbers",
    "How_to_setupuserrightsduringregistration": "How to set up user rights during registration",
    "How_to_deleteauserbytheCustomerAdmin": "How to delete a user by the Customer Admin",
    "How_to_DisableauserbyaCompanyAdmin": "How to Disable a user by a Company Admin",
    "How_to_startapasswordresetbyaCompanyAdmin": "How to start a password reset by a Company Admin",
    "How_to_searchforacorereport": "How to search for a core report",
    "How_to_searchforaWarrantyclaim": "How to search for a Warranty claim",
    "register_company_additionalSoldToLocations": "Additional Knorr-Bremse Customer Numbers",
    "heading_dtc_description": "DTC Description",
    "heading_service_data_sheet": "Service Data Sheet",
    "heading_dtc_search": "DTC Search",
    "dtc_go_btn": "Go",
    "dtc_component_title": "Component (ECU)",
    "dtc_type_title": "DTC Type",
    "error_dtc_component_title": "Please select component",
    "error_dtc_type_title": "Please select DTC Type",
    "dtc_empty_records": "No record found",
    "search_reference_and_customer_info": "Search Reference and Customer Information",
    "emea_core_customer_id_placeholder": "Search Customer ID",
    "emea_collection_address_placeholder": "Search Collection Address",
    "homepage_teaser_name_brakeRepair": "Brake Repair Kits",
    "homepage_teaser_name_trainingEmea": "Technical Training",
    "homepage_teaser_name_fanclutches": "Fan Clutches",
    "homepage_teaser_name_StartersAlternators": "Starters and Alternators",
    "homepage_teaser_name_WorkshopTools": "Workshop Tools",
    "homepage_teaser_name_BrakePadFinder": "Brake Parts Finder",
    "homepage_teaser_name_EconX": "EconX®",
    "homepage_teaser_name_AirDryerCartridges": "Air Dryer Cartridges",
    "homepage_teaser_name_Compressors": "Compressors",
    "homepage_teaser_name_Contacts": "Contacts",
    "homepage_teaser_name_Filters": "Filters",
    "homepage_teaser_name_EconXElefant": "EconX® Calipers",
    "homepage_teaser_name_Bearings": "Wheel Bearings",
    "homepage_teaser_name_AdjusterIndicator": "Adjuster Indicator tool kit",
    "core_page_placeholder": "Search core parent",
    "register_company_state_code_canada": "State/Province*",
    "na_customer_admin_user_manual": "Customer admin user manual",
    "na_how_to_submit_core_returns": "How to submit core returns",
    "na_how_to_submit_core_returns_over500lbs": "How to submit a core returns - Over 500lbs",
    "na_how_to_submit_core_returns_under500lbs": "How to submit a core returns - Under 500lbs",
    "na_how_to_retrieve_core_reports": "How to retrieve core reports",
    "delete_all_no_text_label": "No",
    "no_price_file_to_download": "No Price File to Download.Référence",
    "text_part_remove": "Remove",
    "text_title_vor": "VOR/Emergency Orders",
    "text_warranty_button_uploadFile": "Upload File",
    "text_account_warranty_table_header_decision_france": "Refusée",
    "errormessage_not_valid_or_not_found_message": "not valid/not found.",
    "errormessage_error_in_line": "Error in line",
    "errormessage_part_no": "Part No.",
    "repair_time_error_text": "Please enter the value in Repair Time field.",
    "hourly_labour_rate_error_text": "Please enter the value in Hourly Labor Rate field.",
    "pick_up_at_warehouse": "Pick up at the warehouse",
    "mexico_error_for_quantity_on_quick_order": "Quantity is mandatory, please enter the missing information.",
    "form_global_errorwarranty_testuser": "Test User is not allowed to submit warranty",
    "form_global_error_testuser": "Test User is not allowed to submit core",
    "text_core_PackageType_one_way_pallet": "One Way Pallet",
    "text_core_PackageType_gitterbox": "Gitter Box",
    "text_core_PackageType_eur_pallet": "EUR Pallet",
    "check_availability_btn_text": "Check Availability",
    "check_availability_delivery_date_text": "Estimated Delivery Date",
    "check_available_table_text": "is available",
    "check_not_available_table_text": "is not available",
    "check_part_available_table_text": "is partially available",
    "please_enter_order_type_text": "Please select the Order Type",
    "please_enter_quantity_text": "Please enter the quantity",
    "some_thing_went_wrong_text": "Something went wrong",
    "go_back_to_cart_button_text": "Go back to Cart",
    "continue_to_checkout_button_text": "Continue to Checkout",
    "available_product_text": "is available for",
    "available_product_text_order_one": "order",
    "not_available_product_text": "is not available for",
    "check_out_of_stock_table_text": "is out of stock",
    "check_out_of_stock_text": "is out of stock for",
    "text_account_closed": "Closed",
    "text_account_open": "Open",
    "text_account_inprocess": "In Process",
    "text_saved_cart_qty_label": "Qty:",
    "text_orderimport_error_allotherlines_message": "All other lines were successfully uploaded to the shopping cart.",
    "text_coreimport_error_allotherlines_message": "All other lines were successfully uploaded to the Core Return Form.",
    "text_orderimport_error_errorinline_message": "Error in line",
    "text_coreimport_error_errorinline_message": "Error in line",
    "text_orderimport_error_semicolon_message": "semicolon",
    "text_orderimport_error_comma_message": "comma",
    "text_orderimport_error_invaliddateformat_message": " Incorrect date format of requested delivery date, please change it to&nbsp",
    "text_orderimport_error_notvalidornotfound_message": "&nbspnot valid/not found.",
    "text_coreimport_error_notvalidornotfound_message": ";Please try again or do a <a href=\"/CoreInfoCenter\" target=\"_blank\" rel=\"noopener noreferrer\"  class=\"coreCsvError\"> core group / core class look up </a>",
    "text_core_csv_infoTip_text": "To avoid upload errors use the following Core Grade Values:<br>Good Core, 1-Part Damage, 2-Parts Damaged, Scrap, and Don't know<br>If you have an Upgrade, check the box after the upload<br>*All fields are mandatory, if invalid information is entered you will see an error message.",
    "text_orderimport_error_partno_message": " Part No. ",
    "text_coreimport_error_partno_message": "Core Group and CPore Class are not valid/not found  ",
    "text_orderimport_error_tryagainorcontact_message": " Please try again or contact<a target='_blank' href = ",
    "text_orderimport_error_customerservice_message": "'> customer service.</a>",
    "text_orderimport_error_notpurchasable_message": " is not purchasable and was not uploaded",
    "text_orderimport_error_pleasecheck_message": " please check the <a href ",
    "text_orderimport_error_notpurchasable1_message": "&nbspPart No. or Quantity cannot be blank.",
    "text_coreimport_error_notpurchasable1_message": "&nbspCore Grade is not valid/not found.",
    "text_orderimport_error_deliverydate_message": " Requested Delivery date for Part no. ",
    "text_orderimport_error_deliverydate1_message": " cannot be in the past.",
    "order_status_emea_OpenQty": "Open Qty:",
    "text_core_form_csvMessage1": "You can automatically load your core return information by using the core template feature",
    "text_core_form_csvMessage2": "You can look up the core group/core class via this link <a href='/CoreInfoCenter' >URL to the Material/core group search</a>",
    "text_orderimport_error_obsolete_message": "&nbspis obsolete and was not uploaded, please check the <a href ",
    "text_orderimport_error_obsolete1_message": "'> product detail page</a> for more information.",
    "text_orderimport_error_invalidcsvformat_message": "&nbspIncorrect csv seperator, please change it to&nbsp",
    "text_dimension_length": "Length",
    "text_dimension_width": "Width",
    "text_dimension_height": "Height",
    "text_breadcrumb_signin": "Sign In",
    "register_to_download_kb_emea_text": "Register to Download a Knorr-Bremse document",
    "checkout_error_payment_address_empty": "Your request cannot be processed, please contact customer service.",
    "please_select_your_customer_id": "Please select your Customer ID",
    "choose_from_existing": "Choose from existing cart",
    "save_a_new_cart": "Save a new cart",
    "please_enter_the_cart_name": "Please enter the cart name",
    "document_text_releaseDate": "Release Date : ",
    "document_video_launch_btn": "Launch Video",
    "text_account_warranty_table_header_inspection_report": "Inspection Report",
    "breadcrumb_bendixAdbCMSPage_text": "Brake Applications",
    "document_library_page": "Document Library",
    "error_email_address": "Please enter proper email address.",
    "document_text_language": "Language : ",
    "document_text_revision": "Revision : ",
    "document_download_btn": "Download Document",
    "document_library_text_language": "Language",
    "document_library_text_document_type": "Document Type",
    "document_library_text_document_category": "Product Category",
    "document_library_text_document": "Document Library",
    "document_library_placeholder_text": "Enter Document Name....",
    "software_library_placeholder_text": "Enter Software Name....",
    "text_breadcrumb_favorite_documents": "my favourite documents",
    "text_adb_admin_edit_partNumber": "Part Number(s)",
    "text_adb_admin_edit_additionComments": "Additional Recommendations by Engineering Team",
    "text_adb_admin_edit_danaContactemail": "Bendix contact email",
    "text_account_document_favorite_table_doc_delete": "Delete +",
    "text_account_document_favorite_table_doc_unsubscribe": "Unsubscribe",
    "text_quote_name": "Quote",
    "search_page_software": "Software",
    "software_text_version": "Version :",
    "software_text_release": "Release :",
    "text_software_request_training_partner": "Trading Partner*",
    "text_software_upload_file": "Upload File",
    "requestform_address_invalid": "Please enter valid address",
    "requestform_address2_invalid": "Please enter valid second address",
    "requestform_city_invalid": "Please enter valid city",
    "requestform_companyName_invalid": "The following characters are not permitted: & * : \" ; , > < ) ( \\ /",
    "requestform_country_invalid": "Please select your country",
    "requestform_department_invalid": "Please select your department",
    "requestform_customTradingPartner_invalid": "Please enter your valid custom trading partner",
    "requestform_emailID_invalid": "Please enter your valid emailId",
    "requestform_phoneNumber_invalid": "Please enter your phone",
    "requestform_phoneNumber_splcharacter_invalid": "Please remove all special characters",
    "requestform_postalCode_invalid": "Please enter valid postal code",
    "requestform_roleInIndustry_invalid": "Please select role in industry",
    "requestform_software_packageCode_invalid": "Please enter software package code",
    "requestform_trainingDate_invalid": "Please enter training date",
    "requestform_tradingPartner_invalid": "Please enter valid trading partner",
    "requestform_trainedPerson_firstName_invalid": "Please enter valid trained person's first name",
    "requestform_trainedPerson_lastName_invalid": "Please enter valid trained person's last name",
    "requestform_trainingPlace_invalid": "Please enter valid training place",
    "requestform_trainnerName_invalid": "Please enter valid trainer name",
    "text_software_language_lable": "Language",
    "text_software_size_lable": "Software Size",
    "text_software_operating_system_lable": "Operating System",
    "text_software_software_producer_lable": "Software Producer",
    "text_software_licence_lable": "Licence",
    "text_software_software_version_lable": "Software Version",
    "text_software_last_update_lable": "Last Update ({0})",
    "text_software_general_information_lable": "General Information",
    "text_software_information_lable": "Software Information",
    "text_software_feature_list_lable": "Software Feature List",
    "text_software_demo_lable": "Demo",
    "text_software_service_lable": "Service",
    "text_software_oem-eol_lable": "OEM-EOL",
    "text_software_request_form_lable": "Please fill the following form to request your Software!",
    "text_software_request_form_choice_lable": "Do you need the Software only or also a License for it?",
    "text_software_request_form_choice_one_lable": "Software and Pin",
    "text_software_request_form_choice_two_lable": "Software Only",
    "text_software_request_form_choice_three_lable": "Software and Pin renewal",
    "text_software_request_form_company_information_lable": "Company Information",
    "text_software_request_form_company_lable": "Company*",
    "text_software_request_form_roleinindustry_lable": "Role in Industry*",
    "text_software_request_form_first_name_lable": "First Name*",
    "text_software_request_form_last_name_lable": "Last Name*",
    "text_software_request_form_department_lable": "Department",
    "text_software_request_form_street_lable": "Street*",
    "text_software_request_form_postal_code_lable": "Postal code*",
    "text_software_request_form_city_lable": "City*",
    "text_software_request_form_country_lable": "Country*",
    "text_software_request_form_phone_lable": "Phone*",
    "text_software_request_form_phone_eol_lable": "Phone",
    "text_software_request_form_email_lable": "E-Mail*",
    "text_software_request_form_information_about_training_lable": "Information about Training",
    "text_software_request_form_check_person_lable": "Trained person still at company ?*",
    "text_software_request_form_check_eLearning_course_lable": "E-Learning course successfully completed?",
    "text_software_request_form_check_yes_lable": "Yes",
    "text_software_request_form_check_no_lable": "No",
    "text_software_request_form_check_certificate_lable": "If available please attach your certificate as PDF:",
    "text_software_request_form_ebs_person_firstname_lable": "Trailer EBS trained person first name*",
    "text_software_request_form_ebs_person_lastname_lable": "Trailer EBS trained person last name*",
    "text_software_request_form_trainer_name_lable": "Training given by (Trainer Name)*",
    "text_software_request_form_dot_lable": "Date of Training",
    "text_software_request_form_dot_lable_elearning": "Date of Training / E-Learning",
    "text_software_request_form_place_of_training_lable": "Place of Training*",
    "text_software_thank_for_request_lable": "Thank you for Requesting a PIN / Software!",
    "text_software_thank_for_request_lable_na": "Thank you for your Software download request.",
    "text_software_return_homepage_lable": "Go back to Homepage",
    "text_software_request_form_termandcondition_lable": "Term and Conditions",
    "text_software_request_form_licence_agreement_lable": "License agreement",
    "text_software_request_form_privacy_agreement_lable": "Privacy Notice",
    "text_software_request_form_conditions_lable": "Webshop Term Of Use",
    "text_software_request_form_conditions_lable_NA": "Software Term of Use",
    "text_software_request_form_submit_lable": "Request Software",
    "text_software_search_software_download_lable": "Software Download",
    "text_software_search_lable": "Search",
    "text_software_search_software_lable": "Software",
    "text_software_search_language_lable": "Language",
    "text_software_search_software_type_lable": "Software Type",
    "text_software_search_button_reset_lable": "Reset",
    "text_software_search_button_search_lable": "Search",
    "software_library_page": "Software Download",
    "text_software_search_title_lable": "Title of Software(Language Pack)",
    "text_software_search_type_lable": "Software Type(Language Package)",
    "text_software_search_description_lable": "Description",
    "text_software_search_lang_lable": "Language:",
    "text_software_search_version_lable": "Version:",
    "text_software_search_release_lable": "Release:",
    "text_software_search_button_download_lable": "Download Software",
    "text_software_search_button_viewdetails_lable": "View Details",
    "text_software_search_button_download_pin_lable": "Download Software and Request PIN",
    "text_software_search_title_code_lable": "Title of Software(TEBS G2)",
    "text_software_search_type_code_lable": "Software Type(InstallationPackage)",
    "text_software_search_type_code_i_accept_the": "I accept the",
    "text_software_search_type_code_i_have_read": "I have read the",
    "text_download_kb_document_popup": "Register to Download a Knorr-Bremse document",
    "text_training_booking_form_terms_text": "By booking this technical training, I am confirming that I have read and agree with the <a href='{0}' > General Conditions of Sale and Delivery </a>",
    "text_training_booking_form_terms_link": "General Conditions of Sale and Delivery",
    "text_software_search_type_code_content1": "Your Request will be processed further",
    "text_software_search_type_code_content2": "You will receive a E-Mail with your request as well another one as soon the request was approved!",
    "text_software_search_type_code_content1_na": "You will receive an email. To download the software, please click on the link contained within the email.",
    "quote_level_comments": "Quote Comments",
    "text_software_quantity_license": "Quantity of License",
    "text_software_quantity_license_lable": "Quantity",
    "order_track_my_status_popup": "Track My Orders",
    "order_track_my_status": "Track my order",
    "order_track_my_status_po": "PO#:",
    "order_track_my_status_pos": "Pos:",
    "order_track_my_status_part": "Part#:",
    "order_track_my_status_qty": "Qty:",
    "order_track_my_status_date-shipped": "Date shipped:",
    "order_track_my_status_carrier": "Carrier:",
    "order_track_my_status_tracking": "Tracking#:",
    "order_back_to_status": "Back to Order Status",
    "compare_product_note_footer_compare_block": "Compare",
    "compare_product_note_footer": "You can compare up to 4 part numbers",
    "compare_product_note_footer_clear_all": "Clear all",
    "compare_product_note_footer_compare": "Compare",
    "text_account_quote_c4c_comment_header": "Comment",
    "document_subscribe_checkbox_label": "I would like to subscribe to the Document Update Service so that I receive an email when a new revision of my downloaded document is available. I can cancel the subscription at any time.",
    "document_doubleopt_success_message_title": "Thank you for your confirmation for document notification.",
    "compare_product_note_checkbox": "Compare",
    "document_doubleopt_unsubscribed_message_title": "Unsubscribed for document notification!",
    "text_software_request_form_pin_important_note": "Important note:",
    "text_software_request_form_expiration_time1": "From the version 22.1 the NEO Green license is time-limited and will expire one year after activation.",
    "text_software_request_form_expiration_time2": "The software will not start after the license expires.",
    "quote_entry_message_remove": "Entry Item has been removed from your Quote.",
    "text_software_request_form_conditions_text": "I want to receive update notifications when a new software version is available.",
    "search_page_training": "Trainings",
    "text_documentLibrary_search_email": "Email",
    "text_documentLibrary_search_firstName": "First Name",
    "text_documentLibrary_search_lastName": "Last Name",
    "text_productCompare_page_remove": "Remove",
    "header_customer_channel_oem": "OEM",
    "header_customer_channel_distributor": "Distributor",
    "header_customer_channel_dealer": "Dealer",
    "header_customer_channel_service_new": "Service New",
    "training_avaialble_seats": "free seats",
    "training_seats_booked_out": "fully booked",
    "breadcrumb_software_text": "Software Confirmation",
    "subscription_text_document_download": "Start Download",
    "training_detail_page_view_all": "All",
    "document_subscription_email": "Email",
    "document_subscription_first_name": "First Name",
    "document_subscription_last_name": "Last Name",
    "text_enter_email_placeholder": "Enter your email address to subscribe to the document update service",
    "text_enter_email_placeholder_show": "Enter your email address",
    "software_doubleopt_unsubscribed_message_title": "Unsubscription for Software Update Notification done successfully.",
    "text_account_document_favorite_table_doc_update": "Update Service",
    "text_account_document_favorite_table_doc_subscription": "Subscription",
    "text_adb_placeholder": "Please Type Here",
    "text_myfavourites_error_message": "The deleted document was unsubscribed from the document update service.",
    "text_breakapplication_name": "Name",
    "text_breakapplication_size": "Size",
    "text_breakapplication_remove": "Remove",
    "text_training_search_plp": "Show Training Details",
    "text_training_enter_name_placeholder": "Search by Name, Company or Email",
    "text_request_search_claim_from_date": "Date From",
    "text_request_search_claim_to_date": "Date To",
    "text_training_request_table_training_bySubmissionDate": "Submission Date",
    "text_training_request_table_training_bySubmissionDatedesc": "Submission Date-Desc",
    "text_training_request_table_training_byCourseDate": "Training Start Date",
    "text_training_request_table_training_byCourseDatedesc": "Training Start Date-Desc",
    "text_training_request_table_training_byCourse": "Training",
    "text_training_request_table_training_byCoursedesc": "Training-Desc",
    "text_training_request_table_training_byLocation": "Location",
    "text_training_request_table_training_byLocationdesc": "Location-Desc",
    "text_training_request_table_training_note_key": "Please note :",
    "text_training_request_table_training_note_value": "For data protection reasons, all information can be accessed for a maximum of 36 months after the end of the training.",
    "text_training_request_table_training_note_value2": "If you have any questions about your training booking or would like to change/cancel it, please contact your local Knorr-Bremse training team.",
    "text_training_participants_byLastName": "Last Name",
    "text_training_participants_byLastNameDesc": "Last Name-Desc",
    "text_training_participants_byCompany": "Company",
    "text_training_participants_byCompanyDesc": "Company-Desc",
    "general_phone_number": "Please Enter Valid Phone Number",
    "How_to_CompareProducts": "How to Compare Products",
    "How_to_FavorizeDocuments": "How to Favorize Documents",
    "How_to_SubscribeToDocuments": "How to Subscribe to a Document",
    "How_to_DownloadDocuments": "How to Download Documents",
    "How_to_CheckAvailiablity": "How to Check Availability",
    "How_to_BookTraining": "How to Book a Training",
    "How_to_LookupMyCoreGroup": "How to lookup my core group",
    "How_to_CheckOrderStatus": "How to check order status",
    "How_to_CheckWarrantyInspectionReport": "How to search the Warranty Claim_Inspection Report",
    "checkout_error_price_call_failed_NA": "We are sorry but your transaction could not be completed at this time; please try again later or <a  target='_blank' href='https://www.bendix.com/en/meta/footer/contact-form/'>customer service.</a>",
    "checkout_error_price_call_failed_EMEA": "We are sorry but your transaction could not be completed at this time; please try again later or <a  target='_blank' href='https://www.knorr-bremsecvs.com/en/cvs_contacts_1/wordwide/eu/cvs_contacts_location_finder.jsp'>customer service.</a>",
    "checkout_error_price_call_failed_APAC": "We are sorry but your transaction could not be completed at this time; please try again later or <a  target='_blank' href='http://www.knorr-bremsecvs.com/en/cvs_contacts_1/wordwide/eu/cvs_contacts_location_finder.jsp'>customer service.</a>",
    "text_training_error_availableDate_notFound": "Sorry, there are no training slots available for this training.",
    "text_training_bookbButton_disabled": "You don't have user rights to book a training. Please contact your company administrator or your local Knorr-Bremse webshop team for further information.",
    "general_quantity_license_number": "Please enter quantity less than 9",
    "placeholder_quantity_lable_validation": "Enter value between 1 and 9",
    "apac_help_title": "Knorr-Bremse Help Center",
    "apac_welcome_to_help_center": "Welcome to Knorr-Bremse Help Center",
    "requestform_trainedPersonStillAtCompany_invalid": "The trained person must still be in the company",
    "closest_equivalent_product_text": "Closest Equivalent Product",
    "closest_equivalent_product_desc": "This is the closest equivalent product and may not be an exact match to your searched part number. Please review all technical documentation before ordering to ensure proper fit, form, and function.",
    "please_enter_numeric_only": "Please enter numeric characters only",
    "register_company_vatIdentificationNo": "VAT identification no.*",
    "training_log_in_register": "Log-in or Register",
    "doubleopt_confirmation_message_title_preApproved": "Thank you for confirming your registration. You can login and book your training as you are pre-approved",
    "register_company_vatIdentificationNo_invalid": "Please enter the Vat Number",
    "text_software_request_form_review_lable": "Review",
    "text_software_request_form_withpin_lable": "Order with obligation to pay",
    "text_software_request_form_submit_button_lable": "Submit",
    "storelocator_digits_validation": "Please enter 5 digits as zip code",
    "storelocator_valid_validation": "Please enter valid zip code",
    "storelocator_notFound_validation": "No match was found using the zip code, please enter a city and state",
    "na_core_over500lbs_msg": "<b>Over</b> 500lbs or 100 brake shoes",
    "na_core_under500lbs_msg": "<b>Under</b> 500lbs (please arrange your own shipment)",
    "text_core_submission_product": "Product Type*",
    "text_core_save_form_text": "You are saving this core return to be completed at a later date or when your shipment is ready for pickup.To open a saved form, go to Search Core Returns under My Account",
    "text_request_core_search_claim_from_date": "Submission Date From*",
    "text_request_core_search_claim_to_date": "Submission Date To*",
    "text_core_submission_sucess_text1": "CANADA:<br/>Bendix CVS LLC / FastFrate<br/>9701 Hwy 50 <br/>Woodbridge, ON L4H 2G4 </br>***The core return documents must also be emailed for <500 lb. Canadian shipments.",
    "text_core_submission_sucess_text2": "US:<br/>Bendix CVS LLC<br/> 1850 Riverfork Dr.</br>Huntington, IN 46750</br>***UPS packages should be marked CORE on the outside",
    "text_core_submission_sucess_text3": "MEXICO:<br/>Distribuidora Bendix / Rio Lerma 108-2<br/>Industrial Tlaxcolpan <br/>Tlalnepantla, Estado de México 54030",
    "text_actual_weight": "Actual weight",
    "text_core_search_contact": "Contact <u><a href=\"mailto:cores@bendix.com\"> cores@bendix.com </a></u> if you have any issues or questions.",
    "text_user_onlineOrdering_label": "Online Ordering",
    "text_user_viewpricesandatp_label": "View Price & Availability",
    "text_storefront_true_value": "True",
    "text_storefront_false_value": "False",
    "text_copy_address_check": "Copy company name + address from previous participant",
    "text_booking_training_address_Participant": "Company Street + House No*",
    "text_booking_training_city_Participant": "Company City*",
    "text_booking_training_postalCode_Participant": "Company Postal Code*",
    "text_country_selector_FOT": "French Overseas Territories",
    "text_order_search_from_date_invalid_future": "Order Date From can't be in future date.",
    "text_order_search_to_date_invalid": "Order Date To can't be less than the Order Date From.",
    "text_order_search_to_date_invalid_future": "Order Date To can't be in future date.",
    "text_order_search_from_date_to_date_invalid": "Order Date From can't be greater than Order Date To.",
    "text_core_claimNumber": "Bendix Claim Number",
    "heading_rhs_search": "Gear serial number Search",
    "rhs_top_heading_text": "Sheppard Steering Gear Classification Tool",
    "rhs_beginning_text": "STOP !! - READ THIS BEFORE BEGINNING.",
    "rhs_first_para_text": "Sheppard <b><u>remanufactured steering gears, slave gears</u></b><b><u>&nbsp;ARE NOT</u></b> affected by this recall, with the exception of the slave gear model HD94SAC2.  <p>Refer to the",
    "rhs_first_para_guide_label": "&nbsp;<u>Identification Guideline</u>",
    "rhs_first_para_identify_text": "&nbsp;for identification of affected steering gears as well as interpretation of the serial and part number.",
    "rhs_select_vehicle_gear_number_text": "Please select your vehicle make and enter the full 8-character serial number before the dash (-) as shown below without any spaces or the “-C” at the end.",
    "rhs_select_vehicle_make_text": "Select Vehicle Make",
    "rhs_search_result_label": "Result",
    "rhs_search_details_label": "Details",
    "rhs_vehicle_make_oem_label": "Vehicle Make (OEM) and Serial Number mismatch",
    "rhs_vehicle_serial_number_label": "Serial Number:",
    "rhs_vehicle_model_number_label": "Gear part number/model number:",
    "rhsSearchText_placeHolder": "Please enter gear serial number",
    "rhs_search_information": "Please enter a gear serial number. Further instructions are available within this document",
    "rhs_search_information_document_code": "RHS0007-EN-000-DRAFT.pdf",
    "rhs_search_form_error_not_found": "Steering Gear serial number : Not Found <br><br>Check serial carefully and re-enter the serial number_  If still not found, please contact Sheppard at <a href",
    "rhs_search_form_success_status_release": "Steering Gear serial number : Good <br><br>Vehicle can be returned to service with no further remedy action",
    "rhs_search_form_rhsRecertified_status_release": "Steering Gear serial number : Good - Recertified <br><br>Vehicle can be returned to service with no further remedy action",
    "rhs_search_form_success_status_suspect": "Steering Gear serial number : Suspect <br><br>Remove and replace gear per the vehicle manufacturer's instructions",
    "rhs_search_form_success_status_datarange": "Serial Number entered is outside of the date range and is not part of the recall",
    "rhs_search_form_success_status_remanufactured": "Serial Number entered is for a remanufactured gear and is not a part of the recall",
    "rhs_search_form_success_status_reenter": "Check serial carefully and re-enter the serial number as per the picture shown above",
    "rhs_search_details_heading": "Gear part number/model number:",
    "rhs_search_details_vehicle_make": "Vehicle Make (OEM) or AM:",
    "rhs_search_form_serialNum_empty": "Please enter full 8 digit Serial Number without any spaces",
    "rhs_search_form_make_empty": "Please select your Vehicle Make",
    "rhs_search_form_serialNum_endsWithHyphenC": "Serial Number should not end with -C. Please re-enter",
    "rhs_search_form_mandate_check": "USER IS SOLELY RESPONSIBLE FOR THE INPUT OF ACCURATE DATA AND ASSUMES ALL RISKS ASSOCIATED WITH FAILURE TO DO SO.",
    "text_rememberMe_cookie": "Please consent to functional cookies to “Remember my log-in”. You may change your cookie settings",
    "here": "here",
    "breadcrumb_recallCMSPage_text": "R.H. Sheppard Recall Search",
    "text_core_submit_address_zipCodeInfoEmea": "(Use correct format to avoid delays)",
    "How_to_downloadPriceFiles": "How To Download Price File",
    "How_to_subscribeToDocument": "How to subscribe to a document",
    "How_to_searchForProducts": "How to search for products",
    "How_to_searchForaRepairKit": "How to search for a repair kit",
    "How_to_seePendingRegistrations": "How to see pending registrations",
    "How_to_downloadASoftware": "How to download a software",
    "How_to_findABookedTraining": "How to find a booked training",
    "How_to_searchForYourParticipants": "How to search for your participants",
    "training_detail_page_location_language": "Organiser * / Venue / Language",
    "training_detail_page_organizer": "*  The invoicing of the training takes place through the respective organizer.",
    "text_Show_warranty_of_coworkers": "Show warranty requests from coworkers",
    "text_anotherCR_sameBOL": "Do you want to create another CR# to be included on the same BOL?",
    "text_No_sameBOL": "Once your done with combining CR# click on \"NO\" to submit your core return",
    "text_No_sameBOL_if_not_combining_cr": "If yes,click on <b>Create.</b> If no,click on <b>Submit</b>",
    "text_create_label": "Create another CR#",
    "text_submit_label": "Submit",
    "text_brake_popup": "You can open this submitted Brake Application Request Form to review or open to start a New Brake Application Request Form",
    "text_brake_bold_popup": "If a New Request is created all information will be copied to the new form",
    "text_ADB_newRequest": "Create a New Request",
    "text_ADB_reviewRequest": "Review Submitted Request",
    "myReport_page_text_download_your_reports_NA": "Bendix Bulletin Board",
    "myReport_page_text_title_NA": "Download your reports",
    "myReport_page_text_paragraph1_NA": "Here you can download your reports. Below you will see a list of reports available to you.",
    "myReport_page_text_paragraph2_NA": "To use this feature, select the reports you want to download and click on the download button.",
    "myReport_page_text_SelectAll_NA": "Select All",
    "myReport_page_text_button_NA": "Download selected files",
    "no_report_file_to_download_NA": "No Report Files to Download.",
    "myReport_page_text_download_your_reports_EMEA": "Knorr-Bremse Bulletin Board",
    "myReport_page_text_title_EMEA": "Select and download your Knorr-Bremse bulletin files",
    "myReport_page_text_paragraph1_EMEA": "In this section Knorr-Bremse provides relevant information so that you can manage your day-to-day business more efficiently.",
    "myReport_page_text_paragraph2_EMEA": "To use this feature:",
    "myReport_page_text_paragraph3_EMEA": "1. Select the files that you want to download",
    "myReport_page_text_paragraph4_EMEA": "2. Click on the button \"Download selected files\"",
    "myReport_page_text_SelectAll_EMEA": "Select All",
    "myReport_page_text_button_EMEA": "Download selected files",
    "no_report_file_to_download_EMEA": "No Report Files to Download.",
    "register_checkbox_customerDocDownloadAccess_label": "Download Customer Documents",
    "document_page_russia_restricted": "Dear customers, we currently do not offer the document download service in your region_<br><br>For further support, please contact our Russian team at: <br><br> <ul class",
    "text_pdp_document_search": "Enter document name, number or language",
    "text_pdp_parthassol_search": "Enter part number, type number or title",
    "myaccount_brakeform_customer_id": "Customer ID",
    "myaccount_brakeform_levelofexp_text": "Level of experience with installation/design/testing of ADB or S-Cam brakes*",
    "myaccount_brakeform_check_apply": "Check all that apply",
    "myaccount_brakeform_levelofexp_tooltext": "Foundation brake refers to air-actuated systems (air disc brake, s-cam drum brake)<br/>The purpose of this question is to determine the level of support you, the OEM customer, may require during the application request stage and the verification/validation and part release stages.",
    "myaccount_brakeform_projectreq_text": "Project Requirements",
    "myaccount_brakeform_projecttarget_text": "Project Target (Reason for Request)*",
    "myaccount_brakeform_projecttarget_tooltext": "\"Brake Model\" refers to the type (ADB or S-Cam) and sub-model (e.g. ADB22X, SN7, etc) <br/> \"Duty Cycle\" refers to the frequency, duration, magnitude, and other characteristics of the brake cycle that affect brake durability and performance.",
    "myaccount_brakeform_required_sample_text": "Will you require samples?",
    "myaccount_brakeform_required_sample_tooltext": "Select Yes if at least one type is needed",
    "myaccount_brakeform_required_sampleA_text": "Planned Unit Numbers",
    "myaccount_brakeform_required_sampleA_tooltext": "Indicate the quantity of A-Samples needed (first functional or prototype sample)",
    "myaccount_brakeform_targetdate_text": "Do you have target dates for samples?",
    "myaccount_brakeform_targetdate_text_tooltext": "Indicate whether you have target delivery dates.",
    "myaccount_brakeform_targetdate_sampleA_text": "Schedule For Samples",
    "myaccount_brakeform_targetdate_sampleA_tooltext": "A-Samples to something else (Design Verification Samples maybe)",
    "myaccount_brakeform_sop_targetdate_text": "Customer Schedule (Start of Production Date)*",
    "myaccount_brakeform_sop_targetdate_tooltext": "Indicate the target date of start of production of the vehicle (or axle, in the case of axle manufacturers)",
    "myaccount_brakeform_ppv_firstyear_text": "Planned Production Volume - 1st Year (# of Vehicles)*",
    "myaccount_brakeform_ppv_secondyear_text": "Planned Production Volume - 2nd Year (# of Vehicles)*",
    "myaccount_brakeform_ppv_thirdyear_text": "Planned Production Volume - 3rd Year (# of Vehicles)*",
    "myaccount_brakeform_ppap_level_text": "PPAP Level Required",
    "myaccount_brakeform_ppap_level_tooltext": "Bendix standard is Level 1 (Part Submission Warrant). Other requirements may incur additional cost and lead time.",
    "myaccount_brakeform_FMEA_text": "Are you able to provide FMEA (Design, System, or Process)?",
    "myaccount_brakeform_FMEA_tooltext": "Indicate whether you, the customer, are able to provide or show Bendix (under NDA) a Design, System, or Process FMEA at the level of the brake-to-axle interface",
    "myaccount_brakeform_conduct_fields_text": "Do you plan to conduct field tests for this application?*",
    "myaccount_brakeform_conduct_fields_tooltext": "A field test is a test using a fleet of vehicles in real world environments, serving the vehicle's primary vocation or purpose",
    "myaccount_brakeform_vehicles_used_text": "How many vehicles are or will be used in your field test(s)?",
    "myaccount_brakeform_field_test_text": "Have you performed field tests on similar applications? If yes, please provide detail*.",
    "myaccount_brakeform_field_test_tooltext": "Indicate whether you have performed field tests on similar applications. Provide detail on the vocation, axle weight ratings, brake models tested, number of vehicles tested, duration of the test, and the results",
    "myaccount_brakeform_legal_requirement_text": "Vehicle Operation Outside of USA/Canada?*",
    "myaccount_brakeform_legal_requirement_tooltext": "IF YES, List all countries where vehicle(s) will operate and the associated name/number of regulation(s) governing braking performance requirements in the COMMENTS section of this form",
    "myaccount_brakeform_cad_model_text": "Axle/chassis 3D CAD model availability for installation investigation*",
    "myaccount_brakeform_cad_model_tooltext": "\"3D CAD model\" refers to the customer model of the chassis or axle environment where the brake will be mounted.",
    "myaccount_brakeform_painting_condition_text": "Painting Conditions - Will Parts Be Painted after Delivery?",
    "myaccount_brakeform_painting_condition_tooltext": "Indicate whether parts will be painted after receipt, type and thickness of paint, and method of application",
    "myaccount_brakeform_vehicle_genral_tooltex": "Vehicle Information - General:",
    "myaccount_brakeform_Chassis_modification_text": "Post-Production Chassis Modification*",
    "myaccount_brakeform_Chassis_modification_tooltext": "Please describe whether you expect the chassis to be modified after delivery to your customer, and the details of the expected or known modification (e.g. body builder chassis modification)",
    "myaccount_brakeform_Vehicle_lifetime_text": "Lifetime of Vehicle*",
    "myaccount_brakeform_Vehicle_lifetime_tooltext": "Indicate the expected lifetime, in years, of the vehicle",
    "myaccount_brakeform_annual_use_text": "Annual Use (miles)*",
    "myaccount_brakeform_annual_use_tooltext": "Indicate expected or typical annual use, in miles per year",
    "myaccount_brakeform_highway_operation_text": "% On-Highway Operation*",
    "myaccount_brakeform_highway_operation_tooltext": "Indicate what percentage of total vehicle operation time is spent on-highway. Includes well-maintained major highways of excellent concrete or asphalt construction.Terrain may be level to rolling with occasional maximum adverse grades to 8%. Operations are subject to legal weight and dimensional limits.",
    "myaccount_brakeform_average_grade_text": "Average Grade (%)*",
    "myaccount_brakeform_avergae_grade_tooltext": "Indicate the average grade encountered during operation",
    "myaccount_brakeform_maximum_optimum_grade_text": "Maximum Operating Grade, Length, Speed (Descent)",
    "myaccount_brakeform_maximum_optimum_grade_tooltext": "Indicate the maximum grade encountered during typical operation (descent), length down grade, and speed down grade.",
    "myaccount_brakeform_endurance_brake_text": "What type of Endurance Brake System is onboard?*",
    "myaccount_brakeform_endurance_brake_tooltext": "Indicate the endurance brake systems equipped to the vehicle. An endurance brake system is an additional braking system having the capability to provide and to maintain a braking effect over a long period of time without a significant reduction in performance.",
    "myaccount_brakeform_service_brake_text": "Service Brake Duty Cycle (Excluding Parking)*",
    "myaccount_brakeform_service_brake_tooltext": "Describe the typical frequency (how often), duration (for how long), and magnitude (how hard) of the brake actuation. Describe typical speeds at which brakes are applied.",
    "myaccount_brakeform_parking_duty_text": "Parking Duty Cycle / Conditions*",
    "myaccount_brakeform_parking_duty_tooltext": "Describe the frequency and duration of the application of the parking brake, as well as the average and maximum grades on which the vehicle is expected to park",
    "myaccount_brakeform_parking_test_oem_text": "Parking Test Requirements - Customer (OEM)*",
    "myaccount_brakeform_parking_test_oem_tooltext": "*Note: Parking is a function of vehicle systems beyond the wheel end. The vehicle manufacturer is responsible for ensuring the vehicle meets parking requirements specified by FMVSS 121.",
    "myaccount_brakeform_parking_test_text": "Parking Test Requirements same as End User*",
    "myaccount_brakeform_parking_test_tooltext": "Indicate whether the end user's method to test parking performance is the same as your (the customer's) method",
    "myaccount_brakeform_Vehicle_Operating_text": "Vehicle's Operating Environment Conditions (as related to NVH)",
    "myaccount_brakeform_Vehicle_Operating_tooltext": "Select all usage/operational conditions that apply:",
    "myaccount_brakeform_required_NVH_text": "NVH Requirements, NVH Regional Concerns, NVH Application Concerns",
    "myaccount_brakeform_required_NVH_tooltext": "Please describe any NVH (Noise, Vibration, Harshness) expectations or requirements that Bendix is expected or required to meet. Consider NVH requirements specific to regions or countries the vehicle will be used in, or application-specific concerns. If none, type \"None\". If left blank, \"Bendix will contact you to obtain further clarification\".",
    "myaccount_brakeform_brake_type_text": "Brake Type",
    "myaccount_brakeform_brake_type_tooltext": "Indicate whether the vehicle uses or will use only ADB, only S-Cam, or a combination of ADB and S-Cam brakes on its axles",
    "myaccount_brakeform_axle_config_text": "Axle Configuration",
    "myaccount_brakeform_axle_config_tooltext": "Indicate the configuration of total wheel ends vs driven wheel ends (e.g. 6X4, 4X2, etc.)",
    "myaccount_brakeform_abs_sensor_text": "ABS Sensors for all wheel positions?",
    "myaccount_brakeform_abs_sensor_tooltext": "Indicate whether each wheel position has an ABS sensor",
    "myaccount_brakeform_abs_modular_count_text": "ABS Modulator Count*",
    "myaccount_brakeform_abs_modular_count_tooltext": "Indicate how many ABS modulators are equipped",
    "myaccount_brakeform_GVWR_lbs_text": "Gross Vehicle Weight Rating (GVWR) (lbs)*",
    "myaccount_brakeform_wheelbase_range_text": "Wheelbase Range (in)*",
    "myaccount_brakeform_cog_height_laden_text": "Center of Gravity Height (Laden) (in)*",
    "myaccount_brakeform_cog_height_unladen_text": "Center of Gravity Height (Unladen) (in)*",
    "myaccount_brakeform_abs_sensor_count_text": "ABS Sensor Count",
    "myaccount_brakeform_end_user_text": "End User (Fleet Customer)",
    "myaccount_brakeform_end_user_tooltext": "Indicate the end user(s) (your fleet customer(s), dealer(s), or other customer(s)) if known. If left blank, Bendix will assume the end user is unknown.",
    "myaccount_brakeform_vehicle_info_text": "Vehicle Information - Axle Information:",
    "myaacount_brakeform_steer_text": "Steer Axle",
    "myaacount_brakeform_drive_text": "Drive Axle",
    "myaccount_brakeform_axle_manu_text": "Axle Manufacturer*",
    "myaccount_brakeform_axle_manu_tooltext": "Indicate the manufacturer of the axle",
    "myaccount_brakeform_brake_assembly_text": "Party performing brake assembly install onto the axle(s)*",
    "myaccount_brakeform_brake_assembly_tooltext": "Indicate the manufacturer that installs the brake assembly onto the axle during production.",
    "myaccount_brakeform_axle_design_text": "Axle design release/production status*",
    "myaccount_brakeform_axle_design_tooltext": "Indicate the release status of the axle(s) on which the requested brakes will be mounted.",
    "myaccount_brakeform_axle_toc_text": "Type of Connection to Axle Flange*",
    "myaccount_brakeform_axle_toc_tooltext": "Indicate the type/manufacturer of the mounting interface to the axle",
    "myaccount_brakeform_brake_disc_text": "Rotor or Drum Intended Manufacturer and Part Number*",
    "myaccount_brakeform_brake_disc_tooltext": "Indicate the manufacturer and part number or model of the disc/drum of the requested brakes",
    "myaccount_brakeform_hub_intended_text": "Hub Intended Manufacturer and Part Number*",
    "myaccount_brakeform_hub_intended_tooltext": "Indicate the manufacturer and part number or model of the hub for the requested brakes",
    "myaccount_brakeform_actuator_intended_text": "Actuator/Chamber Intended Manufacturer and Part Number*",
    "myaccount_brakeform_act_intended_tooltext": "Indicate the manufacturer and part number or model of the actuator/chamber/cylinder of the requested brakes",
    "myaccount_brakeform_vcp_text": "Relay Valve Crack Pressure*",
    "myaccount_brakeform_steer_axle_text": "Steer Axle Driven?",
    "myaccount_brakeform_steer_axletype_text": "Axle Type*",
    "myaccount_brakeform_steer_axletype_tooltext": "Indicate whether the axle is Single, Tandem, or Tridem (excluding pusher and tag axles)",
    "myaccount_brakeform_desired_parking_text": "Intended or Desired Parking Axle Configuration*",
    "myaccount_brakeform_desired_parking_tooltext": "Indicate which axle(s) are set up for or are allowed to be set up for parking.",
    "myaccount_brakeform_GAWR_lbs_text": "Gross Axle Weight Rating (GAWR) (lbs)*",
    "myaccount_brakeform_GAWR_lbs_tooltext": "Enter the gross axle weight rating",
    "myaccount_brakeform_axle_weight_text": "Customer Axle Weight Limit (lbs)",
    "myaccount_brakeform_axle_weight_tooltext": "Enter the axle weight limitation (below the GAWR), if any. This rating may be imposed by you, the customer, or the end user",
    "myaccount_brakeform_wheel_rimsize_text": "Wheel/Tire Size (example: 295/75R22.5)*",
    "myaccount_brakeform_tire_type_text": "Tire Type*",
    "myaccount_brakeform_tire_type_tooltext": "Indicate the tire type for the given axle",
    "myaccount_brakeform_tire_static_text": "Tire Static Loaded Radius (SLR) (in)*",
    "myaccount_brakeform_proposed_brake_text": "Customer-Proposed Brake",
    "myaccount_brakeform_proposed_brake_tooltext": "Indicate the proposed or desired brake model, friction material, chamber size, and slack adjuster (if applicable), for Bendix to consider for review",
    "myaccount_brakeform_disc_intended_tooltext": "Indicate the intended/requested manufacturer of the disc/drum of the requested brakes",
    "myaccount_brakeform_actuator_intended_tooltext": "Indicate the intended/requested manufacturer of the actuator/chamber/cylinder of the requested brakes",
    "myaccount_brakeform_value_crack_text": "Relay Valve Crack Pressure*",
    "myaccount_brakeform_axle_type_text": "Axle Type*",
    "myaccount_brakeform_axle_type_tooltext": "Indicate whether the axle is Single, Tandem, or Tridem (excluding pusher and tag axles)",
    "myaccount_brakeform_auxAxle_type_text": "Auxiliary Axle Type*",
    "myaccount_brakeform_auxAxle_type_tooltext": "Indicate whether the auxiliary axle is a \"pusher axle or tag axle\".",
    "myaccount_brakeform_auxAxle_attribute_text": "Auxiliary Axle Attributes",
    "myaccount_brakefor_addAux_button_text": "Add Auxiliary Axle",
    "myaccount_brakeform_auxAxle_attribute_tooltext": "Indicate whether the auxiliary axle is liftable and/or steerable, and whether it is set up for or intended for parking",
    "myaccount_brakeform_comments_attachments_tooltext": "Comments and Attachments",
    "myaccount_brakeform_pneumatic_system_text": "Bendix-Recommended Pneumatic System Design*",
    "myaccount_brakeform_pneumatic_system_tooltext": "Please indicate whether the vehicle's pneumatic system is a Bendix-recommended design",
    "myaccount_brakeform_brake_equipped_text": "Work Brake Equipped? If yes, enter pressure and application frequency*",
    "myaccount_brakeform_brake_equipped_tooltext": "Indicate whether the vehicle is equipped with a work brake and indicate the work brake pressure & application frequency. A work brake is a system or mechanism that allows the service brake to be applied at a defined pressure to act as a temporary parking brake. It may be activated (set) or deactivated by the driver but is not modulated by the driver through the treadle / pedal.",
    "myaccount_brakeform_brake_final_review": "Check Completeness",
    "text_training_booking_form_privacy_notice": "I have read the <a target='_blank' href='/privacyNote'> privacy notice </a> of Knorr-Bremse",
    "sort_by_pdp": "Sort by:",
    "text_pdp_document_desc_asc": "Document Description Ascending",
    "text_pdp_document_desc_desc": "Document Description Descending",
    "text_pdp_document_type_asc": "Document Type Ascending",
    "text_pdp_document_type_desc": "Document Type Descending",
    "text_pdp_document_code_asc": "Document Number Ascending",
    "text_pdp_document_code_desc": "Document Number Descending",
    "text_pdp_document_relDate_asc": "Document Release Date Ascending",
    "text_pdp_document_relDate_desc": "Document Release Date Descending",
    "pdp_part_partNum_asc": "Part Number Ascending",
    "pdp_part_partNum_dsc": "Part Number Descending",
    "pdp_part_decs_asc": "Description Ascending",
    "pdp_part_desc_dsc": "Description Descending",
    "pdp_part_typeNum_asc": "Type Number Ascending",
    "pdp_part_typeNum_dsc": "Type Number Descending",
    "text_software_language_text": "all languages",
    "text_smartire_header": "SmarTire®",
    "text_smartire_return_investment": "Return On Investment",
    "text_smartire_return_bottom_line": "Tire Pressure Monitoring... Your Bottom Line.",
    "text_smartire_return_bottom_line_para": "Under-inflation increases the amount of fuel a vehicle burns and reduces the life of its tire's tread and carcass. When multiplied by the number vehicles in your fleet and the thousands of miles they travel per year, it is no surprise that under-inflated tires represent the single highest maintenance expense for a commercial fleet. Often neglected as a result of high costs and steep labor requirements, regular fleet tire maintenance can actually save you money when performed consistently and efficiently.",
    "text_smartire_return_smartware": "SmartWave Active Tire Pressure Monitoring",
    "text_smartire_return_smartware_para": "The SmartWave active tire pressure and temperature monitoring system is designed to take the hassle out of regular tire maintenance. The system provides both your drivers and maintenance personnel the tools they need to easily keep tires rolling as safely and cost effectively as possible. The system generates a rapid return on investment by maximizing tire life, fuel economy and road safety while reducing unscheduled downtime and the potential for dangerous tire blowouts or fires.",
    "text_smartire_return_calculator": "ROI Calculator: USA Imperial",
    "text_smartire_return_calculator_para": "Enter your information in the calculator below and an approximate return on investment for the SmartWave system will be generated. Since every fleet is different the value generated is only an estimate.",
    "text_smartire_company_info": "Company Information",
    "text_smartire_units": "Units",
    "text_smartire_numberof_vahicles": "Number of Vehicles*",
    "text_smartire_vehicles": "vehicles",
    "text_smartire_average_mileage": "Average Mileage per Vehicle*",
    "text_smartire_numberof_tires": "Number of Tires per Vehicle*",
    "text_smartire_per_year": "per year",
    "text_smartire_tire_inspection": "Tire Inspection Interval*",
    "text_smartire_tires": "tires",
    "text_smartire_per_month": "per month",
    "text_smartire_average_under_inflation": "Average Under-Inflation*",
    "text_smartire_average_anual_downtime": "Average Annual Downtime*",
    "text_smartire_instance": "instance for every",
    "text_smartire_tire_life": "Tire Life (in distance)*",
    "text_smartire_miles": "Miles",
    "text_smartire_fuel_cunsumption": "Fuel Consumption*",
    "text_smartire_deafult_values": "Default Values",
    "text_smartire_cost_fuel": "Cost of Diesel Fuel*",
    "text_smartire_usd_per_gallon": "US Miles/Gallon(MPG)",
    "text_smartire_cost_per_tire": "Cost per Tire*",
    "text_smartire_cost_downtime": "Cost per Down-Time Instance*",
    "text_smartire_service_cost": "Service cost per vehicle*",
    "text_smartire_minutes_per_tire": "Minutes/Tire",
    "text_smartire_usd_per_hour": "USD / hour",
    "text_smartire_usd": "USD",
    "text_smartire_btn_calculate": "Calculate",
    "text_smartire_error_numeric": "Use numeric values",
    "text_smartire_xyz_trucking_co": "XYZ Trucking Co.",
    "text_smartire_normal": "Normal",
    "text_smartire_with_smartwave": "With Smartwave",
    "text_smartire_saving": "Savings",
    "text_smartire_annual_tire_cost": "Annual Tire Costs:",
    "text_smartire_annual_fuel_cost": "Annual Fuel Costs:",
    "text_smartire_annual_tire_maintenance_cost": "Annual Tire Maintenance Costs:",
    "text_smartire_annual_downtime_cost": "Annual Downtime Costs:",
    "text_smartire_total": "TOTAL:",
    "text_smartire_annual_saving": "Annual Savings per Vehicle:",
    "text_smartire_calculate_following": "Values are calculated using the following:",
    "text_smartire_reduce_tire_thread": "20% under-inflation reduces tire tread life by 25%",
    "text_smartire_reduce_fuel_economy": "20% under-inflation reduces fuel economy by 2%",
    "text_smartire_tire_failure": "90% of tire failures are as a result of under-inflation",
    "text_smartire_tire_related": "Almost half (49%) of all road side assistance calls are tire related",
    "text_smartire_smartwave_tpms": "SmartWave TPMS will reduce tire maintenance time by:",
    "register_captcha_expired_msg": "Captcha expired! Please re-enter valid captcha",
    "register_captcha_invalid_msg": "Please enter valid Captcha",
    "register_captcha_failed_msg": "Failed to load Captcha",
    "vizseek_Search_results": "Visual Search Feedback",
    "vizseek_Search_NOresults": "Visual Search Feedback - No Results",
    "secure_update_application_title": "Secure Password Update Form",
    "secure_password_update_title": "Secure Update Password",
    "secure_update_application_msg": "Dear customers, in order to manage your transactions and your data in the customer portal even more securely, please change your password.",
    "secure_update_pwd_validation_title": "Your new secure password must conform to these rules:",
    "secure_update_pwd_validation_msg1": "At least 12 characters",
    "secure_update_pwd_validation_msg2": "At least 1 lowercase letter",
    "secure_update_pwd_validation_msg3": "At least 1 capital letter",
    "secure_update_pwd_validation_msg4": "At least one number",
    "secure_update_pwd_validation_msg5": "At least one of these special characters: ( )~!@#$%^&*_-+=`|(){}[]:;\"'<>,?/",
    "secure_update_recentused_pwdMsg": "The last 5 passwords cannot be re-used",
    "secure_update_pwd_personalInfo_msg": "Do not use any personal information or company names for your password",
    "secure_update_pwd_mustChange_msg": "Password must be changed once per year",
    "secure_update_pwd_doesnot_meetReq_msg": "The password chosen does not meet the requirements.",
    "secure_update_pwd_alreadyUsed_msg": "This password has already been used, please create a new password",
    "secure_update_pwd_expiration_msg": "Your password has expired after 365 days. Please create a new password.",
    "break_view_comments": "View Comments",
    "vizseek_Search_NOresults_found": "Sorry ,we could not find a product result using visual search.<br> Please navigate using the product drilldown / categories.",
    "vizseek_Search_category": "Is this the correct product category page ?",
    "vizseek_Search_category_info": "For more info,refer to the",
    "vizseek_tooltip": "Visual Search Image",
    "Vizseek_Search_Guide": "Search Guide",
    "vizseek_search_Invalid_text1": "Sorry,we are unable to locate your product category.",
    "vizseek_search_Invalid_text2": "Please refer to the",
    "vizseek_search_Invalid_text3": "or ",
    "contactUs_label_taxt": "Contact Us",
    "contactUS_form_select_empty": "Please Select",
    "contactUs_topics": "Topic*",
    "contactUs_firstName": "First Name*",
    "contactUs_lastName": "Last Name*",
    "contactUs_company_name": "Company",
    "contactUs_address_street_text": "Street*",
    "contactUs_address_city_text": "City*",
    "contactUs_address_zip_text": "Zip/Postal Code*",
    "contactUs_email_text": "Email address*",
    "contactUs_countryCode_text": "Country*",
    "contactUs_phoneNumber_text": "Phone Number",
    "#contactUs_company_state_code_canada": "State/Province**",
    "#contactUs_company_companyStateCode": "State**",
    "contactUs_company_comments_text": "Your Message*",
    "contactUs_comments_note_text": "Enter note here",
    "contactUs_dataprotection_acceptNA": "I Accept the",
    "contacUS_privacyPolicy_msgNA": "Privacy Policy",
    "contactUs_privacyPolicy_accept_invalid": "It is required to accept the privacy policy",
    "typeMismatch_contactUSForm_termsOfUsageAcceptance": "It is required to accept the privacy policy",
    "contactUs_captcha_text": "Captcha",
    "contactUs_form_submit_msg": "Your message has been successfully sent",
    "contactUS_send_button_msg": "Send",
    "import_csv_savedCart_genericErrorNA": "Error in uploading the order template_ Please try again or contact <a href",
    "checkout_order_type_maxWeightExceeded": "You have selected as order type {0}. Your shopping cart exceeds the total weight limit of {1} KG for this order type . Please adjust the contents of your shopping cart accordingly or select a different order type.",
    "basket_page_weightPerKg": "Weight (KG)",
    "basket_page_totalWeight": "TOTAL Weight",
    "training_eLearning_regular_course_name": "eLEARNING Course",
    "text_select_country_emea": "To access your local customer portal, please select your country and language.",
    "value_calculator_header": "EnduraSure®-Pro Savings Summary",
    "value_calculator_title": "Bendix Value Calculator",
    "value_calculator_visitor_info_title": "Visitor Information",
    "value_calculator_firstName": "First Name",
    "value_calculator_lastName": "Last Name",
    "value_calculator_email": "Company Email Address",
    "value_calculator_privacy_accept": "I Accept the",
    "value_calculator_privacy_accept_link": "Value Calculator(s) Disclaimer",
    "value_calculator_next_button": "Next",
    "value_calculator_back_button": "Back",
    "value_calculator_flit_info_title": "Fleet Information",
    "value_calculator_fleetSizeTractors": "Fleet Size - Tractors*",
    "value_calculator_tractors_text": "Tractors",
    "value_calculator_tractorTradeInCycle": "Tractor Trade-In Cycle*",
    "value_calculator_fleetSizeTrailers": "Fleet Size - Trailers*",
    "value_calculator_trailers_text": "Trailers",
    "value_calculator_year_text": "Years",
    "value_calculator_trailerTradeInCycle": "Trailer Trade-In Cycle*",
    "value_calculator_actuator_text": "Actuator",
    "value_calculator_usdOcc_text": "USD / Occurrence",
    "value_calculator_calls_text": "Calls",
    "value_calculator_usdDay_text": "USD / Day",
    "value_calculator_replacement_costNode_title": "Replacement Cost per Actuator",
    "value_calculator_replacement_cost_title": "Annual Replacement Cost per Actuator:",
    "value_calculator_replacementFleetCostPerActuator": "Replacement Fleet Cost per Actuator",
    "value_calculator_replacementFleetCostPerActuator_toolTip": "The average fleet cost for the failed actuator.",
    "value_calculator_laborToInstallActuator": "Labor to Install Actuator",
    "value_calculator_laborToInstallActuator_toolTip": "Labor cost based on 30 minutes to install replacement actuator.",
    "value_calculator_totalCostPerFailedActuator": "Total Cost per Failed Actuator",
    "value_calculator_numberOfActuatorsReplacedPerYear": "Number of Actuators Replaced per Year",
    "value_calculator_numberOfActuatorsReplacedPerYear_toolTip1": "On average, fleets replace one actuator annually on 15% of their tractors and 12% of trailers.",
    "value_calculator_numberOfActuatorsReplacedPerYear_toolTip2": "Source: MacKay & Company 2023",
    "value_calculator_product_performance_title": "Current Product Performance",
    "value_calculator_brandOfActuator": "Brand of Actuator",
    "value_calculator_csa_title": "CSA Downtime Costs",
    "value_calculator_roadsideCallRate": "Roadside Call Rate",
    "value_calculator_roadsideCallRate_toolTip": "Average cost of a roadside assistance call, including downtime.",
    "value_calculator_annualRoadsideCallsToActuators": "Annual Number of Roadside Calls related to Actuators*",
    "value_calculator_violations_text": "Violations",
    "value_calculator_roadsideCallRateCsaViolation": "Roadside Call Rate for CSA Violation",
    "value_calculator_roadsideCallRateCsaViolation_toolTip": "Estimated cost of roadside assistance during CSA Out-of-Service (OOS) event.",
    "value_calculator_annualOutOfServiceCsaViolations": "Annual Number of Out-of-Service Brake CSA Violations*",
    "value_calculator_fleetDowntimeRate": "Fleet Downtime Rate*",
    "value_calculator_upcharge_title": "Upcharge on New Equipment",
    "value_calculator_estUpchargeForEndTractor": "Estimated upcharge for EnduraSure-Pro on tractor over current option*",
    "value_calculator_estUpchargeForEndTractor_errorMsg": "Please enter Estimated upcharge for EnduraSure-Pro on tractor over current option",
    "value_calculator_estUpchargeForEndTrailer": "Estimated upcharge for EnduraSure-Pro on trailer over current option*",
    "value_calculator_estUpchargeForEndTrailer_errorMsg": "Please enter Estimated upcharge for EnduraSure-Pro on trailer over current option",
    "value_calculator_enduraSure_summary": "EnduraSure®-Pro Summary",
    "value_calculator_standardChamberLifetime": "Standard Chamber (Lifetime)",
    "value_calculator_sealedChamberLifetime": "Sealed Chamber (Lifetime)",
    "value_calculator_description": "Description",
    "value_calculator_estUpchargeForEndTractor_pdf": "Upcharge for EnduraSure-Pro per tractor",
    "value_calculator_estUpchargeForEndTrailer_pdf": "Upcharge for EnduraSure-Pro per trailer",
    "value_calculator_unit_cost": "Unit Cost",
    "value_calculator_totalFleet_cost": "Total Fleet Cost",
    "value_calculator_initialpurchase_tractor_cost": "Initial Purchase Cost - tractor",
    "value_calculator_initialpurchase_trailer_cost": "Initial Purchase Cost - trailer",
    "value_calculator_replacementTractor_cost": "Lifetime replacement costs - tractor",
    "value_calculator_replacementTrailer_cost": "Lifetime replacement costs - trailer",
    "value_calculator_csaTractor_cost": "CSA Related Costs - tractor",
    "value_calculator_csaTrailer_cost": "CSA Related Costs - trailer",
    "value_calculator_total_text": "Total",
    "value_calculator_return_investment": "Return on Investment (ROI)",
    "value_calculator_TCO_perUnit_standard": "TCO per Unit - Standard (USD)",
    "value_calculator_TCO_perUnit_Sealed": "TCO per Unit - Sealed (USD)",
    "value_calculator_fleet_saving": "Net Fleet Savings (USD)",
    "value_calculator_description_text": "Description",
    "value_calculator_email_results": "Email Results",
    "value_calculator_reset_text": "Reset",
    "value_calculator_email_text": "Email",
    "value_calculator_enduraSure_perTractor": "Upcharge for EnduraSure®-Pro per Tractor",
    "value_calculator_enduraSure_perTractor_desc": "Estimated upcharge for EnduraSure®-Pro on tractor over current option. Cost can range from $50 to $150 per new tractor.",
    "value_calculator_enduraSure_perTrailer": "Upcharge for EnduraSure®-Pro per Trailer",
    "value_calculator_enduraSure_perTrailer_desc": "Estimated upcharge for EnduraSure®-Pro on trailer over current option. Cost can range from $50 to $150 per new trailer.",
    "value_calculator_proEmail_summary": "EnduraSure®-Pro Email Summary",
    "value_calculator_contact_info": "Contact Information",
    "valueCalculator_brandOfActuator_bendixEnduraSure": "Bendix EnduraSure",
    "valueCalculator_brandOfActuator_bendixEnduraSurePro": "Bendix EnduraSure-Pro",
    "valueCalculator_brandOfActuator_haldexGoldSeal": "Haldex Gold Seal",
    "valueCalculator_brandOfActuator_haldexLifeSeal": "Haldex Life Seal",
    "valueCalculator_brandOfActuator_tseOmni": "TSE Omni",
    "valueCalculator_brandOfActuator_tseUltra": "TSE Ultra",
    "valueCalculator_brandOfActuator_wabcoTristop": "WABCO Tristop",
    "valueCalculator_brandOfActuator_other": "Other",
    "value_cal_fleetSizeTractors_valMsg": "Please enter Fleet Size - Tractors",
    "value_cal_tractorTradeInCycle_valMsg": "Please enter Tractor Trade-In Cycle",
    "value_cal_fleetSizeTrailers_valMsg": "Please enter Fleet Size - Trailers",
    "value_cal_trailerTradeInCycle_valMsg": "Please enter Trailer Trade-In Cycle",
    "value_cal_repFleetCostPerActuator_valMsg": "Please enter Replacement Fleet Cost per Actuator",
    "value_cal_laborToInstallActuator_valMsg": "Please enter Labor to Install Actuator",
    "value_cal_noOfActuatorsReplacedPerYear_valMsg": "Please enter Number of Actuators Replaced per Year",
    "value_cal_roadsideCallRate_valMsg": "Please enter Roadside Call Rate",
    "value_cal_annualRoadsideCallsToActuators_valMsg": "Please enter Annual Number of Roadside Calls related to Actuators",
    "value_cal_roadsideCallRateCsaViolation_valMsg": "Please enter Roadside Call Rate for CSA Violation",
    "value_cal_annualOutOfServiceCsaViolations_valMsg": "Please enter Annual Number of Out-of-Service Brake CSA Violations",
    "value_cal_fleetDowntimeRate_valMsg": "Please enter Fleet Downtime Rate",
    "value_cal_greaterThan_zeroMsg": "Enter value greater than 0",
    "value_cal_landingPage_textMsg": "Find out how much you can save when you choose Bendix® Air Disc Brakes, EnduraSure®-Pro Spring Brakes and SmarTire® Tire Pressure Monitoring System by Bendix CVS. Check out our easy-to-use value calculators.",
    "value_cal_negativeVal_text": "No net savings realized. Fleet should consider other benefits such as reduced warranty, parts inventory, and utilization of technician time.",
    "value_calculator_formSubmit_success": "Your EnduraSure-Pro savings projection summary has been emailed.",
    "value_calculator_formSubmit_failed": "Something went wrong while submitting the  EnduraSure-Pro savings. Please try again later.",
    "value_calculator_formSubmit_error": "Please correct the below errors.",
    "value_calculator_fName_emptyMsg": "First Name Cannot be empty.",
    "value_calculator_lName_emptyMsg": "Last Name Cannot be empty.",
    "value_calculator_email_emptyMsg": "Company Email Cannot be empty.",
    "value_calculator_captcha_validMsg": "Please enter valid Captcha.",
    "value_calculator_captcha_expiredMsg": "Captcha expired.",
    "value_calculator_captcha_failedMsg": "Failed to load captcha.",
    "value_calculator_captcha_invalidMsg": "Invalid captcha, Please try again.",
    "text_software_request_edit": "Click here to edit entries",
    "text_booking_training_information_extraInfo": "For changes contact your local Knorr-Bremse team",
    "text_core_submit_internalTrackingNumber": "This is your internal tracking number (optional)",
    "text_core_submit_internalUseOnly": "Bendix internal use only",
    "endurasure_procalculator_title": "EnduraSure®-Pro",
    "text_warranty_submit_datein_service_invalid_future": "Date In Service can't be in future date.",
    "text_warranty_submit_date_removed_service_invalid_future": "Date Removed from Service can't be in future date.",
    "default_soldto_invaliddata": "Wrong or missing customer number. If you do not have the correct customer number, please contact your local Knorr-Bremse sales team.",
    "default_soldto_description": "Mandatory entry for Expert Network Workshop",
    "text_cart_delivery_information_title": "Important Delivery Information!",
    "text_cart_delivery_information_text": "Your shopping cart contains<u> part numbers that will be shipped separately from our central warehouse in Germany</u> to the selected delivery address.",
    "text_cart_delivery_information_paragraph": "Therefore, this shipment may not arrive on the estimated delivery date.",
    "text_cart_delivery_information_note": "Note: There are <u>no additional freight costs for this.</u>",
    "text_cart_delivery_information_parts": "These are the relevant part numbers:",
    "text_cart_delivery_information_position": "Position",
    "text_cart_delivery_information_paragraph1": "All other part numbers will ship from your local warehouse as usual.",
    "text_cart_delivery_information_paragraph2": "If you have got any questions, please contact your local customer service.",
    "text_cart_delivery_information_agree": "I agree",
    "recent_search": "Recent Searches",
    "text_warranty_submit_part_mileage": "Mileage in Service*",
    "register_site_description": "Upon completion of the registration form below, your account request will be submitted for review. You will receive a confirmation via email with additional instructions.",
    "text_warranty_vinNumber_invalid": "Please enter a valid Vehicle ID/VIN-Number/Chassis Number",
    "login_info": "Register with Bendix and get product availability, pricing, order information, and much more!",
    "text_warranty_submit_date_removed_invalid": "Date removed from service can't be less than the Date put in service.",
    "error_account_myPart_part_notcorrect": "line {0} : {1} part number {2} is not recognize and was not uploaded. Please revise your entry or contact your local {3} customer service.",
    "error_account_myPart_part_dublicate": "Line {0} : Part number already used.",
    "text_warranty_search_claim_number": "Bendix Warranty Claim Number",
    "cart_page_req_delivery_date_for_all_items": "All Lines Requested Delivery Date",
    "error_account_myPart_solto_select": "Please select customer.",
    "text_warranty_search_part_number": "Bendix Part Number",
    "text_warranty_axle_position": "Axle Position*",
    "text_warranty_submit_kb_claim_generated": "Automatically generated by Bendix",
    "text_warranty_submit_part_datein_service": "Date in Service*",
    "text_account_warranty_table_header_claim_number": "Bendix Warranty Claim No.",
    "warranty_information": "Bendix Warranty Information Center",
    "text_core_search_coreGroup": "Enter Core Group",
    "text_warranty_submit_alphanumeric_invalid": "Please enter alphanumeric Number",
    "text_warranty_search_customer_part_number": "Customer Part Number",
    "text_warranty_submit_part_type_number": "Model (auto fill)",
    "text_core_search_partNumber": "Enter Bendix Part #",
    "error_account_myPart_part_notfound": "Part number is already exists.",
    "text_account_warranty_table_header_dsiplay_status": "Claim Status Reason",
    "text_warranty_claimRefNumber_invalid": "Please enter a valid Claim Number",
    "text_warranty_submit_phone": "Phone Number",
    "text_warranty_submit_kb_claim_number": "Bendix Claim Number",
    "import_csv_savedCart_customerPartNumber": "Customer Part Number(will determine Bendix Part Number)",
    "quick_order_page_req_delivery_date_for_all_items": "All Lines Requested Delivery Date",
    "error_account_myPart_template_select": "Please select template.",
    "text_warranty_submit_returning_part_number": "Returning Part Number*",
    "text_return_request_submit_returning_part_number": "Bendix Part Number*",
    "text_account_warranty_table_header_part_number": "Bendix Part Number",
    "text_account_warranty_table_header_display_creditmemo": "Billing Address",
    "text_account_warranty_claim_tracking_info": "Parts Returned Via",
    "text_account_warranty_table_header_display_creditmemo_popup_content": "Please contact your corporate offices for payment details. All warranty payments are issued to",
    "ppd_freight_greater_than_subtotal_info": "Your cart total (exclude core charges) is {0} {1}. You can qualify for prepaid freight if you add {2} {1} worth of parts to your cart.",
    "text_warranty_submit_datein_service_invalid": "Please enter valid Date in Service",
    "text_warranty_submit_date_removed_service_invalid": "Please enter valid Date Removed from Service",
    "address_firstName": "First Name",
    "address_line2": "Address Line 2",
    "address_surname": "Last Name",
    "address_title": "Title",
    "address_title_none": "None",
    "b2bcustomer_cancel": "Cancel",
    "b2bunit_approvalProcess": "Approval Process",
    "b2bunit_cancel": "Cancel",
    "b2bunit_disabled_infomsg": "This business unit is disabled",
    "b2bunit_id": "Business Unit ID",
    "b2bunit_name": "Business Unit Name",
    "b2bunit_no_button": "No",
    "b2bunit_notfound": "Business Unit was not found",
    "b2bunit_parent": "Parent Business Unit",
    "b2bunit_save": "Save changes",
    "b2bunit_yes_button": "Yes",
    "b2buser_no_button": "No",
    "b2buser_yes_button": "Yes",
    "b2busergroup_b2badmingroup_name": "B2B Administrator",
    "b2busergroup_b2bapprovergroup_name": "B2B Approver",
    "b2busergroup_b2bcustomergroup_name": "B2B Customer",
    "b2busergroup_b2bmanagergroup_name": "B2B Manager",
    "b2busergroup_cancel": "Cancel",
    "b2busergroup_id": "User group ID",
    "b2busergroup_name": "User group Name",
    "b2busergroup_parent": "Parent Business Unit",
    "b2busergroup_save": "Save Updates",
    "error_bugetcode_notfound": "Budget code is not valid",
    "form_b2bcustomer_adminrole_error": "A B2B Administrator can not downgrade their administrative role.",
    "form_b2bcustomer_parentunit_error": "A B2B Administrator can not modify his parent unit.",
    "form_b2bunit_approvalProcessCode_required": "Please select an approval process for the root unit",
    "form_b2bunit_notunique": "Business unit with the same id already exists",
    "form_b2bunit_success": "Business unit saved successfully",
    "form_b2busergroup_noeditpermissions": "You don't have an appropriate permissions to edit this group.",
    "form_b2busergroup_notunique": "User group with the same id already exists",
    "form_b2busergroup_success": "User group updated successfully",
    "form_b2busergroup_parentunit_updated": "Please be aware that modifying a user group's parent unit can have adverse affects.",
    "form_global_error": "Please correct the errors below.",
    "form_required": "Fields marked * are required",
    "form_select_empty": "Please select",
    "general_required": "Required",
    "header_link_company": "My Company",
    "myCompany_login_myCompanyHome": "Login to My Company",
    "profile_checkNewPassword": "Confirm New Password*",
    "profile_checkNewPassword_invalid": "Please confirm your new password",
    "profile_email_invalid": "Please enter a valid email",
    "profile_newPassword_invalid": "Please enter your new password",
    "success_remove_user_from_unit": "{0} successfully removed from {1} Business Unit",
    "text_company_back": "Back",
    "search_page_showing_text": "Showing",
    "search_page_of_text": "of",
    "search_page_result_text": "results",
    "text_account_addressBook_addEditform": "Please use this form to add/edit an address",
    "text_account_user_saveUpdates": "Save Updates",
    "text_company_actions_name": "Actions",
    "text_company_cancel_button": "Cancel",
    "text_company_disable_button": "Disable",
    "text_company_not_applicable": "n/a",
    "text_company_addNewBudgets": "Add New Budgets",
    "text_company_addNewCostCenters": "Add new cost center",
    "text_company_addNewPermission": "Add new permission",
    "text_company_addNewUsergroup": "Add new user group",
    "text_company_addNewUsers": "Add new users",
    "text_company_administrators_page_currentPage": "Page {0} of {1}",
    "text_company_administrators_page_firstPage": "&laquo;",
    "text_company_administrators_page_lastPage": "&raquo;",
    "text_company_administrators_page_linkNextPage": "Next Page",
    "text_company_administrators_page_linkPreviousPage": "Previous Page",
    "text_company_administrators_page_showAllResults": "Show all",
    "text_company_administrators_page_showPageResults": "Show paginated",
    "text_company_administrators_page_sort_byDate": "Date",
    "text_company_administrators_page_sort_byName": "Name",
    "text_company_administrators_page_sort_byUnit": "Parent Unit",
    "text_company_administrators_page_sortTitle": "Sort by:",
    "text_company_administrators_page_totalResults": "{0} Administrators found",
    "text_company_administrators_viewPage": "View Administrators",
    "text_company_approvers_actions_title": "Actions",
    "text_company_approvers_name_title": "Name",
    "text_company_approvers_page_currentPage": "Page {0} of {1}",
    "text_company_approvers_page_firstPage": "&laquo;",
    "text_company_approvers_page_lastPage": "&raquo;",
    "text_company_approvers_page_linkNextPage": "Next Page",
    "text_company_approvers_page_linkPreviousPage": "Previous Page",
    "text_company_approvers_page_showAllResults": "Show all",
    "text_company_approvers_page_showPageResults": "Show paginated",
    "text_company_approvers_page_sort_byName": "Name",
    "text_company_approvers_page_sort_byUnit": "Parent Unit",
    "text_company_approvers_page_sortTitle": "Sort by:",
    "text_company_approvers_page_totalResults": "{0} Approvers found",
    "text_company_approvers_unit_title": "Parent Unit",
    "text_company_approvers_viewPage": "View Approvers",
    "text_company_budget_SelectBudgets": "Select Budgets.",
    "text_company_budget_actions": "Actions",
    "text_company_budget_addPage": "New",
    "text_company_budget_amount": "Budget Amount",
    "text_company_budget_budgetBreadCrumb": "Budget {0}",
    "text_company_budget_budgetId": "Budget ID",
    "text_company_budget_cancelButton_displayName": "Cancel",
    "text_company_budget_code_exists_error_title": "Budget Id already exists.",
    "text_company_budget_create_title_label": "New Budget",
    "text_company_budget_createButton_displayName": "Add New",
    "text_company_budget_currency": "Currency",
    "text_company_budget_disable_confirm": "Confirm Disable",
    "text_company_budget_deselect_confirm": "Confirm Budget Deselect",
    "text_company_budget_disable_confirm_message": "Doing this will prevent this budget from being used. Do you wish to continue?",
    "text_company_budget_disable_confirm_no": "No",
    "text_company_budget_disable_confirm_yes": "Yes",
    "text_company_budget_disableButton_displayName": "Disable Budget",
    "text_company_budget_edit": "Edit",
    "text_company_budget_edit_title_label": "Edit Budget",
    "text_company_budget_editPage": "Edit",
    "text_company_budget_enableButton_displayName": "Enable",
    "text_company_budget_enabledDisabled": "Status",
    "text_company_budget_end": "End",
    "text_company_budget_endDate": "End Date",
    "text_company_budget_endDateLesser_error_title": "End Date should be greater than Start Date",
    "text_company_budget_id": "ID",
    "text_company_budget_name": "Budget Name",
    "text_company_budget_noBudgetMessage": "No Budgets found.",
    "text_company_budget_noCostCentersFound_message": "No Cost Centers found.",
    "text_company_budget_page_currentPage": "Page {0} of {1}",
    "text_company_budget_page_firstPage": "&laquo;",
    "text_company_budget_page_lastPage": "&raquo;",
    "text_company_budget_page_linkNextPage": "Next Page",
    "text_company_budget_page_linkPreviousPage": "Previous Page",
    "text_company_budget_page_showAllResults": "Show all",
    "text_company_budget_page_showPageResults": "Show paginated",
    "text_company_budget_page_sort_byCode": "Id",
    "text_company_budget_page_sort_byName": "Name",
    "text_company_budget_page_sort_byUnitName": "Parent Unit",
    "text_company_budget_page_sort_byValue": "Budget Amount",
    "text_company_budget_page_sortTitle": "Sort by:",
    "text_company_budget_page_totalResults": "{0} Budgets found",
    "text_company_budget_saveButton_displayName": "Save",
    "text_company_budget_start": "Start",
    "text_company_budget_startDate": "Start Date",
    "text_company_budget_status": "Status",
    "text_company_budget_status_active": "Active",
    "text_company_budget_status_disabled": "Disabled",
    "text_company_budget_unit": "Parent business unit",
    "text_company_budget_viewPage": "{0}",
    "text_company_budget_viewPage_costCenters": "Cost Centers",
    "text_company_budget_viewPage_label": "Budget Details",
    "text_company_budget_viewPage_back": "Back to Budgets",
    "text_company_children_page_currentPage": "Page {0} of {1}",
    "text_company_children_page_firstPage": "&laquo;",
    "text_company_children_page_lastPage": "&raquo;",
    "text_company_children_page_linkNextPage": "Next Page",
    "text_company_children_page_linkPreviousPage": "Previous Page",
    "text_company_children_page_showAllResults": "Show all",
    "text_company_children_page_showPageResults": "Show paginated",
    "text_company_children_page_sort_byDate": "Date",
    "text_company_children_page_sort_byName": "Name",
    "text_company_children_page_sortTitle": "Sort by:",
    "text_company_children_page_totalResults": "{0} Child Units found",
    "text_company_column_id_name": "ID",
    "text_company_column_name_name": "Name",
    "text_company_column_parentUnit_name": "Parent Unit",
    "text_company_column_roles_name": "Roles",
    "text_company_column_status_name": "Status",
    "text_company_costCenter_addButton_displayName": "Create New Cost Center",
    "text_company_costCenter_addNew": "Add New",
    "text_company_costCenter_addPage": "New",
    "text_company_costCenter_budget_title": "Budget(s)",
    "text_company_costCenter_button_displayName": "Edit",
    "text_company_costCenter_cancelButton_displayName": "Cancel",
    "text_company_costCenter_code_exists_error_title": "This Cost Center ID already exists.",
    "text_company_costCenter_costCenterBreadCrumb": "Cost Center: {0}",
    "text_company_costCenter_create_label": "Create Cost Center",
    "text_company_costCenter_create_success": "Cost Center created successfully",
    "text_company_costCenter_currency_title": "Currency",
    "text_company_costCenter_state_title": "Status",
    "text_company_costCenter_state_active": "Active",
    "text_company_costCenter_state_inactive": "Disabled",
    "text_company_costCenter_disable_button": "Disable Cost Center",
    "text_company_costCenter_disable_confirm": "Confirm Disable",
    "text_company_costCenter_disable_confirm_message": "Doing this will prevent this cost center from being used when placing orders. Do you wish to continue?",
    "text_company_costCenter_disable_warning_message": "Warning!  Disabling this Cost Center will make it unavailable when placing orders.",
    "text_company_costCenter_disable_confirm_no": "No",
    "text_company_costCenter_disable_confirm_yes": "Yes",
    "text_company_costCenter_edit_label": "Edit Cost Center",
    "text_company_costCenter_edit_title": "Edit",
    "text_company_costCenter_edit_required_label": "Fields marked with * are required",
    "text_company_costCenter_editPage_breadcrumb": "Edit Cost Center: {0}",
    "text_company_costCenter_enable_button": "Enable",
    "text_company_costCenter_enabled_title": "Cost Center Enabled/disabled",
    "text_company_costCenter_id": "ID",
    "text_company_costCenter_id_title": "Cost Center ID",
    "text_company_costCenter_name": "Name",
    "text_company_costCenter_name_title": "Cost Center Name",
    "text_company_costCenter_page_currentPage": "Page {0} of {1}",
    "text_company_costCenter_page_firstPage": "&laquo;",
    "text_company_costCenter_page_lastPage": "&raquo;",
    "text_company_costCenter_page_linkNextPage": "Next Page",
    "text_company_costCenter_page_linkPreviousPage": "Previous Page",
    "text_company_costCenter_page_showAllResults": "Show all",
    "text_company_costCenter_page_showPageResults": "Show paginated",
    "text_company_costCenter_page_sort_byCode": "Id",
    "text_company_costCenter_page_sort_byName": "Name",
    "text_company_costCenter_page_sort_byUnitName": "Parent Unit",
    "text_company_costCenter_page_sortTitle": "Sort by:",
    "text_company_costCenter_page_totalResults": "{0} Cost Centers found",
    "text_company_costCenter_saveButton_displayName": "Save",
    "text_company_costCenter_select_budget": "Edit Related Budgets",
    "text_company_costCenter_selectBox_currency": "Please select currency",
    "text_company_costCenter_selectBox_unit": "Please select unit",
    "text_company_costCenter_unit_title": "Parent unit",
    "text_company_costCenter_update_success": "Cost Center updated successfully",
    "text_company_costCenter_viewDetails_label": "Cost Center Details",
    "text_company_costCenter_add_new_label": "New Cost Center",
    "text_company_costCenter_viewPage": "{0}",
    "text_company_costCenter_back": "Back to Cost Centers",
    "text_company_createNewUnits": "Create new units",
    "text_company_customers_page_currentPage": "Page {0} of {1}",
    "text_company_customers_page_firstPage": "&laquo;",
    "text_company_customers_page_lastPage": "&raquo;",
    "text_company_customers_page_linkNextPage": "Next Page",
    "text_company_customers_page_linkPreviousPage": "Previous Page",
    "text_company_customers_page_showAllResults": "Show all",
    "text_company_customers_page_showPageResults": "Show paginated",
    "text_company_customers_page_sort_byDate": "Date",
    "text_company_customers_page_sort_byName": "Name",
    "text_company_customers_page_sort_byUnit": "Parent Unit",
    "text_company_customers_page_sortTitle": "Sort by:",
    "text_company_customers_page_totalResults": "{0} Customers found",
    "text_company_customers_viewPage": "View Customers",
    "text_company_deselect_action_label": "Deselect",
    "text_company_deselect_action_label_confirm": "Confirm Deselect",
    "text_company_disable_name": "Disable",
    "text_company_diselect_name": "Diselect",
    "text_company_editOrDisableBudgets": "Edit or disable budgets",
    "text_company_editOrDisableCostCenters": "Edit or disable cost centers",
    "text_company_editOrDisablePermissions": "Edit or disable permissions",
    "text_company_editOrDisableUnits": "Edit or disable units",
    "text_company_editOrDisableUsergroups": "Edit or disable order user groups",
    "text_company_editOrDisableUsergroups_confirm": "Confirm User group Changes",
    "text_company_editOrDisableUsergroups_confirm_message": "There are possible implications or limitations associated with modifying a user group's parent unit.  Please confirm these changes are intended.",
    "text_company_editOrDisableUsergroups_confirm_action_label_confirm": "Confirm Changes",
    "text_company_editOrDisableUsergroups_confirm_action_label_cancel": "Cancel",
    "text_company_editOrDisableUsers": "Edit or disable users",
    "text_company_id_name": "ID",
    "text_company_manage_budget_subtitle": "Budgets limit the amount your organization can spend at the {0}.",
    "text_company_manage_budget_title": "Budgets",
    "text_company_manage_budget_view_costcenter_subtitle": "The budget is assigned to these cost centers.<br /> To modify these assignments you need to navigate to the respective cost center using the links below.",
    "text_company_manage_budget_view_subtitle": "Budgets limit the amount your organization can spend at the {0}. For a budget to be used by the system it must be assigned to a cost center so that it is assessed when an order is placed against the cost center.",
    "text_company_manage_costcenter_budget_title": "Budgets",
    "text_company_manage_costcenters_disable": "Disable",
    "text_company_manage_costcenters_edit_budgets_subtitle": "A cost center needs an active budget in so that a customer can place orders against it.",
    "text_company_manage_costcenters_subtitle": "All orders purchased on credit must be ordered against a cost center. The cost center&#145;s place within the organization structure defines who can place orders against it and its budget defines the limit of expenditure for that cost center at the {0}.",
    "text_company_manage_costcenters_title": "Cost Centers",
    "text_company_manage_costcenters_view_budgets_subtitle": "A cost center needs budgets assigned to it so that customers can place orders against the cost center. This is possible until the limit of the active budget is reached.",
    "text_company_manage_costcenters_view_subtitle": "All orders purchased on credit must be ordered against a cost center. The cost center's parent unit defines its place within the organization and hence the users who can place orders against it.",
    "text_company_manage_unit_address_cancelButton": "Cancel",
    "text_company_manage_unit_childrenUnits_edit": "Edit",
    "text_company_manage_unit_childrenUnits_view": "View",
    "text_company_manage_unit_costCenter_actions": "Actions",
    "text_company_manage_unit_costCenter_currency": "Currency",
    "text_company_manage_unit_costCenter_edit": "Edit",
    "text_company_manage_unit_costCenter_id": "ID",
    "text_company_manage_unit_costCenter_name": "Name",
    "text_company_manage_unit_costCenter_view": "View",
    "text_company_manage_unit_editAddress": "Edit Address",
    "text_company_manage_unit_saveAddress": "Save Address",
    "text_company_manage_unit_user_disable": "Disable",
    "text_company_manage_unit_user_edit": "Edit",
    "text_company_manage_unit_user_enable": "Enable",
    "text_company_manage_unit_user_remove": "Remove",
    "text_company_manage_unit_user_view": "View",
    "text_company_manage_units": "Units",
    "text_company_manage_units_accountManager_name": "Name",
    "text_company_manage_units_accountManagers": "Account Managers",
    "text_company_manage_units_addAddress": "New Address",
    "text_company_manage_units_addCostCenter_breadcrumb": "New Cost Center",
    "text_company_manage_units_viewcustomer_breadcrumb": "{0}",
    "text_company_manage_units_addnewUnit": "Add New Unit",
    "text_company_manage_units_address_actions": "Actions",
    "text_company_manage_units_address_country": "Country/Region",
    "text_company_manage_units_address_line1": "Address Line 1",
    "text_company_manage_units_address_line2": "Address Line 2",
    "text_company_manage_units_address_towncity": "Town/City",
    "text_company_manage_units_address_zipcode": "Postal Code",
    "text_company_manage_units_addressForm_create_header": "Create Address for Unit: {0}",
    "text_company_manage_units_addressForm_create_title": "New Address",
    "text_company_manage_units_addressForm_edit_header": "Edit Address for Unit: {0}",
    "text_company_manage_units_addressForm_edit_title": "Edit Address",
    "text_company_manage_units_addressForm_header": "Add Business Address",
    "text_company_manage_units_addresses": "Addresses",
    "text_company_manage_units_adduser": "Create User for Unit: {0}",
    "text_company_manage_units_adduser_title": "Create User for Unit: {0}",
    "text_company_manage_units_administrators_mainTitle": "Select Administrator(s)",
    "text_company_manage_units_administrators": "Administrator(s)",
    "text_company_manage_units_administrators_subtitle": "Select or deselect users which should be administrators for this unit.",
    "text_company_manage_units_administrators_title": "Manage Administrators for Unit: {0}",
    "text_company_manage_units_approvers": "Approver(s)",
    "text_company_manage_units_approvers_mainTitle": "Select Approver(s)",
    "text_company_manage_units_approvers_manage_title": "Manage Approvers for Unit: {0}",
    "text_company_manage_units_approvers_subtitle": "Select or deselect users which should be approvers for this unit.",
    "text_company_manage_units_button_create": "Create",
    "text_company_manage_units_button_createnew": "Create New",
    "text_company_manage_units_button_disableUnit": "Disable Unit",
    "text_company_manage_units_button_editChildren": "Edit",
    "text_company_manage_units_button_editUnit": "Edit",
    "text_company_manage_units_button_enableUnit": "Enable Unit",
    "text_company_manage_units_childUnits": "Child Units",
    "text_company_manage_units_children": "Business Unit {0} Child Units",
    "text_company_manage_units_childrenUnits_actions": "Actions",
    "text_company_manage_units_childrenUnits_id": "ID",
    "text_company_manage_units_childrenUnits_name": "Name",
    "text_company_manage_units_costCenters": "Cost Centers",
    "text_company_manage_units_create": "Create Child Unit for Unit: {0}",
    "text_company_manage_units_create_costCenter_title": "Create Cost Center for Unit: {0}",
    "text_company_manage_units_createUnit_breadcrumb": "New",
    "text_company_manage_units_customers_mainTitle": "Select Customer(s)",
    "text_company_manage_units_customers": "Customer(s)",
    "text_company_manage_units_customers_subtitle": "Select or deselect users which should be customers for this unit.",
    "text_company_manage_units_customers_title": "Manage Customers for Unit: {0}",
    "text_company_manage_units_delete_address": "Delete Address",
    "text_company_manage_units_delete_address_message": "Are you sure you would like to delete this address?",
    "text_company_manage_units_createuser_breadcrumb": "New User",
    "text_company_manage_units_details": "{0}",
    "text_company_manage_units_disable_breadcrumb": "Disable {0} Business Unit",
    "text_company_manage_units_disableUnit_confirmation": "Warning! Disabling this unit will also disable its child units, users, budgets, and cost centers.",
    "text_company_manage_units_disabled": "Business Unit has been disabled",
    "text_company_manage_units_disabled_label": "disabled",
    "text_company_manage_units_edit": "Edit",
    "text_company_manage_units_editCostCenter_breadcrumb": "Edit Cost Center for Unit: {0}",
    "text_company_manage_units_editForm": "Please use this form to update business unit details",
    "text_company_manage_units_editUnit_breadcrumb": "Edit",
    "text_company_manage_units_edituser": "Edit User for Unit: {0}",
    "text_company_manage_units_edituser_title": "Edit User for Unit: {0}",
    "text_company_manage_units_header_administrators": "Administrators",
    "text_company_manage_units_header_approvers": "Approvers",
    "text_company_manage_units_header_customers": "Customers",
    "text_company_manage_units_header_managers": "Managers",
    "text_company_manage_units_label": "Units",
    "text_company_manage_units_managers_mainTitle": "Select Manager(s)",
    "text_company_manage_units_managers": "Manager(s)",
    "text_company_manage_units_managers_subtitle": "Select or deselect users which should be managers for this unit.",
    "text_company_manage_units_managers_title": "Manage Managers for Unit: {0}",
    "text_company_manage_units_newUnitButton": "Add New",
    "text_company_manage_units_createNewUnit": "New Unit",
    "text_company_manage_units_parentUnit_disabled": "It is not possible to enable unit whose parent unit is disabled",
    "text_company_manage_units_permissions_breadcrumb": "Permission(s)",
    "text_company_manage_units_remove": "Remove",
    "text_company_manage_units_subtitle": "Units represent a logical grouping of individuals or function within an organization, such as a project team or a department. Units are placed into an organization hierarchy, which is navigable below. Units inherit from their parent unit (unless overridden locally) and as such the placement of a unit within the hierarchy is important. The organization hierarchy also affects such things as available cost centers, budgets, delivery addresses and the escalation of such things as order approval.",
    "text_company_manage_units_unit_create": "Create Child Unit for Unit: {0}",
    "text_company_manage_units_unit_disable": "Confirm Disable",
    "text_company_manage_units_unit_edit_title": "Edit Unit: {0}",
    "text_company_manage_units_unitDetails": "Unit Details",
    "text_company_manage_units_users_new_title": "New User",
    "text_company_manage_units_user_actions": "Actions",
    "text_company_manage_units_user_email": "Email",
    "text_company_manage_units_user_name": "Name",
    "text_company_manage_units_user_roles": "Roles",
    "text_company_manage_units_userDetails": "View User for Unit: {0}",
    "text_company_manage_units_usergroups_title": "Manage User groups for User: {0}",
    "text_company_manage_units_users_button_createnew": "New",
    "text_company_manage_units_users_button_edit": "Edit",
    "text_company_manage_units_view_accountManagers_subtitle": "The Account Managers are the {0} contacts for this unit.",
    "text_company_manage_units_view_addresses_subtitle": "The Addresses will be available to a customer ordering for a cost center related to this unit.",
    "text_company_manage_units_view_administrators_subtitle": "Users with the administrator role have the ability to administrate this branch of the organization using the My Company area of the storefront. Adding or removing a user here adds or removes the administrator role from the user.",
    "text_company_manage_units_view_approvers_subtitle": "The approval process will assign orders to approvers referenced here if the individual has sufficient permissions to approve the order and an approver with lower sufficient permissions was not already found further down this branch of the organization hierarchy before reaching the cost center against which the order was placed.",
    "text_company_manage_units_view_costCenters_subtitle": "The cost centers will be available to members of this branch when placing an order.",
    "text_company_manage_units_view_customers_subtitle": "Users with the customer role have the ability to place orders against cost centers to which they have access. Adding or removing a user here adds or removes the customer role.",
    "text_company_manage_units_view_managers_subtitle": "Users with the manager role have the ability to see reports using the reports area of the storefront (awaiting implementation). Adding or removing a user here adds or removes the manager role from the user.",
    "text_company_manage_units_view_subtitle": "Units represent a logical grouping of individuals or function within an organization, such as a project team or a department. Units are placed into an organization hierarchy where units inherit properties from their parent unit, although this can be overridden for each unit.",
    "text_company_manage_units_view_units_subtitle": "Units represent a logical grouping of individuals or function within an organization, such as a project team or a department. The units below are descendant units of the current unit, for example, if this unit was \"Procurement\" then the child units might be \"Electricals Procurement\" and \"Office Supplies Procurement\". The child units, along with other business objects connected to them, form this branch of the organization hierarchy.",
    "text_company_manageB2BUserGroup_page_currentPage": "Page {0} of {1}",
    "text_company_manageB2BUserGroup_page_firstPage": "&laquo;",
    "text_company_manageB2BUserGroup_page_lastPage": "&raquo;",
    "text_company_manageB2BUserGroup_page_linkNextPage": "Next Page",
    "text_company_manageB2BUserGroup_page_linkPreviousPage": "Previous Page",
    "text_company_manageB2BUserGroup_page_showAllResults": "Show all",
    "text_company_manageB2BUserGroup_page_showPageResults": "Show paginated",
    "text_company_manageB2BUserGroup_page_sort_byGroupID": "Id",
    "text_company_manageB2BUserGroup_page_sort_byName": "Name",
    "text_company_manageB2BUserGroup_page_sort_byUnitName": "Parent Unit",
    "text_company_manageB2BUserGroup_page_sortTitle": "Sort by:",
    "text_company_manageB2BUserGroup_page_totalResults": "{0} User Groups found",
    "text_company_manageB2BUserGroup_subtitle": "User Groups allow you to assign permissions to multiple customers without adhering to the hierarchical structure of the organization hierarchy.",
    "text_company_manageB2BUserGroup_title": "User Groups",
    "text_company_manageB2BUserGroup_viewPage": "View Groups",
    "text_company_manageBudgets": "Budgets",
    "text_company_manageBudgets_budget_invalid": "Please enter a valid budget",
    "text_company_manageCostCenters": "Cost Centers",
    "text_company_managePermissions": "Permissions",
    "text_company_managePermissions_actions_title": "Actions",
    "text_company_managePermissions_active_label": "Permission enabled/disabled",
    "text_company_managePermissions_add_page_title": "Create Permission",
    "text_company_managePermissions_addButton_displayName": "Add New",
    "text_company_managePermissions_assignName_budget": "BUDGET",
    "text_company_managePermissions_assignName_order": "ORDER",
    "text_company_managePermissions_assignName_per": "PER",
    "text_company_managePermissions_code_exists_error_title": "Permission with this name already exists.",
    "text_company_managePermissions_create_continueButton": "Continue",
    "text_company_managePermissions_create_permission_title": "New Permission",
    "text_company_managePermissions_create_step1": "Step 1 of 2",
    "text_company_managePermissions_create_step1_page": "Create Permission - Step 1",
    "text_company_managePermissions_create_new_permission": "New",
    "text_company_managePermissions_create_step2": "Step 2 of 2",
    "text_company_managePermissions_create_step2_page": "Step2",
    "text_company_managePermissions_currency_label": "Permission currency",
    "text_company_managePermissions_currency_title": "Currency",
    "text_company_managePermissions_disable_breadcrumb": "Disable {0}",
    "text_company_managePermissions_disable_confirm": "Confirm Disable",
    "text_company_managePermissions_disable_confirm_message": "Doing this will stop this permission level from being used. Do you wish to continue?",
    "text_company_managePermissions_disable_confirm_no": "No",
    "text_company_managePermissions_disable_confirm_yes": "Yes",
    "text_company_managePermissions_edit_cancelButton": "Cancel",
    "text_company_managePermissions_edit_page": "Edit",
    "text_company_managePermissions_edit_page_title": "Edit Permission",
    "text_company_managePermissions_edit_saveButton": "Save",
    "text_company_managePermissions_name_label": "Permission ID",
    "text_company_managePermissions_name_title": "Permission Name",
    "text_company_managePermissions_page_currentPage": "Page {0} of {1}",
    "text_company_managePermissions_page_firstPage": "&laquo;",
    "text_company_managePermissions_page_lastPage": "&raquo;",
    "text_company_managePermissions_page_linkNextPage": "Next Page",
    "text_company_managePermissions_page_linkPreviousPage": "Previous Page",
    "text_company_managePermissions_page_showAllResults": "Show all",
    "text_company_managePermissions_page_showPageResults": "Show paginated",
    "text_company_managePermissions_page_sort_byDate": "Date",
    "text_company_managePermissions_page_sort_byName": "Name",
    "text_company_managePermissions_page_sort_byUnitName": "Parent Unit",
    "text_company_managePermissions_page_sortTitle": "Sort by:",
    "text_company_managePermissions_page_totalResults": "{0} Permissions found",
    "text_company_managePermissions_permissionType_title": "Permission Type",
    "text_company_managePermissions_create_type_label": "Type",
    "text_company_managePermissions_selectBox_permissionType": "Select",
    "text_company_managePermissions_selectBox_timespan": "Select a timespan",
    "text_company_managePermissions_status_disabled": "Disabled",
    "text_company_managePermissions_status_enabled": "Enabled",
    "text_company_managePermissions_status_title": "Status",
    "text_company_managePermissions_subtitle": "Permissions define the financial limits of a user. Permissions can be on a per-order or per-timespan basis.",
    "text_company_managePermissions_threshold_value_error": "Please enter a value greater than zero",
    "text_company_managePermissions_threshold_value_invalid": "Please enter a valid amount",
    "text_company_managePermissions_timespan_label": "Time Period",
    "text_company_managePermissions_timespan_title": "Timespan",
    "text_company_managePermissions_title": "Permissions",
    "text_company_managePermissions_type_label": "Permission type",
    "text_company_managePermissions_unit_label": "Parent Unit",
    "text_company_managePermissions_unit_title": "Parent Business Unit",
    "text_company_managePermissions_value_label": "Threshold Amount",
    "text_company_managePermissions_value_title": "Threshold Value",
    "text_company_managePermissions_view_page": "{0}",
    "text_company_managePermissions_viewDetails_page_title": "Permission Details",
    "text_company_managePermissions_disable_button": "Disable Permission",
    "text_company_managePermissions_enable_button": "Enable",
    "text_company_permission_disable_confirm": "Disable Permission",
    "text_company_permission_enable_confirm": "Enable Permission",
    "text_company_permission_disable_confirm_message": "Warning! Disabling this Permission will not allow it to be used.",
    "text_company_permission_disable_confirm_no": "Cancel",
    "text_company_permission_disable_confirm_yes": "Disable",
    "text_company_column_type": "Type",
    "text_company_manageThresholds": "Manage Order Thresholds",
    "text_company_manageUser": "Users",
    "text_company_manageUser_addedituser": "Edit User",
    "text_company_manageUser_adduser": "Add User",
    "text_company_manageUser_button_create": "Create New User",
    "text_company_manageUser_button_edit": "Edit",
    "text_company_manageUser_edituser": "Edit User Details",
    "text_company_manageUser_noUser": "You have no users",
    "text_company_manageUser_pageAll": "Show All",
    "text_company_manageUser_pageAll_currentPage": "Page {0} of {1}",
    "text_company_manageUser_pageAll_firstPage": "&laquo;",
    "text_company_manageUser_pageAll_lastPage": "&raquo;",
    "text_company_manageUser_pageAll_linkNextPage": "Next Page",
    "text_company_manageUser_pageAll_linkPreviousPage": "Previous Page",
    "text_company_manageUser_pageAll_showAllResults": "Show All",
    "text_company_manageUser_pageAll_showPageResults": "Show paginated",
    "text_company_manageUser_pageAll_sort_byDate": "Date",
    "text_company_manageUser_pageAll_sort_byName": "Name",
    "text_company_manageUser_pageAll_sort_byUnit": "Parent Unit",
    "text_company_manageUser_pageAll_sortTitle": "Sort By:",
    "text_company_manageUser_pageAll_totalResults": "{0} User(s) Found",
    "text_company_manageUser_permission": "Permission",
    "text_company_manageUser_permission_title": "Permissions",
    "text_company_manageUser_roles": "Roles",
    "text_company_manageUser_user_costCenter": "Cost Centers",
    "text_company_manageUser_user_firstName": "First Name",
    "text_company_manageUser_user_lastName": "Last Name",
    "text_company_manageUser_user_parentUnit": "Parent Unit",
    "text_company_manageUser_user_roles": "Roles",
    "text_company_manageUser_user_viewDetails": "View User Detail",
    "text_company_manageUser_userDetails": "User Details",
    "text_company_manageUser_usergroups_title": "User Groups",
    "text_company_manageUser_viewUsers": "View Users",
    "text_company_manageUser_back_button": "Back to User Details",
    "text_company_manageUsergroup": "User groups",
    "text_company_manageUsergroup_editForm": "Please use this form to update user group details",
    "text_company_manageUsergroups": "Manage User groups",
    "text_company_manageUsergroups_breadcrumb": "User groups",
    "text_company_manageUsergroups_createUserGroup_title": "New User Group",
    "text_company_manageUsergroups_details": "{0}",
    "text_company_manageUsergroups_createUsergroup_breadcrumb": "New",
    "text_company_manageUsergroups_disableUsergroup_confirmation": "Doing this will remove all the members from this User Group and it will become disabled. Do you want to proceed?",
    "text_company_manageUsergroups_editUsergroup_breadcrumb": "Edit",
    "text_company_manageUsergroups_editUserGroup_title": "Edit User Group",
    "text_company_manageUsergroups_detailsUserGroup_title": "User Group Details",
    "text_company_manageUsergroups_newUserGroupButton": "Create New User group",
    "text_company_manageUsergroups_unit_create": "Create User group",
    "text_company_manageUsergroups_unit_edit": "Edit User group",
    "text_company_manageUsergroups_usergroup_disable": "Confirm Disable",
    "text_company_manageUsergroups_remove_breadcrumb": "Remove {0} User group",
    "text_company_manageUsergroups_remove": "Confirm Remove",
    "text_company_manageUsergroups_remove_confirmation": "Doing this will remove User Group : {0} . Do you want to proceed?",
    "text_company_manageUsergroups_remove_success": "User group successfully removed",
    "text_company_manageUsers": "Users",
    "text_company_manageUsers_adduser_title": "Add User Details",
    "text_company_manageUsers_details_breadcrumb": "{0}",
    "text_company_manageUsers_edit_title": "Edit User",
    "text_company_manageUsers_edituser_title": "Edit User Details",
    "text_company_manageUsers_users_new_title": "New User",
    "text_company_manageUsers_userDetails_title": "View User: {0}",
    "text_company_manageUsers_usergroups_breadcrumb": "User Group(s)",
    "text_company_manageUsers_usergroups_title": "Select User Group(s)",
    "text_company_manageUsers_back_button": "Back to Users",
    "text_company_managers_page_currentPage": "Page {0} of {1}",
    "text_company_managers_page_firstPage": "&laquo;",
    "text_company_managers_page_lastPage": "&raquo;",
    "text_company_managers_page_linkNextPage": "Next Page",
    "text_company_managers_page_linkPreviousPage": "Previous Page",
    "text_company_managers_page_showAllResults": "Show all",
    "text_company_managers_page_showPageResults": "Show paginated",
    "text_company_managers_page_sort_byName": "Name",
    "text_company_managers_page_sort_byUnit": "Parent Unit",
    "text_company_managers_page_sortTitle": "Sort by:",
    "text_company_managers_page_totalResults": "{0} Managers found",
    "text_company_managers_viewPage": "View Managers",
    "text_company_manageuser_disableuser_confirmation": "Doing this will prevent customer {0} from logging to storefront and placing order. Do you want to proceed?",
    "text_company_manageuser_user_disable": "Confirm Disable",
    "text_company_manageusers_approvers_subtitle": "The approval process will assign orders to approvers if the customer placing the order has insufficient permissions to do so. By default approvers are picked from the organization hierarchy, but additional approvers can be assigned to a specific customer here.",
    "text_company_manageUsers_approvers_breadcrumb": "Approver(s)",
    "text_company_manageusers_button_disableuser": "Disable User",
    "text_company_manageusers_button_enableuser": "Enable User",
    "text_company_manageusers_details_subtitle": "The functionality available to a user is dependent on the roles they have. In general, the visibility and jurisdiction of a user is restricted to the branch of the unit to which they are assigned.",
    "text_company_manageusers_edit": "Edit",
    "text_company_manageusers_label": "Users",
    "text_company_manageusers_permission_edit": "Edit Permission {0}",
    "text_company_manageusers_permissions_subtitle": "Permissions define the financial limits of a user. Permissions can be on a per-order or per-timespan basis.",
    "text_company_manageusers_permissions_title": "Select Permission(s)",
    "text_company_manageusers_restpassword_breadcrumb": "Update Password",
    "text_company_manageusers_roles_subtitle": "A user is an individual who is able to login to the {0}. The functionality available to a user is dependent on the roles they have. B2B Administrators have access to the My Company area to modify the organization hierarchy. B2B Managers can view statistics on the sales of the organization (awaiting implementation). B2B Approvers can approve orders for which the B2B Customer did not have enough permissions. B2B Customers can place orders in the {0}front.",
    "text_company_manageusers_subtitle": "A user is an individual who is able to login to the {0}. The {0} functionality available to the user is dependent on the roles they have. B2B Administrators have access to the My Company area to modify the organization hierarchy. B2B Managers can view statistics on the sales of the organization (awaiting implementation). B2B Approvers can approve orders for which the B2B Customer did not have enough permissions. B2B Customers can place orders in the {0}front. In general, the visibility and jurisdiction of a user is restricted to the branch of the unit to which they are assigned.",
    "text_company_manageusers_usergroups_subtitle": "User groups allow you to assign permissions to multiple customers without adhering to the hierarchical structure of the organization hierarchy.",
    "text_company_members_actions_title": "Actions",
    "text_company_members_name_title": "Name",
    "text_company_members_page_currentPage": "Page {0} of {1}",
    "text_company_members_page_firstPage": "&laquo;",
    "text_company_members_page_lastPage": "&raquo;",
    "text_company_members_page_linkNextPage": "Next Page",
    "text_company_members_page_linkPreviousPage": "Previous Page",
    "text_company_members_page_showAllResults": "Show all",
    "text_company_members_page_showPageResults": "Show paginated",
    "text_company_members_page_sort_byDate": "Date",
    "text_company_members_page_sort_byName": "Name",
    "text_company_members_page_sort_byUnit": "Parent Unit",
    "text_company_members_page_sortTitle": "Sort by:",
    "text_company_members_page_totalResults": "{0} Members found",
    "text_company_members_roles_title": "Roles",
    "text_company_members_unit_title": "Parent unit",
    "text_company_myCompany": "My Company",
    "text_company_name_name": "Name",
    "text_company_name_name_title": "Name",
    "text_company_noentries": "No Entries",
    "text_company_off": "OFF",
    "text_company_on": "ON",
    "text_company_organizationManagement": "Organization Management",
    "text_company_organizationManagement_createuser": "New",
    "text_company_organizationManagement_manageUser_breadcrumb": "Manage User",
    "text_company_organizationManagement_manageUsergroup_breadcrumb": "Manage User group",
    "text_company_parentUnit_name": "Parent Unit",
    "text_company_permissions_actions_title": "Actions",
    "text_company_permissions_currency_title": "Currency",
    "text_company_permissions_name_title": "Permission Name",
    "text_company_permissions_page_currentPage": "Page {0} of {1}",
    "text_company_permissions_page_firstPage": "&laquo;",
    "text_company_permissions_page_lastPage": "&raquo;",
    "text_company_permissions_page_linkNextPage": "Next Page",
    "text_company_permissions_page_linkPreviousPage": "Previous Page",
    "text_company_permissions_page_showAllResults": "Show all",
    "text_company_permissions_page_showPageResults": "Show paginated",
    "text_company_permissions_page_sort_byDate": "Date",
    "text_company_permissions_page_sort_byName": "Name",
    "text_company_permissions_page_sort_byUnitName": "Parent Unit",
    "text_company_permissions_page_sortTitle": "Sort by:",
    "text_company_permissions_page_totalResults": "{0} Permissions found",
    "text_company_permissions_subtitle": "Permissions define the financial limits of a user. Permissions can be on a per-order or per-timespan basis.",
    "text_company_permissions_timespan_label": "Permission timespan",
    "text_company_permissions_timespan_title": "Timespan",
    "text_company_permissions_title": "Manage Permissions",
    "text_company_permissions_type_label": "Permission type",
    "text_company_permissions_unit_label": "Parent Business Unit",
    "text_company_permissions_unit_title": "Parent Business Unit",
    "text_company_permissions_value_label": "Permission value",
    "text_company_permissions_value_title": "Value",
    "text_company_permissions_view_page": "View Permission {0}",
    "text_company_permissions_viewDetails_page_title": "View Permissions",
    "text_company_roles_name": "Roles",
    "text_company_roles_all_label": "All Roles:",
    "text_company_select_action_label": "Select",
    "text_company_select_budget": "Edit Related Budgets for Cost Center: {0}",
    "text_company_select_budgets": "Select Budget(s)",
    "text_company_select_name": "Select",
    "text_company_status_active_false": "Disabled",
    "text_company_status_active_true": "Active",
    "text_company_status_title": "Status",
    "text_company_unit_approvalProcess": "Approval Process",
    "text_company_unit_contactNumber": "Contact Number",
    "text_company_unit_id": "Unit ID",
    "text_company_unit_name": "Unit Name",
    "text_company_unit_parent": "Parent Unit",
    "text_company_units_remove_b2badmingroup_confirmation": "Remove B2B Administrator {0}",
    "text_company_units_remove_b2bapprovergroup_confirmation": "Remove B2B Approver {0}",
    "text_company_units_remove_b2bcustomergroup_confirmation": "Remove B2B Customer {0}",
    "text_company_units_remove_b2bmanagergroup_confirmation": "Remove B2B Manager {0}",
    "text_company_units_remove_confirmation_b2badmingroup": "Doing this will remove B2B Administrator {0} from Business unit {1}. Do you want to proceed?",
    "text_company_units_remove_confirmation_b2bapprovergroup": "Doing this will remove B2B Approver {0} from Business unit {1}. Do you want to proceed?",
    "text_company_units_remove_confirmation_b2bcustomergroup": "Doing this will remove B2B Customer {0} from Business unit {1}. Do you want to proceed?",
    "text_company_units_remove_confirmation_b2bmanagergroup": "Doing this will remove B2B Manager {0} from Business unit {1}. Do you want to proceed?",
    "text_company_units_remove_confirmation_title_b2badmingroup": "Confirm removal of B2B Administrator",
    "text_company_units_remove_confirmation_title_b2bapprovergroup": "Confirm removal of B2B Approver",
    "text_company_units_remove_confirmation_title_b2bcustomergroup": "Confirm removal of B2B Customer",
    "text_company_units_remove_confirmation_title_b2bmanagergroup": "Confirm removal of B2B Manager",
    "text_company_user_dr_name": "Dr.",
    "text_company_user_email": "Email",
    "text_company_user_miss_name": "Miss",
    "text_company_user_mr_name": "Mr",
    "text_company_user_mrs_name": "Mrs",
    "text_company_user_ms_name": "Ms",
    "text_company_user_name": "First Name:",
    "text_company_user_parentBusinessUnit": "Parent Business Unit",
    "text_company_user_resetPassword": "Reset Password",
    "text_company_user_password": "Password:",
    "text_company_user_rev_name": "Rev.",
    "text_company_user_roles": "Roles",
    "text_company_user_title": "Title:",
    "text_company_user_unit_title": "Parent Unit",
    "text_company_user_userEnabledStatus": "User Enabled Status",
    "text_company_usergroup_back_button": "Back to User Groups",
    "text_company_usergroup_button_createnew": "Edit",
    "text_company_usergroup_currency_title": "Currency",
    "text_company_usergroup_delete_label": "Delete User Group",
    "text_company_usergroup_delete_warning_message": "Warning! Are you sure you would like to delete this user group?",
    "text_company_usergroup_disable_button": "Disable",
    "text_company_usergroup_disable_label": "Disable User Group",
    "text_company_usergroup_disable_warning_message": "Warning! Disabling {0} will remove all users.",
    "text_company_usergroup_edit_button": "Edit",
    "text_company_usergroup_enable_button": "Enable",
    "text_company_usergroup_id_title": "User group ID",
    "text_company_usergroup_members": "Users",
    "text_company_usergroup_name_title": "User Name",
    "text_company_usergroup_permission_name": "Permission Name",
    "text_company_usergroup_timespan_title": "TimeSpan",
    "text_company_usergroup_unit_title": "Parent unit",
    "text_company_usergroup_value_title": "Value",
    "text_company_usergroups_members_breadcrumb": "User(s)",
    "text_company_usergroups_members_title": "Select User(s)",
    "text_company_usergroups_page_currentPage": "Page {0} of {1}",
    "text_company_usergroups_page_firstPage": "&laquo;",
    "text_company_usergroups_page_lastPage": "&raquo;",
    "text_company_usergroups_page_linkNextPage": "Next Page",
    "text_company_usergroups_page_linkPreviousPage": "Previous Page",
    "text_company_usergroups_page_showAllResults": "Show all",
    "text_company_usergroups_page_showPageResults": "Show paginated",
    "text_company_usergroups_page_sort_byDate": "Date",
    "text_company_usergroups_page_sort_byGroupID": "Id",
    "text_company_usergroups_page_sort_byName": "Name",
    "text_company_usergroups_page_sort_byUnitName": "Parent Unit",
    "text_company_usergroups_page_sortTitle": "Sort by:",
    "text_company_usergroups_page_totalResults": "{0} User groups found",
    "text_company_usergroups_permissions_breadcrumb": "Permission(s)",
    "text_company_usergroups_permissions_title": "Select Permission(s)",
    "text_company_usergroups_users_subtitle": "Users within a User group will in-effect be assigned the Permissions of the User group.",
    "text_company_usergroups_viewDetails_label": "View User group Details",
    "text_company_usergroups_viewPage": "View User groups",
    "text_company_users_remove_confirmation_b2bapprovergroup": "Doing this will remove B2B Approver {0} from Customer {1}. Do you want to proceed?",
    "text_company_users_remove_confirmation_permission": "Doing this will remove Permission {0} from Customer {1}. Do you want to proceed?",
    "text_company_users_remove_confirmation_title_b2bapprovergroup": "Confirm removal of B2B Approver",
    "text_company_users_remove_confirmation_title_permission": "Confirm removal of Permission",
    "text_company_users_remove_confirmation_title_usergroup": "Confirm removal of User Group",
    "text_company_users_remove_confirmation_usergroup": "Doing this will remove member {0} from user group {1}. Do you want to proceed?",
    "text_company_users_remove_permission_confirmation": "Remove Permission {0}",
    "text_confirmation_approver_removed": "Approver removed successfully",
    "text_confirmation_budget_created": "Budget created successfully",
    "text_confirmation_budget_updated": "Budget updated successfully",
    "text_confirmation_password_updated": "Password of the customer updated successfully",
    "text_confirmation_permission_created": "Permission created successfully",
    "text_confirmation_permission_removed": "Permission removed successfully",
    "text_confirmation_permission_updated": "Permission updated successfully",
    "text_confirmation_user_added": "Customer successfully created",
    "text_confirmation_user_disable": "The user {0} has been disabled",
    "text_confirmation_user_close": "The user account {0} has been closed",
    "text_confirmation_user_edited": "Customer successfully updated",
    "text_confirmation_user_enable": "The user {0} has been enabled",
    "text_confirmation_usergroup_removed": "User group removed successfully",
    "text_costcenter_parentunit_disabled_error": "This cost center may not be set to active state because the parent B2B Unit not active.",
    "error_budget_parentunit_disabled": "This budget may not be set to not active state because the parent B2B Unit not active.",
    "text_edit": "Edit",
    "text_manageuser_error_email_exists_title": "Email already exists",
    "text_manageuser_password": "Please enter and confirm the password for customer {0}",
    "text_manageuser_restpasswordform": "Reset Password",
    "text_myCompany_manageUsers_approvers_title": "Select Approver(s)",
    "text_mycompany_user_createForm": "Please use this form to create a new customer",
    "text_mycompany_user_updateForm": "Please use this form to update customer {0} details",
    "text_parentunit_disabled_warning": "The parent business unit of this customer is not active. In order to manage this customer activate the parent unit first.",
    "text_user_disabled": "Disabled User",
    "text_company_add_button": "Add",
    "text_company_addExisting_button": "Add Existing",
    "text_company_addNew_button": "Add New",
    "text_company_delete_button": "Delete",
    "text_company_done_button": "Done",
    "text_company_save_button": "Save",
    "text_company_save_later_button": "Save for later",
    "text_company_disable_confirm": "Confirm Disable",
    "text_company_disable_confirm_no": "No",
    "text_company_disable_confirm_yes": "Yes",
    "unit_name_invalid": "Please select a name for the business unit",
    "unit_uid_invalid": "Please select a unique identifier for the business unit",
    "updatePwd_pwd_invalid": "Password does not meet minimum requirements.",
    "user_email": "Email",
    "user_firstName": "First Name",
    "user_lastName": "Last Name",
    "user_title": "Title",
    "usergroup_disabled": "User group is not active, in order to activate it add members to this user group",
    "usergroup_name_invalid": "Please select a name for the user group",
    "usergroup_no_button": "No",
    "usergroup_notfound": "User group not found",
    "usergroup_uid_invalid": "Please select a unique identifier for the user group",
    "usergroup_unit_invalid": "Please select a Parent Business unit",
    "usergroup_yes_button": "Yes",
    "validation_checkPwd_equals": "Password and password confirmation do not match",
    "text_confirmation_user_rejected": "The registration request for {0} been rejected.",
    "text_confirmation_user_accepted": "The Registration request has been accepted.",
    "text_company_manageUser_registration": "Show All",
    "text_company_manageUser_registration_currentPage": "Page {0} of {1}",
    "text_company_manageUser_registration_firstPage": "&laquo;",
    "text_company_manageUser_registration_lastPage": "&raquo;",
    "text_company_manageUser_registration_linkNextPage": "Next Page",
    "text_company_manageUser_registration_linkPreviousPage": "Previous Page",
    "text_company_manageUser_registration_showAllResults": "Show All",
    "text_company_manageUser_registration_showPageResults": "Show paginated",
    "text_company_manageUser_registration_sort_byDate": "Date-Asc",
    "text_company_manageUser_registration_sort_byDateDesc": "Date-Desc",
    "text_company_manageUser_registration_sort_byName": "Name-Asc",
    "text_company_manageUser_registration_sort_byNameDesc": "Name-Desc",
    "text_company_manageUser_registration_sort_byEmail": "Email-Asc",
    "text_company_manageUser_registration_sort_byEmailDesc": "Email-Desc",
    "text_company_manageUser_registration_sort_byCity": "City-Asc",
    "text_company_manageUser_registration_sort_byCityDesc": "City-Desc",
    "text_company_manageUser_registration_sort_byCountry": "Country-Asc",
    "text_company_manageUser_registration_sort_byCountryDesc": "Country-Desc",
    "text_company_manageUser_registration_sort_byActive": "Active-Asc",
    "text_company_manageUser_registration_sort_byActiveDesc": "Active-Desc",
    "text_company_manageUser_registration_sortTitle": "Sort By:",
    "text_company_manageUser_registration_zeroResults": "0 New Request(s) Found",
    "text_company_manageUser_registration_totalResultsCurrPage": "Showing {0} of {1} results",
    "text_company_manageUser_registration_totalResultsSinglePag": "{0} New Request(s) found",
    "text_company_manageUser_registration_noRequestFound": "There are no registration requests pending.",
    "text_company_manageUser_pageAll_totalResultsSingleOrder": "Showing {0} result.",
    "text_confirmation_user_approved": "The registration request for {0} has been approved.",
    "text_company_manageUser_registration_totalResultsSingleOrder": "1 New Request(s) found",
    "text_company_manageUser_registration_request_breadcrumb": "Requests",
    "text_company_breadcrumb": "My Company Account",
    "text_company_manageUser_registration_request_details": "Request Details",
    "text_confirmation_user_saved": "The user details for {0} has been saved.",
    "text_company_manageUser_page_totalResults": "{0} User(s) Found",
    "text_How_to_guide": "How-to Guides",
    "text_Shipping_Packaging": "Shipping/Packaging",
    "text_Document": "Documents",
    "text_Material_Core_Group": "Material/Core Group",
    "text_coreSearchTab_error": "Invalid input or no results found, please try again.",
    "text_coreSearchTab_content": "If you are unsure of the material number or core group enter the known information below in the appropriate field.",
    "text_mails_doubleopt_triggered": "Double Opt in Mail has been sent to : {0}",
    "text_mails_passwordSetup_triggered": "Password Setup Mail has been sent to : {0}",
    "mycompany_user_delete_note": "Note: You can not undo this deletion.",
    "mycompany_user_delete_account": "Delete a user account",
    "mycompany_user_delete_confMessage": "Are you sure you want to delete the following user account?",
    "mycompany_delete_error_message": "Cannot delete as at least one sold to must be linked",
    "text_account_dropship_address": "Drop ship Address",
    "text_training_participants_page_totalResult": "{0} Participants Found",
    "text_training_participants_firstName": "First Name",
    "text_training_participants_lastName": "Last Name",
    "text_training_participants_email": "Email",
    "text_training_participants_company": "Company",
    "mycompany_accessAdditionalRights": "Additional user rights",
    "text_account_document_favorite_heading": "My Favourites",
    "text_account_document_favorite_heading_NA": "My Favorites",
    "text_account_document_favorite_table_doc_number": "Doc Number",
    "text_account_document_favorite_table_doc_description": "Doc Description",
    "text_account_document_favorite_table_doc_type": "Doc Type",
    "text_account_document_favorite_table_doc_language": "Language",
    "text_account_document_favorite_table_doc_rev": "Doc Rev",
    "text_account_document_favorite_table_doc_remove": "Remove",
    "text_account_document_favorite_totalResults": " Document(s) Found",
    "text_account_document_favorite_table_doc_subscribed": "Subscribed",
    "text_adb_admin_edit_adminName": "Engineering Admin Name",
    "text_adb_admin_edit_applicationNum": "Application Number",
    "text_adb_admin_edit_applicationDate": "Application Date",
    "text_adb_search_result_inreview": "IN REVIEW",
    "text_application_request": "Brake Application Request Form",
    "text_application_requestt": "Brake Application Requests",
    "text_account_document_favorite_subscribed_boolean": "Yes",
    "text_account_document_favorite_not_subscribed_boolean": "No",
    "text_adb_admin_edit_front": "Recommended Front",
    "text_adb_admin_edit_forward": "Recommended Forward Rear",
    "text_adb_admin_edit_mid": "Recommended Mid Rear",
    "text_adb_admin_edit_rear": "Recommended Rear Rear",
    "text_adb_admin_edit_pusher": "Recommended Pusher",
    "text_adb_admin_edit_tag": "Recommended Tag/Auxiliary",
    "text_adb_admin_edit_axle": "Recommended Auxiliary Axle",
    "na_crm_alreadyused_message": "The CR entered has already been used, please enter a different CR number.",
    "asm_login": "Sign In",
    "asm_login_username_placeholder": "Agent ID",
    "asm_login_password_placeholder": "Password",
    "asm_login_error": "Agent ID and / or Password not found",
    "asm_login_logged": "Signed in as:",
    "asm_login_disabled": "Sorry. You do not have access rights to the ASM. Please contact your Administrator.",
    "asm_login_blocked": "Your account has been locked. Please contact your system administrator.",
    "asm_logout": "Sign Out",
    "asm_logout_error": "Error during logout",
    "asm_logout_error_no_agent": "There is no logged in agent.",
    "asm_action_restricted": "You do not have access rights to perform this action.",
    "asm_emulate_start": "Start",
    "asm_emulate_start_ending": "&nbsp;Session",
    "asm_emulate_end": "End",
    "asm_emulate_end_ending": "Session",
    "asm_emulate_reset": "Reset",
    "asm_emulate_customer_not_found": "No Customer ID found",
    "asm_emulate_error_agent_missed": "Log in to continue",
    "asm_emulate_error_cart": "Cart ID/Order ID not found",
    "asm_emulate_error_customer": "Unknown customer ID. Will not add customer and/or cart to the session.",
    "asm_emulate_error_no_customer_or_cart_id_provided": "No Customer or Cart ID were provided.",
    "asm_emulate_error_cart_became_an_order": "The customer''s cart has been checked out into the order below.",
    "asm_emulate_error_order_not_found": "The customer''s order ID {0} cannot be found. Please investigate.",
    "asm_emulate_error_customer_login_disabled": "Cannot emulate customer with disabled login and/or deactivated account.",
    "asm_emulate_timer": "Session timeout:",
    "asm_emulate_timer_min": "min",
    "asm_emulate_username_label": "Customer ID",
    "asm_emulate_username_placeholder": "Customer Name/Email Address",
    "asm_emulate_cart_label": "Cart ID",
    "asm_emulate_cart_placeholder": "Cart ID Number",
    "asm_emulate_cart_bind": "Assign",
    "asm_emulate_cart-order_label": "Cart ID/Order Id",
    "asm_emulate_cart-order_placeholder": "Cart ID/Order ID Number",
    "asm_emulate_customer_bind_ending": "&nbsp;Account to Cart",
    "asm_emulate_cart_bind_ending": "&nbsp;Cart to Account",
    "asm_emulate_createAccount": "Create",
    "asm_emulate_createAccount_ending": "&nbsp;New Account",
    "asm_emulate_at": "Location:",
    "asm_emulate_no_stores": "Not Assigned",
    "asm_emulate_multiple_stores": "Multiple Store Assignments",
    "asm_session_ends": "Your session has been ended",
    "asm_session_inProgress": "ASM Session In Progress",
    "asm_createCustomer_duplicate_error": "Customer ID already exists",
    "asm_createCustomer_error": "Error during customer creating",
    "asm_bindCart_error_not_anonymous_cart": "Only anonymous cart can be bound to customer.",
    "asm_bindCart_error_unknown_cart_id": "Unknown Cart ID. Cart will not be bound.",
    "text_account_order_placedBy": "Placed by: {0}",
    "text_account_order_placedByText": "Placed by: Customer Service Team Member",
    "text_asm_customerList_noCustomers": "There are currently no customers in this customer list.",
    "text_asm_customerList_component": "Customers",
    "text_asm_customerList_name": "NAME",
    "text_asm_customerList_email": "EMAIL/ID",
    "text_asm_customerList_phone": "PHONE",
    "text_asm_customerList_cart": "CART",
    "text_asm_customerList_orders": "ORDERS",
    "text_asm_customerList_viewCarts": "View Cart",
    "text_asm_customerList_viewOrders": "View Orders",
    "text_asm_customerList_360view": "360 View",
    "text_asm_customerList_phone_empty": "-",
    "text_asm_customerList_carts_empty": "-",
    "text_asm_customerList_picture_alt": "Emulate ASM Customer Session",
    "text_asm_customerList_360view_alt": "360 View of Customer",
    "text_asm_util_MOMENT": "moments",
    "text_asm_util_SECOND": "a second",
    "text_asm_util_SECONDS": "{0} seconds",
    "text_asm_util_MINUTE": "a minute",
    "text_asm_util_MINUTES": "{0} minutes",
    "text_asm_util_HOUR": "an hour",
    "text_asm_util_HOURS": "{0} hours",
    "text_asm_util_DAY": "a day",
    "text_asm_util_DAYS": "{0} days",
    "text_asm_util_MONTH": "a month",
    "text_asm_util_MONTHS": "{0} months",
    "text_asm_util_YEAR": "a year",
    "text_asm_util_YEARS": "{0} years",
    "text_asm_util_ago": "ago",
    "text_account_customerList_page_currentPage": "Page {0} of {1}",
    "text_account_customerList_page_firstPage": "&laquo;",
    "text_account_customerList_page_lastPage": "&raquo;",
    "text_account_customerList_page_linkNextPage": "Next Page",
    "text_account_customerList_page_linkPreviousPage": "Previous Page",
    "text_account_customerList_page_showAllResults": "Show all",
    "text_account_customerList_page_showPageResults": "Show paginated",
    "text_account_customerList_page_sort_byDateAsc": "Date (Asc)",
    "text_account_customerList_page_sort_byDateDesc": "Date (Desc)",
    "text_account_customerList_page_sort_byNameAsc": "Name (Asc)",
    "text_account_customerList_page_sort_byNameDesc": "Name (Desc)",
    "text_account_customerList_page_sort_byOrderDateAsc": "Order Date (Asc)",
    "text_account_customerList_page_sort_byOrderDateDesc": "Order Date (Desc)",
    "text_account_customerList_page_sort_byName": "Name (Asc)",
    "text_account_customerList_page_sort_byUnit": "Account (Asc)",
    "text_account_customerList_page_sort_byUnitDesc": "Account (Desc)",
    "text_account_customerList_page_sortTitle": "Sort by",
    "text_account_customerList_page_totalResults": "of {0} Customers",
    "text_account_customerList_page_totalResultsCurrPage": "{0} of {1} Customers",
    "text_account_customerList_page_totalResultsSinglePage": "{0} Customers",
    "text_account_customerList_page_totalResultsSinglePag": "{0} Customers",
    "text_account_customerList_page_totalResultsSingleCustomer": "1 Customer",
    "text_account_customerList_page_totalResultsSingleOrder": "1 Customer",
    "text_customer360_buttonLabelCustomer": "Customer",
    "text_customer360_buttonLabelView": "View",
    "text_customer360_headline": "{0} 360&#176; View",
    "text_customer360_headline_cart": "{0} items added to cart",
    "text_customer360_headline_cart_empty": "The cart is empty",
    "text_customer360_headline_order": "Last order",
    "text_customer360_headline_order_empty": "There are no orders",
    "text_customer360_headline_ticket": "Last ticket",
    "text_customer360_headline_ticket_empty": "There are no tickets",
    "text_customer360_headline_ticket_empty_link": "view all tickets",
    "text_customer360_customer_overview": "OVERVIEW",
    "text_customer360_customer_profile": "PROFILE",
    "text_customer360_activity": "ACTIVITY",
    "text_customer360_sales_summary": "SALES",
    "text_customer360_storeLocations": "MAPS",
    "text_customer360_activity_general": "General",
    "text_customer360_activity_general_type": "Type",
    "text_customer360_activity_general_id": "ID",
    "text_customer360_activity_general_description": "Description",
    "text_customer360_activity_general_status": "Status",
    "text_customer360_activity_general_created": "Created",
    "text_customer360_activity_general_updated": "Updated",
    "text_customer360_activity_general_cart": "Cart",
    "text_customer360_activity_general_cart_description": "Cart items: {0}/ Total Amount: {1}{2}",
    "text_customer360_activity_general_savedcart": "Saved Cart",
    "text_customer360_activity_general_ticket": "Ticket",
    "text_customer360_activity_general_order": "Order",
    "text_customer360_activity_general_order_description": "Order items: {0}/ Total Amount: {1}{2}",
    "text_customer360_activity_general_status_undefined": "---",
    "text_customer360_activity_tickets": "Support Tickets",
    "text_customer360_activity_tickets_headline": "Headline",
    "text_customer360_activity_tickets_category": "Category",
    "text_customer360_activity_tickets_no": "There are currently no Support Ticket items",
    "text_customer360_colors_headline": "<span>{0}''s</span> Favorites",
    "text_customer360_colors_subheadline": "Colors",
    "text_customer360_devices_used": "Devices Used",
    "text_customer360_favorite_colors": "Favorite Colors",
    "text_customer360_profile": "Profile",
    "text_customer360_profile_phone1": "Phone 1",
    "text_customer360_profile_phone2": "Phone 2",
    "text_customer360_profile_payment_methods": "Saved Payment Methods",
    "text_customer360_profile_nosavedpayments": "There are no payment methods",
    "text_customer360_profile_default": "Default",
    "text_customer360_summary_heading": "Summary",
    "text_customer360_summary_signedUp": "Signed up",
    "text_customer360_summary_customer_since": "Customer For",
    "text_customer360_summary_cartId": "Cart ID",
    "text_customer360_summary_recent_order": "Most Recent Order",
    "text_customer360_summary_days_ago": "Days",
    "text_customer360_fragment_notfound": "Fragment Not Found!",
    "text_customer360_overview_devices_heading": "{0} Uses",
    "text_customer360_overview_customer_cart": "Active Cart",
    "text_customer360_overview_customer_cart_no": "There are currently no Active Cart items",
    "text_customer360_overview_customer_cart_total_items": "Total No. Items",
    "text_customer360_overview_customer_cart_total_price": "Total Price",
    "text_customer360_overview_customer_cart_item_qty": "Qty",
    "text_customer360_overview_customer_cart_items_price": "Item Price",
    "text_customer360_overview_customer_savedCart": "Last saved Cart",
    "text_customer360_overview_customer_savedCart_no": "There are currently no Saved Cart items",
    "text_customer360_feedback": "Feedback",
    "text_customer360_feedback_review": "Product Reviews",
    "text_customer360_review_item": "Item",
    "text_customer360_review_date_status": "Date / Status",
    "text_customer360_review_stars": "Rate",
    "text_customer360_review_review": "Review",
    "text_customer360_feedback_review_no": "There are currently no Product Review items",
    "text_customer360_activity_general_status_PAYMENT_AMOUNT_RESERVED": "Payment Reserved",
    "text_customer360_activity_general_status_PAYMENT_AMOUNT_NOT_RESERVED": "Payment Not Reserved",
    "text_customer360_activity_general_status_PAYMENT_CAPTURED": "Payment Captured",
    "text_customer360_activity_general_status_PAYMENT_NOT_CAPTURED": "Payment Not Captured",
    "text_customer360_activity_general_status_FRAUD_CHECKED": "Fraud Checked",
    "text_customer360_activity_general_status_ORDER_SPLIT": "Order Split",
    "text_customer360_activity_general_status_PROCESSING_ERROR": "Processing Error",
    "text_customer360_activity_general_status_WAIT_FRAUD_MANUAL_CHECK": "Waiting For Manual Validation",
    "text_customer360_activity_general_status_SUSPENDED": "Suspended",
    "text_customer360_activity_general_status_ON_HOLD_SOURCING_FAILED": "On Hold: Sourcing Failed",
    "text_customer360_activity_general_status_ON_HOLD_PARTIALLY_FULFILLED": "On Hold: Partially Fulfilled",
    "text_customer360_activity_general_status_READY": "Ready",
    "text_customer360_activity_general_status_COMPLETED": "Completed",
    "text_customer360_overview_favoritecolors_heading": "Favorites",
    "checkout_multi_costCenter_label": "Cost Center",
    "checkout_multi_costCenter_notprovided": "You must provide a cost center in order to go to the next step.",
    "checkout_multi_costCenter_title_pleaseSelect": "Please select...",
    "checkout_multi_deliveryAddress_noPickup": "SHIPPING ADDRESS",
    "checkout_multi_deliveryAddress_noPickup_breadcrumb": "SHIPPING ADDRESS",
    "checkout_multi_paymentType": "CUSTOMER INFORMATION",
    "checkout_multi_paymentType_breadcrumb": "CUSTOMER INFORMATION",
    "checkout_multi_paymentType_notprovided": "You must provide a payment type in order to go to the next step.",
    "checkout_multi_paymentType_selectPaymentTypeMessage": "Please select your payment type.",
    "checkout_multi_paymentType_stepHeader": "Payment Type",
    "checkout_multi_purchaseOrderNumber_label": "P.O. No.",
    "checkout_multi_replenishment": "Replenishment",
    "checkout_multi_paymentType_continue": "Save and Next",
    "checkout_multi_summary_orderPlacedBy": "Order placed by",
    "checkout_summary_requestApproval_cancel": "Cancel",
    "checkout_summary_scheduleReplenishment": "Back to checkout",
    "checkout_summary_placeReplenishmentOrder": "Place Replenishment Order",
    "checkout_summary_replenishmentScheduleForm_title": "Set replenishment schedule",
    "checkout_summary_replenishmentScheduleForm_cancel": "Cancel",
    "text_account_customerPONumber": "Customer PO Number",
    "text_Show_orders_of_coworkers": "Show orders of coworkers",
    "text_account_table_header_entry_status": "Order Item Status",
    "text_account_quote_msg4": "Click to modify user information",
    "text_user_table_approve": "Approve",
    "text_account_openPosition_page_totalResultsSingleOrder": "1 Open Position found",
    "text_account_openPosition_page_totalResults": "{0} Open Position(s) Found",
    "text_account_openPosition_page_totalResultsCurrPage": "{0} of {1} Open Positions Found",
    "text_account_openPositions_export": "Export",
    "text_account_table_header_date": "Order Date",
    "text_account_table_header_naNumber": "Bendix Order Number",
    "text_account_open_positions": "Search Open Positions",
    "text_account_table_header_partNo": "Part No.",
    "text_account_table_header_typeNo": "Type No.",
    "text_account_table_header_customerNo": "Customer Part Number",
    "text_account_table_header_orderedQty": "Ordered Qty.",
    "text_account_table_header_openQty": "Open Qty.",
    "text_account_table_header_confirmedQty": "Confirmed Qty.",
    "text_account_table_header_reqDelDate": "Requested delivery date",
    "text_account_table_header_estDelDate": "Estimated delivery date",
    "text_account_table_header_pricePerUnit": "Net Price*",
    "text_account_naPartNumber": "Bendix Part Number/Customer Part Number",
    "text_account_openPosition_page_totalResultsSinglePag": "{0} Open Position(s) Found",
    "replenishmentScheduleForm_activateDaily": "Activate daily",
    "replenishmentScheduleForm_activateMonthly": "Activate monthly",
    "replenishmentScheduleForm_activateWeekly": "Activate weekly",
    "replenishmentScheduleForm_daily_days": "Replenish every",
    "replenishmentScheduleForm_days": "days",
    "replenishmentScheduleForm_month": "day/month",
    "replenishmentScheduleForm_monthly_day": "Send on the",
    "replenishmentScheduleForm_startDate": "Start auto-replenishment on",
    "replenishmentScheduleForm_weekly_daysOfWeek": "Send every",
    "replenishmentScheduleForm_weekly_weeks": "Every",
    "replenishmentScheduleForm_weeks": "weeks",
    "order_replenishment_confirmation": "Replenishment Order Confirmation",
    "order_replenishment_confirmation_number": "Confirmation Number:",
    "order_replenishment_schedule_title": "Your replenishment schedule",
    "order_replenishment_thankYou": "Thank you for your scheduled Replenishment Order!",
    "order_reorder_error": "Error reordering.",
    "checkout_error_invalid_accountType": "Your account does not allow you to checkout here.",
    "checkout_error_paymenttype_formentry_invalid": "Customer PO # is mandatory in order to complete the checkout process.",
    "checkout_error_paymenttype_formentry_repeat": "The PO number entered has already been used, please enter a new Customer PO #",
    "text_order_reorderbutton": "Reorder",
    "search_advanced_meta_description_title": "Order Forms",
    "search_advanced": "Order Forms",
    "search_advanced_keyword": "Keyword Search",
    "search_advanced_onlyproductids": "Product IDs Only",
    "search_advanced_catalog": "Catalog",
    "search_advanced_createorderform": "Create Order Form",
    "search_advanced_orderform": "Order Form",
    "search_advanced_productids": "Enter Product Id(s) separated by a comma",
    "search_advanced_productids_add": "Add",
    "search_advanced_search": "Search",
    "text_account_orderApproval_addApproverComments": "Please add comments for your decision",
    "text_account_orderApproval_approveButton_displayName": "Accept Order",
    "text_account_orderApproval_approve_reason": "Add approval comment below (optional):",
    "text_account_orderApproval_orderStatus": "Order Status",
    "text_account_orderApproval_rejectButton_displayName": "Reject Order",
    "text_account_orderApproval_reject_reason": "Add reason for rejection below",
    "text_account_orderApprovalDashBoard_actions": "Actions",
    "text_account_orderApprovalDashBoard_orderCreated": "Order Created",
    "text_account_orderApprovalDashBoard_orderNumber": "Order Number",
    "text_account_orderApprovalDashBoard_orderStatus": "Order Status",
    "text_account_orderApprovalDashBoard_purchaseOrderNumber": "P.O.No:",
    "text_account_orderApprovalDashBoard_viewOrdersPendingForApproval": "Orders pending for your approval",
    "text_account_orderApprovalDashboard": "Order Approval Dashboard",
    "text_account_order_status_display_assigned_admin": "Assigned To Administrator",
    "text_account_order_status_display_pending_approval": "Pending Approval",
    "text_account_order_status_display_pending_merchant_approval": "Pending Merchant Approval",
    "text_account_order_status_display_rejected": "Rejected",
    "text_account_order_status_display_merchant_approved": "Merchant Approved",
    "text_account_order_status_display_merchant_rejected": "Merchant Rejected",
    "text_account_order_status_display_approved": "Approved",
    "text_account_orderHistoryEntry_merchantTitle": "Merchant Approval Details",
    "text_account_orderHistoryEntry_customerTitle": "Customer Approval Details",
    "text_notAvailable": "NA",
    "text_account_order_purchase": "Purchaser",
    "text_account_orderApprovalDetails_OrderNumber": "Order Number",
    "text_account_orderApprovalDetails_comments_label": "Comments",
    "text_account_orderApprovalDetails_costCenter": "Cost Center",
    "text_account_orderApprovalDetails_orderPlacedBy": "Order placed by",
    "text_account_orderApprovalDetails_orderStatusDetails_label": "Order Status Details",
    "text_account_orderApprovalDetails_paidOntoAccount": "Paid onto account",
    "text_account_orderApprovalDetails_parentBusinessUnit": "Parent Business Unit",
    "text_account_orderApprovalDetails_purchaseOrderNumber": "P.O.No",
    "text_account_orderApprovalDetails_label": "Order Approval Details",
    "text_account_order_approval_title": "Approval details",
    "text_account_order_approver_title": "Approver",
    "text_account_order_permission_notes": "Approver Comments",
    "text_account_order_permission_title": "Permission",
    "text_account_order_status_title": "Status",
    "text_store_dateformat": "MM/dd/yyyy",
    "text_store_dateformat_datepicker_selection": "mm/dd/yy",
    "text_store_dateformat_datepicker_selection_hint": "mm/dd/yyyy",
    "text_account_myReplenishment": "My Replenishment Orders",
    "text_account_manageReplenishment": "Manage Replenishment Schedule",
    "text_account_manageReplenishment_confirm_cancel_breadcrumb": "Remove Replenishment Schedule {0}",
    "text_account_replenishment_Schedule": "Schedule",
    "text_account_replenishment_actions": "Cancel",
    "text_account_replenishment_canceled": "Canceled",
    "text_account_replenishment_confirm_cancel": "End Schedule Order Now. Are you sure you want to stop automatic replenishment of this order ({0})?",
    "text_account_replenishment_confirmation_canceled": "Your replenishment order has been canceled",
    "text_account_replenishment_manageReplenishmentSchedule": "Manage Your Replenishment Schedule",
    "text_account_replenishment_nextOrderDate": "Next Order Date",
    "text_account_replenishment_noReplenishment": "You have no replenishment orders scheduled",
    "text_account_replenishment_page_currentPage": "Page {0} of {1}",
    "text_account_replenishment_page_firstPage": "&laquo;",
    "text_account_replenishment_page_lastPage": "&raquo;",
    "text_account_replenishment_page_linkNextPage": "Next Page",
    "text_account_replenishment_page_linkPreviousPage": "Previous Page",
    "text_account_replenishment_page_showAllResults": "Show all",
    "text_account_replenishment_page_showPageResults": "Show paginated",
    "text_account_replenishment_page_sort_byDate": "Date Created",
    "text_account_replenishment_page_sort_byOrderNumber": "Order Number",
    "text_account_replenishment_page_sort_byReplenishmentNumber": "Replenishment Number",
    "text_account_replenishment_page_sort_byNextOrderDate": "Next Order Date",
    "text_account_replenishment_page_sortTitle": "Sort by:",
    "text_account_replenishment_page_totalResults": "{0} Replenishments found",
    "text_account_replenishment_purchaseOrderNumber": "P.O. No",
    "text_account_replenishment_remove_confirmation_title": "Confirm Removal",
    "text_account_replenishment_replenishmentNumber": "Replenishment No",
    "text_account_replenishment_startDate": "Start",
    "text_account_replenishment_creationDate": "Date Created",
    "text_account_replenishment_total": "Est. Total",
    "text_account_replenishment_cancel_button": "Cancel Replenishment",
    "text_account_replenishment_orders": "Replenishment Orders",
    "text_account_replenishment_viewReplenishmentOrders": "View your replenishment orders",
    "text_account_replenishment_orderNumber": "Order Number",
    "text_account_replenishment_orderStatus": "Order Status",
    "text_account_replenishment_datePlaced": "Date Placed",
    "text_account_replenishment_noOrders": "You have no orders",
    "text_account_replenishment_replenishmentOrderDetailBreadcrumb": "Order {0}",
    "text_account_replenishment_replenishmentBreadcrumb": "Replenishment Schedule {0}",
    "text_account_replenishment_details": "Replenishment Details",
    "text_account_replenishmentOrderDetails_title": "Replenishment Order Details",
    "text_account_replenishment_frequency": "Frequency",
    "text_account_replenishment_history": "Replenishment History",
    "text_account_replenishment_noOrdersFound": "No Replenishment Orders found",
    "text_account_replenishment_shipToItems": "Ship To Items",
    "text_account_endNow": "End Now",
    "text_account_no_button": "No",
    "text_account_yes_button": "Yes",
    "text_account_orderHistory_purchaseOrderNumber": "P.O. Number",
    "text_account_orderHistory_replenishment": "This is a scheduled Order",
    "text_account_orderHistory_replenishment_link": "View the Replenishment Schedule",
    "text_account_orderHistory_replenishment_schedule": "Replenishment schedule: {0}",
    "text_account_orderHistory_replenishment_startFrom": "Start replenishment from: {0}",
    "search_nav_facetShowLess_color": "less colors..",
    "search_nav_facetShowLess_fit": "less fits...",
    "search_nav_facetShowMore_color": "more colors...",
    "search_nav_facetShowMore_fit": "more fits...",
    "text_account_order_orderDetails_purchaseOrderNumber": "P.O. Number",
    "text_account_order_orderDetails_ParentBusinessUnit": "Parent Unit",
    "text_account_order_orderDetails_CostCenter": "Cost Center",
    "text_account_order_orderDetails_validUntil": "Valid Until",
    "responsive_checkout_summary_requestApproval_maxchars": "Maximum 255 characters",
    "responsive_replenishmentScheduleForm_activateDaily": "Daily",
    "responsive_replenishmentScheduleForm_activateMonthly": "Monthly",
    "responsive_replenishmentScheduleForm_activateWeekly": "Weekly",
    "responsive_replenishmentScheduleForm_daily_days": "Every # of days:",
    "responsive_replenishmentScheduleForm_weekly_weeks": "Every # of weeks:",
    "responsive_replenishmentScheduleForm_weekly_daysOfWeek": "On the following days:",
    "responsive_replenishmentScheduleForm_monthly_day": "On this day of the month:",
    "text_account_orderStatus": "Order Status",
    "text_account_customerID": "Customer ID",
    "text_account_kbOrderNumber": "Bendix Order Number",
    "text_account_naOrderNumber": "Bendix Order Number",
    "text_account_reset": "Reset",
    "text_account_search": "Search",
    "text_account_table_header_category": "Order Category",
    "text_account_table_header_sentBy": "Sent By",
    "text_account_table_header_status": "Order Status",
    "text_account_table_header_lineItem": "Position No.",
    "text_account_table_header_description": "Description",
    "text_account_table_header_currency": "Currency",
    "partsAvailable": "Order will only ship when all parts are available",
    "checkout_multi_paymentType_continue_NA": "Next",
    "text_Show_adb_of_coworkers": "Show Brake Application requests from coworkers",
    "text_Show_core_of_coworkers": "Show core requests from coworkers",
    "text_account_supporttickets": "Support Tickets",
    "text_account_supporttickets_heading": "Support Tickets",
    "text_account_supporttickets_history": "Support Tickets",
    "text_account_supporttickets_noSupporttickets": "You have no support tickets",
    "text_account_supporttickets_subHeading": "Manage your support tickets",
    "text_account_supporttickets_requestSupport": "Create New Ticket",
    "text_account_supporttickets_ticketId": "Ticket ID",
    "text_account_supporttickets_customerID": "Customer ID",
    "text_account_supporttickets_ticketType": "Ticket Type",
    "text_account_supporttickets_subject": "Subject",
    "text_account_supporttickets_category": "Category",
    "text_account_supporttickets_dateCreated": "Date Created",
    "text_account_supporttickets_dateUpdated": "Date Updated",
    "text_account_supporttickets_status": "Status",
    "text_account_supporttickets_statusList": "Please select the status",
    "text_account_supporttickets_tickettypeList": "Please select the Ticket Type",
    "text_account_supporttickets_status_All": "All",
    "text_account_supporttickets_viewDetails": "View Details",
    "text_account_supporttickets_addSupportTicket": "Add Support Ticket",
    "text_supporttickets_search_from_date": "Ticket Date From",
    "text_supporttickets_search_to_date": "Ticket Date To",
    "text_supporttickets_reset": "Reset",
    "text_supporttickets_search": "Search",
    "text_account_supportTickets_page_currentPage": "Page {0} of {1}",
    "text_account_supportTickets_page_firstPage": "&laquo;",
    "text_account_supportTickets_page_lastPage": "&raquo;",
    "text_account_supportTickets_page_linkNextPage": "Next Page",
    "text_account_supportTickets_page_linkPreviousPage": "Previous Page",
    "text_account_supportTickets_page_showAllResults": "Show all",
    "text_account_supportTickets_page_showPageResults": "Show paginated",
    "text_account_supportTickets_page_sort_byDate": "Date Updated",
    "text_account_supportTickets_page_sort_byTicketId": "Ticket ID",
    "text_account_supportTickets_page_sort_LastChangeDateTime": "Date Updated",
    "text_account_supportTickets_page_sort_ObjectID": "Ticket ID",
    "text_account_supportTickets_page_sortTitle": "Sort by",
    "text_account_supportTickets_page_totalResults": "of {0} Tickets",
    "text_account_supportTickets_page_totalResults_AllTickets": "{0} Tickets Found",
    "text_account_supportTickets_page_totalResultsCurrPage": "{0} of {1} Tickets",
    "text_account_supportTickets_page_totalResultsSinglePag": "{0} Tickets",
    "text_account_supportTickets_page_totalResultsSingleOrder": "1 Ticket",
    "text_software_request_form_pin_price": "NOTE: The price for a PIN code is {0}. When submitting this online form with obligation to pay, a sales order for a PIN code will be created, and you will receive an invoice from the selected trading partner or from Knorr-Bremse.",
    "supportticket_subject_invalid": "Please enter subject.",
    "supportticket_startDate_invalid": "Please select valid start date.",
    "supportticket_endDate_invalid": "Please select valid end date.",
    "supportticket_subject_invalid_length": "Subject should not be more than 255 characters.",
    "supportticket_message_invalid": "Please enter a valid message.",
    "supportticket_message_invalid_length": "Message should not be more than 5000 characters.",
    "supportticket_tickettype_invalid": "Please enter a valid Ticket Type.",
    "supportticket_category_invalid": "Please enter a valid Category.",
    "supportticket_associatedTo_invalid": "Please enter a valid Associated To.",
    "text_account_supportticket_startDate": "Please select start date.",
    "text_account_search_to_date_invalid_future": "To Date can't be in future date.",
    "text_account_search_from_date_invalid_future": "From Date can't be in future date.",
    "text_account_search_from_date_to_date_invalid": "Date From can't be greater than Date To.",
    "text_account_search_to_date_invalid": "Date To can't be less than the Date From.",
    "text_account_supportticket_endDate": "Please select end date.",
    "text_account_supportticket_defaultSoldTo": "Please select CustomerID.",
    "text_account_supporttickets_messages": "Messages",
    "text_account_supporttickets_newticket": "Create New Ticket",
    "text_account_supporttickets_createTicket_heading": "Request Customer Support",
    "text_account_supporttickets_createTicket_tickettype_WEB": "Created by User",
    "text_account_supporttickets_createTicket_tickettype_MANUAL": "Created by Customer Service",
    "text_account_supporttickets_createTicket_ticketID": "Ticket ID",
    "text_account_supporttickets_createTicket_subject_mandatory": "Subject*",
    "text_account_supporttickets_createTicket_subject": "Subject",
    "text_account_supporttickets_createTicket_subject_desc": "Enter the subject of your request.",
    "text_account_supporttickets_createTicket_message_mandatory": "Message*",
    "text_account_supporttickets_createTicket_message": "Message",
    "text_account_supporttickets_createTicket_message_history": "Message History",
    "text_account_supporttickets_createTicket_message_desc": "Enter a message. Please provide as much information as possible.",
    "text_account_supporttickets_attachment_block_listed": "File attachment has unsupported extension. Only {0} are allowed.",
    "text_account_supporttickets_createTicket_associatedTo": "Associated To",
    "text_account_supporttickets_createTicket_associatedTo_option1": "Optionally Select...",
    "text_account_supporttickets_createTicket_category_option1": "Please select category",
    "text_account_supporttickets_createTicket_associatedTo_option2": "Please select associated to",
    "text_account_supporttickets_createTicket_associatedTo_option_na": "Not Applicable",
    "text_account_supporttickets_createTicket_ticketCategory": "Category",
    "text_account_supporttickets_createTicket_ticketCategory_ENQUIRY": "Enquiry",
    "text_account_supporttickets_createTicket_ticketCategory_COMPLAINT": "Complaint",
    "text_account_supporttickets_createTicket_ticketCategory_PROBLEM": "Problem",
    "text_account_supporttickets_createTicket_status_NEW": "New",
    "text_account_supporttickets_createTicket_status_OPEN": "Open",
    "text_account_supporttickets_createTicket_status_INPROGRESS": "In Progress",
    "text_account_supporttickets_createTicket_status_CUSTOMERACTION": "Customer Action",
    "text_account_supporttickets_createTicket_status_COMPLETED": "Completed",
    "text_account_supporttickets_createTicket_status_CLOSED": "Closed",
    "text_account_supporttickets_createTicket_ticketCategory_PSA": "Product / System Application",
    "text_account_supporttickets_createTicket_ticketCategory_PSG": "Product / System (General Information)",
    "text_account_supporttickets_createTicket_ticketCategory_TST": "Troubleshooting",
    "text_account_supporttickets_createTicket_ticketCategory_ORDER": "Ordering Support",
    "text_account_supporttickets_createTicket_ticketCategory_WARRANTY": "Warranty Support",
    "text_account_supporttickets_createTicket_ticketCategory_CORE": "Core Support",
    "text_account_supporttickets_createTicket_ticketCategory_OTH": "Other Technical Product Issues",
    "text_account_supporttickets_createTicket_ticketCategory_SOTHER": "Others Support Issues",
    "text_account_supporttickets_createTicket_updated": "Updated",
    "text_account_supporttickets_createTicket_selectFile": "Select a file",
    "text_account_supporttickets_createTicket_chooseFile": "Choose file",
    "text_account_supporttickets_fileMaxSizeExceeded": "The file is too large.",
    "text_account_supporttickets_file_is_large_than": "File is too big (>{0})",
    "text_account_supporttickets_createTicket_noFileChosen": "No file chosen",
    "text_account_supporttickets_createTicket_Cart": "Cart",
    "text_account_supporttickets_createTicket_SavedCart": "Saved Cart",
    "text_account_supporttickets_createTicket_Order": "Order",
    "text_account_supporttickets_createTicket_submit": "Submit",
    "text_account_supporttickets_createTicket_back": "Back",
    "text_account_supportTicket_confirmation_ticket_added": "Thank you for submitting your support ticket request. Your message has been sent to our Customer Service team, who will respond back to your request.",
    "text_account_supporttickets_history_addedBy_customerService": "Customer Service",
    "text_account_supporttickets_search_ticketCategory_PSA": "Product / System Application",
    "text_account_supporttickets_search_ticketCategory_PSG": "Product / System (General Information)",
    "text_account_supporttickets_search_ticketCategory_TST": "Troubleshooting",
    "text_account_supporttickets_search_ticketCategory_Order": "Ordering Support",
    "text_account_supporttickets_search_ticketCategory_Warranty": "Warranty Support",
    "text_account_supporttickets_search_ticketCategory_Core": "Core Support",
    "text_account_supporttickets_search_ticketCategory_OTH": "Other Technical Product Issues",
    "text_account_supporttickets_search_ticketCategory_SOther": "Others Support Issue",
    "text_account_supporttickets_updateSupportTicket": "Update Support Ticket",
    "text_account_supportTicket_updateTicket_heading": "Update Support Ticket",
    "text_account_supportTicket_updateTicket_status": "Status",
    "text_account_supporttickets_updateTicket_message_desc": "Update a message. Please provide as much information as possible.",
    "text_account_supporttickets_currentStatus": "current status",
    "text_account_supporttickets_tryLater": "Sorry, there was a problem, please try again later",
    "text_account_supporttickets_updateTicket_addMessage": "Add Message",
    "text_account_supporttickets_updateTicket_on": "on",
    "text_account_supporttickets_cancel": "Cancel",
    "text_account_supporttickets_content": "Please attach max 9.00 mb",
    "text_account_supporttickets_content1": "no file selected",
    "text_account_supporttickets_content2": "(Max: 9 MB)",
    "text_account_supporttickets_content3": "View/Add",
    "ticketstatus_OPEN": "Open",
    "ticketstatus_INPROCESS": "In Process",
    "ticketstatus_COMPLETED": "Completed",
    "ticketstatus_CLOSED": "Closed",
    "ticketstatus_REOPEN": "Reopened",
    "ticketstatus_IN_PROCESS": "In Process",
    "ticketstatus_box_COMPLETED": "Complete",
    "ticketstatus_box_INPROCESS": "Reopen",
    "ticketstatus_box_CLOSED": "Closed",
    "ticketstatus_box_REOPEN": "Reopened",
    "ticketstatus_Open": "Open",
    "ticketstatus_InProcess": "In Process",
    "ticketstatus_Closed": "Closed",
    "ticketstatus_Completed": "Completed",
    "text_account_supporttickets_createTicket_attachement_label": "Attachments",
    "text_account_supporttickets_createTicket_no_attachement_label": "No attachments founds",
    "text_account_supporttickets_ticketIdAscending": "Ticket ID Ascending",
    "text_account_supporttickets_ticketIdDescending": "Ticket ID Descending",
    "text_account_supporttickets_categoryAscending": "Category Ascending",
    "text_account_supporttickets_categoryDescending": "Category Descending",
    "text_account_supporttickets_headlineAscending": "Subject Ascending",
    "text_account_supporttickets_headlineDescending": "Subject Descending",
    "text_account_supporttickets_creationtimeAscending": "Date Created Ascending",
    "text_account_supporttickets_creationtimeDescending": "Date Created Descending",
    "text_account_supporttickets_modifiedtimeAscending": "Date Updated Ascending",
    "text_account_supporttickets_modifiedtimeDescending": "Date Updated Descending",
    "text_account_supporttickets_stateAscending": "Status Ascending",
    "text_account_supporttickets_stateDescending": "Status Descending",
    "text_account_supporttickets_updateTicket_c4cMessage1": "This ticket is moved to Customer Services",
    "text_account_supporttickets_updateTicket_c4cMessage2": "Click here",
    "text_account_supporttickets_updateTicket_c4cMessage3": "to update the ticket",
    "update_ticket_time_am": "AM",
    "update_ticket_time_pm": "PM",
    "text_breakapplication_button_uploadfile": "Upload File",
    "text_software_request_form_tebs_info": "<div style",
    "text_training_elearingrequired": "include eLearning bookings",
    "type_WarrantyClaim_name": "Warranty Claim",
    "type_B2BCustomerWarrantyRightsEnum_WARRANTY_SEARCH_name": "Warranty Search",
    "type_productWeight_unit_name": "Weight unit",
    "type_B2BCustomerCoreRightsEnum_CORE_SUBMISSION_name": "Core Submission",
    "type_CoreCollectionAddress_zipCode_name": "Zip Code",
    "type_ProductPlantStructure_plantNumber_name": "Plant Number",
    "type_AbstractOrderEntry_updatedEntryNumber_name": "Updated Entry Number",
    "type_SapOrderType_WEB_name": "WEB",
    "type_salesdata_product_name": "Product",
    "type_CoreGradeType_SC_name": "Scrap",
    "type_WarrantyClaim_businessType_name": "Business Type",
    "type_KbEcomImportDataCronJob_name": "KB Import Data CronJob",
    "type_product_customerLimitations_name": "Customer specific sales limitation",
    "type_saleableItemType_IC_name": "Single Component",
    "type_WarrantyClaimProcess_warranty_name": "Warranty Claim",
    "type_B2BCustomerAccessRequestEnum_name": "Access Requesting",
    "type_SapOrderType_CONV_name": "CONV",
    "type_Product2KbEcomDocumentRel_name": "Product Document Relation",
    "type_CoreCollectionAddress_emailAddress_name": "Email Address",
    "type_CoreRequest_crmNumber_name": "CRM Number",
    "type_productReferenceTypeEnum_HasServiceTool_name": "Service Tool",
    "type_EngineManufacturer_code_name": "Code",
    "type_CoreRequest_exportStatus_name": "Export Status",
    "type_AbstractOrder_cutOffTimeMessage_name": "CutOffTime Message",
    "type_SAPCpiOutboundOrder_referenceNumber_name": "Reference Number",
    "type_CoreGradeType_PD_name": "1- Part Damage",
    "type_KbEcomDocument_url_name": "Remote document URL",
    "type_CoreRequest_firstName_name": "First Name",
    "type_CoreRequest_lastName_name": "Last Name",
    "type_CoreRequest_packageInfo_name": "Package Info",
    "type_WarrantyClaim_customer_name": "Customer",
    "type_CorePackaging_Weight_name": "Weight",
    "type_saleableItemType_IY_name": "System",
    "type_ProductPlantStructure_product_name": "Product",
    "type_WarrantyClaim_exportStatus_name": "Export Status",
    "type_WarrantyClaim_errorResponse_name": "Error Response",
    "type_WarrantyClaim_errorResponse_description": "Error Payload or Exception received from CPI.This is first time response from CPI which contains actual reason for the warranty claim submission fail.",
    "type_WarrantyClaim_vinNumber_name": "VIN-Numme",
    "type_BaseSite_registrationCustomerIndustryRoles_name": "Registration - Industry Roles",
    "type_BaseSite_isDownloadDisclaimerEnabled_name": "isDownloadDisclaimerEnabled",
    "type_RecallNumber_code_name": "Code",
    "type_product_typenumber_name": "Type Number",
    "type_B2BCustomerIndustryRoleEnum_EXPERT_NETWORK_SERVICE_CENTRE_name": "Expert Network Workshop",
    "type_B2BCustomerIndustryRoleEnum_ALLTRUCKS_name": "Alltrucks",
    "type_CoreRequest_user_name": "User",
    "type_product_vmrsCodeRear_name": "VMRS Code Rear ",
    "productSalesStatus_label_APAC_CODE10": "Obsolete",
    "type_Order_idocNumber_name": "IDoc Number",
    "type_Product2SalesRegions_name": "Products To Sales Regions Relation",
    "type_Category_externalUrl_name": "External URL",
    "type_Category_categoryStore_name": "Category Store",
    "type_CMSNavigationNode_productCategoryTree_name": "Contains Category Tree",
    "type_OrderTypeQuantityMapping_salesOrgId_name": "Sales Org",
    "type_ProductSalesStatus_CODE40_name": "40",
    "type_ProductImageMediaConversionCronJob_pictureMediaFormat_name": "Picture format",
    "type_OrderTypeQuantityMapping_name": "Order Schema",
    "type_CorePackaging_typeOfpackaging_name": "Packaging Type",
    "type_WarrantyPart_serialNumber_name": "Serial Number",
    "type_WarrantyPart_quantity_name": "Quantity",
    "type_PrimaryComplaint_name": "Primary Complaint",
    "type_CoreCollectionAddress_totalWeight_name": "Total Weight",
    "type_AbstractOrderEntry_listPrice_name": "List Price",
    "type_WarrantyPart_otherCost_name": "Other Cost",
    "type_WarrantyPart_hourlyLaborRate_name": "Hourly Labor Rate",
    "type_KbOrderStatus_D_name": "Cancelled",
    "type_KbEcomImportDataCronJob_catalogVersion_name": "Catalog Version",
    "type_Chassis_name_name": "Name",
    "type_CrossReferenceRelation_name": "Cross Reference Relation",
    "type_B2BUnit_deliveryPriority_name": "Delivery Priority",
    "type_CoreCollectionAddress_tailLiftRequired_name": "Tail Lift",
    "productSalesStatus_label_APAC_CODE20": "Non saleable to the IAM",
    "type_CoreRequestItem_qty_name": "Quantity",
    "type_B2BCustomerIndustryRoleEnum_DISTRIBUTER_name": "Distributor",
    "type_ProductWeight_name": "Product Weight",
    "type_salesChannelLimitation_OEtruckonly_name": "OE truck only",
    "type_ProductSalesStatus_CODE20_name": "20",
    "type_WarrantyPart_invoiceNumber_name": "InvoiceNumber",
    "type_B2BCustomerIndustryRoleEnum_WORKSHOP_name": "Workshop",
    "type_B2BCustomerIndustryRoleEnum_MILITARY_name": "Public Service/Military/Private Citizen etc.",
    "type_AbstractOrderEntry_posType_name": "POS Type",
    "type_B2BCustomer_defaultB2BUnit_name": "Default SoldTO",
    "productSalesStatus_label_APAC_CODE30": "Saleable to the IAM",
    "type_VehicleManufacturer_name_name": "Name",
    "type_CustomerPartNumber_code_name": "code",
    "type_PrimaryComplaint_name_name": "Name",
    "type_PackageType_CONTAINER_name": "Container",
    "type_product_dimension_name": "dimension",
    "type_product_exportToOpticat_name": "Export To Opticat",
    "type_WarrantyPart_dateInService_name": "Date In Service",
    "type_ProductDimension_height_name": "Height",
    "type_SAPCpiOutboundOrderItem_purchaseOrderNumber_name": "Purchase Order Number",
    "type_saleableItemType_IK_name": "Spares Kit/Part",
    "type_CrossReference_alternativeXref_name": "Alternative X-ref",
    "type_WarrantyPart_attachments_name": "Attachments",
    "type_Principal_firstName_name": "First Name",
    "type_Principal_lastName_name": "Last Name",
    "type_saleableItemType_N_name": "Not for external sale",
    "type_CoreRequest_packageCount_name": "Package Count",
    "type_ExternalLanguageMapping_languages_name": "Languages",
    "productSalesStatus_label_APAC_CODE40": "Saleable to the IAM - whilst stocks last",
    "type_productReferenceTypeEnum_IsReplacedBy_name": "Is Replaced By",
    "type_PartsDisposition_name": "Parts Disposition",
    "type_WarrantyPart_warrantyClaim_name": "Warranty Claim",
    "type_WarrantyPart_scale_name": "Scale",
    "type_B2BUnit_orderBlocked_name": "Order Blocked",
    "type_CoreItemsEMEA_WeightAppx_name": "Weight Approx",
    "type_SalesRegionCountryRelation_countries_name": "Countries",
    "type_productReferenceTypeEnum_IsAccessoryPartFor_name": "Is Accessory For",
    "type_productReferenceTypeEnum_HasAlternative_name": "Has Alternative",
    "type_productReferenceTypeEnum_IsAlternativeFor_name": "Is Alternative For",
    "type_WarrantyClaim_phoneNumber_name": "Phone Number",
    "type_CoreGradeType_GC_name": "Good Core",
    "type_CoreGradeType_PSD_name": "2- Parts Damaged",
    "type_CoreItemsEMEA_description_name": "Description",
    "type_CoreCollectionAddress_firstName_name": "First Name",
    "type_KbEcomImportDataCronJob_fileName_name": "File Name",
    "type_ExternalLanguageMapping_sourceSystem_name": "Source System",
    "type_VehicleManufacturer_customerSite_name": "Site",
    "type_CustomerPartNumber_customer_name": "Customer",
    "type_SapOrderType_EDI_name": "EDI",
    "type_B2BCustomerAccessRequestEnum_INFORMATION_ONLY_name": "Information Only",
    "type_WarrantyClaim_site_name": "Site",
    "type_product_minimumDeliveryUnit_name": "Minimum Delivery Unit",
    "type_Address_stateCode_name": "Company State",
    "type_ProductWeight_netWeight_name": "Net Weight",
    "type_CoreCollectionAddress_lastName_name": "Last Name",
    "type_product_salesDatas_name": "Sales Data",
    "type_WarrantyPart_laborAmount_name": "Labor Amount",
    "type_VehicleManufacturer_name": "Vehicle Manufacturer",
    "type_CoreItemsEMEA_qty_name": "Quantity",
    "type_ProductImageMediaConversionCronJob_thumbnailMediaFormat_name": "Thumbnail format",
    "type_productWeight_grossWeight_name": "weight",
    "type_OrderTypeQuantityMapping_overWritten_description": "Flag for enabling or disabling Request Delivery Date overwriting from UI.",
    "type_marketType_NoExternalMarket_name": "No External Market",
    "type_product_excludedCountries_name": "Excluded Countries",
    "type_ProductDimension_width_name": "Width",
    "type_saleableItemType_name": "Salable Item Type",
    "type_B2BCustomerApprovalStatus_name": "Approval Status",
    "type_DocumentType_name_name": "DocumentType Name",
    "type_CoreRequest_fax_name": "Fax",
    "type_User_isPasswordExpired_name": "Password Expired",
    "export_openpositions_seebelow": "See Below",
    "type_salesChannelLimitation_NoLimitation_name": "No Limitation",
    "type_AbstractOrderEntry_customerReferenceNumber_name": "Customer Reference Number",
    "type_B2BCustomerWarrantyRightsEnum_WARRANTY_SEARCH_name": "Warranty Search",
    "type_productReferenceTypeEnum_HasSparesKits_name": "Spares Kit",
    "type_CoreRequest_coreDate_name": "Core Date",
    "type_Product2SalesRegions_salesRegions_name": "Sales Regions",
    "type_PriceDocument_document_name": "Price Document",
    "type_ExternalLanguageMapping_code_name": "Code",
    "type_WarrantyClaim_email_name": "Email",
    "type_B2BCustomerApprovalStatus_DENIED_name": "Approval Denied",
    "type_B2BCustomer_customerSite_name": "Customer Site",
    "type_B2BCustomer_isTestUser_name": "Test User",
    "type_product_productHierarchy_name": "Product Hierarchy",
    "type_ProductMediaContainer_name": "Product Media Container",
    "type_CoreRequestItem_coreGroupUpgrade_name": "Core Group Upgrade",
    "type_AbstractOrderEntry_updateFlag_name": "Update Flag",
    "type_WarrantyPart_laborRequested_name": "Labor Requested",
    "type_ProductDimension_product_name": "Product",
    "type_AbstractOrderEntry2AbstractOrderEntry_entries_name": "Entries",
    "type_B2BCustomerAccessRequestEnum_CORE_REPORTS_name": "Core Reports / Core Return Submissions",
    "type_AbstractOrderEntry_estimatedDeliveryDate_name": "Estimated Delivery Date",
    "type_B2BCustomerCoreRightsEnum_CORE_REPORTS_name": "Core Reports",
    "type_WarrantyPart_repairTime_name": "Repair Time (in hrs)",
    "type_CoreRequest_warrantyMaterial_name": "Warranty Material Included",
    "type_Chassis_code_name": "Code",
    "type_productDimension_width_name": "Width",
    "type_salesChannelLimitation_ContractPartneronly_name": "Contract Partner only",
    "type_CrossReference_target_name": "Cross Reference Value (X-ref material number)",
    "type_SalesRegion_name_name": "Name",
    "type_AbstractOrderEntry_entries_name": "Entries",
    "type_KbEcomDocument_code_name": "Document Number",
    "type_BaseSite_siteInitialUrl_name": "Site Initial Url",
    "type_SAPConfiguration_allSAPDistributionChannel_name": "All SAP DistributionChannels",
    "type_DeliveryType_name": "Delivery Type Enum",
    "type_EngineManufacturer_name_name": "Name",
    "type_EngineManufacturer_name": "Engine Manufacturer",
    "type_CoreRequestItem_coreGrade_name": "Core Grade",
    "type_salesChannelLimitation_OEMonly_name": "OEM only",
    "type_PartsDisposition_name_name": "Name",
    "type_B2BUnit_customerHierarchy_name": "Customer Hierarchy Path",
    "type_marketType_AftermarketNew_name": "Aftermarket (New)",
    "type_WarrantyPart_axleNumber_name": "Axle Number",
    "type_productReferenceTypeEnum_name": "Product Reference Type",
    "type_B2BCustomer_showNetPrice_name": "Show Net Price",
    "type_Address_displayPobox_name": "PO Box",
    "type_WarrantyClaim_firstName_name": "First Name",
    "type_WarrantyClaim_lastName_name": "Last Name",
    "password_policy_violation_regex_required_mustcontaindigit": "\"Password must meet the given requirements\".",
    "type_productReferenceTypeEnum_HasExchangeProduct_name": "Exchange Product",
    "type_ProductWeight_grossWeight_name": "Gross Weight",
    "type_PriceDocument_catalogVersion_name": "Catalog Version",
    "type_product_webView_name": "Web View",
    "type_product_xSuffixPart_name": "X Suffix Part",
    "type_B2BCustomer_industryRoles_name": "Role",
    "type_productReferenceTypeEnum_REPAIRKIT_name": "Repair kit",
    "type_product_titleId_name": "Title Id",
    "type_product_sapSalesStatus_name": "SAP Sales Status",
    "type_productDimension_unit_name": "Unit of length",
    "type_WarrantyClaim_vehicleId_name": "Vehicle/Unit Number",
    "type_B2BCustomer_approvalStatus_name": "Approval Status",
    "type_CustomerSite_name": "Site",
    "type_salesChannelLimitation_OEtraileronly_name": "OE trailer only",
    "type_KbEcomDocument_description_name": "Document Description",
    "type_productWeight_unit_name": "Weight unit",
    "type_saleableItemType_IF_name": "Field Action Kit",
    "type_PartsDisposition_customerSite_name": "Site",
    "type_B2BUnit_erpID_name": "ERP ID",
    "type_WarrantyPart_product_name": "Part Number",
    "type_KbCoreDocument_CoreDocuments_name": "Core Document",
    "type_product_vmrsList_name": "VMRS List",
    "type_productReferenceTypeEnum_HasAccessoryPart_name": "Accessory",
    "type_KbOrderStatus_A_name": "Acknowledged",
    "type_CrossReference_webName_name": "Web Name",
    "type_B2BCustomerIndustryRoleEnum_OEM_name": "OEM",
    "type_Address_displayPostalCode_name": "Postal Code",
    "type_KBOrderTypeEnum_name": "Order Type Enum",
    "type_productReferenceTypeEnum_IsSparesKitsFor_name": "Is Spares Kit For",
    "type_CoreItemsEMEA_WeightComplete_name": "Complete Weight",
    "type_Product2KbEcomDocumentRel_products_name": "Products",
    "type_productReferenceTypeEnum_HasAftermarketProduct_name": "Aftermarket Product",
    "type_DocumentTimeStamp_b2bUnit_name": "B2b Unit",
    "type_ReportsDocumentTimeStamp_b2bUnit_name": "B2b Unit",
    "type_productReferenceTypeEnum_HasRationalisedProduct_name": "Rationalised Product",
    "type_productDimension_length_name": "Length",
    "type_CoreRequest_phoneNumber_name": "Phone Number",
    "type_CoreRequest_totalWeight_name": "Total Weight",
    "type_WarrantyClaim_parts_name": "Parts",
    "type_CoreCollectionAddress_additionInfo_name": "Additional Info",
    "type_B2BCustomerIndustryRoleEnum_FLEET_name": "Fleet",
    "type_CoreRequest_corePdfMedia_name": "PDF",
    "type_salesChannelLimitation_name": "Sales Channel Limitation",
    "type_salesChannelLimitation_AMonly_name": "AM only",
    "type_saleableItemType_IT_name": "Service Tool",
    "type_SalesRegion_name": "Sales Region",
    "type_productReferenceTypeEnum_COMPETITOR_name": "Competitor",
    "type_PackageType_BOX_name": "Box ",
    "type_CoreRequest_coreReturnItems_name": "Core Items(NA)",
    "type_WarrantyDecision_code_name": "Code",
    "type_AbstractOrderEntry2AbstractOrderEntry_originalEntry_name": "Original Entry",
    "type_AbstractOrder_shippingCondition_name": "Shipping Condition",
    "type_B2BUnit_versionNumber_name": "Version Number",
    "type_CoreCollectionAddress_country_name": "Counrty",
    "type_CorePackaging_size_name": "Size",
    "type_product_hazardousMaterial_name": "Hazardous Material",
    "type_PricingProceduresSubtotal_KZWI3_name": "KB Core Surcharge",
    "type_B2BUnit_salesOffice_name": "Sales Office",
    "type_B2BUnit_salesGroup_name": "Sales Group",
    "type_B2BUnit_netValue_name": "Net Value",
    "type_SAPConfiguration_sappricingbol_surchargeSub_name": "Surcharge",
    "type_CoreRequestItem_itemWeight_name": "Item Weight",
    "type_PricingProceduresSubtotal_KZWI1_name": "KB List / Net Price",
    "type_CMSStaticCategoryPageRestriction_description": "Used to control whether the static category page or the standard hybris product grid page is displayed",
    "type_AbstractOrder_lastPricingCallMode_name": "Pricing Call Mode",
    "type_BaseStore_timeZone_name": "Time Zone",
    "type_WarrantyPart_partInService_name": "Mileage / Part In Service",
    "type_Order_sapOrderId_name": "SAP Order Number",
    "type_KbEcomDocument_revision_name": "Revision",
    "type_KbEcomDocument_revisionLoc_name": "Revision",
    "type_WarrantyDecision_decision_name": "Decision",
    "type_saleableItemType_IA_name": "Accessory Part",
    "type_DocumentType_name": "DocumentType",
    "type_BaseStore_maxRadiusForPoSSearch_name": "Max Radius for POS Search",
    "type_product_marketType_name": "Market Type",
    "type_ProductSalesStatus_name": "Salable Status",
    "type_B2BCustomerApprovalStatus_PENDING_name": "Waiting for Approval",
    "type_WarrantyClaim_claimType_name": "Claim Type",
    "type_product_salesStatusDescription_name": "Sales Status Label",
    "type_WarrantyClaim_email2_name": "Email2",
    "type_CoreCollectionAddress_requestedTime_name": "Requested Time",
    "type_ProductPlantStructure_countryOfOrigin_name": "Country of origin",
    "type_salesChannelLimitation_OESonly_name": "OES only",
    "type_CustomerPartNumber_sourceSystem_name": "Source System",
    "type_SalesRegionCountryRelation_salesRegions_name": "Sales Regions",
    "type_ProductCategoryMapping_name": "Product Category Mapping",
    "type_saleableItemType_IM_name": "Information Media",
    "type_KbCoreReports_b2bUnit_name": "Core Parent",
    "type_WarrantyPart_natureOfDefect_name": "Nature Of Defect",
    "type_CustomerHierarchyUnit_parent_name": "Parent",
    "type_WarrantyClaim_partsDisposition_name": "Parts Disposition if denied",
    "type_Product_crossReferences_name": "Cross References (X-ref material numbers)",
    "type_B2BCustomerApprovalStatus_APPROVED_name": "Approved",
    "productSalesStatus_label_EMEA_CODE40_anonymous": "Saleable to the IAM",
    "type_WarrantyPart_name": "Warranty Part",
    "type_Product2KbEcomDocumentRel_kbEcomDocuments_name": "Documents",
    "type_ProductMediaContainer_assetId_name": "Asset ID",
    "type_B2BCustomer_showListPrice_name": "Show List Price",
    "type_WarrantyClaim_tagSerialNumber_name": "T.A.G. Serial Number",
    "type_CorePackaging_stackable_name": "Stackable",
    "type_VehicleMfg2ChassisRelation_chassis_name": "Chassis(chass-eez)",
    "type_WarrantyClaim_date_name": "Date",
    "type_AbstractOrderEntry_estimatedQuantity_name": "Estimated Quantity",
    "type_CoreCollectionAddress_fax_name": "Fax",
    "type_WarrantyClaim2PartInfo_parts_name": "Parts",
    "type_VehicleManufacturer_code_name": "Code",
    "type_WarrantyTypeOperation_name": "Warranty Type Operation",
    "type_saleableItemType_IP_name": "Product",
    "type_productReferenceTypeEnum_IsRationalisedProductFor_name": "Is Rationalised Product For",
    "type_AbstractOrder_minOrderCharge_name": "Minimum Order Charge",
    "type_AbstractOrder_currentDeliveryType_name": "Delivery Type",
    "type_WarrantyClaim_claimRefNumber_name": "Claim Reference Number",
    "type_WarrantyPart_returningPartNumber_name": "Returning Customer Part Number",
    "type_CustomerPartNumber_customerPartNumber_name": "Customer Part Number",
    "type_WarrantyClaim_attachments_name": "Attachments",
    "type_WarrantyClaim_barCodeLabel_name": "BarCode Label",
    "type_OrderTypeQuantityMapping_lPriority_name": "LPriority",
    "type_productReferenceTypeEnum_IsExchangeProductFor_name": "Is Exchange Product For",
    "type_product_regionIndependentSaleableCountries_name": "Region Independent Salable Countries",
    "type_CMSSiteRestriction_name": "Side Restriction",
    "type_CoreRequest_totalQuantity_name": "Total Quantity",
    "type_SalesData_minOrderQuantity_name": "Minimum Order Quantity",
    "type_Category_productCategoryMapping_name": "Product Category Mapping",
    "type_PartsDisposition_code_name": "Code",
    "type_marketType_AftermarketRemanufactured_name": "Aftermarket (Remanufactured)",
    "productSalesStatus_label_EMEA_CODE10": "Obsolete",
    "type_SAPConfiguration_kbOrderTypes_name": "Order Types",
    "type_CoreCollectionAddress_forkListRequired_name": "Fork Lift",
    "type_Address_displayCompany_name": "Company",
    "type_WarrantyClaim_chassis_name": "Chassis",
    "type_B2BCustomerIndustryRoleEnum_name": "Company Industry Role",
    "type_ProductSalesStatus_CODE30_name": "30",
    "type_ProductDimension_name": "Product Dimension",
    "type_salesChannelLimitation_IAMonly_name": "IAM only",
    "type_saleableItemType_IE_name": "Exchange Product",
    "type_WarrantyDecision_name": "Warranty Decision",
    "type_WarrantyClaim_name": "Warranty Claim",
    "type_WarrantyClaim_language_name": "Language",
    "type_productReferenceTypeEnum_IsServiceToolFor_name": "Is Service Tool For",
    "type_CMSSiteRestriction_cmssite_name": "CMS Page",
    "productSalesStatus_label_EMEA_CODE20": "Non saleable to the IAM",
    "type_CoreCollectionAddress_phone_name": "Phone",
    "type_sapMarketType_name": "SAP Market Type",
    "type_product_sapMarketType_name": "SAP Market Type",
    "type_B2BCustomer_accessRequests_name": "Access Requesting",
    "type_B2BCustomer_vatIdentificationNo_name": "VAT number",
    "type_B2BCustomer_requestedby_name": "Closure Requested By",
    "type_ProductDimension_length_name": "Length",
    "type_product_articleType_name": "Article Type",
    "type_WarrantyTypeOperation_code_name": "Code",
    "type_CoreRequest_email_name": "Email",
    "type_OrderProcess_sendOrderFailEmail_name": "Order Submit Fail Email Sent",
    "type_product_sapLifecycleStatus_name": "Sap Lifecycle Status",
    "type_SAPCpiOutboundOrderItem_deliveryPriority_name": "Delivery Priority",
    "type_productReferenceTypeEnum_IsAftermarketProductFor_name": "Is Aftermarket Product For",
    "productSalesStatus_label_EMEA_CODE30": "Saleable to the IAM",
    "type_KbEcomDocument_catalogVersion_name": "Catalog Version",
    "type_ProductCategoryMapping_deviceCode_name": "Device Code",
    "type_SalesRegion_products_name": "Products",
    "type_address_defaultAddress_name": "defaultAddress",
    "type_SAPCpiOutboundOrder_purchaseOrderType_name": "Requested DeliveryDate",
    "type_OrderTypeQuantityMapping_maxQuantityAllowed_name": "Max Quantity Allowed",
    "type_CrossReference_name": "Cross Reference",
    "type_SalesRegion_countries_name": "Countries",
    "type_Employee_isPasswordExpired_name": "Password Expired",
    "type_B2BUnit_shippingInstructions_name": "Shipping Instructions",
    "type_WarrantyClaim_idocNumber_name": "IDoc Number",
    "type_WarrantyClaim_email1_name": "Email1",
    "type_B2BCustomerAccessRequestEnum_SUBMIT_WARRANTY_name": "Submit Warranty Claims",
    "type_WarrantyPart_partsDisposition_name": "Parts Disposition if denied",
    "type_PrimaryComplaint_code_name": "Code",
    "type_DownloadableMediaContainer_url_name": "Remote image URL",
    "type_product_salesStatus_name": "Sales Status",
    "type_B2BUnit_defaultCurrency_name": "Default Currency",
    "productSalesStatus_label_EMEA_CODE40": "Saleable to the IAM - whilst stocks last",
    "type_product_salesChannelLimitation_name": "Sales Channel Limitation",
    "type_RecallNumber_name": "Recall Number",
    "type_CoreCollectionAddress_requestedDate_name": "Requested Date",
    "type_WarrantyPart_dateCode_name": "Date Code",
    "type_ProductMediaContainer_product_name": "Product",
    "type_SalesRegionCountryRelation_name": "Sales Regions To Countries Relation",
    "type_WarrantyClaim2PartInfo_name": "Warranty Claim to Parts relation",
    "type_WarrantyClaim_store_name": "Base Store",
    "type_ProductCategoryMapping_category_name": "Category",
    "type_B2BUnit_customerHierarchyUnit_name": "Customer Hierarchy Unit",
    "type_B2BUnit_incoTerms1_name": "IncoTerms1",
    "productSalesStatus_label_NA_CODE20": "Not for Sale",
    "type_CoreCollectionAddress_companyAddress_name": "Address",
    "type_CoreCollectionAddress_companyAddress2_name": "Address 2",
    "type_B2BCustomer_doubleOptCheck_name": "Double Opt Check",
    "type_B2BCustomer_dataAnonymized_name": "Data Anonymized",
    "productSalesStatus_label_APAC_CODE40_anonymous": "Saleable to the IAM",
    "type_WarrantyClaim_natureOfDefect_name": "Nature Of Defect",
    "type_WarrantyPart_entryNumber_name": "Entry Number",
    "type_CoreRequest_coreItemsEMEA_name": "Core Items(EMEA)",
    "type_PriceDocument_code_name": "Name",
    "type_marketType_AllMarketsNew_name": "All Markets (New)",
    "type_KBEcomProductCategoryMappingJob_name": "ProductCategoryMappingJob",
    "type_CoreRequest_coreCollectionAddress_name": "Collection Address",
    "type_Product2SalesRegions_products_name": "Products",
    "type_WarrantyClaimProcess_sendWarrantyClaimRetryCount_name": "Number of attempts to send new warranty",
    "type_CrossReference_source_name": "Product",
    "type_KbOrderStatus_B_name": "In Process",
    "type_productReferenceTypeEnum_IsSoftwareFor_name": "Is Software For",
    "type_DocumentTimeStamp_lastDownloadtime_name": "Last Download Time",
    "type_ReportsDocumentTimeStamp_lastDownloadtime_name": "Last Download Time",
    "type_ReportsDocumentTimeStamp_reportDocument_name": "Report Document",
    "type_CoreRequest_coreMonth_name": "Core Month",
    "productSalesStatus_label_NA_CODE30": "For Sale",
    "type_WarrantyClaim_recallNumber_name": "Recall Number",
    "type_CoreRequest_site_name": "Site",
    "type_PackageType_PALLET_name": "Pallet",
    "type_B2BUnit_glnNumber_name": "GLN Number",
    "type_ProductWeight_unit_name": "Unit",
    "type_product_saleableItemType_name": "Salable Item Type",
    "type_SAPCpiOutboundOrder_deliveryPriority_name": "Delivery Priority",
    "type_RecallNumber_name_name": "Name",
    "type_WarrantyClaim_user_name": "User",
    "type_WarrantyClaim_engineManufacturer_name": "Engine Manufacturer",
    "type_VehicleMfg2ChassisRelation_name": "Vehicle Manufacturer to Chassis(chass-eez) Relation",
    "type_WarrantyDecision_name_name": "Name",
    "type_Country_salesRegions_name": "Sales Regions",
    "type_Product_productPlantStructures_name": "Plant Data",
    "type_DeliveryType_Partial_name": "Partial Delivery",
    "type_Chassis_name": "Chassis",
    "type_KbOrderStatus_C_name": "Shipped",
    "type_salesdata_salesOrganizationID_name": "Sales Organization ID",
    "type_WarrantyPart_requestedPartCost_name": "Requested Part Amount",
    "type_CoreCollectionAddress_shipTo_name": "B2b Unit",
    "type_ProductSalesStatus_CODE10_name": "10",
    "type_CoreRequest_language_name": "Language",
    "type_OrderTypeQuantityMapping_maxLineEntriesAllowed_name": "Max Line entries Allowed",
    "type_ClaimType_name": "Claim Type",
    "type_KbCoreReports_pfdMedia_name": "PDF",
    "type_CoreRequestItem_coreGroup_name": "Core Group",
    "type_WarrantyClaim2PartInfo_warrantyClaim_name": "Warranty Claim",
    "type_CMSSiteRestriction_description": "A page restriction regulates access based on the current CMS page",
    "productSalesStatus_label_NA_CODE10": "Obsolete",
    "type_B2BCustomerWarrantyRightsEnum_WARRANTY_CLAIM_name": "Warranty Claim",
    "type_OrderTypeQuantityMapping_days_name": "Days",
    "type_B2BCustomer_showCorePrice_name": "Show Core Price",
    "type_SAPCpiOutboundOrder_completeDelivery_name": "Complete Delivery",
    "type_Address_companyAddressTwo_name": "Company address 2",
    "type_marketType_name": "Market Type",
    "type_WarrantyClaimProcess_name": "Warranty Document Media",
    "type_CustomerHierarchyUnit_children_name": "Children",
    "type_ProductImageMediaConversionCronJob_name": "Product main image media conversion",
    "type_BaseStore_dateFormat_name": "Date Format",
    "type_CoreRequest_uid_name": "ID",
    "type_product_vmrsCode_name": "VMRS Code",
    "type_ProductMediaContainer_mediasMap_name": "Image Map",
    "type_OrderTypeQuantityMapping_supportedDeliveryTypes_name": "Supported Delivery Types",
    "type_DownloadableMediaContainer_name": "Downloadable Media Container",
    "type_MaintenanceScale_name": "Scale",
    "type_VehicleManufacturer_chassis_name": "Chassis(chass-eez)",
    "type_Address_displayStreetNumber_name": "Street Number",
    "type_DocumentType_code_name": "DocumentType Code",
    "type_ProductCategoryMapping_titleId_name": "Title Id",
    "type_productReferenceTypeEnum_CUSTOMER_name": "Customer",
    "type_AbstractOrderEntry_surcharge_name": "Core Surcharge",
    "type_B2BCustomerIndustryRoleEnum_DEALER_name": "Dealer",
    "type_productDimension_height_name": "Height",
    "type_B2BCustomerAccessRequestEnum_ORDER_ONLINE_name": "Order On-Line",
    "type_ProductWeight_product_name": "Product",
    "validation_B2BCustomer_DefaultB2BUnit_missing": "The Default B2B unit must be a sales area specific B2B unit!",
    "type_salesdata_distributionChannelID_name": "Distribution Channel ID",
    "type_WarrantyTypeOperation_name_name": "Name",
    "type_CoreCollectionAddress_city_name": "City",
    "type_productReferenceTypeEnum_IsReplacementFor_name": "Is Replacement For",
    "type_saleableItemType_IB_name": "Sales BOM",
    "type_WarrantyClaim_primaryComplaint_name": "Primary Complaint",
    "type_KBEcomProductCategoryMappingJob_lastExecutedtime_name": "Last Executed Time",
    "type_product_coreClass_name": "Core Class",
    "type_CoreRequest_b2bUnit_name": "B2b Unit",
    "type_product_webData_name": "Web Data",
    "type_KbCoreReports_csvMedia_name": "CSV",
    "type_productDimension_product_name": "Product",
    "type_TypeOfOperation_name_name": "Name",
    "type_product_code_name": "Part Number",
    "type_CoreItemsEMEA_coreGroup_name": "Core Group",
    "productSalesStatus_label_NA_CODE40": "For Sale - While Supplies Last",
    "type_OrderTypeQuantityMapping_carriers_name": "Carriers",
    "type_WarrantyClaim_claimNumber_name": "Claim Number",
    "type_AbstractOrder_currentOrderType_name": "OrderType",
    "type_WarrantyDecision_customerSite_name": "Site",
    "type_CoreCollectionAddress_packagingItems_name": "Packaging Info",
    "type_WarrantyPart_totalCost_name": "Total Cost",
    "type_SapOrderType_code_name": "Sap Order Type",
    "type_product_materialType_name": "Material Type",
    "type_ProductPlantStructure_name": "Product Plant Structure",
    "type_Country_products_name": "Products",
    "type_WarrantyPart_dateRemoved_name": "Date Removed",
    "type_ProductPlantStructure_tariffNumber_name": "Tariff Number",
    "type_KbEcomDocument_name": "Documents",
    "type_product_name_name": "Part Name",
    "type_WarrantyClaim_dealerCode_name": "Dealer Code",
    "type_CoreRequest_coreTransportRequired_name": "Core Transport Required",
    "type_AbstractOrderEntry_entryPricingError_name": "Pricing Error",
    "type_WarrantyDocumentMedia_name": "Warranty Document Media",
    "type_TypeOfOperation_code_name": "Code",
    "type_KbCoreReports_statementDate_name": "Statement Date",
    "type_KbEcomDocument_documentType_name": "Document Type",
    "type_AbstractOrder_docType_name": "SAP DocType",
    "type_PackageType_OTHER_name": "Other",
    "type_ProductDimension_unit_name": "Unit",
    "type_DeliveryType_Complete_name": "Complete Delivery",
    "type_product_coreGroup_name": "Core Group",
    "type_Address_displayDistrict_name": "District",
    "type_PricingProceduresSubtotal_KZWI2_name": "KB Customer Price",
    "type_AbstractOrder_currentCarrierType_name": "Carrier Type",
    "type_CustomerPartNumber_product_name": "Product",
    "type_KbCoreReports_reportType_name": "Report Type",
    "type_B2BUnit_incoTerms2_name": "incoTerms2",
    "type_KbEcomImportDataCronJob_deleteAssetsFromBlob_name": "Delete Assets From Blob",
    "type_SalesData_minDeliveringQuantity_name": "Minimum Delivering Quantity",
    "type_WarrantyClaim_typeOfOperation_name": "Type Of Operation",
    "type_AbstractOrder_supportedDeliveryTypes_name": "Supported Delivery Types",
    "type_Chassis_vehicleManufacturer_name": "Vehicle Manufacturer",
    "type_WarrantyClaim_warrantyPdf_name": "Warranty PDF",
    "type_CustomerHierarchyUnit_b2bUnits_name": "Directly assigned B2B units",
    "type_product_salesRegions_name": "Sales Regions",
    "type_CoreRequestItem_coreClass_name": "Core Class",
    "type_CorePackaging_packageQty_name": "Quantity",
    "type_CrossReferenceRelation_crossReferences_name": "Cross Reference",
    "type_CustomerHierarchyUnit_name": "Customer Hierarchy",
    "type_AbstractOrderEntry_originalEntry_name": "Original Entry",
    "type_B2BUnit_accountGroup_name": "Account Group",
    "type_productReferenceTypeEnum_HasSoftware_name": "Software",
    "type_ExternalLanguageMapping_name": "External Language Mapping",
    "type_CustomerHierarchyUnit_name_name": "Name",
    "type_product_deviceCode_name": "Device Code / Type",
    "type_OrderTypeQuantityMapping_orderTypeCode_name": "OrderType Code",
    "type_CrossReference_customer_name": "Customer",
    "type_CustomerHierarchyUnit_uid_name": "ID",
    "type_Address_dealerCode_name": "Dealer Code",
    "type_productWeight_product_name": "product",
    "type_salesChannelLimitation_Intercompanyonly_name": "Intercompany only",
    "type_Category_useExternalUrl_name": "Use External URL",
    "type_VehicleMfg2ChassisRelation_vehicleManufacturer_name": "Vehicle Manufacturer",
    "type_CoreCollectionAddress_companyName_name": "Company Name",
    "type_TypeOfOperation_name": "Type Of Operation",
    "type_product_weight_name": "Weight",
    "type_CMSStaticCategoryPageRestriction_name": "Static category page limitation",
    "type_ExternalLanguageMapping_description": "Mapping of an external language code to a list of actual languages",
    "type_SAPCpiOutboundOrderItem_requestedDeliveryDate_name": "Requested DeliveryDate",
    "type_WarrantyPart_otherCostDescription_name": "Other Cost Description",
    "type_SAPCpiOutboundOrder_requestedDeliveryDate_name": "Requested DeliveryDate",
    "type_CoreGradeType_DN_name": "Don't Know",
    "type_WarrantyPart_requestedHandlingCost_name": "Requested Handling Amount",
    "type_WarrantyClaim_vehicleManufacturer_name": "Vehicle Manufacturer",
    "type_WarrantyPart_replacementType_name": "Replacement Type",
    "type_WarrantyPart_axlePosition_name": "Axle Position",
    "type_AbstractOrderEntry2AbstractOrderEntry_name": "AbstractOrderEntry2AbstractOrderEntry Relation",
    "type_SalesRegion_code_name": "Code",
    "type_B2BCustomer_doubleOptUrl_name": "Double Opt Url",
    "type_CoreRequest_store_name": "Store",
    "type_KbEcomDocument_fileName_name": "File Name",
    "type_OrderTypeQuantityMapping_overWritten_name": "Overwritten",
    "type_SalesData_roundingProfile_name": "Rounding Profile",
    "type_KbEcomDocument_products_name": "Products",
    "type_CrossReferenceRelation_source_name": "Product",
    "type_Address_displayTown_name": "Town",
    "type_KbCoreDocument_TabCode_name": "Tab Name",
    "type_AbstractOrderEntry_requestedDeliveryDate_name": "Requested Delivery Date",
    "type_Address_displayStreetName_name": "Street Name",
    "type_OrderProcess_sendOrderFailEmail_description": "Send order fail email after exceeding maximum retry.",
    "type_Product_kbEcomDocuments_name": "Documents",
    "type_B2BUnit_paymentTerms_name": "Payment Terms",
    "type_OrderTypeQuantityMapping_days_description": "Minimum Number of business days to calculate default Request Delivery Date",
    "type_ReplacementType_name": "Replacement Type",
    "type_marketType_OriginalEquipment_name": "Original Equipment",
    "type_KbOrderStatus_code_name": "Order Status",
    "type_B2BCustomerWarrantyRightsEnum_WARRANTY_CLAIM_VALUES_name": "Warranty Claim Value",
    "type_CustomerPartNumber_catalogVersion_name": "Catalog Version",
    "type_KbEcomImportDataCronJob_lastRunTime_name": "Last Run Time",
    "type_KbEcomImportDataCronJob_exportedFiles_name": "Exported Files",
    "type_KbEcomImportDataCronJob_catalogVersions_name": "Catalog Versions",
    "type_CorePackagingType_GITTERBOX_name": "Gitter Box",
    "type_CorePackagingType_EUR_PALLET_name": "EUR Pallet",
    "type_CorePackagingType_ONE_WAY_PALLET_name": "One Way Pallet",
    "type_BaseStore_isCarrierSelectionsEnabledInBaseStore_name": "IsCarrierSelectionsEnabledInBaseStore",
    "type_Country_isCarrierSelectionsEnabled_name": "IsCarrierSelectionsEnabledInRegions",
    "type_BaseStore_isCoreEnabledInBaseStore_name": "Core Enabled",
    "type_BaseStore_isWarrantyEnabledInBaseStore_name": "Warranty Enabled",
    "type_CMSLinkComponent_localizedUrl_name": "Localized URL",
    "type_Product_netWeight_name": "Net Weight",
    "type_Product_grossWeight_name": "Gross Weight",
    "type_Product_productWeightUnit_name": "Product Weight Unit",
    "type_Product_length_name": "Length",
    "type_Product_width_name": "Width",
    "type_Product_height_name": "Height",
    "type_Product_productDimensionUnit_name": "Product Dimension Unit",
    "type_B2BCustomer_additionalSoldToLocations_name": "Additional Sold-to Locations",
    "type_B2BCustomer_defaultSoldTo_name": "Default Sold To",
    "type_B2BCustomer_userDeletionRequestDate_name": "User Deletion Date in Cron Job",
    "type_B2BUnit_isSoldToSignalEnabled_name": "Customer Level Notification Enabled",
    "type_B2BUnit_soldToSignalMessage_name": "Customer Level Notification Text",
    "type_Country_isCountrySignalEnabled_name": "Country Level Notification Enabled",
    "type_Country_countrySignalMessage_name": "Country Level Notification Text",
    "type_CMSSite_isSiteSignalEnabled_name": "Website Level Notification Enabled",
    "type_CMSSite_isSoftwareSearchEnabled_name": "Software Search Enabled",
    "type_CMSSite_siteSignalMessage_name": "Website Level Notification Text",
    "type_SAPSalesOrganization_isSalesOrgSignalEnabled_name": "Location Level Notification Enabled",
    "type_SAPSalesOrganization_salesOrgSignalMessage_name": "Location Level Notification Text",
    "type_SAPSalesOrganization_messageValidDateStart_name": "Message Start Time",
    "type_SAPSalesOrganization_messageValidDateEnd_name": "Message End Time",
    "type_Country_signalMsgStartDate_name": "Signal Message Start Time",
    "type_Country_signalMsgEndDate_name": "Signal Message End Time",
    "text_excel_customerPartNumber": "Customer Part Number",
    "text_excel_partNumber": "Part Number",
    "type_BreakAppRequest_code_name": "Code",
    "type_BreakAppRequest_date_name": "Date",
    "type_BreakAppRequest_oemCode_name": "OEM",
    "type_BreakAppRequest_oem_msg_name": "OEM Message",
    "type_BreakAppRequest_firstName_name": "First Name",
    "type_BreakAppRequest_lastName_name": "Last Name",
    "type_BreakAppRequest_emailAddress_name": "Email Address",
    "type_BreakAppRequest_phone_name": "Phone",
    "type_BreakAppRequest_soldToNumber_name": "Sold-to Code",
    "type_BreakAppRequest_customerControlNum_name": "Customer Control Number",
    "type_BreakAppRequest_attachments_name": "Attachments",
    "type_BreakAppRequest_chassisNumber_name": "Chassis Number",
    "type_BreakAppRequest_chassisNumber_msg_name": "Chassis Number Message",
    "type_BreakAppRequest_vehicleType_name": "Vehicle Type",
    "type_BreakAppRequest_vehicleType_msg_name": "Vehicle Type Message",
    "type_BreakAppRequest_axleConfiguration_name": "Axle Configuration",
    "type_BreakAppRequest_axleConfiguration_msg_name": "Axle Configuration Message",
    "type_BreakAppRequest_commodity_name": "Commodity Hauled",
    "type_BreakAppRequest_commodity_msg_name": "Commodity Hauled Message",
    "type_BreakAppRequest_GAWE_Front_name": "GAWE Front",
    "type_BreakAppRequest_GAWE_Front_msg_name": "GAWE Front Message",
    "type_BreakAppRequest_GAWR_Pusher_name": "GAWR Pusher",
    "type_BreakAppRequest_GAWR_Pusher_msg_name": "GAWR Pusher Message",
    "type_BreakAppRequest_GAWR_Forward_name": "GAWR Forward Rear",
    "type_BreakAppRequest_GAWR_Forward_msg_name": "GAWR Forward Rear Message",
    "type_BreakAppRequest_GAWR_Rear_name": "GAWR Rear Rear",
    "type_BreakAppRequest_GAWR_Rear_msg_name": "GAWR Rear Rear Message",
    "type_BreakAppRequest_GVWR_name": "GVWR",
    "type_BreakAppRequest_GVWR_msg_name": "GVWR Message",
    "type_BreakAppRequest_wheelbaseRange_name": "Wheelbase Range",
    "type_BreakAppRequest_wheelbaseRange_msg_name": "Wheelbase Range Message",
    "type_BreakAppRequest_frontTires_name": "Front Tires",
    "type_BreakAppRequest_frontTires_msg_name": "Front Tires Message",
    "type_BreakAppRequest_frontTireSLR_name": "Front Tire SLR",
    "type_BreakAppRequest_frontTireSLR_msg_name": "Front Tire SLR Message",
    "type_BreakAppRequest_rearTire_name": "Rear Tire",
    "type_BreakAppRequest_rearTire_msg_name": "Rear Tire Message",
    "type_BreakAppRequest_wheelBase_name": "Wheelbase",
    "type_BreakAppRequest_wheelBase_msg_name": "Wheelbase Message",
    "type_BreakAppRequest_steerAxleBreak_name": "Proposed Steer Axle Brake",
    "type_BreakAppRequest_steerAxleBreak_msg_name": "Proposed Steer Axle Brake Message",
    "type_BreakAppRequest_driveAxleBreak_name": "Proposed Drive Axle Brake",
    "type_BreakAppRequest_driveAxleBreak_msg_name": "Proposed Drive Axle Brake Message",
    "type_KbEcomDocument_createdDocumentDate_name": "Document Creation Date",
    "type_KbEcomDocument_createdDocumentDateLoc_name": "Document Release Date",
    "type_KbEcomDocument_team_name": "PLM team ",
    "type_B2BUnit_warrantyPeriod_name": "Warranty Period",
    "type_B2BUnit_sdpGrp01_name": "SDP Group",
    "type_KBEcomDocumentCategory_code_name": "Code",
    "type_KBEcomDocumentCategory_description_name": "Description",
    "type_KBEcomDocumentCategory_kbecomdocuments_name": "Documents",
    "type_KbEcomDocument_kbecomcategories_name": "Document Categories",
    "type_KbEcomDocument2CategoryRelation_name": "Document And Categories Relation",
    "type_KbEcomDocument2CategoryRelation_kbecomdocuments_name": "Document Categories",
    "type_WarrantyClaim_placedBy_name": "Placed By",
    "type_CoreRequest_placedBy_name": "Placed By",
    "type_Quote_externalPricingIndicator_name": "External Pricing Indicator",
    "type_Quote_cancellationReasonCode_name": "Cancellation Reason Code",
    "type_FavoriteList_name": "Favorite List",
    "type_FavoriteList_description": "Document Favorite List",
    "type_FavoriteList_code_name": "Favorite List",
    "type_FavoriteList_code_description": "Favorite List for adding list of documents to the user",
    "type_FavoriteList_docUser_name": "Doc User",
    "type_FavoriteList_docUser_description": "Doc Use",
    "type_FavoriteList_docUser_email_name": "Doc User Email",
    "type_FavoriteList_docUser_email_description": "Doc User Email",
    "type_FavoriteList_docUser_docUserSite_name": "Doc User Site",
    "type_FavoriteList_docUser_docUserSite_description": "Doc User Site",
    "type_FavoriteList_entries_name": "Favorite List Entries",
    "type_FavoriteList_entries_description": "Favorite List Entries",
    "type_FavoriteListEntry_document_name": "document",
    "type_FavoriteListEntry_document_description": "document in each entry list",
    "type_FavoriteListEntry_addedDate_name": "Added Date",
    "type_FavoriteListEntry_addedDate_description": "Added Date of each entry list",
    "type_FavoriteListEntry_documentLanguage_name": "Document Language",
    "type_FavoriteListEntry_documentLanguage_description": "Added Document Language of each entry list",
    "type_DocUser_name": "DOC User",
    "type_DocUser_description": "Doc User for Favorite List ",
    "type_DocUser_email_name": "Email",
    "type_DocUser_email_description": "Doc User email",
    "type_GuestUser2FavoriteList_name": "GuestUser to FavoriteList",
    "type_GuestUser2FavoriteList_description": "GuestUser2FavoriteList",
    "type_GuestUser2FavoriteList_docUser_name": "Doc User",
    "type_GuestUser2FavoriteList_docUser_description": "Doc User in GuestUser2FavoriteList Relation",
    "type_GuestUser2FavoriteList_favoriteList_name": "Favorite List",
    "type_GuestUser2FavoriteList_favoriteList_description": "Favorite List in GuestUser2FavoriteList Relation",
    "type_FavoriteList2Entry_name": "Favorite List entry",
    "type_FavoriteList2Entry_description": "Favorite List entry",
    "type_FavoriteList2Entry_favoriteList_name": "Favorite List",
    "type_FavoriteList2Entry_favoriteList_description": "Favorite List",
    "type_FavoriteList2Entry_entries_name": "Entries",
    "type_FavoriteList2Entry_entries_description": "Entries",
    "type_CsTicket_AssociatedTo_name": "Associated To",
    "type_ReportDocument_report_name": "Report Document",
    "type_ReportDocument_code_name": "Report Code",
    "type_ReportDocument_site_name": "Site",
    "type_ReportDocument_b2bUnit_name": "B2BUnit",
    "type_ReportDocument_countries_name": "Countries",
    "type_ReportDocument_salesOffices_name": "Sales Offices",
    "type_ReportDocument_salesOrgs_name": "SAP Sales Areas",
    "type_Report2B2BUnitRelation_reportDocument_name": "Report Documents",
    "type_Report2B2BUnitRelation_b2bUnit_name": "B2BUnit",
    "type_ReportDocument2SalesOrgRelation_reportDocument_name": "Report Documents",
    "type_ReportDocument2SalesOrgRelation_salesOrgs_name": "SAP Sales Area",
    "type_ReportDocument2SalesOfficeRelation_reportDocument_name": "Report Documents",
    "type_ReportDocument2SalesOfficeRelation_salesOffices_name": "Sales Office",
    "type_ReportDocument2CountryRelation_reportDocument_name": "Report Documents",
    "type_ReportDocument2CountryRelation_countries_name": "Country",
    "type_B2BCustomer_customerDocDownloadAccess_name": "Download Customer Documents",
    "type_SalesOffice_code_name": "Code",
    "type_SalesOffice_name_name": "Name",
    "type_WarrantyClaim_returnRequest_name": "Return Request",
    "type_WarrantyPart_returnRequestType_name": "Return Request Type",
    "type_WarrantyClaim_PONumber_name": "PO Number",
    "type_Address_searchTerm1_name": "Search Term 1",
    "type_Address_searchTerm2_name": "Search Term 2",
    "type_Address_publicKeyIndexed_name": "Public Key Indexed",
    "type_Address_transpzone_name": "Dealer Code",
    "type_product_ssgDocName_name": "SSG Document Name",
    "type_BaseStore_separator_name": "Separator",
    "type_BaseStore_separator_description": "Separator for order import associated with the base Store",
    "type_KbCoreReports_payload_name": "Pay Load",
    "type_CoreCollectionAddress_sapCustomerID_name": "SAP Customer ID",
    "type_OrderProcess_isCoreTeamEmail_name": "Is Core Team Email Check",
    "type_CoreCollectionAddress_newAddressFlag_name": "New Address Flag",
    "type_SAPConfiguration_name": "SAP Configuration",
    "type_User_isTestUser_name": "Test User",
    "type_LocalisedMessages_name": "Localized Message",
    "type_LocalisedMessages_messagesKey_name": "Messages Key",
    "type_LocalisedMessages_messagesKey_description": "Added to store key",
    "type_LocalisedMessages_messagesValue_name": "Message Value",
    "type_LocalisedMessages_messagesValue_description": "Added to store localise value",
    "type_Company_name": "Company",
    "type_Company_displayName_name": "Display Name",
    "type_SAPCpiOutboundOrder_specialProInd_name": "Special Processing Indicator",
    "type_SAPCpiOutboundOrder_orderNote_name": "Order Note",
    "type_SAPCpiOutboundOrder_orderNoteLang_name": "Order Note Language",
    "type_SAPCpiOutboundOrder_carrierNumber_name": "Carrier Number",
    "type_AbstractOrder_clientResponseException_name": "Client Response Exception",
    "type_AbstractOrder_orderNote_name": "Order Note",
    "type_AbstractOrder_specialProInd_name": "Special Processing Indicator",
    "type_AbstractOrder_carrierNumber_name": "Carrier Number",
    "type_AbstractOrder_isReorderable_name": "Check Reorderable",
    "type_AbstractOrder_isReorderable_description": "if order is eligible for reorder?",
    "type_AbstractOrderEntry_deliveryQty_name": "Delivery Quantity",
    "type_AbstractOrderEntry_openQty_name": "Open Quantity",
    "type_AbstractOrderEntry_scheduleLines_name": "Schedule Lines",
    "type_AbstractOrderEntry_netPricePerPiece_name": "Net Price Per Piece",
    "type_AbstractOrderEntry_entryStatus_name": "Entry Status",
    "type_ScheduleLine_estimatedQty_name": "Estimated Quantity",
    "type_ScheduleLine_estimatedDate_name": "Estimated Date",
    "type_ScheduleLine_trackingNumber_name": "Tracking Number",
    "type_ScheduleLine_carrier_name": "Carrier",
    "type_Order_sapOrderType_name": "SAP Order Type",
    "type_Order_sapOrderStatus_name": "SAP Order Status",
    "type_Order_hybrisOrderNumber_name": "Hybris Order Number",
    "type_ProductCategoriesComponent_title_name": "Title",
    "type_ProductCategoriesComponent_name": "Product Categories Component",
    "type_ProductCategoriesComponent_description_name": "Localized description of the component.",
    "type_ProductCategoriesComponent_CategoryList_name": "Category List",
    "type_KbEcomImportDataCronJob_job_name": "KB Import Data CronJob Job",
    "type_CMSNavigationNode_distributionChannels_name": "Distribution Channels",
    "type_SimpleResponsiveBannerComponent_name": "Simple Responsive Banner Component",
    "type_SimpleResponsiveBannerComponent_content_name": "Content",
    "type_B2BUnit_language_name": "Language",
    "type_B2BUnit_marketSegment_name": "Market Segment",
    "type_B2BCustomer_warrantyRights_name": "Warranty Rights",
    "type_B2BCustomer_coreRights_name": "Core Rights",
    "type_B2BCustomer_showCoWorkerOrders_name": "Show Co-Workers Information",
    "type_B2BCustomer_updateMyPart_name": "Update MyPart",
    "type_B2BCustomer_onlineOrdering_name": "Online Ordering",
    "type_B2BCustomer_viewPriceAndATP_name": "View Price & Availability",
    "type_B2BCustomer_dealerADBAccess_name": "OEM (ADB Access/Only for Bendix)",
    "type_B2BCustomer_technicalTrainingAccess_name": "Technical Training",
    "type_B2BCustomerAccessRequestEnum_TECHNICAL_TRAINING_name": "Technical Training",
    "type_B2BCustomer_inverseSearchXref_name": "Xref Inverse Search",
    "type_B2BCustomer_alreadyProcessed_name": "Business Process State",
    "type_B2BCustomer_registrationType_name": "Registration type",
    "type_B2BCustomer_priceDownloadAccess_name": "Price Document Download Access",
    "type_B2BCustomer_defaultSoldToText_name": "Default Sold To Text",
    "type_B2BCustomer_myDocumentUpdate_name": "My Document Update Flag",
    "type_SAPProductSalesAreaToCatalogMapping_name": "SAP Product Sale Area To Catalog Mapping",
    "type_SAPProductSalesAreaToCatalogMapping_region_name": "Region",
    "type_SAPProductSalesAreaToCatalogMapping_description": "Region this sales area belongs to",
    "type_OrderImportComponent_name": "Order Import Component",
    "type_OrderImportComponent_template_name": "Order Import Component Template",
    "type_OrderImportComponent_KBOrderTypesEnumCollection_name": "KB Order Type Enum Collection",
    "type_KbDocumentDownloadLog_name": "KB Document Download",
    "type_KbDocumentDownloadLog_documentName_name": "Document Name",
    "type_KbDocumentDownloadLog_version_name": "Document Version",
    "type_KbDocumentDownloadLog_emailID_name": "Email ID",
    "type_KbDocumentDownloadLog_newUser_name": "New User",
    "type_KbDocumentDownloadLog_consentAccepted_name": "Consent Accepted",
    "type_CronJob_isCustomizeCronJob_name": "Customize Cronjob",
    "type_CronJob_jobLogText_name": "Joblog Text",
    "type_CronJob_name": "Cronjob",
    "type_SendEmailCronJobProcess_name": "Send Email Cronjob Process",
    "type_SendEmailCronJobProcess_cronLogsMessages_name": "Cronjob Message",
    "type_Training_name": "Training",
    "type_Training_disable_name": "Disable",
    "type_TrainingSlot_name": "Training slot",
    "type_TrainingSlot_trainingStartDate_name": "Training Start Date",
    "type_TrainingSlot_trainingEndDate_name": "Training End Date",
    "type_TrainingSlot_language_name": "Training Language",
    "type_TrainingSlot_country_name": "Country",
    "type_TrainingSlot_address_name": "Address",
    "type_TrainingSlot_trainingSchedule_name": "Training Schedule",
    "type_TrainingSlot_price_name": "Price",
    "type_TrainingSlot_active_name": "Active",
    "type_TrainingSchedule_name": "Training schedule",
    "type_TrainingSchedule_day_name": "Training day",
    "type_TrainingSchedule_startTime_name": "Training Start Time",
    "type_TrainingSchedule_endTime_name": "Training End Time",
    "type_TrainingSchedule_timeZone_name": "Training Time Zone",
    "type_TrainingAddressDetails_name": "Training Address Details",
    "type_TrainingAddressDetails_address_name": "Training Address",
    "type_TrainingAddressDetails_vatId_name": "Vat ID",
    "type_TrainingParticipants_name": "Training Participant",
    "type_TrainingParticipants_kbParticipant_name": "KB Participant",
    "type_TrainingParticipants_billParticipant_name": "Bill Participant",
    "type_TrainingParticipants_acknowledged_name": "Acknowledged",
    "type_TrainingParticipants_companyName_name": "Company Name",
    "type_TrainingParticipants_firstName_name": "First Name ",
    "type_TrainingParticipants_lastName_name": "Last Name",
    "type_TrainingParticipants_uid_name": "UID",
    "type_TrainingParticipants_kbRegisterUser_name": "KB Register User",
    "type_TrainingParticipants_trainingRegistration_name": "Training Registration",
    "type_TrainingParticipants_participantCertificate_name": "Participant Certificate",
    "type_TrainingParticipants_SPECertificate_name": "SPE Certificate",
    "type_TrainingParticipants_trainingDatasheet_name": "Training Data Sheet",
    "type_TrainingParticipants_trainingSlot_name": "Training Slot",
    "type_TrainingRegistration_name": "Training registration",
    "type_TrainingRegistration_isTrainingModified_name": "Training Modified",
    "type_TrainingRegistration_bookedTraining_name": "Training Booked",
    "type_TrainingRegistration_selectedSlot_name": "Selected Slot",
    "type_TrainingRegistration_companyDetails_name": "Company Details",
    "type_TrainingRegistration_billingInformation_name": "Billing Information",
    "type_TrainingRegistration_participants_name": "Training Participants",
    "type_TrainingRegistration_associatedUser_name": "Associates User",
    "type_TrainingRegistration_code_name": "Code",
    "type_TrainingRegistration_registrationDate_name": "Registration Date",
    "type_TrainingRegistration_soldTo_name": "Sold To",
    "type_TrainingRegistration_trainingStartDate_name": "Training Start Date",
    "type_TrainingRegistration_approved_name": "Approved",
    "type_TrainingRegistration_exportStatus_name": "Export Status",
    "type_TrainingRegistrationEmailProcess_name": "Training Registration Email Process",
    "type_TrainingRegistrationEmailProcess_trainingRegistration_name": "Training Registration",
    "type_TrainingRegistrationEmailProcess_sendInvoicingRetryCount_name": "Send Invoicing Retry Count",
    "type_TrainingRegistrationEmailProcess_reminderDays_name": "Reminder Days",
    "type_TrainingRegistrationEmailProcess_reminderDays_description": "No of days for reminder",
    "type_TrainingRegistrationEmailProcess_attributesChanged_name": "Attributes Changed",
    "type_TrainingRegistrationEmailProcess_attributesChanged_description": "Gives the name of attribute changed",
    "type_TrainingRegistration_country_name": "Country",
    "type_TrainingRegistration_language_name": "Language",
    "type_TrainingCertificate_name": "Training Certificate",
    "type_TrainingCertificate_report_name": "Report",
    "type_TrainingCertificate_code_name": "Code",
    "type_ParticipantEditEmailProcess_name": "Participant Edit Email Process",
    "type_ParticipantEditEmailProcess_participants_name": "Participants",
    "type_KbTrainingReminderDataJob_name": "KB Training Reminder DataJob",
    "type_KbTrainingReminderDataJob_reminderDays_name": "Reminder days",
    "type_CMSSite_name": "CMS Site",
    "type_CMSSite_isDownloadDisclaimerEnabled_description_name": "Is Download Disclaimer Enabled",
    "type_ExportProductDataToCSVAttachmentProcess_name": "Export Product Data To CSV Attachment Process",
    "type_ExportProductDataToCSVAttachmentProcess_cSVAttachment_name": "CSV Attachment",
    "type_ExportProductDataToCSVAttachmentProcess_cSVMessages_name": "CSV Messages",
    "type_SAPCpiOutboundAddress_name": "SAPCpi Outbound Address",
    "type_SAPCpiOutboundAddress_transpzone_name": "Transpzone",
    "type_Employee_token_name": "Token",
    "type_Employee_email_name": "Email",
    "type_Employee_countries_name": "Software Admin Countries",
    "type_Employee_countries_description": "Represents Software Admin Countries",
    "type_Employee_country_name": "Country",
    "type_Employee_country_description": "Employee belongs to this Country",
    "type_StoreFrontEmployeeProcess_name": "Store Front Employee Process",
    "type_StoreFrontEmployeeProcess_description": "Represents employee related store front business process.",
    "type_StoreFrontEmployeeProcess_employee_name": "Employee",
    "type_StoreFrontEmployeeProcess_language_name": "Language",
    "type_ForgottenEmployeePasswordProcess_name": "Forgotten Employee Password Process",
    "type_ForgottenEmployeePasswordProcess_description": "Represents process that is used for retrieving forgotten password.",
    "type_ForgottenEmployeePasswordProcess_token_name": "Token",
    "type_KbEcomImportUserDataCronJob_name": "KbEcomImport UserData CronJob",
    "type_KbEcomImportUserDataCronJob_userDetailFile_name": "User Detail file",
    "type_KbEcomImportUserDataCronJob_sendEmailNotification_name": "Send Email Notification",
    "type_CoreSubmissionProcess_name": "Core Submission Process",
    "type_CoreSubmissionProcess_sendCoreClaimRetryCount_name": "Send Core Claim Retry Count",
    "type_CoreSubmissionProcess_coreRequest_name": "Core Request",
    "type_KBSapToHybrisOrderMapping_name": "KB SapToHybris Order Mapping",
    "type_KBSapToHybrisOrderMapping_sales_org_name": "Sales Org",
    "type_KBSapToHybrisOrderMapping_orderType_name": "Order Type",
    "type_KBSapToHybrisOrderMapping_documentType_name": "Document Type",
    "type_KBSapToHybrisOrderMapping_shippingCondition_name": "Shipping Condition",
    "type_KBSapToHybrisOrderMapping_lpriority_name": "L Priority",
    "type_Country_kbTransportRequired_name": "KB Transport required",
    "type_Country_coreCollectionAvailable_name": "Core Collection Available",
    "type_CoreRequest_clientResponseException_name": "Client Response Exception",
    "type_CoreGroupEMEA_name": "Core Group EMEA",
    "type_CoreGroupEMEA_code_name": "Code",
    "type_CoreGroupEMEA_coreMaterial_name": "Core Material",
    "type_CoreGroupEMEA_desc_name": "Description for core group",
    "type_CoreGroupEMEA_weight_name": "Group Weight",
    "type_CoreClass_name": "Core Class",
    "type_CoreClass_code_name": "code for core class",
    "type_CoreClass_desc_name": "Description for core class",
    "type_CoreClass_weight_name": "Weight",
    "type_UpgradeGroup_name": "Upgrade Group",
    "type_UpgradeGroup_code_name": "Upgrade Code",
    "type_UpgradeGroup_upgradeGroup_name": "Upgrade Group",
    "type_UpgradeGroup_upgradeGroup_description": "Upgrade Group for core class",
    "type_CoreGroup_name": "Core Group",
    "type_CoreGroup_code_name": "Code for Core Group",
    "type_CoreGroup_desc_name": "Description for core group",
    "type_DTCLookupResource_name": "DTC Lookup Resource",
    "type_DTCLookupResource_dtcFaultDescription_name": "Description for DTC",
    "type_DTCLookupResource_SDSheet_name": "Sheet Number for DTC",
    "type_DTCLookupResource_component_name": "DTC Component",
    "type_DTCLookupResource_blinkCode1_name": "Blink Code 1",
    "type_DTCLookupResource_blinkCode2_name": "Blink Code 2",
    "type_DTCLookupResource_internalCode1_name": "Internal Code 1",
    "type_DTCLookupResource_internalCode2_name": "Internal Code 2",
    "type_DTCLookupResource_overview_name": "Overview",
    "type_DTCLookupResource_possibleCauses_name": "Possible Causes",
    "type_DTCLookupResource_disclaimer_name": "Disclaimer",
    "type_DTCLookupResource_beforeYouBegin_name": "Before You Begin",
    "type_DTCLookupResource_afterRepairsMade_name": "After Repairs Made",
    "type_DTCLookupResource_dtcSteps_name": "steps",
    "type_MasterADBBreaking_name": "Master ADB Breaking",
    "type_MasterADBBreaking_typeOfADB_name": "Type of ADB",
    "type_MasterADBBreaking_code_name": "Code",
    "type_MasterADBBreaking_name_name": "Name",
    "type_ADBRequest_name": "ADB Request",
    "type_ADBRequest_description": "Break Application form Request",
    "type_ADBRequest_approvalStatus_name": "Approval Status",
    "type_ADBRequest_code_name": "BBA Number",
    "type_ADBRequest_date_name": "Date",
    "type_ADBRequest_oemCodeADB_name": "OEM Code ADB",
    "type_ADBRequest_oem_msg_name": "OEM Message",
    "type_ADBRequest_firstName_name": "First Name",
    "type_ADBRequest_lastName_name": "Last Name",
    "type_ADBRequest_emailAddress_name": "Email Address",
    "type_ADBRequest_phone_name": "Phone",
    "type_ADBRequest_soldTo_name": "SoldTo",
    "type_ADBRequest_customerControlNum_name": "Customer Control Number",
    "type_ADBRequest_attachments_name": "Attachments",
    "type_ADBRequest_Axle_Manufacturer_name": "Axle_Manufacturer",
    "type_ADBRequest_Axle_ManufacturerMsg_name": "Axle_Manufacturer Message",
    "type_ADBRequest_chassisNumber_name": "Chassis Number",
    "type_ADBRequest_vehicleType_name": "Vehicle Type",
    "type_ADBRequest_vehicleTypeMsg_name": "Vehicle Type Message",
    "type_ADBRequest_axleConfiguration_name": "Axle Configuration",
    "type_ADBRequest_vocation_name": "Vocation",
    "type_ADBRequest_vocationMsg_name": "Vocation Message",
    "type_ADBRequest_vehicleModel_name": "Vehicle Model",
    "type_ADBRequest_vehicleModelMsg_name": "Vehicle Model Message",
    "type_ADBRequest_axle_GAWR_name": "Axle GAWR",
    "type_ADBRequest_customerAxle_Weight_name": "Customer Axle Weight",
    "type_ADBRequest_ADBtire_Type_name": "ADBtire Type",
    "type_ADBRequest_ADBtire_SLR_name": "ADBtire_SLR",
    "type_ADBRequest_GVWR_name": "GVWR",
    "type_ADBRequest_wheelbaseRange_name": "Wheelbase Range",
    "type_ADBRequest_frontTires_name": "Front Tires",
    "type_ADBRequest_frontTireSLR_name": "Front Tire SLR",
    "type_ADBRequest_rearTire_name": "Rear Tire",
    "type_ADBRequest_wheelBase_name": "Wheel Base",
    "type_ADBRequest_CG_Height_laden_name": "CG_Height_laden",
    "type_ADBRequest_CG_Height_unladen_name": "CG_Height_unladen",
    "type_ADBRequest_Proposed_FR_name": "Proposed_FR",
    "type_ADBRequest_Proposed_FM_name": "Proposed_FM",
    "type_ADBRequest_Proposed_SAB_name": "Proposed_SAB",
    "type_ADBRequest_Proposed_DAB_name": "Proposed_DAB",
    "type_ADBRequest_Proposed_Pusher_name": "Proposed_Pusher",
    "type_ADBRequest_Proposed_Tag_name": "Proposed_Tag",
    "type_ADBRequest_Proposed_AuxilaryAxle_name": "Proposed_AuxilaryAxle",
    "type_ADBRequest_Cust_comments_name": "Customer comments",
    "type_ADBRequest_user_name": "User",
    "type_ADBRequest_store_name": "Store",
    "type_ADBRequest_site_name": "Site",
    "type_ADBRequest_language_name": "Language",
    "type_ADBRequest_brakeType_name": "Brake Type",
    "type_GAWRInformation_name": "GAWR Information",
    "type_GAWRInformation_GAWR_Front_name": "GAWR Front",
    "type_GAWRInformation_GAWR_Forward_name": "GAWR Forward",
    "type_GAWRInformation_GAWR_Pusher_name": "GAWR Pusher",
    "type_GAWRInformation_GAWR_Rear_name": "GAWR Rear",
    "type_GAWRInformation_GAWR_Mid_Rear_name": "GAWR_Mid Rear",
    "type_GAWRInformation_GAWR_Tag_name": "GAWR Tag",
    "type_GAWRInformation_Auxiliary_Axle_name": "Auxiliary Axle",
    "type_GAWRInformation_Additional_Axle_name": "Additional Axle",
    "type_BreakFormInfo_name": "Break Form Information",
    "type_BreakFormInfo_code_name": "Code",
    "type_BreakFormInfo_message_name": "Message",
    "type_EngineerComment_name": "Engineer Comment",
    "type_EngineerComment_date_name": "Date",
    "type_EngineerComment_engineer_name": "Engineer",
    "type_EngineerComment_additionalMessage_name": "Additional Message",
    "type_EngineerComment_partNumber_name": "Part Number",
    "type_AdbRequestProcess_name": "ADB Request Process",
    "type_AdbRequestProcess_adbRequest_name": "ADB Request",
    "type_B2BCustomerAccessRequestEnum_DEALER_ADB_name": "Brake Application Request Form",
    "type_AbstractOrder_ppdDelta_name": "PPD Delta Price",
    "type_AbstractOrder_ppdDelta_description": "PPD Delta Price coming from SAP response during price call ",
    "type_Training_name_name": "Training Short Code",
    "type_Training_description_name": "Long Copy Training Name",
    "type_DocumentSubscribersList_name": "Document Subscribers Collection",
    "type_DocumentSubscribersList_description": "Document Subscribers Collection",
    "type_DocumentSubscriptionInfo_name": "Document Subscription Info",
    "type_DocumentSubscriptionInfo_description": "Document Subscription Info",
    "type_DocumentSubscriptionInfo_docUser_name": "docUser",
    "type_DocumentSubscriptionInfo_docUser_description": "docUser",
    "type_DocumentSubscriptionInfo_subscribed_name": "subscribed to document",
    "type_DocumentSubscriptionInfo_subscribed_description": "subscribed to document",
    "type_DocumentSubscriptionInfo_doubleOptIn_name": "double Opt-In",
    "type_DocumentSubscriptionInfo_doubleOptIn_descripton": "double Opt-In",
    "type_FavoriteListEntry_documentSubscribers_name": "Subscribed Users ",
    "type_FavoriteListEntry_documentSubscribers_description": "List of users subscribed to the document seen in favorite list entry",
    "type_CsTicket_c4cId_name": "Customer Services ID",
    "type_CsTicket_c4cId_description": "C4C ID",
    "type_CsTicket_c4cObjectId_name": "Customer Services Object ID",
    "type_CsTicket_c4cObjectId_description": "C4C Object ID",
    "type_DocumentUpdatedNotificationEmailProcess_name": "Document Updated Notification  Email Process",
    "type_DocumentUpdatedNotificationEmailProcess_description": "Document Updated Notification  Email Process",
    "type_DocumentUpdatedNotificationEmailProcess_document_name": "document",
    "type_DocumentUpdatedNotificationEmailProcess_document_description": "document",
    "type_DocumentUpdatedNotificationEmailProcess_docUser_name": "Doc User",
    "type_DocumentUpdatedNotificationEmailProcess_docUser_description": "Doc User",
    "type_DocumentUpdatedNotificationEmailProcess_language_name": "language",
    "type_DocumentUpdatedNotificationEmailProcess_language_description": "language",
    "type_DocumentUpdatedNotificationEmailProcess_documentSubscriptionInfo_name": "Document Subscription Info",
    "type_UserGroup_asmLocationIsoCodeAccess_name": "ASM Location Access ISOCODES",
    "type_UserGroup_asmLocationIsoCodeAccess_description": "All the ISOCode locations that ASM users that can access to (similar functionality to backoffice locations per backoffice user)",
    "type_RotatingImagesComponent_simpleResponsiveBanners_name": "Simple Responsive Banners",
    "type_SimpleResponsiveBannerComponent_rotatingImageComponent_name": "Rotating Images Component",
    "productSalesStatus_label_NA_CODE50": "For Sale (Restricted)",
    "productSalesStatus_label_NA_CODE60": "For Sale (Restricted) - While Supplies Last",
    "productSalesStatus_label_EMEA_CODE70": "Obsolete, has repair kits",
    "type_ReportsDocumentTimeStamp_user_name": "User  ",
    "type_ADBRequest_levelOfExp_name": "Level of experience with installation/design/testing of ADB/S-Cam brakes",
    "type_ADBRequest_projectTarget_name": "Project Target",
    "type_ADBRequest_samplesRequired_name": "Required Sample(A,B or C)",
    "type_ADBRequest_sampleANum_name": "A-Sample",
    "type_ADBRequest_sampleBNum_name": "B-Sample",
    "type_ADBRequest_sampleCNum_name": "C-Sample",
    "type_ADBRequest_targetDateAvailable_name": "Target Date Available",
    "type_ADBRequest_sampleADate_name": "Sample A Date",
    "type_ADBRequest_sampleBDate_name": "Sample B Date",
    "type_ADBRequest_sampleCDate_name": "Sample C Date",
    "type_ADBRequest_productionStartDate_name": "Production Start Date",
    "type_ADBRequest_firstYearVol_name": "First Year Vol",
    "type_ADBRequest_secondYearVol_name": "Second Year Vol",
    "type_ADBRequest_thirdYearVol_name": "Third Year Vol",
    "type_ADBRequest_ppapLevel_name": "PPAP Level",
    "type_ADBRequest_endUser_name": "End User (Fleet Customer)",
    "type_ADBRequest_fmeaAvailable_name": "FMEA Available",
    "type_ADBRequest_ftPlanned_name": "Do you plan to conduct field tests for this application?",
    "type_ADBRequest_ftVehicleCount_name": "How many vehicles are or will be used in your field test?",
    "type_ADBRequest_ftDetails_name": "Have you performed field tests on similar applications? If yes, please provide detail",
    "type_ADBRequest_plannedMarketUsage_name": "Planned Market Usage / Legal Requirements",
    "type_ADBRequest_cadModelAvailability_name": "CAD Model Availability",
    "type_ADBRequest_paintingCondition_name": "Painting Conditions",
    "type_ADBRequest_chassisModification_name": "Post-Production Chassis Modification",
    "type_ADBRequest_vehicleLifetime_name": "Lifetime of Vehicle",
    "type_ADBRequest_annualUsage_name": "Annual Use",
    "type_ADBRequest_onHighwayUsage_name": "% On-Highway Operation",
    "type_ADBRequest_averageGrade_name": "Average Grade (%)",
    "type_ADBRequest_maximumOptimumGrade_name": "Maximum Operating Grade, Length, Speed (Descent)",
    "type_ADBRequest_enduranceBreakSys_name": "What type of Endurance Brake System is onboard?",
    "type_ADBRequest_oemPTReq_name": "Parking Test Requirements-Customer (OEM)",
    "type_ADBRequest_vehicleOEC_name": "Vehicle's Operating Environment Conditions (as related to NVH)",
    "type_ADBRequest_serviceBrakeDutyCycle_name": "Service Brake Duty Cycle (Excluding Parking)",
    "type_ADBRequest_parkingDutyCycle_name": "Parking Duty Cycle / Conditions",
    "type_ADBRequest_endUserPTReq_name": "Parking Test Requirements - End User",
    "type_ADBRequest_nvhRequirements_name": "NVH Requirements, NVH Regional Concerns, NVH Application Concern",
    "type_ADBRequest_absSensors_name": "ABS Sensors for all wheel positions?",
    "type_ADBRequest_absModulatorCount_name": "ABS Modulator Count",
    "type_ADBRequest_absSensorCount_name": "ABS Sensor Count",
    "type_ADBRequest_steerAxleManu_name": "Steer Axle Manufacturer",
    "type_ADBRequest_steerAxleManuBox_name": "Steer Axle Manufacturer Box(Others)",
    "type_ADBRequest_steerAxleBAIP_name": "(Steer)Party performing brake assembly install onto the axle",
    "type_ADBRequest_steerAxleStatus_name": "(Steer)Axle design release/production status",
    "type_ADBRequest_steerAxleTOC_name": "(Steer)Type of Connection to Axle Flange",
    "type_ADBRequest_steerAxleBrakeDiscInfo_name": "(Steer)Rotor or Drum Intended Manufacturer and Part Number",
    "type_ADBRequest_steerAxleBrakeHubInfo_name": "(Steer)Hub Intended Manufacturer and Part Number",
    "type_ADBRequest_steerAxleBrakeActInfo_name": "(Steer)Actuator/Cylinder Intended Manufacturer and Part Number",
    "type_ADBRequest_steerAxleValveCP_name": "(Steer)Valve Crack Pressure",
    "type_ADBRequest_steerAxleDriven_name": "(Steer)Axle Driven",
    "type_ADBRequest_steerAxleType_name": "(Steer)Axle Type",
    "type_ADBRequest_steerAxleParking_name": "(Steer)Intended or Desired Parking Axle Configuration",
    "type_ADBRequest_steerAxleGAWR_name": "(Steer)Steer Gross Axle Weight Rating (GAWR)",
    "type_ADBRequest_steerAxleWeightLimit_name": "(Steer)Customer Axle Weight Limit",
    "type_ADBRequest_steerAxleWheelRimSize_name": "(Steer)Wheel/Tire Size (example: 295/75R22.5)",
    "type_ADBRequest_steerAxleTireType_name": "(Steer)Tire Type",
    "type_ADBRequest_steerAxleSLR_name": "(Steer)Tire Static Loaded Radius",
    "type_ADBRequest_steerAxleCustPropBrake_name": "(Steer)Customer-Proposed Brake",
    "type_ADBRequest_driveAxleManu_name": "Drive Axle Manufacturer",
    "type_ADBRequest_driveAxleManuBox_name": "Drive Axle Manufacturer Box(Others)",
    "type_ADBRequest_driveAxleBAIP_name": "(Drive)Party performing brake assembly install onto the axle",
    "type_ADBRequest_driveAxleStatus_name": "(Drive)Axle design release/production status",
    "type_ADBRequest_driveAxleTOC_name": "(Drive)Type of Connection to Axle Flange",
    "type_ADBRequest_driveAxleBrakeDiscInfo_name": "(Drive)Rotor or Drum Intended Manufacturer and Part Number",
    "type_ADBRequest_driveAxleBrakeHubInfo_name": "(Drive)Hub Intended Manufacturer and Part Number",
    "type_ADBRequest_driveAxleBrakeActInfo_name": "(Drive)Actuator/Cylinder Intended Manufacturer and Part Number*",
    "type_ADBRequest_driveAxleValveCP_name": "(Drive)Valve Crack Pressure",
    "type_ADBRequest_driveAxleType_name": "(Drive)Axle Type",
    "type_ADBRequest_driveAxleParking_name": "(Drive)Intended or Desired Parking Axle Configuration",
    "type_ADBRequest_driveAxleGAWR_name": "(Drive)Gross Axle Weight Rating (GAWR)",
    "type_ADBRequest_driveAxleWheelRimSize_name": "(Drive)Wheel/Tire Size (example: 295/75R22.5)",
    "type_ADBRequest_driveAxleTireType_name": "(Drive)Tire Type",
    "type_ADBRequest_driveAxleSLR_name": "(Drive)Tire Static Loaded Radius",
    "type_ADBRequest_driveAxleCustPropBrake_name": "(Drive)Customer-Proposed Brake",
    "type_ADBRequest_auxAxleList_name": "Auxiliary Axle List",
    "type_ADBAuxiliaryAxle_auxAxleManu_name": "Axle Manufacturer",
    "type_ADBAuxiliaryAxle_auxAxleBAIP_name": "Party performing brake assembly install onto the axle(s)",
    "type_ADBAuxiliaryAxle_auxAxleManuBox_name": "Axle Manufacturer Box(Others)",
    "type_ADBAuxiliaryAxle_auxAxleStatus_name": "Axle design release/production status",
    "type_ADBAuxiliaryAxle_auxAxleTOC_name": "Type of Connection to Axle Flange",
    "type_ADBAuxiliaryAxle_auxAxleBrakeDiscInfo_name": "Rotor or Drum Intended Manufacturer and Part Number",
    "type_ADBAuxiliaryAxle_auxAxleBrakeHubInfo_name": "Hub Intended Manufacturer and Part Number",
    "type_ADBAuxiliaryAxle_auxAxleBrakeActInfo_name": "Actuator/Cylinder Intended Manufacturer and Part Number",
    "type_ADBAuxiliaryAxle_auxAxleValveCP_name": "Valve Crack Pressure (psi)",
    "type_ADBAuxiliaryAxle_auxAxleType_name": "Auxiliary Axle Type",
    "type_ADBAuxiliaryAxle_auxAxleAttributes_name": "Auxiliary Axle Attributes",
    "type_ADBAuxiliaryAxle_auxAxleGAWR_name": "Gross Axle Weight Rating (GAWR) (lbs)",
    "type_ADBAuxiliaryAxle_auxAxleWheelRimSize_name": "Wheel/Tire Size (example: 295/75R22.5)",
    "type_ADBAuxiliaryAxle_auxAxleTireType_name": "Tire Type",
    "type_ADBAuxiliaryAxle_auxAxleSLR_name": "Tire Static Loaded Radius (SLR) (in)",
    "type_ADBAuxiliaryAxle_auxAxleCustPropBrake_name": "Customer-Proposed Brake",
    "type_ExportStatus_saved_name": "Saved (Not Submitted)",
    "type_AxlePositionEnum_name": "Axle Position",
    "type_CoreRequest_customerCRNumber_name": "Customer Reference Number",
    "type_CoreRequest_barCode_name": "BarCode Label",
    "type_CoreRequest_sapExportStatus_name": "SAP Export Status",
    "type_CoreRequest_sapErrorMessage_name": "SAP Response Message",
    "type_Product_remanType_name": "Reman Type",
    "type_SalesData_materialGrouping_name": "Material Grouping",
    "type_ADBRequest_vehicleOperationalOutsideFlag_name": "Vehicle Operation Outside of USA/Canada",
    "type_ADBRequest_vehicleOperationalOutsideText_name": "Vehicle Operation Outside of USA/Canada Text",
    "airdisc_value_calculator_tractors_text": "Tractors",
    "airdisc_value_calculator_privacy_accept": "I Accept the ",
    "airdisc_value_calculator_privacy_accept_link": "Value Calculator(s) Disclaimers",
    "airDiscBrake_value_calculator_header": "Drum vs. ADB Summary",
    "airDiscBrake_value_calculator_drumvsadb": "Drum vs. ADB Summary",
    "airDiscBrake_value_calculator_firstName": "First Name",
    "airDiscBrake_value_calculator_lastName": "Last Name",
    "airDiscBrake_value_calculator_email": "Company Email Address",
    "airDiscBrake_value_calculator_adbValueCalculatorType": "ADB Value Calculator Type*",
    "airDiscBrake_value_calculator_fleetSize": "Fleet Size*",
    "airDiscBrake_value_calculator_totalNumberOfAxlesPerUnit": "Total Number of Axles per Unit",
    "airDiscBrake_value_calculator_tractorTradeInCycle": "Tractor Trade-In Cycle*",
    "airDiscBrake_value_calculator_averageAnnualUnitMileage": "Average Annual Unit (Vehicle) Mileage*",
    "airDiscBrake_value_calculator_drumtoshorereplacementFrequency": "Drum to Shoe Replacement Frequency",
    "airDiscBrake_value_calculator_drumtoshorereplacementFrequency_everyFrictionChange": "Every Friction Change",
    "airDiscBrake_value_calculator_drumtoshorereplacementFrequency_everyOtherFrictionChange": "Every Other Friction Change",
    "airDiscBrake_value_calculator_adbupcharge": "ADB Up-Charge (over Drum)",
    "airDiscBrake_value_calculator_adbResidualValueatTradeIn": "ADB Residual Value at Trade-In (Increase over Drum)",
    "airDiscBrake_value_calculator_fleetDowntimeRate": "Fleet Downtime Rate*",
    "airDiscBrake_value_calculator_fleetMaintenanceLaborRate": "Fleet Maintenance Labor Rate",
    "airDiscBrake_value_calculator_annualFleetAccidentRate": "Annual Fleet Accident Rate*",
    "airDiscBrake_value_calculator_noofRearEndCollisionsDuringLifeCycle": "Number of Rear-End Collisions during Lifecycle",
    "airDiscBrake_value_calculator_rearEndCollisionUnitCost": "Rear-End Collison Unit Cost",
    "airDiscBrake_value_calculator_lifeCycleRearEndCollisionsFleetCost": "Lifecycle Rear-End Collisions Fleet Cost",
    "airDiscBrake_value_calculator_noOfFrictionReplacementsInTradeIn": "Number of Friction Replacements at Trade-In",
    "airDiscBrake_value_calculator_brakeFrictionRequirementAtTradeIn": "Brake Friction Requirement at Trade-In",
    "airDiscBrake_value_calculator_brakeFrictionRequirementAtTradeIn_minimum": "Minimum 50% Friction at Trade-In",
    "airDiscBrake_value_calculator_brakeFrictionRequirementAtTradeIn_nominimum": "No Minimum Requirement at Trade-In",
    "airDiscBrake_value_calculator_numberOfDrumReplacementsAtTradeIn": "Number of Drum Replacements at Trade-In",
    "airDiscBrake_value_calculator_drumBrakeShoeReplacementUnitCost": "Drum Brake Shoe Replacement Unit Cost",
    "airDiscBrake_value_calculator_drumBrakeReplacementUnitCost": "Drum Brake (Shoe & Drum) Replacement Unit Cost",
    "airDiscBrake_value_calculator_drumReplacementUnitCost": "Drum Replacement Unit Cost",
    "airDiscBrake_value_calculator_drumbrakeReplacementFleetCost": "Drum Brake (Shoe & Drum) Replacement Fleet Cost",
    "airDiscBrake_value_calculator_drum_maintenance": "Drum Brake Service Costs (Brake Inspection, Adjustment, Lubrication)",
    "airDiscBrake_value_calculator_drumBrakeServiceLaborCost": "Drum Brake Service Labor Cost",
    "airDiscBrake_value_calculator_totalDrumBrakeServiceUnitCost": "Total Drum Brake Service Unit Cost",
    "airDiscBrake_value_calculator_drumBrakeServiceAnnualFrequency": "Drum Brake Service Annual Frequency",
    "airDiscBrake_value_calculator_totalDrumBrakeServiceFleetCost": "Total Drum Brake Service Unit Cost",
    "airDiscBrake_value_calculator_csaViolationsAnnualPercentage": "CSA Violations Annual Percentage",
    "airDiscBrake_value_calculator_numberofCSAViolations": "Number of CSA Violations",
    "airDiscBrake_value_calculator_roadsideCallRateForCSAViolation": "Roadside Call Rate for CSA Violation*",
    "airDiscBrake_value_calculator_annualNoOfOutOfServiceBrakeCSAViolations": "Annual Number of Out-of-Service Brake CSA Violations*",
    "airDiscBrake_value_calculator_CSAUnitCost": "CSA Unit Cost (includes Downtime)",
    "airDiscBrake_value_calculator_lifecycleCSAFleetCost": "Lifecycle CSA Fleet Cost",
    "airDiscBrake_value_calculator_drumbrakeReplacementDueToRustJacking": "Drum Brake Replacement Due to Rust Jacking",
    "airDiscBrake_value_calculator_rustJackingShoeReplacementUnitCost": "Rust Jacking Shoe Replacement Unit Cost",
    "airDiscBrake_value_calculator_rustJackingShoeReplacementFleetCost": "Rust Jacking Shoe Replacement Fleet Cost",
    "airDiscBrake_value_calculator_adbImpactWithImprovedStoppingDistance": "ADB Impact with Improved Stopping Distance",
    "airDiscBrake_value_calculator_adbImpactWithImprovedStoppingDistance_ZERO": "0",
    "airDiscBrake_value_calculator_adbImpactWithImprovedStoppingDistance_ONE": "1",
    "airDiscBrake_value_calculator_adbImpactWithImprovedStoppingDistance_TWO": "2",
    "airDiscBrake_value_calculator_adbImpactWithImprovedStoppingDistance_FIVE": "5",
    "airDiscBrake_value_calculator_adbImpactWithImprovedStoppingDistance_TEN": "10",
    "airDiscBrake_value_calculator_initialAdbFleetCost": "Initial ADB Fleet Cost",
    "airDiscBrake_value_calculator_impactToFleetAccidentCosts": "Impact to Fleet Accident Costs",
    "airDiscBrake_value_calculator_accidentcost": "Impact to Fleet Accident Costs ¹,²",
    "airDiscBrake_value_calculator_adbFrictionMileage": "ADB Friction Mileage",
    "airDiscBrake_value_calculator_adbFriction": "ADB Friction Mileage ³",
    "airDiscBrake_value_calculator_noOfPadReplacementsAtTradeIn": "Number of Pad Replacements at Trade-In",
    "airDiscBrake_value_calculator_noOfRotarReplacementsAtTradeIn": "Number of Rotor Replacements at Trade-In",
    "airDiscBrake_value_calculator_padandRotarReplacementUnitCost": "Pad & Rotor Replacement Unit Cost",
    "airDiscBrake_value_calculator_lifeCyclePadAndRotarReplacementFleetCosts": "Lifecycle Pad & Rotor Replacement Fleet Costs",
    "airDiscBrake_value_calculator_adbBrakeAdjustmentMaintanaceFleetCost": "ADB Brake Adjustment Maintenance Fleet Cost",
    "airDiscBrake_value_calculator_csaViolationFleetCost": "CSA Violation Fleet Cost",
    "airDiscBrake_value_calculator_adbRustJackingPadReplacementFleetCost": "ADB Rust Jacking Pad Replacement Fleet Cost",
    "airDiscBrake_value_calculator_totalAdbUnitCost": "Total ADB Unit Cost",
    "airDiscBrake_value_calculator_totalAdbFleetCost": "Total ADB Fleet Cost",
    "airDiscBrake_value_calculator_tractorDrumvsAirDiscBrakeSummaryCosts": "Tractor Drum vs. Air Disc Brake Summary Costs (USD)",
    "airDiscBrake_value_calculator_trailerDrumvsAirDiscBrakeSummaryCosts": "Trailer Drum vs. Air Disc Brake Summary Costs (USD)",
    "airDiscBrake_value_calculator_drum": "Drum",
    "airDiscBrake_value_calculator_adb": "ADB",
    "airDiscBrake_value_calculator_description": "Description",
    "airDiscBrake_value_calculator_unit_cost": "Unit Cost",
    "airDiscBrake_value_calculator_totalFleet_cost": "Total Fleet Cost",
    "airDiscBrake_value_calculator_initialpurchase_cost": "Initial Purchase Cost ",
    "airDiscBrake_value_calculator_residualValueAtTradeIn": "Residual Value at Trade-In",
    "airDiscBrake_value_calculator_estimatedImpactOfSafety": "Estimated Impact on Safety",
    "airDiscBrake_value_calculator_estimatedReplacementMaintenanceCost": "Estimated Replacement Maintenance Costs",
    "airDiscBrake_value_calculator_continuiousMaintananceCost": "Continuous Maintenance Cost",
    "airDiscBrake_value_calculator_csaRelatedCosts": "CSA Related Costs",
    "airDiscBrake_value_calculator_rustJackingCosts": "Rust Jacking Costs",
    "airDiscBrake_value_calculator_total_text": "Total",
    "airDiscBrake_value_calculator_returnOnInvestmentROI": "Return on Investment (ROI)",
    "airDiscBrake_value_calculator_roiOverLifeCycleUSD_UNIT": "ROI over LIfecycle (USD / unit)",
    "airDiscBrake_value_calculator_roiOVerLifeCycleUSD": "ROI over LIfecycle (USD)",
    "airDiscBrake_value_calculator_changeFriction": "Average Mileage to Change Friction",
    "airDiscBrake_value_calculator_replacementCycle": "Replacement Cycle(s)",
    "airDiscBrake_value_calculator_usd_hour": "USD / Hour",
    "airDiscBrake_value_calculator_usd_unit": "USD / Unit",
    "airDiscBrake_value_calculator_hours_wheelend": "Hours / Wheel-End",
    "airDiscBrake_value_calculator_times/year": "Times / Year",
    "airDiscBrake_value_calculator_drum_service": "Total Drum Brake Service Fleet Cost",
    "airDiscBrake_value_calculator_CSA_violation": "CSA Violation Costs (Out of Adjustment / Cracked Friction)",
    "airDiscBrake_value_calculator_drum_rust": "Drum Brake Maintenance (Rust Jacking)",
    "airDiscBrake_value_calculator_brake_summary": "Air Disc Brake Cost Summary",
    "airDiscBrake_value_calculator_adb_percentage": "% with ADB",
    "airDiscBrake_value_calculator_totalNumberOfAxlesPerUnit_tooltip": "Total Number of Axles per Unit configuration (i.e. 3 axles for a 6x4 tractor or tridem axle trailer, 2 axles for a 4x2 vehicle or tandem axle trailer, etc.)",
    "airDiscBrake_value_calculator_drumtoshorereplacementFrequency_tooltip": "Select the drum replacement frequency relative to the drum shoe replacement frequency.",
    "airDiscBrake_value_calculator_adbupcharge_tootlip": "Up-charge for all-wheel ADB (front steer and drive axles).  This will vary by OEM (consider drum delete credits).",
    "airDiscBrake_value_calculator_popup_tradeIn": "Provide residual amount that ADB vehicle would get at trade-in over drum.",
    "airDiscBrake_value_calculator_popup_fleet": "Downtime rate (USD / day) while truck is not operating. (Fleet Survey Average = 850 USD / day)",
    "airDiscBrake_value_calculator_popup_annualfeet": "Provide estimated annual accident rate for fleet.  Typical 7% accident rate based on RigDig™ data for the Top 200 major fleets (i.e. fleet size of 100 units with 5 accidents per year would input a 5% accident rate)",
    "airDiscBrake_value_calculator_popup_annualfeet_title": "Annual Fleet Accident Rate",
    "airDiscBrake_value_calculator_popup_rearendCycle": "Estimated 22.8% of commercial vehicle accidents are characterized as rear-end collisions per FMCSA Large Truck and Bus Crash Facts (2022).",
    "airDiscBrake_value_calculator_popup_rearendCost": "Rear-end collisions average 75,301 USD / incident (property damage only) for estimated calculations per 2020 FMCSA Pocket Guide to Large Truck and Bus Statistics.",
    "airDiscBrake_value_calculator_popup_changeFriction": "Average vehicle mileage to replace normally worn friction.",
    "airDiscBrake_value_calculator_popup_brakeFrictionRequirementAtTradeIn": "Choose between brake friction requirements defined at vehicle trade-in.",
    "airDiscBrake_value_calculator_popup_drumBrakeShoeReplacementUnitCost": "Cost per vehicle to replace drum brake shoes at all wheel positions (i.e. 60 USD / shoe kit x 6 shoe kits / vehicle = 360 USD / unit)",
    "airDiscBrake_value_calculator_popup_drumReplacementUnitCost": "Cost per vehicle to replace drums at all wheel positions (i.e. 100 USD / drum x 6 drums / vehicle = 600 USD / unit).",
    "airDiscBrake_value_calculator_popup_drumBrakeReplacementUnitCost": "Average lifecycle friction and drum replacement costs (per vehicle) accumulated during lifecycle. (Replacement parts and labor costs only)",
    "airDiscBrake_value_calculator_popup_drumBrakeServiceLaborCost": "Labor time (hours/ wheel end) required to visually inspect brakes, measure adjustment, and grease slack adjusters and cam tubes. (i.e. 10 minutes = 0.17 hours)",
    "airDiscBrake_value_calculator_popup_drumBrakeServiceAnnualFrequency": "Average number of times drum brakes are inspected / adjusted annually.",
    "airDiscBrake_value_calculator_popup_csaViolationsAnnualPercentage": "Estimated CSA violations as an annual percentage of a fleet's vehicles.",
    "airDiscBrake_value_calculator_popup_roadsideCallRateForCSAViolation": "Estimated cost of roadside assistance during CSA Out-of-Service (OOS) event.",
    "airDiscBrake_value_calculator_popup_annualNoOfOutOfServiceBrakeCSAViolations": "Calculated number of CSA violations resulting in Out-of-Service (OOS) brakes, based on 13% of CSA violations related to OOS brakes.",
    "airDiscBrake_value_calculator_popup_CSAUnitCost": "Total lifecycle estimated CSA violation costs per vehicle, includes downtime.",
    "airDiscBrake_value_calculator_popup_drumbrakeReplacementDueToRustJacking": "Annual number of vehicles requiring drum shoe replacement due to rust jacking.",
    "airDiscBrake_value_calculator_popup_rustJackingShoeReplacementUnitCost": "Total lifecycle brake shoe replacement unit cost associated with rust jacking (per vehicle), includes labor and downtime.",
    "airDiscBrake_value_calculator_popup_adbImpactWithImprovedStoppingDistance": "Fleet input for estimated level of impact associated with rear-end collisions by improving vehicle stopping distance performance over drum brakes.  (i.e. 2% impact to 125 estimated rear-end collisions would be approximately 3 incidents)",
    "airDiscBrake_value_calculator_popup_impactToFleetAccidentCosts": "Estimated cost avoidance based on fleet input for level of impact associated with rear-end collisions (i.e. 2 incidents x 75,301 USD / incident = 150,602 USD avoidance) ",
    "airDiscBrake_value_calculator_popup_adbFrictionMileage": "Wear rate calculation assumes a 1.5x improvement for Bendix ADB pad life over drum brake friction life.",
    "airDiscBrake_value_calculator_popup_noOfRotarReplacementsAtTradeIn": "Calculated number of rotor replacements based on estimated number of pad replacements (assumes rotor replacement with 2nd pad replacement).",
    "airDiscBrake_value_calculator_popup_adbBrakeAdjustmentMaintanaceFleetCost": "Air disc brakes have an internal adjustment mechanism which does not require maintenance labor to inspect for or maintain adjustment.",
    "airDiscBrake_value_calculator_popup_csaViolationFleetCost": "Air disc brakes have an internal adjustment mechanism which reduces the risk for CSA violations related to brakes out of adjustment and / or cracked friction related to rust jacking.",
    "airDiscBrake_value_calculator_popup_adbRustJackingPadReplacementFleetCost": "ADB pad design does not allow for contaminants to get beneath the friction, eliminating costs associated with replacing friction due to rust jacking.",
    "value_calculator_adb_calculatorTypes": "ADB Value Calculator Type:",
    "value_calculator_adb_tractors": "Tractor",
    "value_calculator_adb_trailer": "Trailer",
    "value_calculator_fleetSize": "Fleet Size",
    "value_calculator_fleet_error": "Enter greater than 1",
    "value_calculator_fleet_mileage": "Average Annual Unit (Vehicle) Mileage",
    "value_calculator_fleet_axles_unit": "Axles / Unit",
    "value_calculator_fleet_miles": "Miles",
    "value_calculator_fleet_residualValue": "ADB Residual Value at Trade-In (Increase over Drum)",
    "value_calculator_fleet_safety_title": "Fleet Safety Costs",
    "value_calculator_fleet_drumBrake_title": "Drum Brake Maintenance Associated with Brake Inspection, Adjustment, and Lubrication\t",
    "airdiscBrake_calculator_drum_costs": "Drum Brake Service Costs",
    "airdiscBrake_calculator_csa_costs": "CSA Violation Costs",
    "airdiscBrake_calculator_rust": "Rust Jacking Maintenance",
    "airdiscBrake_calculator_adbCost": "ADB Cost Summary",
    "airdiscBrake_value_calculator_violations_text": "Violations",
    "airdiscBrake_value_calculator_annualOutOfServiceCsaViolations": "Annual Number of Out-of-Service Brake CSA Violations",
    "airdiscBrake_value_calculator_negative_roi": "No net savings realized.  Fleet may want to consider other benefits such as reduced warranty, parts inventory, and utilization of technician time.",
    "airdisc_value_calculator_fleet_drumBrake_title": "Friction / Drum Maintenance",
    "airdiscBrake_value_calculator_emailResult": "Bendix ADB Savings Summary",
    "airdiscBrake_value_calculator_cost_summary": "Rear-end collisions average 75,301 USD / incident (property damage only) for estimated calculations.",
    "airdiscBrake_value_calculator_cost_line": "(2020 FMCSA Pocket Guide to Large Truck and Bus Statistics)",
    "airdiscBrake_value_calculator_cost_secondsummary": "This is an estimated cost based on fleet inputs and does not represent a validated cost by Bendix.",
    "airdiscBrake_value_calculator_cost_thirdsummary": "Estimated mileages are based off wear test results. Actual results may vary based on (but not limited to) fleet variation, maintenance practices, equipment specifications, driver behavior, application, duty-cycle, etc. Proper maintenance is an important requirement in maintaining any brake system to optimize its performance.",
    "airdiscBrake_value_calculator_negative_estimated_roi": "Based on your fleet inputs, choosing Air Disc Brakes provides an estimated net ROI to your fleet.",
    "airdiscBrake_value_calculator_formSubmit_success": "Your Air Disc Brake Summary has been emailed.",
    "airdiscBrake_value_calculator_formSubmit_failed": "Something went wrong while submitting the Air Disc Brake Savings.  Please try again later.",
    "airdiscBrake_value_calculator_title": "Bendix Value Calculator",
    "airDisc_value_calculator_title": "Value Calculator",
    "airdiscBrake_text_numberof_vahicles": "Number of Vehicles",
    "airdiscBrake_drum_summary_paragraph1": "Find out more about Bendix® air disc brakes for tractors and trailers. Contact your Bendix account manager,\n call 1-800-AIR-BRAKE (1-800-247-2725) or visit Bendix.com today.",
    "airdiscBrake_drum_summary_paragraph2": "The Bendix Value Calculator(s) are intended for reference only; the calculator helps provide guidance to\n users interested in",
    "airdiscBrake_drum_summary_paragraph3": "understanding their potential return on investment (ROI) for various products while comparing them to other\n systems/products. Calculator results are considered estimates only. Actual wear data, component life,\n replacement schedules/cycles, lifecycle costs, savings/avoidance data, product performance, and\n specifications may vary depending upon (but not limited to) vehicle configurations, vehicle applications,\n driver behavior, maintenance practices, duty-cycles, vehicle operation, and other factors.",
    "airdiscBrake_drum_summary_paragraph4": "In cases where the user does not have specific information, Bendix has provided default numbers that are\n based upon general survey information, national fleet data/information, etc., in order to help with the\n                                analysis.",
    "airdiscBrake_drum_summary_paragraph5": "VEHICLE COMPLIANCE AND CERTIFICATION TO ALL REGULATIONS ARE SOLELY THE RESPONSIBILITY OF THE VEHICLE\n MANUFACTURER.",
    "airdiscBrake_drum_summary_paragraph6": "© Bendix Commercial Vehicle Systems LLC, a member of the Knorr-Bremse Group. All Rights Reserved.",
    "airDisc_value_calculator_visitor_info_title": "Visitor Information",
    "airdisc_value_calculator_flit_info_title": "Fleet Information",
    "airdiscbreak_calculator_title": "Air Disc Brake",
    "endurasure_summary_paragraph1": "Find out more about Bendix® EnduraSure® -Pro for tractors and trailers. Contact your Bendix account manager, call 1-800-AIR-BRAKE (1-800-247-2725) or visit Bendix.com today.",
    "endurasure_summary_paragraph2": "The Bendix Value Calculator(s) are intended for reference only; the calculator helps provide guidance to users interested in understanding their potential return on investment (ROI) for various products while comparing them to other systems/products. Calculator results are considered estimates only. Actual wear data, component life, replacement schedules/cycles, lifecycle costs, savings/avoidance data, product performance, and specifications may vary depending upon (but not limited to) vehicle configurations, vehicle applications, driver behavior, maintenance practices, duty-cycles, vehicle operation, and other factors.",
    "endurasure_summary_paragraph3": "In cases where the user does not have specific information, Bendix has provided default numbers that are based upon general survey information, national fleet data/information, etc., in order to help with the analysis.",
    "endurasure_summary_paragraph4": "VEHICLE COMPLIANCE AND CERTIFICATION TO ALL REGULATIONS ARE SOLELY THE RESPONSIBILITY OF THE VEHICLE MANUFACTURER.",
    "endurasure_summary_paragraph5": "© Bendix Commercial Vehicle Systems LLC, a member of the Knorr-Bremse Group. All Rights Reserved.",
    "endurasure_summary_paragraph6": "",
    "text_select_master_country_europe": "Europe",
    "text_select_master_country_na": "North America",
    "text_select_master_country_asia": "Asia Pacific",
    "text_select_master_country_africa": "Middle East & Africa",
    "text_select_master_country_frenchoverseas": "French Overseas Territories",
    "text_software_placeholder": "Please Type Here",
    "register_password_not_match": "Passwords do not match",
    "notifications_available": "New Notification(s)",
    "notifications_not_available": " No new notifications",
    "text_orderTemplate_csv_missing_header": "The order could not be uploaded. Please use the order template to upload an order.",
    "authMessages": {
      "signedOutSuccessfully": "You have signed out of your account"
    },
    "search_page_showing_text": "Showing",
    "search_page_of_text": "of",
    "search_page_result_text": "results",
    "replaceByText": "Replaced by:",
    "smartire_maintaince": "Maintenance Costs",
    "smartire_savings": "SmarTire® Annual Savings",
    "smartire_fleetcost": "Fleet Cost Information",
    "smartire_Annual_Tire_Costs": "Annual Tire Costs (USD)",
    "smartire_Annual_Fuel_Costs": "Annual Fuel Costs (USD)",
    "smartire_Annual_Tire_Maintenance": "Annual Tire Maintenance Costs (USD)",
    "smartire_Downtime": "Annual Downtime Costs (USD)",
    "smartire_total": "Total (USD)",
    "smartire_roi": "Return on Investment (ROI)",
    "smartire_Annual_Savings": "Annual Savings per Vehicle (USD)",
    "smartire_Normal": "Normal",
    "smartire_Savings": "Savings",
    "smartire_negativeValue": ": No net savings realized with data provided. Fleet may want to consider other benefits such as reduced warranty related expenses, reduced parts inventory, and technician availability for higher priority maintenance.",
    "smartire_tooltip_tittle": "Service Cost per Vehicle",
    "smartire_tooltip_content": "This is the cost of routinely checking tire pressures manually per vehicle.  Enter the time per tire and the hourly rate for inspection",
    "smartire_proEmail_summary": "SmarTire® ROI Summary Email",
    "smartire_calculator_formSubmit_success": "Your SmarTire® savings projection summary has been emailed.",
    "smartire_maintaince_per_Vechile": "Maintenance Costs per Vehicle",
    "text_demo_bendix_center": "Bendix Demo Center",
    "text_demo_bendix_form": "Demo Registration",
    "register_jobTitle_invalid": "Please enter a job Title",
    "register_success": "You have successfully register for the demo. You will receive an email confirmation with your accepted waiver.",
    "text_core_submission_invoiceNumber": "Invoice Number",
    "text_core_new_invoiceNumber": "Add Another",
    "Enter_your_part_number_using_the_magnifying_glass_below": "Enter your part number using the magnifying glass below.",
    "asmuser_message_display": "ASM User is not allowed to place an order",
    "form_global_error_asmagent": "ASM User is not allowed to submit core",
    "form_global_errortraining_asmagent": "ASM User is not allowed to submit training",
    "form_global_errorwarranty_asmagent": "ASM User is not allowed to submit warranty",
    "description_text": "Description"
  },
  "pageMetaResolver": {
    "category": {
      "title": "{{title}} | B2Bendix",
      "title_other": "{{count}} results for {{query}} | B2Bendix"
    },
    "checkout": {
      "title": "Checkout"
    },
    "search": {
      "title": "{{count}} result for {{query}} | B2Bendix",
      "title_other": "{{count}} results for {{query}} | B2Bendix",
      "findProductTitle": "{{count}} result for coupon {{coupon}}",
      "findProductTitle_other": "{{count}} results for coupon {{coupon}}",
      "default_title": "All products | B2Bendix"
    },
    "product": {
      "description": "{{description}}",
      "heading": "{{heading}}",
      "title": "{{title}} | B2Bendix"
    }
  },
  "formErrors": {
    "cxInvalidEmail": "This is not a valid email format",
    "required": "This field is required"
  },
  "httpHandlers": {
    "badRequest": {
      "bad_credentials": "The entered email address or password is not correct.",
      "user_is_disabled": "Your account has been locked, please contact your company administrator accordingly"
    }
  },
  "authMessages": {
    "signedOutSuccessfully": "You have signed out of your account"
  },
  "user": {
    "authMessages": {
      "signedOutSuccessfully": "You have signed out of your account"
    }
  },
  "registrationDemoLandingPage": {
    "bendix_demo_center": "BENDIX DEMO CENTER",
    "title1": "Make the Smart Investment in Safety",
    "p1": "Having the right technology on your trucks and trailers can help increase your safety and driver retention … not to mention lowering  your total cost of ownership (TCO). ",
    "p2": "That’s where we can help. Discover what the suite of Bendix safety technologies can mean for your fleet. -",
    "resgister": "register",
    "today": " today!",
    "image-text": "More Learning Available to you",
    "title2": "Technologies Featured",
    "p3": "Firsthand Experience from the Passenger Seat",
    "p4": "Feel the power of these integrated Bendix safety solutions",
    "list_title1": "Bendix® Fusion™",
    "list_desc1": "- includes enhanced features like highway departure warning and braking, multi-lane AEB, and more.",
    "list_title2": "Bendix® ADB22X®",
    "list_desc2": "- virtually no brake fade and longer service life with optimized friction couple design.",
    "list_title3": "ESP® Full Stability",
    "list_desc3": "- decreases rollovers and loss-of-control situations.",
    "list_title4": "TABS with TRSP® ",
    "list_desc4": "- helps maintain control and reduce the risk of trailer rollovers.",
    "launch_video": "Launch Video",
    "register_here": "Register Here",
    "Currently_no_demos": "Currently no demos",
    "Bendix_in_action": "Click Here to See the Bendix Demo Experience in Action"
  },
  "registrationDemoForm": {
    "ll1": "Thank you for your interest in attending a Bendix Safety Technology demonstration.",
    "ll2": "Please enter your information as requested below, accept the waiver and",
    "ll3": "select the demo session (time & date) you will be attending.",
    "l4": "All demo participants must follow this process to attend.   If you have any questions,",
    "l5": "please email us at",
    "l6": "We look forward to seeing you soon!",
    "l7": "Thank You.",
    "l8": "The Bendix Demo Team",
    "demo_team": " Demo Team.",
    "demo": "DEMO",
    "date_and_times": "DATE / TIME",
    "Locations": "LOCATION",
    "language": "Language",
    "Wavier": "WAIVER / SIGNUP",
    "Wavier_sentence": "Sign Waiver",
    "Wavier_accepted_sentence": "Waiver accepted",
    "waiver_hyperlink": "waiver",
    "Wavier_accepted_sentence": "Waiver accepted",
    "confirmEmailAddresslabel": "Confirm Email Address*",
    "confirmEmailAddressError": "incorrect please try again",
    "popupMsgDemoCode": "Only applies if you received an access code from Bendix."
  },
  "WarrentyParagraph": {
    "p1": "To submit a Bendix Warranty claim, please complete the following on-line form. Required information is marked with an asterisk (*).",
    "p2": "If you have any additional questions, please download",
    "hyperlinkText": "How to submit a warranty claim",
    "p3": "Thank you, Your Bendix Warranty Support Team"
  },
  "coreReport": {
    "page_Title": "Bendix Core Center",
    "p1": "Welcome to the Bendix Core Center",
    "p2": "As a customer you will be able to access core reports, submit core returns, schedule shipments...and much more. Don't forget ",
    "hyperlinkText1": "Bendix Buys Cores",
    "p3": "You must ",
    "hyperlinkText2": "Sign in",
    "p4": "to your account to access the following links:",
    "link1": "Submit Core Returns",
    "link2": "Search Core Returns",
    "link3": "Bendix Core Reports"
  },
  "warrentyLandingPageParagraph": {
    "page_announcement": "Announcements",
    "page_p1": "As a customer you will be able to submit warranty claims, view warranty status, review warranty policies, and use our NEW warranty eligibility checker.",
    "page_p2": "For common inquiries, please review the",
    "hyperlinkText1": "Warranty FAQ",
    "page_p3": "Warranty Team contact information: ",
    "hyperlinkText2": "warranty@bendix.com"
  },
  "SelectAllVehicalPopup": {
    "p1": "Vehicle Type(s):",
    "p2": "Each Industry Role will be limited to only one Vehicle Type – except for Fleet customers.  Fleet customers will be permitted to select multiple Vehicle Type(s).",
    "p3": "The selected Vehicle Type(s) will determine the available Demo schedule.",
    "p4": "Your Industry Role along with the selected Vehicle Type(s) will determine your Demo Schedule Availability."
  },
  "waiver_popup_content": {
    "title": "RELEASE AND ASSUMPTION OF RISK AGREEMENT",
    "p1": "In consideration of the opportunity granted to me by Bendix Commercial Vehicle Systems LLC (“BENDIX”) allowing me to participate as a passenger, driver or spectator observing a motor vehicle demonstration conducted by BENDIX demonstrating the characteristics of a BENDIX product and/or the operation of a vehicle featuring Bendix Active & Supportive Safety Technologies, I do hereby – for myself and on behalf of my heirs, executors, administrators, successors, and assigns – completely and unconditionally release and discharge BENDIX and each of its past, present, and future officers, directors, shareholders, members, attorneys, dealers, distributors, suppliers, insurers, indemnitors, agents, servants, representatives, employees, parent and subsidiary corporations, affiliates, partners, predecessors, successors and assigns (collectively “the Releasees”), from any and all past, present and future claims, demands, obligations, actions, causes of action, wrongful death claims, rights, damages, costs, loss of services, loss of comfort and society, expenses and compensation of any nature whatsoever, including all claims for compensatory, exemplary or punitive damages, contribution or indemnification, whether based in negligence, contract, breach of warranty, strict liability or any other legal or equitable theory, which I ever had, now have, or which may hereafter accrue or otherwise be acquired by me and arising from or relating to: (a) the product demonstration, its environment and location, (b) any defect or condition associated with the products demonstrated or vehicles used during such demonstration, (c) any physical conditions associated with the Site, (d) my participation in or observation of the product demonstration, and/or (e) riding in, driving or being present near any motor vehicle at the Site during such product demonstration (collectively “The Voluntarily Assumed and Released Risks”).",
    "p2": "This Release and Assumption of Risk Agreement specifically includes any and all known or unknown claims or causes of action against BENDIX and the Releasees for economic losses, personal injury, illness, death or property damage caused to or by me or sustained by me, whether occurring or accruing before, as of, or after the date of this Agreement, and also includes all consequences of any such economic loss, personal injury, illness, death or property damage (whether expected, anticipated, unexpected or unanticipated), resulting from or which may in the future result from one or more of The Voluntarily Assumed and Released Risks.",
    "p3": "I knowingly and voluntarily acknowledge and personally assume all risks attendant to (a) the product demonstration, its environment and location, (b) any defect or condition associated with the products demonstrated or vehicles used during such demonstration, (c) any physical conditions associated with the Site, (d) my participation in or observation of the product demonstration, and/or (e) riding in, driving or being present near any motor vehicle at the Site during such product demonstration. I further warrant and represent to BENDIX that I know of no physical or mental defect, medical condition, physical illness, or physical limitations or restrictions that would prevent, hinder or otherwise make me susceptible to injury while participating in or observing the product demonstration or while riding in, driving or being present near any motor vehicle at the Site during the product demonstration.",
    "p4": "I voluntarily acknowledge and permit BENDIX and its duly authorized agents or assigns to use on a non-exclusive basis, my name, likeness, images, sounds and/or performance as recorded, photographed, videotaped or otherwise preserved, digitally or otherwise, while participating in or observing such product demonstration, and I do hereby relinquish to BENDIX in perpetuity all rights thereto for such purposes.",
    "p5": "IN WITNESS WHEREOF, I have executed this Release and Assumption of Risk Agreement as my voluntary act and deed, this on:",
    "p6": "Demo Liability Waiver – 06-29-26 BCVS",
    "accept": "Accept"
  },
  "dataExtractionRquest": {
    "dataExtractionRquestTitle": "Data Extraction Request",
    "dataExtractionOverview": "Data Extraction Overview",
    "customerVehicleOwner": "Customer / Vehicle Owner",
    "requestor": "Requestor",
    "reportECURecipient": "Report / ECU Recipient",
    "vehicleInformation": "Vehicle Information",
    "eCUInformation": "ECU Information",
    "incidentInformation": "Incident Information",
    "returnShippingInformation": "Return Shipping Information",
    "Next": "Next",
    "back": "Back",
    "error_message": "Please enter a valid value.",
    "DATA_EXTRACTION_SUCCESS_MESSAGE": "SUCCESS"
  },
  "dataExtractionOverviewPage": {
    "p1": "Please use this form to request and release Bendix® Electronic Control Unit (ECU) data extractions and to track custody of any component(s) removed from your vehicle and sent to Bendix Commercial Vehicle Systems (Bendix)",
    "Note": "NOTE: THERE IS A DATA EXTRACTION FEE OF $1,000.00 USD.",
    "p2": "Following removal from the vehicle, send the component(s), this completed form, and a check made payable to Bendix Commercial Vehicle Systems for $1,000.00 USD to:",
    "address1": "Bendix Commercial Vehicle Systems",
    "address2": "Event Log Reporting",
    "address3": "35500 Chester Road",
    "address4": "Avon, Ohio 44011",
    "p3_1": " The component(s), the completed form, and the check for $1,000.00 USD must be received prior to the start of any extraction by Bendix. For questions, please email",
    "p3_2": "or contact your Bendix Account Manager directly. Thank you.",
    "p4_1": "I Accept the",
    "p4_2": "Bendix Data Extraction Disclaimer"
  },
  "bendix_data_extraction_disclaimer_popup": {
    "title": "Bendix Data Extraction Disclaimer",
    "p1": "Exclusion of incidental, consequential, and certain other damages:",
    "p2": "To the maximum extent permitted by applicable law, in no event shall Bendix, its subsidiaries, affiliates, suppliers, or approved service providers be liable for any special, incidental, indirect, or consequential damages whatsoever arising out of or in any way related to the loss of the ecu, the use of or inability to use the data extraction, the provision of or failure to provide event reports, or otherwise under or in connection with any provision of this agreement.",
    "attention": "ATTENTION:",
    "p3": "Depending on the product type and version, Bendix® Electronic Control Units (ECUs) may store data related to troubleshooting, diagnostics, service needs, vehicle system operating status, and vehicle operator inputs.  No personally identifying data (e.g. name, gender, or age) is recorded. Bendix will not access stored ECU data or share it with others except with the consent of the vehicle owner; in response to an official request by law enforcement or other governmental agency; as part of Bendix’s defense of litigation; or, as otherwise required by law. Data that Bendix receives may also be used for research purposes or made available to others for research purposes, where a need is shown and the data is not linked to a specific vehicle or owner.",
    "p4": "Bendix®-brand Electronic Control Units (ECUs) are not designed to store data for purposes of accident reconstruction, and Bendix® ACom® Diagnostic Software is not intended to retrieve data for purposes of accident reconstruction. Bendix makes no representations as to the accuracy of data retrieved and interpreted from ECUs for purposes of accident reconstruction. Bendix does not offer accident reconstruction services or interpretation of stored data. Bendix ECUs are not protected from fire, loss of power, impact damage, or other conditions that may be sustained in a crash situation and may cause data to be unavailable or irretrievable.",
    "p5_1": "When requesting an ECU data extraction from Bendix components, a single form can be used when sending in multiple components for extraction.",
    "p5_2": "It is essential that this is if filled out completely.",
    "p5_3": "PLEASE LIST THE SERIAL NUMBER",
    "p5_4": "for each component you are sending. It is also strongly recommended to send in a clear photo of the label of each component.",
    "p6": "Note the following exceptions:",
    "p7": "Bendix® Antilock Braking System (ABS) ECU: ",
    "p7_1": "It is not required to send in the brake ECU if you are requesting a Bendix Data Recorder (BDR) report. The ABS Diagnostic Trouble Code (DTC) report in HTML format (for Bendix® ACom® Legacy) or a ZIP file (for Bendix® ACom® PRO™/AE™ Diagnostic Software) is required for Bendix to generate the BDR report. Bendix recommends you submit the DTC report on a USB/thumb drive accompanied by the required items noted in SECTION 1: OVERVIEW of this document. Incomplete or missing materials will lead to delays in processing.",
    "p8": "Bendix™ FLR-21™, FLR-25™ (Forward Looking Radar):",
    "p8_1": "The only data that is available is the DTC report from the radar",
    "p8_2": "Please do not send in either of these radars",
    "p8_3": "as there is no data that will be extracted.",
    "note": "NOTE: AutoVue® / SafetyDirect® ECUs must be sent to Rand McNally®.",
    "p9": "©Bendix Commercial Vehicle Systems LLC, a member of the Knorr-Bremse Group. All Rights Reserved.",
    "accept": "Accept"
  },
  "customerVehicleOwnerForm": {
    "companyName": "Company Name*",
    "contactName": "Contact Name*",
    "contactEmail": "Contact Email*",
    "contactPhoneNumber": "Contact Phone Number*",
    "companyAddresswithStreetNumber": "Company Address with Street Number*",
    "address2": "Address 2 (e.g. Unit, Floor, House Name)",
    "city": "City*",
    "state": "State*",
    "zipPostalCode": "Zip / Postal Code*",
    "country": "Country*",
    "company_name_popup_title": "Company Name",
    "company_name_popup_content": "The company that owns the vehicle.",
    "contact_name_popup_title": "Contact Name",
    "contact_name_popup_content": "The person that owns the vehicle."
  },
  "requestorForm": {
    "checkbox_label": "Same as Customer / Vehicle Owner Information",
    "companyName": "Requestor Company Name*",
    "contactName": "Requestor Contact Name*",
    "contactEmail": "Requestor Contact Email*",
    "contactPhoneNumber": "Requestor Contact Phone Number*",
    "companyAddresswithStreetNumber": "Requestor Company Address with Street Number*",
    "address2": "Address 2 (e.g. Unit, Floor, House Name)",
    "city": "City*",
    "state": "State*",
    "zipPostalCode": "Zip / Postal Code*",
    "country": "Country*",
    "company_name_popup_title": "Requestor Company Name",
    "company_name_popup_content": "The company requesting the data extraction (if not the vehicle owner).",
    "contact_name_popup_title": "Requestor Name",
    "contact_name_popup_content": "The person requesting the data extraction (if not the vehicle owner)."
  },
  "reportECURecipientForm": {
    "checkbox_label": "Same as Requestor Information",
    "companyName": "Recipient Company Name*",
    "contactName": "Recipient Contact Name*",
    "contactEmail": "Recipient Contact Email*",
    "contactPhoneNumber": "Recipient Contact Phone Number*",
    "companyAddresswithStreetNumber": "Recipient Company Address with Street Number*",
    "address2": "Address 2 (e.g. Unit, Floor, House Name)",
    "city": "City*",
    "state": "State*",
    "zipPostalCode": "Zip / Postal Code*",
    "country": "Country*",
    "customer_reference_number": "Customer Reference Number",
    "company_name_popup_title": "Report Recipient Company Name",
    "company_name_popup_content": "The company to whom Bendix will return the report(s) and ECU(s).",
    "contact_name_popup_title": "Report Recipient Name",
    "contact_name_popup_content": "The person to whom Bendix will return the report(s) and ECU(s)."
  },
  "vehicleInformation": {
    "vehicleIdentificationNumber": "Vehicle Identification Number(VIN)*",
    "vehicleYear": "Vehicle Year*",
    "vehicleMake": "Vehicle Make*",
    "vehicleModel": "Vehicle Model*",
    "vehicleTruckNumber": "Vehicle Truck Number*",
    "vehicleMileage": "Vehicle Mileage",
    "mileageUnit": "Miles"
  },
  "IncidentForm": {
    "label_Is_this_Request_the_Result_of_an_Accident": "Is this Request the Result of an Accident?*",
    "Yes": "Yes",
    "No": "No",
    "Date_of_Incident": "Date of Incident*",
    "Select_Date": "Select Date",
    "Time_of_Incident": "Time of Incident*",
    "City_of_Incident": "City of Incident*",
    "State_of_Incident": "State of Incident*",
    "Select_Your_State": "Select Your State",
    "Country_of_Incident": "Country of Incident*",
    "Select_Your_Country": "Select Your Country"
  },
  "returnShippingInformation": {
    "return_shipping_type": "Return Shipping Type:",
    "domestic": "Domestic",
    "international": "International",
    "carrier": "Carrier*",
    "account_number": "Account Number*",
    "account_postal_code": "Account Postal Code*",
    "account_country_code": "Account Country Code*",
    "e-signature": "E-signature",
    "i_am_not_robot": "I am not a robot",
    "domestic_shipping_label": "For Domestic shipping:",
    "domestic_not_required": " not required ",
    "domestic_shipping_desc": "if return shipping is within the United States.",
    "international_shipping_label": "For International Shipping:",
    "international_required": "  required ",
    "international_shipping_desc": "to return of the ECU to the customer.  Any duties or fees associated with this shipment will be charged to your account"
  },
  "ECUForm": {
    "dtc_report_text": "Diagnostic Trouble Code (DTC) Report*",
    "ecu_removed": "ECU(s) Removed - Check All That Apply*",
    "ecu_serial_no": "ECU Serial Number*",
    "ecu_photo": "ECU Photo*",
    "ecu_serial_popup": "ECU Serial Number",
    "ecu_serial_popup_title": "Display Instructions on how to find each ECU serial number – work with Keving Kinley (this will vary by product)",
    "ecu_photo_popup": "ECU Photo",
    "ecu_photo_popup_title": "Photo of the ECU being sent to Bendix for data extraction (for traceability).",
    "dtc_report_text_popup": "Diagnostic Trouble Code (DTC) Report",
    "dtc_report_text_popup_title": "Attach Bendix® Antilock Braking System (ABS) Diagnostic Trouble Code (DTC) Report in HTML format for Bendix® ACom® Legacy and as a ZIP or XML file for Bendix® ACom® PRO™/ AE™ Diagnostic Software.",
    "text_ecu_select_file_wish": "Select the file you wish to upload and click on the \"Upload\" button. Each upload file will be added to the request.",
    "text_ecu_select_file_type_upload": "Note: only html, xml, or zip files are permitted.",
    "text_ecu_select_file_type_upload_1": "Note: Only image file formats are permitted.",
    "bendix_ABS_text": "Bendix® ABS ECU",
    "bendix_EBS_Text": "Bendix® EBS-90™ ECU",
    "bendix_FLC_text": "Bendix® FLC-20™ Camera (Black)",
    "bendix_intellipark_text":"Bendix® Intellipark® Dash ECU (DECU)",
    "sdp_text": "SafetyDirect® Processor (SDP)",
    "ecu_text": "AutoVue® Electronic Control Unit (ECU)",
    "camera_text": "AutoVue® 3G Camera (Gray)",
    "flr_text": "Bendix® FLR-21™, FLR-25™ (Forward Looking Radar)",
    "not_send_bendix_text": "Do <u>not</u> send to Bendix.  Send to Rand McNally for Processing.",
    "not_send_ecu_text": "Do <u>not</u> send to Bendix.  This ECU will <u>not</u> be processed.",
    "record_text": "Record"
  },
  "DTC_PAGE": {
    "dtc_Form_title": "Diagnostic Trouble Code Search",
    "product_type": "Product Type",
    "dtc_type": "DTC Type*",
    "search": "Search",
    "search_string": "Search String*",
    "internalCodesOptional": "Internal Codes (Optional)",
    "internalCode1": "Internal Code 1:",
    "internalCode2": "Internal Code 2:",
    "downloadDocument": "Download Document",
    "troubleshootingSteps": "Troubleshooting Steps",
    "reset": "Reset",
    "dtc_popup_title": "DTC Type:",
    "spn_text": "<b>SPN</b> is the <b>Suspect Parameter Number</b> - identifying the specific product or system where a problem is detected.",
    "fmi_text": "<b>FMI</b> is the <b>Failure Mode Identifier</b> - indicating the type of problem or failure.",
    "hex_code_text": "<b>Hex Codes</b> are the entire combined fault information including all diagnostic metadata stored in a hexadecimal format.",
    "blink_codes_text": "<b>Blink Codes</b> are a method of displaying fault codes - using an indicator light (like the ABS light) to blink out a series of flashes representing a numerical code.",
    "faultCodeSpnSidDecPreferred": "Fault Code SPN/SID (DEC) Preferred",
    "fmi": "SPN/FMI:",
    "hexCode": "Hex Code",
    "internalCode1Path": "Internal Code 1 (Path)",
    "internalCode2Type": "Internal Code 2 (Type)",
    "blinkCode1": "Blink Code 1",
    "blinkCode2": "Blink Code 2",
    "publiclySharableFaultDescription": "Publicly sharable fault description",
    "public": "Public",
    "repairTabInfoSection": "Repair Tab info. / Section",
    "serviceActionCodeList": "Service Action (SD Sheet fault table) Code List.",
    "ecuPinLocations": "ECU Pin locations",
    "overview": "Overview",
    "possibleCauses": "Possible Causes",
    "sdSheetFaultCodeTableSection": "SD Sheet Fault Code Table Section",
    "schematics": "Schematics",
    "disclaimer": "Disclaimer",
    "beforeYouBegin": "Before you begin",
    "afterRepairsHaveBeenMade": "After repairs have been made",
    "sortBy": "Sort By",
    "dtcTypeAscending": "DTC Type Ascending",
    "dtcTypeDescending": "DTC Type Descending",
    "productTypeAscending": "Product Type Ascending",
    "productTypeDescending": "Product Type Descending",
    "defaultSort": "DTC Type Ascending",
    "back_button": "Back"
  },
  "orderConfirmation": {
    "emergencyNote": {
      "note": {
        "message": ""
      }
    }
  },
  "searchBox": {
    "placeholder": "Enter a part number, type number, title or document details",
    "productSearch": "Find a product",
    "ariaLabelInput": "Search here...",
    "ariaLabelSuggestions": "typing suggestions",
    "ariaLabelProducts": "product results",
    "initialDescription": "When autocomplete results are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures.",
    "suggestions": "Suggested Keywords",
    "recentSearches": "Recent Searches",
    "trendingSearches": "Trending Searches",
    "suggestionsResult": "{{ count }} suggestion and ",
    "suggestionsResult_other": "{{ count }} suggestions and ",
    "products": "Recommended Products",
    "productsResult": "{{ count }} product is available.",
    "productsResult_other": "{{ count }} products are available.",
    "resetLabel": "Reset Search",
    "help": {
      "insufficientChars": "Please type more characters",
      "noMatch": "We could not find any results",
      "exactMatch": "{{ term }}",
      "empty": "Ask us anything"
    },
    "closeSearchPanel": "Close",
    "queryError": "Your search query is incorrectly formatted. Please remove special characters like \":\" and try again."
  },
  "navigation": {
    "categoryNavLabel": "Category menu",
    "footerNavLabel": "Footer links",
    "goTo": "Go to {{location}}",
    "navigateTo": "Navigate to {{nav}}",
    "scrollToTop": "Scroll back to the top of the page",
    "linkItemInList": "{{title}}. {{position}} of {{listLength}}",
    "menuButonTitle": "{{title}} Menu"
  }
}